webpackJsonp([2],{

/***/ "+33e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"url_valid"}},[_c('div',{staticStyle:{"text-align":"center"}},[_c('div',[_c('h4',[_vm._v("Welcome "+_vm._s(_vm.userDetails.first_name)),_c('br'),_vm._v("("+_vm._s(_vm.userDetails.mobile)+")")])]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.userDetails.address))]),_vm._v("\n    *****"),_c('br'),_vm._v(" "),_c('div',{attrs:{"id":"not_subscribed"}},[_vm._v("\n      Payment Type : "+_vm._s(_vm.subscriptionType)),_c('br'),_vm._v("\n      Start Date : "+_vm._s(_vm.userDetails.displayedStartDate)),_c('br'),_c('br'),_vm._v(" "),_c('i',[_vm._v("Delivery Schedule :")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.deliveryFrequency),expression:"deliveryFrequency"}],attrs:{"type":"radio","id":"everyday","value":"3"},domProps:{"checked":_vm._q(_vm.deliveryFrequency,"3")},on:{"change":function($event){_vm.deliveryFrequency="3"}}}),_vm._v(" "),_c('label',{attrs:{"for":"everyday"}},[_vm._v("Everyday")]),_vm._v(" \n      "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.deliveryFrequency),expression:"deliveryFrequency"}],attrs:{"type":"radio","id":"alternate","value":"2"},domProps:{"checked":_vm._q(_vm.deliveryFrequency,"2")},on:{"change":function($event){_vm.deliveryFrequency="2"}}}),_vm._v(" "),_c('label',{attrs:{"for":"alternate"}},[_vm._v("Alternate")]),_c('br'),_c('br'),_vm._v(" "),_c('i',[_vm._v("Quantity :")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.quantity),expression:"quantity"}],attrs:{"type":"radio","id":"one","value":"1"},domProps:{"checked":_vm._q(_vm.quantity,"1")},on:{"change":function($event){_vm.quantity="1"}}}),_vm._v(" "),_c('label',{attrs:{"for":"one"}},[_vm._v("1 litre")]),_vm._v(" \n      "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.quantity),expression:"quantity"}],attrs:{"type":"radio","id":"two","value":"2"},domProps:{"checked":_vm._q(_vm.quantity,"2")},on:{"change":function($event){_vm.quantity="2"}}}),_vm._v(" "),_c('label',{attrs:{"for":"two"}},[_vm._v("2 litre")]),_vm._v(" \n      "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.quantity),expression:"quantity"}],attrs:{"type":"radio","id":"three","value":"3"},domProps:{"checked":_vm._q(_vm.quantity,"3")},on:{"change":function($event){_vm.quantity="3"}}}),_vm._v(" "),_c('label',{attrs:{"for":"three"}},[_vm._v("3 litre  ")]),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"w3-center"},[_c('form',[_c('input',{staticClass:"subs",attrs:{"value":"SUBSCRIBE NOW","type":"button"},on:{"click":function($event){_vm.subscribe();}}})])])]),_vm._v(" "),_c('div',{attrs:{"id":"subscribed"}},[_vm._v("\n      Successfully Subscribed. Your delivery will start from "+_vm._s(_vm.userDetails.displayedStartDate)),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":_vm.subscriptionObj.paymentUrl}},[_vm._v("Click")]),_vm._v(" to Pay"),_c('br'),_c('br')])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+KYZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__ = __webpack_require__("WEHx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_clickaway__);


/**
 * You can register global directives here and use them as a plugin in your main Vue instance
 */

var GlobalDirectives = {
  install: function install(Vue) {
    Vue.directive('click-outside', __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__["directive"]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (GlobalDirectives);

/***/ }),

/***/ "+P70":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+XOo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    LTable: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Table_vue__["a" /* default */],
    ChartCard: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */],
    StatsCard: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */]
  },
  data: function data() {
    return {
      urlInterface: [],
      apiDataObj: [],
      userDetails: [],
      disagreeResponse: [],
      successfully_feedback: false,
      isLoading: true,
      isFullPage: true,
      text1: '',
      text2: '',
      imageFormat: '',
      imageContent: ''
    };
  },
  created: function created() {
    this.fetchData();
  },

  methods: {
    fetchData: function fetchData() {
      var _this = this;

      var params = new URLSearchParams();
      var fullUrl = document.URL;
      var splitUrl = fullUrl.split('f1?');
      params.append('url_str', splitUrl[1]);
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/accounts/fetch-url-interface-data',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this.urlInterface = {};
        if (response.data.status === '000001' || response.data.status === '000002' || response.data.status === '000003') {
          _this.urlInterface.error_msg = response.data.msg;
          document.getElementById('url_valid').style.display = 'none';
          _this.isLoading = false;
        } else {
          document.getElementById('url_expired').style.display = 'none';
          _this.urlInterface.action_name = response.data.action_name;
          _this.urlInterface.url_interface_id = response.data.url_interface_id;
          _this.invokeUrlAction();
          _this.isLoading = false;
        }
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          _this.list = response.data.user_record;
          alert(_this.list);
        }
      }).catch(function (e) {
        alert('not ok');
      });
    },
    invokeUrlAction: function invokeUrlAction() {
      var _this2 = this;

      var params = new URLSearchParams();
      params.append('url_interface_id', this.urlInterface.url_interface_id);
      params.append('action_name', this.urlInterface.action_name);
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/accounts/invoke-url-action',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this2.apiDataObj = {};
        switch (_this2.urlInterface.action_name) {
          case 'all_not_taken_cust_loc_set_db_in_range':
          case 'not_open_cust_loc_set_db_in_range':
            _this2.apiDataObj.userId = response.data.action_response.user_id;
            _this2.apiDataObj.deliveryDate = response.data.action_response.delivery_date;
            _this2.apiDataObj.deliveryId = response.data.action_response.delivery_id;
            _this2.text1 = response.data.action_response.text1;
            _this2.text2 = response.data.action_response.text2;
            _this2.imageFormat = response.data.action_response.image_format;
            _this2.imageContent = response.data.action_response.image_content;
            _this2.userInfo();
            _this2.isLoading = false;
            break;
          default:
            break;
        }
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          _this2.list = response.data.user_record;
          alert(_this2.list);
        }
      }).catch(function (e) {
        alert('not ok');
      });
    },
    userInfo: function userInfo() {
      var _this3 = this;

      var params = new URLSearchParams();
      var userId = this.apiDataObj.userId;
      params.append('user_id', userId);
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/users/user-info',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this3.userDetails = {};
        _this3.userDetails.userId = userId;
        _this3.userDetails.first_name = response.data.user_record.user_details.first_name;
        _this3.userDetails.mobile = response.data.user_record.user.username;
        _this3.userDetails.address = response.data.user_record.address.address1 + ' ' + response.data.user_record.address.address2 + ' ' + response.data.user_record.address.city;
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          _this3.list = response.data.user_record;
          alert(_this3.list);
        }
      }).catch(function (e) {
        alert('not ok');
      });
    },
    locationModule: function locationModule() {
      // alert('location')
      sessionStorage.setItem('userId', this.userDetails.userId);
      sessionStorage.setItem('isProfile', 1);
      sessionStorage.setItem('actionName', 'subscription');
      sessionStorage.setItem('callbackUrlForSubscription', document.URL);
      sessionStorage.setItem('locationAction', 'getOldLocation');
      this.$router.push('/a/location');
    }
  }
});

/***/ }),

/***/ "+a+j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UserProfile_EditProfileForm_vue__ = __webpack_require__("nqbW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UserProfile_UserCard_vue__ = __webpack_require__("/IDP");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    EditProfileForm: __WEBPACK_IMPORTED_MODULE_0__UserProfile_EditProfileForm_vue__["a" /* default */],
    UserCard: __WEBPACK_IMPORTED_MODULE_1__UserProfile_UserCard_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "+l2j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import axios from 'axios'
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {},
  created: function created() {
    var fullUrl = document.URL;
    var splitUrl = fullUrl.split('r?');
    sessionStorage.setItem('urlstr', splitUrl[1]);
  },

  methods: {}
});

/***/ }),

/***/ "+zKw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Btn_vue__ = __webpack_require__("ioF4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_746d95a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Btn_vue__ = __webpack_require__("/Mjc");
function injectStyle (ssrContext) {
  __webpack_require__("+P70")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-746d95a4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Btn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_746d95a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Btn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/4dZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/8C+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Referral_vue__ = __webpack_require__("4kWO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80262c2a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Referral_vue__ = __webpack_require__("6+hp");
function injectStyle (ssrContext) {
  __webpack_require__("2cDc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Referral_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80262c2a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Referral_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/IDP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserCard_vue__ = __webpack_require__("hHDF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08d3df3e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserCard_vue__ = __webpack_require__("UvxC");
function injectStyle (ssrContext) {
  __webpack_require__("qq+n")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08d3df3e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/KV2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/Mjc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.btnColor},[_vm._t("default"),_vm._v(" "),(_vm.cartIcon)?_c('img',{attrs:{"src":__webpack_require__("KEEg"),"alt":"Cart Icon"}}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/Ngp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Td_vue__ = __webpack_require__("fSd6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4fa1e9a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Td_vue__ = __webpack_require__("aHm/");
function injectStyle (ssrContext) {
  __webpack_require__("BdUF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Td_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4fa1e9a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Td_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/P+Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      apiDataObj: {
        default_amount: ""
      },
      customCouponCode: "",
      invalidCouponMsg: "",
      codeLists: [],
      noCouponAvailable: false,
      loading: false
    };
  },
  mounted: function mounted() {
    this.customCouponCode = document.getElementById("coupon_code").value;
    this.getCouponList();
  },

  methods: {
    formattedDescription: function formattedDescription(description) {
      return description.replace(/(?<!^)- /g, " <br>- ");
    },
    getCouponList: function getCouponList() {
      var _this = this;

      this.loading = true;
      this.apiDataObj.default_amount = sessionStorage.getItem("rechargeAmount");
      var params = new URLSearchParams();
      params.append("user_id", sessionStorage.getItem("userId"));
      params.append("code_type", "wallet");
      params.append("recharge_amount", this.apiDataObj.default_amount);

      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + "/products/offers-code-list",
        method: "post",
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this.loading = false;
        if (response.data.status === "000000") {
          // console.log(response.data)
          _this.codeLists = response.data.code_list;
        }
      }).catch(function (error) {
        console.error(error);
        _this.loading = false;
      });
    },
    verifyPromoCode: function verifyPromoCode(couponCode) {
      var _this2 = this;

      // console.log(couponCode)
      sessionStorage.setItem("couponClicked", 1);
      var params = new URLSearchParams();

      params.append("user_id", sessionStorage.getItem("userId"));
      params.append("coupon_code", couponCode);
      params.append("recharge_amount", this.apiDataObj.default_amount);
      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + "/accounts/verify-wallet-coupon",
        method: "post",
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        // console.log(response.data)
        if (response.data.msg_type === "success") {
          sessionStorage.setItem("promoStr", couponCode);
          sessionStorage.setItem("verifyWalletResponse", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
          sessionStorage.setItem("showDialog", true);
          sessionStorage.setItem("promoCodeId", response.data.promo_code_id);
          sessionStorage.setItem("promoCodeStr", response.data.promo_code_str);

          window.location.href = "https://v.doodhvale.in" + "/a/p?" + sessionStorage.getItem("paymentUrl");

          //this.$router.go(-1);
        } else {
          sessionStorage.setItem("promoStr", "");
          _this2.invalidCouponMsg = "Invalid Coupon Code";
        }
      });
    }
  }
});

/***/ }),

/***/ "/rfY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('edit-profile-form')],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('user-card')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/yRs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__ = __webpack_require__("diQi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5549271b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__ = __webpack_require__("kwv9");
function injectStyle (ssrContext) {
  __webpack_require__("ekt6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5549271b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "0A70":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-loading',{attrs:{"is-full-page":_vm.isFullPage,"active":_vm.isLoading},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),(_vm.urlValid === false)?_c('div',[_c('h4',{attrs:{"align":"center"}},[_vm._v("Welcome to Doodhvale, Please wait...")])]):_vm._e(),_vm._v(" "),(_vm.urlValid === true)?_c('div',[_c('listOfProducts',{attrs:{"products":_vm.getFilteredProducts}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0AsC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileMenu_vue__ = __webpack_require__("MDnB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd45af2e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileMenu_vue__ = __webpack_require__("1igO");
function injectStyle (ssrContext) {
  __webpack_require__("xkpb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd45af2e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0FOK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "0QOX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0XqQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'stats-card',
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0__Card_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "0Zgk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0vN4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0wCC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1igO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav nav-mobile-menu"},[_c('drop-down',[_c('template',{slot:"title"},[_c('i',{staticClass:"fa fa-globe"}),_vm._v(" "),_c('b',{staticClass:"caret"}),_vm._v(" "),_c('span',{staticClass:"notification"},[_vm._v("5 Notifications")])]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Notification 1")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Notification 2")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Notification 3")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Notification 4")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Another notification")])],2),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('drop-down',{attrs:{"title":"Dropdown"}},[_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Action")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Another action")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Something")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Something else here")]),_vm._v(" "),_c('div',{staticClass:"divider"}),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Separated link")])]),_vm._v(" "),_vm._m(1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#"}},[_c('i',{staticClass:"nc-icon nc-zoom-split hidden-lg-up"}),_vm._v(" "),_c('span',{staticClass:"d-lg-none"},[_vm._v("Search")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#pablo"}},[_c('span',{staticClass:"no-icon"},[_vm._v("Log out")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1lSy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_UIComponents_Inputs_formGroupInput_vue__ = __webpack_require__("Ond/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_UIComponents_Dropdown_vue__ = __webpack_require__("ZQf1");



/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

var GlobalComponents = {
  install: function install(Vue) {
    Vue.component('fg-input', __WEBPACK_IMPORTED_MODULE_0__components_UIComponents_Inputs_formGroupInput_vue__["a" /* default */]);
    Vue.component('drop-down', __WEBPACK_IMPORTED_MODULE_1__components_UIComponents_Dropdown_vue__["a" /* default */]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (GlobalComponents);

/***/ }),

/***/ "2/wk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/page1.3235965.jpg";

/***/ }),

/***/ "27e6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "28ys":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_v_tooltip__ = __webpack_require__("VN6J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_notifyjs__ = __webpack_require__("1SRG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_notifyjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_notifyjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__globalComponents__ = __webpack_require__("1lSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__globalDirectives__ = __webpack_require__("+KYZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_UIComponents_SidebarPlugin__ = __webpack_require__("Crv8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css__ = __webpack_require__("Jmt5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_notifyjs_themes_default_scss__ = __webpack_require__("Sczw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_notifyjs_themes_default_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_notifyjs_themes_default_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_sass_light_bootstrap_dashboard_scss__ = __webpack_require__("/4dZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_sass_light_bootstrap_dashboard_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_sass_light_bootstrap_dashboard_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_css_demo_css__ = __webpack_require__("947H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_css_demo_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_css_demo_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_es6_promise_auto__ = __webpack_require__("MU8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_es6_promise_auto__);

// Notifications plugin

// A plugin file where you could register global components used across the app

// A plugin file where you could register global directives

// Sidebar on the right. Used as a local plugin in DashboardLayout.vue


// asset imports





// library auto imports


/**
 * This is the main Light Bootstrap Dashboard Vue plugin where dashboard related plugins are registerd.
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    Vue.use(__WEBPACK_IMPORTED_MODULE_2__globalComponents__["a" /* default */]);
    Vue.use(__WEBPACK_IMPORTED_MODULE_3__globalDirectives__["a" /* default */]);
    Vue.use(__WEBPACK_IMPORTED_MODULE_4__components_UIComponents_SidebarPlugin__["a" /* default */]);
    Vue.use(__WEBPACK_IMPORTED_MODULE_1_vue_notifyjs___default.a);
    Vue.use(__WEBPACK_IMPORTED_MODULE_0_v_tooltip__["a" /* default */]);
  }
});

/***/ }),

/***/ "2Y1d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2aTV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopNavbar_vue__ = __webpack_require__("zTLC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d031d852_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopNavbar_vue__ = __webpack_require__("Xi/V");
function injectStyle (ssrContext) {
  __webpack_require__("6zJ5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopNavbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d031d852_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopNavbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2cDc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3LUx":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "3Q3N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  inheritAttrs: false,
  inject: {
    autoClose: {
      default: true
    }
  },
  props: {
    link: {
      type: [String, Object],
      default: function _default() {
        return {
          name: '',
          path: '',
          icon: ''
        };
      }
    },
    tag: {
      type: String,
      default: 'router-link'
    }
  },
  methods: {
    hideSidebar: function hideSidebar() {
      if (this.autoClose && this.$sidebar && this.$sidebar.showSidebar === true) {
        this.$sidebar.displaySidebar(false);
      }
    }
  }
});

/***/ }),

/***/ "3bSs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    LTable: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Table_vue__["a" /* default */],
    ChartCard: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */],
    StatsCard: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */]
  },
  data: function data() {
    return {
      selected: 1,
      urlInterface: [],
      apiDataObj: [],
      userDetails: [],
      subscriptionObj: [],
      successfully_unsubscribe: false,
      unsettled: true,
      items: null
    };
  },
  created: function created() {
    this.fetchData();
  },

  methods: {
    fetchData: function fetchData() {
      var _this = this;

      var params = new URLSearchParams();
      var fullUrl = document.URL;
      var splitUrl = fullUrl.split('u?');
      params.append('url_str', splitUrl[1]);
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/accounts/fetch-url-interface-data',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this.urlInterface = {};
        if (response.data.status === '000001' || response.data.status === '000002' || response.data.status === '000003') {
          _this.urlInterface.error_msg = response.data.msg;
          document.getElementById('url_valid').style.display = 'none';
        } else {
          document.getElementById('url_expired').style.display = 'none';
          _this.urlInterface.action_name = response.data.action_name;
          _this.urlInterface.url_interface_id = response.data.url_interface_id;
          _this.invokeUrlAction();
        }
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          _this.list = response.data.user_record;
          alert(_this.list);
        }
      }).catch(function (e) {
        alert('not ok');
      });
    },
    invokeUrlAction: function invokeUrlAction() {
      var _this2 = this;

      var params = new URLSearchParams();
      params.append('url_interface_id', this.urlInterface.url_interface_id);
      params.append('action_name', this.urlInterface.action_name);
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/accounts/invoke-url-action',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this2.apiDataObj = {};
        switch (_this2.urlInterface.action_name) {
          case 'unsubscribe_product':
            _this2.apiDataObj.userId = response.data.action_response.user_id;
            _this2.apiDataObj.subscriptionIdArr = response.data.action_response.subscription_id_arr;
            _this2.items = response.data.action_response.prod_name_arr;
            if (response.data.action_response.status === '000001') {
              document.getElementById('not_unsubscribe').style.display = 'none';
              document.getElementById('unsub').style.display = 'none';
              document.getElementById('unsettled').style.display = 'none';
              document.getElementById('unsettled_noempty').style.display = 'none';
              document.getElementById('unsubscribe').style.display = 'block';
              _this2.apiDataObj.msg = response.data.action_response.msg;
            } else {
              document.getElementById('unsubscribe').style.display = 'none';
              document.getElementById('unsub').style.display = 'none';
              document.getElementById('unsettled').style.display = 'none';
              document.getElementById('unsettled_noempty').style.display = 'none';
              document.getElementById('not_unsubscribe').style.display = 'block';
              _this2.apiDataObj.reasonList = response.data.action_response.reason_list;
              _this2.apiDataObj.productId = response.data.action_response.product_id;
              _this2.apiDataObj.msg = response.data.action_response.msg;
            }
            _this2.userInfo();
            break;
          default:
            break;
        }
        console.log(response);
        if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          _this2.list = response.data.user_record;
          alert(_this2.list);
        }
      }).catch(function (e) {
        alert('not ok');
      });
    },
    userInfo: function userInfo() {
      var _this3 = this;

      var params = new URLSearchParams();
      var userId = this.apiDataObj.userId;
      params.append('user_id', userId);
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/users/user-info',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this3.userDetails = {};
        _this3.userDetails.userId = userId;
        _this3.userDetails.first_name = response.data.user_record.user_details.first_name;
        _this3.userDetails.mobile = response.data.user_record.user.username;
        _this3.userDetails.address = response.data.user_record.address.address1 + ' ' + response.data.user_record.address.address2 + ' ' + response.data.user_record.address.city;
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          _this3.list = response.data.user_record;
          alert(_this3.list);
        }
      }).catch(function (e) {
        alert('not ok');
      });
    },
    unsubscribe: function unsubscribe() {
      var _this4 = this;

      // alert(this.selected)
      var params = new URLSearchParams();
      params.append('subscription_id', this.apiDataObj.subscriptionIdArr);
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/subscriptions/unsubscribe',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this4.subscriptionObj = {};
        if (response.data.status === '000000') {
          console.log(response);
          _this4.successfully_unsubscribe = true;
          if (response.data.pending_amount > 0) {
            document.getElementById('unsub').style.display = 'none';
            document.getElementById('unsubscribe').style.display = 'none';
            document.getElementById('not_unsubscribe').style.display = 'none';
            if (response.data.pending_empty_bottle <= 0) {
              document.getElementById('unsettled').style.display = 'none';
              document.getElementById('unsettled_noempty').style.display = 'block';
            } else {
              document.getElementById('unsettled').style.display = 'block';
              document.getElementById('unsettled_noempty').style.display = 'none';
            }
            _this4.subscriptionObj.pendingAmount = response.data.pending_amount;
            _this4.subscriptionObj.emptyBottles = response.data.pending_empty_bottle;
            _this4.subscriptionObj.paymentUrl = response.data.payment_url;
          } else {
            document.getElementById('unsubscribe').style.display = 'none';
            document.getElementById('not_unsubscribe').style.display = 'none';
            // document.getElementById('unsettled').style.display = 'none'
            _this4.unsettled = false;
            document.getElementById('unsettled_noempty').style.display = 'none';
            document.getElementById('unsub').style.display = 'block';
          }
          _this4.submitFeedback();
        } else {
          alert(response.data.msg);
        }
        if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          _this4.list = response.data.user_record;
          alert(_this4.list);
        }
      }).catch(function (e) {
        alert('not ok');
      });
    },
    submitFeedback: function submitFeedback() {
      var _this5 = this;

      var params = new URLSearchParams();
      params.append('user_id', this.apiDataObj.userId);
      params.append('product_id', this.apiDataObj.productId);
      params.append('sub_id', this.apiDataObj.subscriptionId);
      params.append('feedback', this.selected);
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/subscriptions/submit-feedback',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        // this.successfully_unsubscribe = true
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          _this5.list = response.data.user_record;
          alert(_this5.list);
        }
      }).catch(function (e) {
        alert('not ok');
      });
    }
  }
});

/***/ }),

/***/ "3fGJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Bill_vue__ = __webpack_require__("gwCQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7107ece3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Bill_vue__ = __webpack_require__("PlqC");
function injectStyle (ssrContext) {
  __webpack_require__("SkI9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Bill_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7107ece3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Bill_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "46ef":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "49Z0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background":"white"},attrs:{"id":"editSub"}},[_c('b-loading',{attrs:{"is-full-page":_vm.isFullPage,"active":_vm.isLoading},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"width":"100%"}},[_c('div',{staticStyle:{"width":"30%","float":"left"}},[_c('img',{staticClass:"productImageOnEditSubscription",attrs:{"src":_vm.productImageUrl,"alt":""}})]),_vm._v(" "),_c('div',{staticStyle:{"width":"65%","float":"right","margin-top":"30px"}},[_c('div',{staticStyle:{"margin-right":"7px"}},[_c('b',[_vm._v(_vm._s(_vm.productName))]),_c('br'),_vm._v(" "),_c('i',{staticStyle:{"color":"gray","font-size":"13px"}},[_vm._v(_vm._s(_vm.productShortDescription))]),_c('br')])])]),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}}),_vm._v(" "),_c('div',{staticClass:"leftMargin topMarginHalf"},[_c('div',{staticStyle:{"width":"30%","float":"left"}},[_vm._v("Produced By")]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","float":"left"}},[_vm._v(": "+_vm._s(_vm.brandName))]),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}})]),_vm._v(" "),(_vm.isPostpaidDisabled === true)?_c('div',{staticClass:"leftMargin topMarginHalf"},[_c('div',{staticStyle:{"width":"30%","float":"left"}},[_vm._v("Price")]),_vm._v(" "),_c('div',{staticStyle:{"width":"70%","float":"left"}},[_vm._v("\n      :\n      "),(_vm.cutPrice === false)?_c('span',{staticStyle:{"font-size":"1rem"}},[_c('i',{staticClass:"fa fa-rupee"}),_vm._v(_vm._s(_vm.prepaidProductPriceObj.prepaidPrice)+"/"+_vm._s(_vm.prepaidProductPriceObj.prodQuantity)+"\n        "+_vm._s(_vm.prepaidProductPriceObj.prodUnit)+"\n      ")]):(_vm.promoCodeVerified === true)?_c('span',{staticStyle:{"font-size":"1rem"}},[_c('span',{staticStyle:{"text-decoration":"line-through","color":"red"}},[_c('i',{staticClass:"fa fa-rupee"}),_vm._v(_vm._s(_vm.prepaidProductPriceObj.prepaidPrice))]),_c('span',[_c('i',{staticClass:"fa fa-rupee"}),_vm._v(_vm._s((
              _vm.prepaidProductPriceObj.prepaidPrice - _vm.directLinkOfferedDiscount
            ).toFixed(2)))]),_vm._v("/"+_vm._s(_vm.prepaidProductPriceObj.prodQuantity)+"\n        "+_vm._s(_vm.prepaidProductPriceObj.prodUnit)+"\n      ")]):_c('span',{staticStyle:{"font-size":"1rem"}},[_c('span',{staticStyle:{"font-size":"13px","text-decoration":"line-through","color":"red"}},[_c('i',{staticClass:"fa fa-rupee"}),_vm._v(_vm._s(_vm.prepaidProductPriceObj.prepaid_price_without_offer)+"/"+_vm._s(_vm.prepaidProductPriceObj.prodQuantity)+"\n          "+_vm._s(_vm.prepaidProductPriceObj.prodUnit))]),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"13px"}},[_c('i',{staticClass:"fa fa-rupee"}),_vm._v(_vm._s(_vm.prepaidProductPriceObj.prepaidPrice)+"/"+_vm._s(_vm.prepaidProductPriceObj.prodQuantity)+"\n          "+_vm._s(_vm.prepaidProductPriceObj.prodUnit))])])]),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}})]):_c('div',{staticClass:"leftMargin topMarginHalf"},[_c('div',[_vm._v("Choose Payment Plan")]),_vm._v(" "),_c('div',{staticClass:"topMarginHalf columns is-mobile"},[_c('div',{staticClass:"column is-7"},[_c('b-checkbox',{attrs:{"id":"postpaidB","type":"","disabled":""},nativeOn:{"click":function($event){return _vm.paymentMode($event)}},model:{value:(_vm.postpaidCheckbox),callback:function ($$v) {_vm.postpaidCheckbox=$$v},expression:"postpaidCheckbox"}},[_vm._v("\n          Postpaid\n        ")]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.cutPrice === false)?_c('span',{staticStyle:{"font-size":"13px"}},[_c('i',{staticClass:"fa fa-rupee"}),_vm._v(_vm._s(_vm.prepaidProductPriceObj.postpaidPrice)+"/"+_vm._s(_vm.prepaidProductPriceObj.prodQuantity)+"\n          "+_vm._s(_vm.prepaidProductPriceObj.prodUnit))]):(_vm.promoCodeVerified === true)?_c('span',[_c('span',{staticStyle:{"font-size":"13px","text-decoration":"line-through","color":"red"}},[_c('i',{staticClass:"fa fa-rupee"}),_vm._v(_vm._s(_vm.prepaidProductPriceObj.postpaidPrice)+"/"+_vm._s(_vm.prepaidProductPriceObj.prodQuantity)+"\n            "+_vm._s(_vm.prepaidProductPriceObj.prodUnit))]),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"13px"}},[_c('i',{staticClass:"fa fa-rupee"}),_vm._v(_vm._s((
                _vm.prepaidProductPriceObj.postpaidPrice -
                _vm.directLinkOfferedDiscount
              ).toFixed(2))+"/"+_vm._s(_vm.prepaidProductPriceObj.prodQuantity)+"\n            "+_vm._s(_vm.prepaidProductPriceObj.prodUnit))])]):_c('span',[_c('span',{staticStyle:{"font-size":"13px","text-decoration":"line-through","color":"red"}},[_c('i',{staticClass:"fa fa-rupee"}),_vm._v(_vm._s(_vm.prepaidProductPriceObj.postpaid_price_without_offer)+"/"+_vm._s(_vm.prepaidProductPriceObj.prodQuantity)+"\n            "+_vm._s(_vm.prepaidProductPriceObj.prodUnit))]),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"13px"}},[_c('i',{staticClass:"fa fa-rupee"}),_vm._v(_vm._s(_vm.prepaidProductPriceObj.postpaidPrice)+"/"+_vm._s(_vm.prepaidProductPriceObj.prodQuantity)+"\n            "+_vm._s(_vm.prepaidProductPriceObj.prodUnit))])])],1),_vm._v(" "),_c('div',{staticClass:"column is-5"},[_c('b-checkbox',{attrs:{"id":"prepaidB","type":"","disabled":""},nativeOn:{"click":function($event){return _vm.paymentMode($event)}},model:{value:(_vm.prepaidCheckbox),callback:function ($$v) {_vm.prepaidCheckbox=$$v},expression:"prepaidCheckbox"}},[_vm._v("\n          Prepaid ")]),_c('br'),_vm._v(" "),(_vm.cutPrice === false)?_c('span',{staticStyle:{"font-size":"13px"}},[_c('i',{staticClass:"fa fa-rupee"}),_vm._v(_vm._s(_vm.prepaidProductPriceObj.prepaidPrice)+"/"+_vm._s(_vm.prepaidProductPriceObj.prodQuantity)+"\n          "+_vm._s(_vm.prepaidProductPriceObj.prodUnit))]):(_vm.promoCodeVerified === true)?_c('span',[_c('span',{staticStyle:{"font-size":"13px","text-decoration":"line-through","color":"red"}},[_c('i',{staticClass:"fa fa-rupee"}),_vm._v(_vm._s(_vm.prepaidProductPriceObj.prepaidPrice)+"/"+_vm._s(_vm.prepaidProductPriceObj.prodQuantity)+"\n            "+_vm._s(_vm.prepaidProductPriceObj.prodUnit))]),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"13px"}},[_c('i',{staticClass:"fa fa-rupee"}),_vm._v(_vm._s((
                _vm.prepaidProductPriceObj.prepaidPrice -
                _vm.directLinkOfferedDiscount
              ).toFixed(2))+"/"+_vm._s(_vm.prepaidProductPriceObj.prodQuantity)+"\n            "+_vm._s(_vm.prepaidProductPriceObj.prodUnit))])]):_c('span',[_c('span',{staticStyle:{"font-size":"13px","text-decoration":"line-through","color":"red"}},[_c('i',{staticClass:"fa fa-rupee"}),_vm._v(_vm._s(_vm.prepaidProductPriceObj.prepaid_price_without_offer)+"/"+_vm._s(_vm.prepaidProductPriceObj.prodQuantity)+"\n            "+_vm._s(_vm.prepaidProductPriceObj.prodUnit))]),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"13px"}},[_c('i',{staticClass:"fa fa-rupee"}),_vm._v(_vm._s(_vm.prepaidProductPriceObj.prepaidPrice)+"/"+_vm._s(_vm.prepaidProductPriceObj.prodQuantity)+"\n            "+_vm._s(_vm.prepaidProductPriceObj.prodUnit))])])],1)])]),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}}),_vm._v(" "),(_vm.subscriptionTypeOneTime === false)?_c('div',{staticClass:"leftMargin"},[_c('span',{staticStyle:{"font-size":"12px","color":"gray"}},[_vm._v(_vm._s(_vm.displayPromocodeText))]),_vm._v(" "),_c('hr',{staticClass:"topMargin",staticStyle:{"width":"90%"}})]):_vm._e(),_vm._v(" "),(_vm.subscriptionTypeDaily === true)?_c('div',{staticClass:"leftMargin"},[_c('div',[_vm._v("Choose Delivery Schedule")]),_vm._v(" "),_c('div',{staticClass:"topMarginHalf columns is-mobile"},[_c('div',{staticClass:"column is-7"},[_c('b-checkbox',{attrs:{"id":"everydayid","type":"","disabled":""},nativeOn:{"click":function($event){return _vm.schedulePlan($event)}},model:{value:(_vm.everydayCheckbox),callback:function ($$v) {_vm.everydayCheckbox=$$v},expression:"everydayCheckbox"}},[_vm._v("\n          Everyday\n        ")])],1),_vm._v(" "),(
          _vm.isEditSubscription === false &&
          (_vm.productId == 128 || _vm.productId == 129 || _vm.productId == 151)
        )?_c('div',{staticClass:"column is-5"}):_c('div',{staticClass:"column is-5"},[_c('b-checkbox',{attrs:{"id":"customizeid","type":"","disabled":""},nativeOn:{"click":function($event){return _vm.schedulePlan($event)}},model:{value:(_vm.customizeCheckbox),callback:function ($$v) {_vm.customizeCheckbox=$$v},expression:"customizeCheckbox"}},[_vm._v("\n          Customize\n        ")])],1)]),_vm._v(" "),_c('div',{staticClass:"columns is-mobile"},[_c('div',{staticClass:"column is-7"},[_c('b-checkbox',{attrs:{"id":"alternateid","type":"","disabled":""},nativeOn:{"click":function($event){return _vm.schedulePlan($event)}},model:{value:(_vm.alternateCheckbox),callback:function ($$v) {_vm.alternateCheckbox=$$v},expression:"alternateCheckbox"}},[_vm._v("\n          Alternate\n        ")])],1)])]):_vm._e(),_vm._v(" "),(_vm.subscriptionTypeBoth === true)?_c('div',{staticClass:"leftMargin"},[_c('div',[_vm._v("Choose Delivery Schedule")]),_vm._v(" "),_c('div',{staticClass:"topMarginHalf columns is-mobile"},[_c('div',{staticClass:"column is-7"},[_c('b-checkbox',{attrs:{"id":"everydayid","type":"","disabled":""},nativeOn:{"click":function($event){return _vm.schedulePlan($event)}},model:{value:(_vm.everydayCheckbox),callback:function ($$v) {_vm.everydayCheckbox=$$v},expression:"everydayCheckbox"}},[_vm._v("\n          Everyday\n        ")])],1),_vm._v(" "),(
          _vm.isEditSubscription === false &&
          (_vm.productId == 128 || _vm.productId == 129 || _vm.productId == 151)
        )?_c('div',{staticClass:"column is-5"}):_c('div',{staticClass:"column is-5"},[_c('b-checkbox',{attrs:{"id":"customizeid","type":"","disabled":""},nativeOn:{"click":function($event){return _vm.schedulePlan($event)}},model:{value:(_vm.customizeCheckbox),callback:function ($$v) {_vm.customizeCheckbox=$$v},expression:"customizeCheckbox"}},[_vm._v("\n          Customize\n        ")])],1)]),_vm._v(" "),_c('div',{staticClass:"columns is-mobile"},[_c('div',{staticClass:"column is-7"},[_c('b-checkbox',{attrs:{"id":"alternateid","type":"","disabled":""},nativeOn:{"click":function($event){return _vm.schedulePlan($event)}},model:{value:(_vm.alternateCheckbox),callback:function ($$v) {_vm.alternateCheckbox=$$v},expression:"alternateCheckbox"}},[_vm._v("\n          Alternate\n        ")])],1)])]):_vm._e(),_vm._v(" "),(_vm.subscriptionTypeOneTime === true)?_c('div',{staticClass:"leftMargin bottomMargin"},[_c('span',{staticStyle:{"font-size":"12px","color":"gray"}},[_vm._v(_vm._s(_vm.displayPromocodeText))]),_vm._v(" "),_c('div',{staticClass:"topMarginHalf",staticStyle:{"width":"30%","float":"left"}},[_vm._v("\n      Delivered On\n    ")]),_vm._v(" "),_c('div',{staticClass:"topMarginHalf",staticStyle:{"width":"70%","float":"left"}},[_vm._v("\n      :\n      "),(_vm.isEditSubscription === false)?_c('date-pick',{attrs:{"inputAttributes":{
          style: {
            border: '0',
            'border-bottom': '1px solid',
            color: 'blue',
            'text-align': 'center',
            'margin-left': '5%',
            width: '70%',
          },
        },"displayFormat":'DD-MM-YYYY',"isDateDisabled":_vm.isPastDate},model:{value:(_vm.subDate),callback:function ($$v) {_vm.subDate=$$v},expression:"subDate"}}):_c('span',{staticStyle:{"text-align":"center","color":"gray","margin-left":"5%","width":"50%"}},[_vm._v(_vm._s(_vm.displayedDate))])],1),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}})]):_c('div',{staticClass:"leftMargin topMarginHalf",staticStyle:{"font-size":"16px"}},[_vm._v("\n    Starting On :\n    "),_vm._v(" "),(_vm.isEditSubscription === false)?_c('date-pick',{attrs:{"inputAttributes":{
        style: {
          border: '0',
          'border-bottom': '1px solid',
          color: 'blue',
          'text-align': 'center',
          'margin-left': '5%',
          width: '70%',
          'font-size': '14px',
        },
      },"displayFormat":'DD-MM-YYYY',"isDateDisabled":_vm.isPastDate},model:{value:(_vm.subDate),callback:function ($$v) {_vm.subDate=$$v},expression:"subDate"}}):_c('span',{staticStyle:{"text-align":"left","color":"gray","margin-left":"5%","width":"50%"}},[_vm._v(_vm._s(_vm.displayedDate))]),_vm._v(" "),(_vm.alternateDisplay === true)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedAlternate),expression:"selectedAlternate"}],staticStyle:{"float":"right","border":"0px","color":"blue","background":"white","margin-right":"10%"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedAlternate=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.alternateOptions),function(option){return _c('option',{domProps:{"value":option.value}},[_vm._v("\n        "+_vm._s(option.text)+"\n      ")])})):_vm._e(),_vm._v(" "),(_vm.customizeDisplay === true)?_c('div',{staticClass:"topMargin"},[_c('div',{staticStyle:{"width":"100%"}},[(_vm.fillSunColor === true)?_c('div',{staticClass:"customizedays"},[_c('div',{staticStyle:{"width":"58%","background":"#3cb6c3","border-radius":"50%","color":"white"},attrs:{"id":"sun"},on:{"click":function($event){_vm.customizeDivColor($event)}}},[_vm._v("\n            S\n          ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"58%"}},[_vm._v(_vm._s(_vm.sunQty))])]):_c('div',{staticClass:"customizedays"},[_c('div',{staticClass:"customizedaycss",attrs:{"id":"sun"},on:{"click":function($event){_vm.customizeDivColor($event)}}},[_vm._v("\n            S\n          ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"58%"}},[_vm._v(_vm._s(_vm.sunQty))])]),_vm._v(" "),_c('div',{staticClass:"customizedays"},[_c('div',{staticClass:"customizedaycss",attrs:{"id":"mon"},on:{"click":function($event){_vm.customizeDivColor($event)}}},[_vm._v("\n            M\n          ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"58%"}},[_vm._v(_vm._s(_vm.monQty))])]),_vm._v(" "),_c('div',{staticClass:"customizedays"},[_c('div',{staticClass:"customizedaycss",attrs:{"id":"tue"},on:{"click":function($event){_vm.customizeDivColor($event)}}},[_vm._v("\n            T\n          ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"58%"}},[_vm._v(_vm._s(_vm.tueQty))])]),_vm._v(" "),_c('div',{staticClass:"customizedays"},[_c('div',{staticClass:"customizedaycss",attrs:{"id":"wed"},on:{"click":function($event){_vm.customizeDivColor($event)}}},[_vm._v("\n            W\n          ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"58%"}},[_vm._v(_vm._s(_vm.wedQty))])]),_vm._v(" "),_c('div',{staticClass:"customizedays"},[_c('div',{staticClass:"customizedaycss",attrs:{"id":"thu"},on:{"click":function($event){_vm.customizeDivColor($event)}}},[_vm._v("\n            T\n          ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"58%"}},[_vm._v(_vm._s(_vm.thuQty))])]),_vm._v(" "),_c('div',{staticClass:"customizedays"},[_c('div',{staticClass:"customizedaycss",attrs:{"id":"fri"},on:{"click":function($event){_vm.customizeDivColor($event)}}},[_vm._v("\n            F\n          ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"58%"}},[_vm._v(_vm._s(_vm.friQty))])]),_vm._v(" "),_c('div',{staticClass:"customizedays"},[_c('div',{staticClass:"customizedaycss",attrs:{"id":"sat"},on:{"click":function($event){_vm.customizeDivColor($event)}}},[_vm._v("\n            S\n          ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"58%"}},[_vm._v(_vm._s(_vm.satQty))])]),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}})])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"topMargin",staticStyle:{"text-align":"center"}},[(_vm.customizeDisplay === true)?_c('vue-numeric-input',{staticClass:"plusMinus",attrs:{"size":"90px","align":"center","min":0,"max":_vm.maxQuantity,"step":1},on:{"change":_vm.changeQuantity},model:{value:(_vm.quantityValue),callback:function ($$v) {_vm.quantityValue=$$v},expression:"quantityValue"}}):(
        _vm.isEditSubscription === false &&
        (_vm.productId == 128 || _vm.productId == 129 || _vm.productId == 151)
      )?_c('vue-numeric-input',{staticClass:"plusMinus",attrs:{"size":"90px","align":"center","min":2,"max":_vm.maxQuantity,"step":1},on:{"change":_vm.changeQuantity},model:{value:(_vm.quantityValue),callback:function ($$v) {_vm.quantityValue=$$v},expression:"quantityValue"}}):_c('vue-numeric-input',{staticClass:"plusMinus",attrs:{"size":"90px","align":"center","min":1,"max":_vm.maxQuantity,"step":1},on:{"change":_vm.changeQuantity},model:{value:(_vm.quantityValue),callback:function ($$v) {_vm.quantityValue=$$v},expression:"quantityValue"}}),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","font-size":"12px","margin-top":"0.2rem"}},[_vm._v("\n      Add Quantity\n    ")])],1),_vm._v(" "),_c('hr',{staticClass:"leftMargin topMargin",staticStyle:{"width":"90%"}}),_vm._v(" "),(_vm.promoCodeVerifiedDirectLink === false)?_c('div',{attrs:{"align":"center"}},[(_vm.closePromo === true)?_c('div',{staticClass:"topMargin",staticStyle:{"text-align":"center"},attrs:{"id":"closePromocode"},on:{"click":function($event){_vm.promocode($event)}}},[_c('u',{staticStyle:{"color":"blue"},attrs:{"id":"closePromocode1"},on:{"click":function($event){_vm.promocode($event)}}},[_vm._v("Apply Promocode")])]):_c('div',{staticClass:"row",staticStyle:{"width":"100%"},attrs:{"id":"row1 col-md-6"}},[_c('div',{staticClass:"col-md-3"}),_vm._v(" "),_c('div',{staticClass:"col-md-6",attrs:{"id":"md6","align":"center"}},[(_vm.promoCodeVerified === false)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.promocodeText),expression:"promocodeText"}],staticClass:"placedPromocode",staticStyle:{"text-align":"left","border":"none","width":"48%","line-height":"1.8rem","border-bottom":"1px solid #3cb6c3"},attrs:{"placeholder":"Enter Promocode"},domProps:{"value":(_vm.promocodeText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.promocodeText=$event.target.value}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.promocodeText),expression:"promocodeText"}],staticStyle:{"text-align":"center","border":"1px solid gray"},attrs:{"placeholder":"","readonly":"true"},domProps:{"value":(_vm.promocodeText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.promocodeText=$event.target.value}}}),_c('i',{staticClass:"mat-raised-button btn btn-info btn-md buttonOnEditSubscription mobile-view",staticStyle:{"color":"white","margin-left":"5px","margin-right":"5px","line-height":"1.8rem","font-weight":"bold","font-style":"normal","width":"65px"},on:{"click":function($event){_vm.checkPromoValid()}}},[_vm._v("Apply")]),_vm._v(" "),_c('i',{staticClass:"mat-raised-button btn btn-info btn-md buttonOnEditSubscription mobile-view",staticStyle:{"color":"white","line-height":"1.8rem","font-weight":"bold","font-style":"normal","width":"65px"},attrs:{"id":"openPromocode"},on:{"click":function($event){_vm.promocode($event)}}},[_vm._v("Cancel")]),_c('br'),_vm._v(" "),(_vm.promoCodeSuccess === true)?_c('div',{},[_c('img',{staticClass:"topMarginHalf promoSuccessFailClass",attrs:{"src":__webpack_require__("TJTB")}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"topMarginHalf",staticStyle:{"color":"#3cb6c3","font-size":"10px"}},[_vm._v(_vm._s(_vm.promoCodeVerifyMsg))])]):_vm._e(),_vm._v(" "),(_vm.promoCodeFailed === true)?_c('div',{},[_c('img',{staticClass:"topMarginHalf promoSuccessFailClass",attrs:{"src":__webpack_require__("3LUx")}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"topMarginHalf",staticStyle:{"color":"#3cb6c3","font-size":"10px"}},[_vm._v(_vm._s(_vm.promoCodeVerifyMsg))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-3"})])]):_vm._e(),_vm._v(" "),(_vm.closeNiceTohave === true)?_c('div',{staticClass:"topMargin",staticStyle:{"text-align":"center"},attrs:{"id":"closeNiceToHaveRequest"},on:{"click":function($event){_vm.nicetohavereq($event)}}},[_c('i',{staticStyle:{"color":"blue"},attrs:{"id":"closeNiceToHaveRequest1"},on:{"click":function($event){_vm.nicetohavereq($event)}}},[_vm._v("+ Add nice to have request")])]):_c('div',{staticClass:"topMargin",staticStyle:{"text-align":"center"}},[_c('i',{staticStyle:{"color":"blue"},attrs:{"id":"openNiceToHaveRequest"},on:{"click":function($event){_vm.nicetohavereq($event)}}},[_vm._v("- Add nice to have request")]),_vm._v(" "),_c('div',{staticClass:"topMargin leftMargin"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nicetohavereqText),expression:"nicetohavereqText"}],staticStyle:{"text-align":"left","border":"1px solid gray","width":"74%"},attrs:{"placeholder":""},domProps:{"value":(_vm.nicetohavereqText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nicetohavereqText=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"topMargin leftMargin",staticStyle:{"text-align":"center"}},[_c('div',[_vm._v("Ring the bell or Not?")]),_vm._v(" "),_c('div',{staticStyle:{"width":"49.35%","float":"left"}},[(_vm.ringOnNotSelected === true)?_c('div',{staticStyle:{"float":"right"},attrs:{"id":"ring_on_not_selected"},on:{"click":function($event){_vm.bellStatusChange($event)}}},[_c('img',{staticStyle:{"width":"37%"},attrs:{"id":"ring_on_not_selected","src":__webpack_require__("XH6a")},on:{"click":function($event){_vm.bellStatusChange($event)}}})]):_vm._e(),_vm._v(" "),(_vm.ringOnSelected === true)?_c('div',{staticStyle:{"float":"right"},attrs:{"id":"ring_on_selected"},on:{"click":function($event){_vm.bellStatusChange($event)}}},[_c('img',{staticStyle:{"width":"37%"},attrs:{"id":"ring_on_selected","src":__webpack_require__("j6QX")},on:{"click":function($event){_vm.bellStatusChange($event)}}})]):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"width":"0.3%","float":"left","background":"gray","height":"40px"}}),_vm._v(" "),_c('div',{staticStyle:{"width":"49.35%","float":"right"}},[(_vm.ringOffNotSelected === true)?_c('div',{staticStyle:{"float":"left"},attrs:{"id":"ring_off_not_selected"},on:{"click":function($event){_vm.bellStatusChange($event)}}},[_c('img',{staticStyle:{"width":"37%"},attrs:{"id":"ring_off_not_selected","src":__webpack_require__("PhT9")},on:{"click":function($event){_vm.bellStatusChange($event)}}})]):_vm._e(),_vm._v(" "),(_vm.ringOffSelected === true)?_c('div',{staticStyle:{"float":"left"},attrs:{"id":"ring_off_selected"},on:{"click":function($event){_vm.bellStatusChange($event)}}},[_c('img',{staticStyle:{"width":"37%"},attrs:{"id":"ring_off_selected","src":__webpack_require__("6K2C")},on:{"click":function($event){_vm.bellStatusChange($event)}}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"bottomMargin",staticStyle:{"clear":"both"}})]),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}}),_vm._v(" "),_c('div',{staticStyle:{"bottom":"0","position":"sticky"}},[_c('div',{staticStyle:{"height":"10px","background-color":"white"}}),_vm._v(" "),_c('div',[_c('input',{staticClass:"buttonOnEditSubscription",attrs:{"value":"CONTINUE","type":"button"},on:{"click":function($event){_vm.isServicePincode()}}})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4DuJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.value}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4gSg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4hQa":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/currentlocation.8527fb6.png";

/***/ }),

/***/ "4kWO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

// import axios from 'axios'
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {},
  created: function created() {},

  methods: {}
});

/***/ }),

/***/ "5Aj9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w3-content",staticStyle:{"max-width":"90%"}},[_c('h2',{staticStyle:{"text-align":"center"}},[_vm._v("Privacy Policy")]),_vm._v(" "),_c('br'),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("Personal Information")]),_c('br'),_c('br'),_vm._v("\n\nSanjeeevani Dairy Farms Pvt. Ltd. is the licensed owner of the brand doodhvale.com and the website doodhvale.com & sanjeevanidairyfarms.com (”The Site”). SDFL respects your privacy. This Privacy Policy provides concisely the manner your data is collected and used by SDFL on the Site. As a visitor to the Site Customer you are advised to please read the Privacy Policy carefully. By accessing the services provided by the Site you agree to the collection and use of your data by SDFL in the manner provided in this Privacy Policy.\n\n \n\n"),_c('br'),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("What information is, or may be, collected from you?")]),_c('br'),_c('br'),_vm._v("\n\nAs part of the registration process on the Site, SDFL may collect the following personally identifiable information about you: Name including first and last name, alternate email address, mobile phone number and contact details, Postal code, Demographic profile (like your age, gender, occupation, education, address etc.) and information about the pages on the Site you visit/access, the links you click on the Site, the number of times you access the page and any such browsing information.\n\n \n\n"),_c('br'),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("How do we Collect the Information?")]),_c('br'),_c('br'),_vm._v("\n\nSDFL will collect personally identifiable information about you only as part of a voluntary registration process, on-line survey or any combination thereof. The Site may contain links to other Web sites. SDFL is not responsible for the privacy practices of such Web sites which it does not own, manage or control. The Site and third-party vendors, including Google, use first-party cookies (such as the Google Analytics cookie) and third-party cookies (such as the Double-click cookie) together to inform, optimize, and serve ads based on someone’s past visits to the Site.\n\n \n\n"),_c('br'),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("How is information used?")]),_c('br'),_c('br'),_vm._v("\n\nSDFL will use your personal information to provide personalized features to you on the Site and to provide for promotional offers to you through the Site and other channels. SDFL will also provide this information to its business associates and partners to get in touch with you when necessary to provide the services requested by you. SDFL will use this information to preserve transaction history as governed by existing law or policy. SDFL may also use contact information internally to direct its efforts for product improvement, to contact you as a survey respondent, to notify you if you win any contest; and to send you promotional materials from its contest sponsors or advertisers. SDFL will also use this information to serve various promotional and advertising materials to you via display advertisements through the Google Ad network on third party websites. You can opt out of Google Analytics for Display Advertising and customize Google Display network ads using the Ads Preferences Manager. Information about Customers on an aggregate (excluding any information that may identify you specifically) covering Customer transaction data and Customer demographic and location data may be provided to partners of SDFL for the purpose of creating additional features on the website, creating appropriate merchandising or creating new products and services and conducting marketing research and statistical analysis of customer behavior and transactions.\n\n \n\n"),_c('br'),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("With whom your information will be shared?")]),_c('br'),_c('br'),_vm._v("\n\nSDFL will not use your financial information for any purpose other than to complete a transaction with you. SDFL does not rent, sell or share your personal information and will not disclose any of your personally identifiable information to third parties. In cases where it has your permission to provide products or services you’ve requested and such information is necessary to provide these products or services the information may be shared with SDFL’s business associates and partners. SDFL may, however, share consumer information on an aggregate with its partners or third parties where it deems necessary. In addition SDFL may use this information for promotional offers, to help investigate, prevent or take action regarding unlawful and illegal activities, suspected fraud, potential threat to the safety or security of any person, violations of the Site’s terms of use or to defend against legal claims; special circumstances such as compliance with subpoenas, court orders, requests/order from legal authorities or law enforcement agencies requiring such disclosure.\n\n \n\n"),_c('br'),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("What Choice are available to you regarding collection, use and distribution of your information?")]),_c('br'),_c('br'),_vm._v("\n\nTo protect against the loss, misuse and alteration of the information under its control, SDFL has in place appropriate physical, electronic and managerial procedures. For example, SDFL servers are accessible only to authorized personnel and your information is shared with employees and authorized personnel on a need to know basis to complete the transaction and to provide the services requested by you. Although SDFL will endeavor to safeguard the confidentiality of your personally identifiable information, transmissions made by means of the Internet cannot be made absolutely secure. By using this Site, you agree that SDFL will have no liability for disclosure of your information due to errors in transmission or unauthorized acts of third parties.\n\n \n\n"),_c('br'),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("How can you correct inaccuracies in the information?")]),_c('br'),_c('br'),_vm._v("\n\nTo correct or update any information you have provided, the Site allows you to do it online. In the event of loss of access details you can send an e-mail to: doodhvale@gmail.com\n\n \n\n"),_c('br'),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("Policy updates")]),_c('br'),_c('br'),_vm._v("\n\nSDFL reserves the right to change or update this policy at any time. Such changes shall be effective immediately upon posting to the Site.\n\n \n\n  ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5D9b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-loading',{attrs:{"is-full-page":_vm.isFullPage,"active":_vm.isLoading},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),(_vm.successfully_feedback === false)?_c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"url_valid"}},[_c('div',{staticStyle:{"text-align":"center"}},[_c('div',[_c('h4',[_vm._v("Welcome "+_vm._s(_vm.userDetails.first_name)),_c('br'),_vm._v("("+_vm._s(_vm.userDetails.mobile)+")")])]),_vm._v(" "),_c('div',{staticStyle:{"padding":"5%"}},[_vm._v("\n        "+_vm._s(_vm.userDetails.address))]),_vm._v("\n        *****\n        "),_c('div',{staticStyle:{"padding":"5%"}},[_vm._v(_vm._s(_vm.text1))]),_c('br'),_vm._v(" "),_c('img',{staticStyle:{"width":"90%"},attrs:{"src":_vm.imageContent}}),_c('br'),_c('br'),_vm._v(" "),_c('input',{staticClass:"buttonOnDelFbLoc",attrs:{"value":"I DISAGREE","type":"button"},on:{"click":function($event){_vm.disagree();}}}),_vm._v(" "),_c('div',{staticStyle:{"padding":"5%"}},[_vm._v(_vm._s(_vm.text2))]),_vm._v(" "),_c('input',{staticClass:"buttonOnDelFbLoc",attrs:{"value":"UPDATE LOCATION","type":"button"},on:{"click":function($event){_vm.locationModule();}}})])])]):_vm._e(),_vm._v(" "),(_vm.successfully_feedback)?_c('div',[_c('div',{staticStyle:{"text-align":"center","width":"90%"}},[_c('br'),_c('br'),_vm._v(" "),_c('img',{staticStyle:{"width":"15%"},attrs:{"src":__webpack_require__("b4Vd")}}),_c('br'),_c('br'),_vm._v("\n      Thanks "+_vm._s(_vm.userDetails.first_name)+" "),_c('br'),_vm._v("\n      Your feedback is sent to our delivery partner. It will not repeat again!!"),_c('br'),_c('br')])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center","width":"90%"},attrs:{"id":"url_expired"}},[_c('h4',[_vm._v("Welcome to Doodhvale, Please wait...")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5FAv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundPage_vue__ = __webpack_require__("eAxr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_115e1bb6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundPage_vue__ = __webpack_require__("DuYP");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_115e1bb6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5ZbH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__ = __webpack_require__("kXiA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_126f8ed7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__ = __webpack_require__("ctRh");
function injectStyle (ssrContext) {
  __webpack_require__("Ojch")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_126f8ed7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5cLx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__ = __webpack_require__("Vj7G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_420ae550_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__ = __webpack_require__("GOCq");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_420ae550_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5eTp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5iiD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubscriptionVerification_vue__ = __webpack_require__("RxQV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b444df98_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubscriptionVerification_vue__ = __webpack_require__("YTW2");
function injectStyle (ssrContext) {
  __webpack_require__("mfGc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubscriptionVerification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b444df98_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubscriptionVerification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5qur":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$route.meta.footer === 1)?_c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"copyright text-center"},[_c('router-link',{attrs:{"to":{path:'/a/terms'}}},[_vm._v("Terms And Conditions")]),_vm._v("  \n      "),_c('router-link',{attrs:{"to":{path:'/a/privacy'}}},[_vm._v("Privacy Policy")]),_vm._v("  \n      "),_c('router-link',{attrs:{"to":{path:'/a/refund'}}},[_vm._v("Refund Policy")]),_vm._v("  \n      "),_c('router-link',{attrs:{"to":{path:'/a/shipping'}}},[_vm._v("Shipping Policy")]),_vm._v("  \n      "),_c('router-link',{attrs:{"to":{path:'/a/contact'}}},[_vm._v("Contact Us")]),_vm._v("  "),_c('br'),_vm._v(" "),_vm._v("\n      © Sanjeevani Dairy Farms Pvt. Ltd. 2023 . All rights reserved.\n      ")],1)])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5xiS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-loading',{attrs:{"is-full-page":_vm.isFullPage,"active":_vm.isLoading},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.sendMail===false)?_c('div',[_c('div',{staticClass:"w3-center"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":__webpack_require__("hr0A")}}),_c('br'),_c('br'),_vm._v(" "),_c('div',{attrs:{"align":"center"}},[_c('FONT',{attrs:{"size":"6","color":"#008080"}},[_c('B',[_vm._v("Pre Registration Form")])],1)],1),_c('br')]),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticStyle:{"width":"50%"}},[_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticStyle:{"text-align":"left","margin-bottom":"10px"}},[_c('input',{staticClass:"inp",attrs:{"id":"mobile","maxlength":"10","placeholder":"Enter mobile number","autofocus":""},on:{"keypress":function($event){_vm.isNumber(_vm.event)}}})]),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4)])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-notification',{attrs:{"type":"is-danger","closable":false,"active":_vm.isActive},on:{"update:active":function($event){_vm.isActive=$event}}},[_vm._v("\n          "+_vm._s(this.errors)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"w3-center"},[_c('input',{staticClass:"email",attrs:{"value":"Submit","type":"button"},on:{"click":function($event){_vm.email();}}})])],1)]):_vm._e(),_vm._v(" "),(_vm.sendMail)?_c('div',[_c('div',{staticClass:"w3-center"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":__webpack_require__("hr0A")}}),_c('br'),_c('br'),_vm._v(" "),_c('div',{attrs:{"align":"center"}},[_c('FONT',{attrs:{"size":"4","color":"#008080"}},[_c('B',[_vm._v("Thanks for registering your child. School admission coordinator will get back to you soon.")])],1)],1),_c('br'),_vm._v("\n      * Admissions are subject of clearing entrance test of school and availability of seats. "),_c('br'),_vm._v("Filling the pre registration form is not confirming the admission of child.\n    ")])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"50%","margin-top":"10px"}},[_c('div',{staticStyle:{"text-align":"right"}},[_c('strong',[_c('label',[_vm._v("Student’s Name*")]),_vm._v("  :  ")])]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin-top":"16px"}},[_c('strong',[_c('label',[_vm._v("Father’s Name*")]),_vm._v("  :  ")])]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin-top":"18px"}},[_c('strong',[_c('label',[_vm._v("Phone No*")]),_vm._v("  :  ")])]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin-top":"15px"}},[_c('strong',[_c('label',[_vm._v("Class*")]),_vm._v("  :  ")])]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin-top":"20px"}},[_c('strong',[_c('label',[_vm._v("Address")]),_vm._v("  :  ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"left","margin-bottom":"10px"}},[_c('input',{staticClass:"inp",attrs:{"name":"stu-name","id":"stu-name","placeholder":"Enter Student Name","required":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"left","margin-bottom":"10px"}},[_c('input',{staticClass:"inp",attrs:{"name":"fath-name","id":"fath-name","placeholder":"Enter Father Name","required":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"left","margin-bottom":"10px"}},[_c('select',{staticClass:"inp",attrs:{"id":"classs"}},[_c('option',{attrs:{"value":"Pre Nursery (2+ Yrs)"}},[_vm._v("Pre Nursery (2+ Yrs)")]),_vm._v(" "),_c('option',{attrs:{"value":"Nursery (3+ Yrs)"}},[_vm._v("Nursery (3+ Yrs)")]),_vm._v(" "),_c('option',{attrs:{"value":"KG (4+ Yrs)"}},[_vm._v("KG (4+ Yrs)")]),_vm._v(" "),_c('option',{attrs:{"value":"1st Class (5+ Yrs)"}},[_vm._v("1st Class (5+ Yrs)")]),_vm._v(" "),_c('option',{attrs:{"value":"2nd Class"}},[_vm._v("2nd Class")]),_vm._v(" "),_c('option',{attrs:{"value":"3rd Class"}},[_vm._v("3rd Class")]),_vm._v(" "),_c('option',{attrs:{"value":"4th Class"}},[_vm._v("4th Class")]),_vm._v(" "),_c('option',{attrs:{"value":"5th Class"}},[_vm._v("5th Class")]),_vm._v(" "),_c('option',{attrs:{"value":"6th Class"}},[_vm._v("6th Class")]),_vm._v(" "),_c('option',{attrs:{"value":"7th Class"}},[_vm._v("7th Class")]),_vm._v(" "),_c('option',{attrs:{"value":"8th Class"}},[_vm._v("8th Class")]),_vm._v(" "),_c('option',{attrs:{"value":"9th Class"}},[_vm._v("9th Class")]),_vm._v(" "),_c('option',{attrs:{"value":"11th (Medical)"}},[_vm._v("11th (Medical)")]),_vm._v(" "),_c('option',{attrs:{"value":"11th (Non Medical)"}},[_vm._v("11th (Non Medical)")]),_vm._v(" "),_c('option',{attrs:{"value":"11th (Commerce)"}},[_vm._v("11th (Commerce)")]),_vm._v(" "),_c('option',{attrs:{"value":"11th (Humanities)"}},[_vm._v("11th (Humanities)")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"left","margin-bottom":"5px"}},[_c('input',{staticClass:"inp",attrs:{"name":"address","id":"address","placeholder":"Enter Address"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6+hp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w3-content",staticStyle:{"max-width":"90%"}},[_c('h3',{staticStyle:{"text-align":"center"}},[_vm._v("Refer & Earn Policy")]),_vm._v(" "),_c('br'),_vm._v("You refer doodhvale.com products to your friends and relatives using doodhvale mobile app. If your referred person download doodhvale app and subscribe the products, when your friend's bill above or equal to Rs 2000/- then you will earn 200 points and get cash back of Rs 200/- in next month bill, and also, your friend will also get Rs 100/- cash back on her bill. You refer as many friends as you want and earn 200 points per individual reference if her bill amount equal or more than Rs 2000/-. But, in case you earn more than 200 points then you will get at max of Rs 200/- referral discount per bill i.e. 200 points redeemed every month but you can earn unlimited earn points. You can check your earned points, redeemed points and balance points at any time in your doodhvale app.\n  "),_c('br'),_vm._v(" "),_c('br'),_vm._v("* Refer & Earn Policy may change any time by doodhvale without intimating anyone. In case of any disputes, doodhvale decision will be final. This policy does not carry any legal obligation on doodhvale or any of its employee or staff or any associates, and it is just a promotional campaign.\n")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6+sq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_R1_vue__ = __webpack_require__("Wgt+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6322a6bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_R1_vue__ = __webpack_require__("ghI9");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_R1_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6322a6bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_R1_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "61BT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.successfully_feedback === false)?_c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"url_valid"}},[_c('div',{staticStyle:{"text-align":"center"}},[_c('div',[_c('h4',[_vm._v("Welcome "+_vm._s(_vm.userDetails.first_name)),_c('br'),_vm._v("("+_vm._s(_vm.userDetails.mobile)+")")])]),_vm._v(" "),_c('div',[_vm._v("\n        "+_vm._s(_vm.userDetails.address))]),_vm._v("\n        *****"),_c('br'),_vm._v(" "),_c('img',{staticStyle:{"width":"15%"},attrs:{"src":__webpack_require__("UBvS")}}),_c('br'),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('button',{staticClass:"disagree",on:{"click":function($event){_vm.disagree();}}},[_vm._v("I DISAGREE")])])])]):_vm._e(),_vm._v(" "),(_vm.successfully_feedback)?_c('div',[_c('div',{staticStyle:{"text-align":"center","width":"90%"}},[_c('br'),_c('br'),_vm._v(" "),_c('img',{staticStyle:{"width":"15%"},attrs:{"src":__webpack_require__("b4Vd")}}),_c('br'),_c('br'),_vm._v("\n      Thanks "+_vm._s(_vm.userDetails.first_name)+" "),_c('br'),_vm._v("\n      Your feedback is sent to our delivery partner. It will not repeat again!!"),_c('br'),_c('br')])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center","width":"90%"},attrs:{"id":"url_expired"}},[_c('h4',[_vm._v("Welcome to Doodhvale, Please wait...")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"90%"}},[_c('b',[_vm._v("Sorry! Inconvenience deeply regretted.")]),_c('br'),_vm._v(" If you disagree with our delivery partner's statement then please press below"),_c('br'),_vm._v(" “"),_c('b',[_vm._v("I DISAGREE")]),_vm._v("” button.")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6K2C":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "6a1u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6ckh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"lottieContainer",style:({ width: _vm.containerWidth, height: _vm.containerHeight })})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6dQT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"w3-center"},[_c('br'),_vm._v(" "),_c('img',{staticStyle:{"width":"35%"},attrs:{"src":__webpack_require__("zV0d")}}),_c('br'),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gender),expression:"gender"}],attrs:{"type":"radio","id":"male","value":"M"},domProps:{"checked":_vm._q(_vm.gender,"M")},on:{"change":function($event){_vm.gender="M"}}}),_vm._v(" "),_c('label',{attrs:{"for":"male"}},[_vm._v("Male")]),_vm._v("     \n    "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gender),expression:"gender"}],attrs:{"type":"radio","id":"female","value":"F"},domProps:{"checked":_vm._q(_vm.gender,"F")},on:{"change":function($event){_vm.gender="F"}}}),_vm._v(" "),_c('label',{attrs:{"for":"female"}},[_vm._v("Female")])]),_vm._v(" "),_c('div',[_c('form',[_vm._m(0),_vm._v(" "),_c('input',{staticClass:"button1",attrs:{"value":"SUBMIT","type":"button"},on:{"click":function($event){}}})])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-left":"5%","margin-top":"5%","width":"90%"}},[_c('input',{staticClass:"profile_edit",attrs:{"id":"profile_name","placeholder":"NAME"}}),_c('br'),_c('hr'),_vm._v(" "),_c('input',{staticClass:"profile_edit",attrs:{"id":"profile_email","placeholder":"EMAIL"}}),_c('br'),_c('hr'),_vm._v(" "),_c('input',{staticClass:"profile_edit",attrs:{"id":"profile_referral","placeholder":"REFERRAL CODE[OPTIONAL]"}}),_c('br'),_c('hr'),_vm._v(" "),_c('br'),_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6zJ5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "72+V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"bafore_checksum"}},[(_vm.successfully_unsubscribe === false)?_c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"unsub"}},[_vm._v("\n      You have successfully Unsubscribed.\n    ")]),_vm._v(" "),_c('div',{attrs:{"id":"unsettled"}},[_vm._v("\n      You have Rs. "+_vm._s(_vm.subscriptionObj.pendingAmount)+" pending and "+_vm._s(_vm.subscriptionObj.emptyBottles)+" pending empty bottles."),_c('a',{attrs:{"href":_vm.subscriptionObj.paymentUrl}},[_vm._v("Click to pay")])]),_vm._v(" "),_c('div',{attrs:{"id":"url_valid"}},[_c('div',{staticStyle:{"text-align":"center"}},[_c('div',[_c('h4',[_vm._v("Welcome "+_vm._s(_vm.userDetails.first_name)),_c('br'),_vm._v("("+_vm._s(_vm.userDetails.mobile)+")")])]),_vm._v(" "),_c('div',[_vm._v("\n        "+_vm._s(_vm.userDetails.address))]),_vm._v("\n        *****"),_c('br'),_vm._v(" "),_c('div',{attrs:{"id":"unsubscribe"}},[_c('h4',[_vm._v(_vm._s(_vm.apiDataObj.msg))])]),_vm._v(" "),_c('div',{attrs:{"id":"not_unsubscribe"}},[_c('ul',{attrs:{"id":"example-1"}},_vm._l((_vm.items),function(item){return _c('li',[_vm._v("\n              "+_vm._s(item)+"\n            ")])})),_c('br'),_vm._v("\n          Choose your feedback before Unsubscribe"),_c('br'),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticStyle:{"width":"70%"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.apiDataObj.reasonList),function(option){return _c('option',{domProps:{"value":option.reason_id}},[_vm._v("\n              "+_vm._s(option.value)+"\n            ")])})),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"display":"inline-block"}},[_c('form',[_c('input',{staticClass:"button1",attrs:{"value":"Unsubscribe","type":"button"},on:{"click":function($event){_vm.unsubscribe();}}})])])]),_vm._v(" "),_c('div',{attrs:{"id":"unsettled_noempty"}},[_vm._v("\n          You have Rs. "+_vm._s(_vm.subscriptionObj.pendingAmount)+" pending."),_c('a',{attrs:{"href":_vm.subscriptionObj.paymentUrl}},[_vm._v("Click to pay")]),_c('br'),_c('br')])])])]):_vm._e(),_vm._v(" "),(_vm.successfully_unsubscribe)?_c('div',[_c('div',{staticStyle:{"text-align":"center"}},[_c('div',[_c('h4',[_vm._v("Welcome "+_vm._s(_vm.userDetails.first_name)),_c('br'),_vm._v("("+_vm._s(_vm.userDetails.mobile)+")")])]),_vm._v(" "),_c('div',[_vm._v("\n      "+_vm._s(_vm.userDetails.address))]),_vm._v("\n      *****"),_c('br'),_vm._v(" "),_c('div',{attrs:{"id":"unsub"}},[_vm._v("\n        You have successfully Unsubscribed.\n      ")]),_vm._v(" "),(_vm.unsettled)?_c('div',[_vm._v("\n        You have Rs. "+_vm._s(_vm.subscriptionObj.pendingAmount)+" pending and "+_vm._s(_vm.subscriptionObj.emptyBottles)+" pending empty bottles."),_c('a',{attrs:{"href":_vm.subscriptionObj.paymentUrl}},[_vm._v("Click to pay")])]):_vm._e()])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"url_expired"}},[_c('h4',[_vm._v("Welcome to Doodhvale, Please wait...")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7QIX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListOfProducts_vue__ = __webpack_require__("ofci");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b5b6f1e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListOfProducts_vue__ = __webpack_require__("u1jR");
function injectStyle (ssrContext) {
  __webpack_require__("tWR5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4b5b6f1e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListOfProducts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b5b6f1e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListOfProducts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7SdG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarLink_vue__ = __webpack_require__("3Q3N");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69d09261_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarLink_vue__ = __webpack_require__("UvUG");
function injectStyle (ssrContext) {
  __webpack_require__("h0DP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69d09261_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarLink_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7a+9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"bafore_checksum"}},[(_vm.successfully_unsubscribe === false)?_c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"url_valid"}},[_c('div',{staticStyle:{"text-align":"center"}},[_c('div',{attrs:{"id":"promo_expired"}},[_c('b',[_vm._v(_vm._s(_vm.apiDataObj.promocodeError))]),_c('br'),_c('br')]),_vm._v(" "),_vm._m(1)])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"url_expired"}},[_c('h4',[_vm._v("Welcome to Doodhvale, Please wait...")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"promo_valid"}},[_c('div',{attrs:{"id":"not_subscribed"}},[_c('div',{attrs:{"id":"show_start_date"}}),_vm._v(" "),_c('div',{attrs:{"id":"show_delivery_date"}}),_vm._v(" "),_c('div',{attrs:{"id":"show_schedule"}})]),_vm._v(" "),_c('div',{attrs:{"id":"subscribed"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7j2F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container is-fluid has-text-centered"},[_c('b-loading',{attrs:{"is-full-page":_vm.isFullPage,"active":_vm.isLoading},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"display":"none"},attrs:{"id":"bafore_checksum"}},[(_vm.userData)?_c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"url_valid"}},[_c('div',[_c('div',[_c('h4',[_vm._v("Welcome "+_vm._s(_vm.custName)),_c('br'),_vm._v("("+_vm._s(_vm.userDetails.mobile)+")")])]),_vm._v(" "),_c('div',[_vm._v("\n            "+_vm._s(_vm.custAddress)+"\n          ")]),_vm._v(" "),_c('div',{attrs:{"id":"clear"}},[_c('h4',[_vm._v("No Dues")]),_vm._v(" "),_c('div',{staticClass:"pending_wallet"},[_c('i',{staticClass:"fa fa-rupee"}),_c('b',[_vm._v(_vm._s(_vm.apiDataObj.wallet_amount))])])]),_vm._v(" "),_c('div',{attrs:{"id":"pending"}},[_c('h4',[_vm._v("Pending Amount")]),_vm._v(" "),_c('div',{staticClass:"pending_wallet"},[_c('i',{staticClass:"fa fa-rupee"}),_c('b',[_vm._v(_vm._s(_vm.apiDataObj.pending_amount))])])]),_vm._v(" "),_c('div',{attrs:{"id":"not_pending"}},[_c('h4',[_vm._v("Wallet Balance")]),_vm._v(" "),_c('div',{staticClass:"pending_wallet"},[_c('i',{staticClass:"fa fa-rupee"}),_c('b',[_vm._v(_vm._s(_vm.apiDataObj.wallet_amount))])])]),_vm._v(" "),_c('div',{staticStyle:{"display":"inline-block"}},[_c('form',[_c('div',{staticClass:"pending_wallet"},[_c('h3',[_vm._v("Enter Amount")]),_vm._v(" "),_c('i',{staticClass:"fa fa-rupee"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rechargeAmount),expression:"rechargeAmount"}],ref:"amountInput",staticClass:"amount_text",attrs:{"id":"txn_amt","name":"TXN_AMOUNT","type":"tel","oninput":"this.value=this.value.replace(/[^0-9]/g,'');","placeholder":"0"},domProps:{"value":(_vm.rechargeAmount)},on:{"focus":_vm.selectContent,"input":function($event){if($event.target.composing){ return; }_vm.rechargeAmount=$event.target.value}}})]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('b-notification',{attrs:{"type":"is-danger","closable":false,"active":_vm.isActive},on:{"update:active":function($event){_vm.isActive=$event}}},[_vm._v("\n                "+_vm._s(this.errors)+"\n              ")]),_vm._v(" "),(_vm.isQuickPaymentButtonDisplay === 1)?_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.btnOneValue),expression:"btnOneValue"}],staticClass:"quickPaymentButton",attrs:{"type":"button"},domProps:{"value":(_vm.btnOneValue)},on:{"click":_vm.btnOneClick,"input":function($event){if($event.target.composing){ return; }_vm.btnOneValue=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.btnTwoValue),expression:"btnTwoValue"}],staticClass:"quickPaymentButton",staticStyle:{"margin-left":"10px"},attrs:{"type":"button"},domProps:{"value":(_vm.btnTwoValue)},on:{"click":_vm.btnTwoClick,"input":function($event){if($event.target.composing){ return; }_vm.btnTwoValue=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.btnThreeValue),expression:"btnThreeValue"}],staticClass:"quickPaymentButton",staticStyle:{"margin-left":"10px"},attrs:{"type":"button"},domProps:{"value":(_vm.btnThreeValue)},on:{"click":_vm.btnThreeClick,"input":function($event){if($event.target.composing){ return; }_vm.btnThreeValue=$event.target.value}}})]):_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sevenDeliveryAmountLabel),expression:"sevenDeliveryAmountLabel"}],staticClass:"quickPaymentButton",attrs:{"type":"button"},domProps:{"value":(_vm.sevenDeliveryAmountLabel)},on:{"click":_vm.sevenDeliveryBtnClick,"input":function($event){if($event.target.composing){ return; }_vm.sevenDeliveryAmountLabel=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fifteenDeliveryAmountLabel),expression:"fifteenDeliveryAmountLabel"}],staticClass:"quickPaymentButton",staticStyle:{"margin-left":"10px"},attrs:{"type":"button"},domProps:{"value":(_vm.fifteenDeliveryAmountLabel)},on:{"click":_vm.fifteenDeliveryBtnClick,"input":function($event){if($event.target.composing){ return; }_vm.fifteenDeliveryAmountLabel=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.thirtyDeliveryAmountLabel),expression:"thirtyDeliveryAmountLabel"}],staticClass:"quickPaymentButton",staticStyle:{"margin-left":"10px"},attrs:{"type":"button"},domProps:{"value":(_vm.thirtyDeliveryAmountLabel)},on:{"click":_vm.thirtyDeliveryBtnClick,"input":function($event){if($event.target.composing){ return; }_vm.thirtyDeliveryAmountLabel=$event.target.value}}}),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fourtyFiveDeliveryAmountLabel),expression:"fourtyFiveDeliveryAmountLabel"}],staticClass:"quickPaymentButton",attrs:{"type":"button"},domProps:{"value":(_vm.fourtyFiveDeliveryAmountLabel)},on:{"click":_vm.fourtyFiveDeliveryBtnClick,"input":function($event){if($event.target.composing){ return; }_vm.fourtyFiveDeliveryAmountLabel=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sixtyDeliveryAmountLabel),expression:"sixtyDeliveryAmountLabel"}],staticClass:"quickPaymentButton",staticStyle:{"margin-left":"10px"},attrs:{"type":"button"},domProps:{"value":(_vm.sixtyDeliveryAmountLabel)},on:{"click":_vm.sixtyDeliveryBtnClick,"input":function($event){if($event.target.composing){ return; }_vm.sixtyDeliveryAmountLabel=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"wallet_coupon_block"},[_c('div',{staticClass:"wallet_coupon_rl"},[_c('div',[_c('div',{staticClass:"apply_block"},[_c('img',{attrs:{"src":__webpack_require__("VuyX")}}),_vm._v(" "),_c('div',[_c('p',{staticClass:"wallet_coupon_et",style:({ color: _vm.isGreen ? '#3CB6C3' : '#000000' })},[_vm._v("\n                          "+_vm._s(_vm.walletCouponMsg)+"\n                        ")]),_vm._v(" "),_c('p',{staticClass:"wallet_coupon_msg",style:({ color: _vm.isGreen ? '#0E8642' : '#ff4c4c' })},[_vm._v("\n                          "+_vm._s(_vm.couponMsg)+"\n                        ")])])])]),_vm._v(" "),_c('div',{staticClass:"coupon_img",on:{"click":_vm.applyCouponClick}},[(_vm.applyCouponImg == 1)?_c('div',[_c('img',{attrs:{"src":__webpack_require__("46ef")}})]):_c('div',[_c('img',{attrs:{"src":__webpack_require__("pvED")}})])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{staticClass:"button3",attrs:{"value":"Payment Now","type":"button"},on:{"click":function($event){_vm.isCouponApplied
                    ? _vm.checkCorrectCouponApplied()
                    : _vm.generateChecksum()}}}),_vm._v(" "),(_vm.showCouponAlertBox)?_c('div',{staticClass:"checkAmtBox"},[_c('div',{staticClass:"alert-box"},[_c('h4',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.alertHeading))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.alertMessage))]),_vm._v(" "),_c('div',{staticClass:"alert-btn"},[_c('button',{on:{"click":function($event){_vm.handleRetry($event)}}},[_vm._v("Retry")]),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.handleIgnoreCoupon($event)}}},[_vm._v("\n                      Ignore Coupon\n                    ")])])])]):_vm._e()],1)])]),_vm._v(" "),(_vm.showDialog)?_c('div',{staticClass:"dialogBox"},[_c('CouponAnimation')],1):_vm._e()]),_vm._v(" "),(_vm.showToast)?_c('div',{staticClass:"toast"},[_vm._v("\n        "+_vm._s(_vm.toastMessage)+"\n      ")]):_vm._e()]):_vm._e()]),_vm._v(" "),(_vm.after_checksum)?_c('div',[_c('div',[_c('br'),_vm._v("\n      Dear "+_vm._s(_vm.userDetails.first_name)+"\n      "),_c('br'),_vm._v("\n      Please press button to continue\n      "),_c('br'),_c('br'),_vm._v("\n      Amount"),_c('i',{staticClass:"fa fa-rupee"}),_c('b',[_vm._v(_vm._s(_vm.genChecksum.TXN_AMOUNT))]),_c('br'),_c('br'),_vm._v(" "),_c('div',[_c('form',{attrs:{"method":"post","action":"https://securegw.paytm.in/theia/processTransaction"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.genChecksum.MID),expression:"genChecksum.MID"}],attrs:{"type":"hidden","name":"MID"},domProps:{"value":(_vm.genChecksum.MID)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.genChecksum, "MID", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.genChecksum.ORDER_ID),expression:"genChecksum.ORDER_ID"}],attrs:{"type":"hidden","name":"ORDER_ID"},domProps:{"value":(_vm.genChecksum.ORDER_ID)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.genChecksum, "ORDER_ID", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.genChecksum.CUST_ID),expression:"genChecksum.CUST_ID"}],attrs:{"type":"hidden","name":"CUST_ID"},domProps:{"value":(_vm.genChecksum.CUST_ID)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.genChecksum, "CUST_ID", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.genChecksum.INDUSTRY_TYPE_ID),expression:"genChecksum.INDUSTRY_TYPE_ID"}],attrs:{"type":"hidden","name":"INDUSTRY_TYPE_ID"},domProps:{"value":(_vm.genChecksum.INDUSTRY_TYPE_ID)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.genChecksum, "INDUSTRY_TYPE_ID", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.genChecksum.CHANNEL_ID),expression:"genChecksum.CHANNEL_ID"}],attrs:{"type":"hidden","name":"CHANNEL_ID"},domProps:{"value":(_vm.genChecksum.CHANNEL_ID)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.genChecksum, "CHANNEL_ID", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.genChecksum.WEBSITE),expression:"genChecksum.WEBSITE"}],attrs:{"type":"hidden","name":"WEBSITE"},domProps:{"value":(_vm.genChecksum.WEBSITE)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.genChecksum, "WEBSITE", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.genChecksum.CALLBACK_URL),expression:"genChecksum.CALLBACK_URL"}],attrs:{"type":"hidden","name":"CALLBACK_URL"},domProps:{"value":(_vm.genChecksum.CALLBACK_URL)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.genChecksum, "CALLBACK_URL", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.genChecksum.checksum),expression:"genChecksum.checksum"}],attrs:{"type":"hidden","name":"CHECKSUMHASH"},domProps:{"value":(_vm.genChecksum.checksum)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.genChecksum, "checksum", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.genChecksum.TXN_AMOUNT),expression:"genChecksum.TXN_AMOUNT"}],attrs:{"type":"hidden","name":"TXN_AMOUNT"},domProps:{"value":(_vm.genChecksum.TXN_AMOUNT)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.genChecksum, "TXN_AMOUNT", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.genChecksum.MERC_UNQ_REF),expression:"genChecksum.MERC_UNQ_REF"}],attrs:{"type":"hidden","name":"MERC_UNQ_REF"},domProps:{"value":(_vm.genChecksum.MERC_UNQ_REF)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.genChecksum, "MERC_UNQ_REF", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.promoCodeId),expression:"promoCodeId"}],attrs:{"type":"hidden","name":"promo_code_id"},domProps:{"value":(_vm.promoCodeId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.promoCodeId=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.promoCodeStr),expression:"promoCodeStr"}],attrs:{"type":"hidden","name":"promo_code_str"},domProps:{"value":(_vm.promoCodeStr)},on:{"input":function($event){if($event.target.composing){ return; }_vm.promoCodeStr=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cashback),expression:"cashback"}],attrs:{"type":"hidden","name":"cashback_amount"},domProps:{"value":(_vm.cashback)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cashback=$event.target.value}}}),_vm._v(" "),_c('input',{staticClass:"button5",attrs:{"id":"pay","value":"Continue","type":"submit"},on:{"click":function($event){_vm.isLoading = true}}})])])])]):_vm._e(),_vm._v(" "),(_vm.app_payment_gate)?_c('div',{staticStyle:{"display":"none !important"}},[_c('div',[_c('br'),_vm._v("\n      Dear "+_vm._s(_vm.userDetails.first_name)+"\n      "),_c('br'),_vm._v("\n      Please press button to continue\n      "),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n      Amount"),_c('i',{staticClass:"fa fa-rupee"}),_c('b',[_vm._v(_vm._s(_vm.appPaymentGateway.TXN_AMOUNT))]),_c('br'),_c('br'),_vm._v(" "),_c('div',[_c('form',{attrs:{"method":"post","name":"hdfcform","id":"hdfcform","action":_vm.appPaymentGateway.actionUrl}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.appPaymentGateway.TID),expression:"appPaymentGateway.TID"}],attrs:{"type":"hidden","name":"tid"},domProps:{"value":(_vm.appPaymentGateway.TID)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.appPaymentGateway, "TID", $event.target.value)}}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"merchant_id","value":"242357"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.appPaymentGateway.ORDER_ID),expression:"appPaymentGateway.ORDER_ID"}],attrs:{"type":"hidden","name":"order_id"},domProps:{"value":(_vm.appPaymentGateway.ORDER_ID)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.appPaymentGateway, "ORDER_ID", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.appPaymentGateway.TXN_AMOUNT),expression:"appPaymentGateway.TXN_AMOUNT"}],attrs:{"type":"hidden","name":"amount"},domProps:{"value":(_vm.appPaymentGateway.TXN_AMOUNT)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.appPaymentGateway, "TXN_AMOUNT", $event.target.value)}}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"currency","value":"INR"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.appPaymentGateway.responseUrl),expression:"appPaymentGateway.responseUrl"}],attrs:{"type":"hidden","name":"redirect_url"},domProps:{"value":(_vm.appPaymentGateway.responseUrl)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.appPaymentGateway, "responseUrl", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.appPaymentGateway.responseUrl),expression:"appPaymentGateway.responseUrl"}],attrs:{"type":"hidden","name":"cancel_url"},domProps:{"value":(_vm.appPaymentGateway.responseUrl)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.appPaymentGateway, "responseUrl", $event.target.value)}}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"language","value":"EN"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.fullName),expression:"userDetails.fullName"}],attrs:{"type":"hidden","name":"delivery_name"},domProps:{"value":(_vm.userDetails.fullName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "fullName", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.address),expression:"userDetails.address"}],attrs:{"type":"hidden","name":"delivery_address"},domProps:{"value":(_vm.userDetails.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "address", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.city),expression:"userDetails.city"}],attrs:{"type":"hidden","name":"delivery_city"},domProps:{"value":(_vm.userDetails.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "city", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.state),expression:"userDetails.state"}],attrs:{"type":"hidden","name":"delivery_state"},domProps:{"value":(_vm.userDetails.state)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "state", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.pincode),expression:"userDetails.pincode"}],attrs:{"type":"hidden","name":"delivery_zip"},domProps:{"value":(_vm.userDetails.pincode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "pincode", $event.target.value)}}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"delivery_country","value":"India"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.mobile),expression:"userDetails.mobile"}],attrs:{"type":"hidden","name":"delivery_tel"},domProps:{"value":(_vm.userDetails.mobile)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "mobile", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.apiDataObj.userId),expression:"apiDataObj.userId"}],attrs:{"type":"hidden","name":"merchant_param1"},domProps:{"value":(_vm.apiDataObj.userId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.apiDataObj, "userId", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.appPaymentGateway.CALLBACK_URL),expression:"appPaymentGateway.CALLBACK_URL"}],attrs:{"type":"hidden","name":"merchant_param2"},domProps:{"value":(_vm.appPaymentGateway.CALLBACK_URL)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.appPaymentGateway, "CALLBACK_URL", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.appPaymentGateway.APP_PAYMENT_GATEWAY),expression:"appPaymentGateway.APP_PAYMENT_GATEWAY"}],attrs:{"type":"hidden","name":"merchant_param3"},domProps:{"value":(_vm.appPaymentGateway.APP_PAYMENT_GATEWAY)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.appPaymentGateway, "APP_PAYMENT_GATEWAY", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.appPaymentGateway.apiUrl),expression:"appPaymentGateway.apiUrl"}],attrs:{"type":"hidden","name":"merchant_param4"},domProps:{"value":(_vm.appPaymentGateway.apiUrl)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.appPaymentGateway, "apiUrl", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.appPaymentGateway.apiUrl),expression:"appPaymentGateway.apiUrl"}],attrs:{"type":"hidden","name":"merchant_param4"},domProps:{"value":(_vm.appPaymentGateway.apiUrl)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.appPaymentGateway, "apiUrl", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.promoCodeId),expression:"promoCodeId"}],attrs:{"type":"hidden","name":"promo_code_id"},domProps:{"value":(_vm.promoCodeId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.promoCodeId=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.promoCodeStr),expression:"promoCodeStr"}],attrs:{"type":"hidden","name":"promo_code_str"},domProps:{"value":(_vm.promoCodeStr)},on:{"input":function($event){if($event.target.composing){ return; }_vm.promoCodeStr=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cashback),expression:"cashback"}],attrs:{"type":"hidden","name":"cashback_amount"},domProps:{"value":(_vm.cashback)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cashback=$event.target.value}}}),_vm._v(" "),_c('input',{staticClass:"button5",attrs:{"id":"pay","value":"Continue","type":"submit"},on:{"click":function($event){_vm.isLoading = true}}})])])])]):_vm._e(),_vm._v(" "),(_vm.payu_payment_gate)?_c('div',{staticStyle:{"display":"none !important"}},[_c('div',[_c('div',[_c('form',{attrs:{"method":"post","action":_vm.appPaymentGateway.actionUrl,"name":"payuform","id":"payuform"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.appPaymentGateway.HASH),expression:"appPaymentGateway.HASH"}],attrs:{"type":"hidden","name":"hash"},domProps:{"value":(_vm.appPaymentGateway.HASH)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.appPaymentGateway, "HASH", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.appPaymentGateway.ORDER_ID),expression:"appPaymentGateway.ORDER_ID"}],attrs:{"type":"hidden","name":"txnid"},domProps:{"value":(_vm.appPaymentGateway.ORDER_ID)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.appPaymentGateway, "ORDER_ID", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.appPaymentGateway.TXN_AMOUNT),expression:"appPaymentGateway.TXN_AMOUNT"}],attrs:{"type":"hidden","name":"amount"},domProps:{"value":(_vm.appPaymentGateway.TXN_AMOUNT)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.appPaymentGateway, "TXN_AMOUNT", $event.target.value)}}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"currency","value":"INR"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.appPaymentGateway.responseUrl),expression:"appPaymentGateway.responseUrl"}],attrs:{"type":"hidden","name":"surl"},domProps:{"value":(_vm.appPaymentGateway.responseUrl)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.appPaymentGateway, "responseUrl", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.appPaymentGateway.responseUrl),expression:"appPaymentGateway.responseUrl"}],attrs:{"type":"hidden","name":"furl"},domProps:{"value":(_vm.appPaymentGateway.responseUrl)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.appPaymentGateway, "responseUrl", $event.target.value)}}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"language","value":"EN"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.first_name),expression:"userDetails.first_name"}],attrs:{"type":"hidden","name":"firstname"},domProps:{"value":(_vm.userDetails.first_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "first_name", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.address),expression:"userDetails.address"}],attrs:{"type":"hidden","name":"address1"},domProps:{"value":(_vm.userDetails.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "address", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.city),expression:"userDetails.city"}],attrs:{"type":"hidden","name":"city"},domProps:{"value":(_vm.userDetails.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "city", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.state),expression:"userDetails.state"}],attrs:{"type":"hidden","name":"state"},domProps:{"value":(_vm.userDetails.state)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "state", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.pincode),expression:"userDetails.pincode"}],attrs:{"type":"hidden","name":"Zipcode"},domProps:{"value":(_vm.userDetails.pincode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "pincode", $event.target.value)}}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"country","value":"India"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.mobile),expression:"userDetails.mobile"}],attrs:{"type":"hidden","name":"phone"},domProps:{"value":(_vm.userDetails.mobile)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "mobile", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.apiDataObj.userId),expression:"apiDataObj.userId"}],attrs:{"type":"hidden","name":"merchant_param1"},domProps:{"value":(_vm.apiDataObj.userId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.apiDataObj, "userId", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.appPaymentGateway.CALLBACK_URL),expression:"appPaymentGateway.CALLBACK_URL"}],attrs:{"type":"hidden","name":"merchant_param2"},domProps:{"value":(_vm.appPaymentGateway.CALLBACK_URL)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.appPaymentGateway, "CALLBACK_URL", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.appPaymentGateway.APP_PAYMENT_GATEWAY),expression:"appPaymentGateway.APP_PAYMENT_GATEWAY"}],attrs:{"type":"hidden","name":"merchant_param3"},domProps:{"value":(_vm.appPaymentGateway.APP_PAYMENT_GATEWAY)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.appPaymentGateway, "APP_PAYMENT_GATEWAY", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.appPaymentGateway.apiUrl),expression:"appPaymentGateway.apiUrl"}],attrs:{"type":"hidden","name":"merchant_param4"},domProps:{"value":(_vm.appPaymentGateway.apiUrl)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.appPaymentGateway, "apiUrl", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.promoCodeId),expression:"promoCodeId"}],attrs:{"type":"hidden","name":"promo_code_id"},domProps:{"value":(_vm.promoCodeId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.promoCodeId=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.promoCodeStr),expression:"promoCodeStr"}],attrs:{"type":"hidden","name":"promo_code_str"},domProps:{"value":(_vm.promoCodeStr)},on:{"input":function($event){if($event.target.composing){ return; }_vm.promoCodeStr=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cashback),expression:"cashback"}],attrs:{"type":"hidden","name":"cashback_amount"},domProps:{"value":(_vm.cashback)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cashback=$event.target.value}}}),_vm._v(" "),_c('input',{staticClass:"button5",attrs:{"id":"pay","value":"Continue","type":"submit"},on:{"click":function($event){_vm.isLoading = true}}})])])])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"url_expired"}},[_c('h4',[_vm._v("Welcome to Doodhvale, Please wait...")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8EQs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      imgPreUrl: "https://doodhvale.in",
      urlInterface: [],
      apiDataObj: [],
      userDetails: [],
      isLoading: true,
      isLoaded: false,
      successMessage: "",
      failMessage: "",
      isFullPage: true
    };
  },
  created: function created() {
    this.fetchData();
  },

  methods: {
    fetchData: function fetchData() {
      var _this = this;

      var params = new URLSearchParams();
      var fullUrl = document.URL;
      var splitUrl = fullUrl.split("Free_order?");
      params.append("url_str", splitUrl[1]);
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + "/accounts/fetch-url-interface-data",
        method: "post",
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this.urlInterface = {};
        if (response.data.status === "000001" || response.data.status === "000002" || response.data.status === "000003") {
          _this.urlInterface.error_msg = response.data.msg;
          document.getElementById("url_valid").style.display = "none";
        } else {
          document.getElementById("url_expired").style.display = "none";
          _this.urlInterface.action_name = response.data.action_name;
          _this.urlInterface.url_interface_id = response.data.url_interface_id;
          _this.invokeUrlAction();
        }
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === "SUCCESS") {
          _this.list = response.data.user_record;
          alert(_this.list);
        }
      }).catch(function (e) {
        alert("1234");
      });
      this.invokeUrlAction();
    },
    invokeUrlAction: function invokeUrlAction() {
      var _this2 = this;

      var params = new URLSearchParams();
      params.append("url_interface_id", this.urlInterface.url_interface_id);
      params.append("action_name", this.urlInterface.action_name);
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + "/accounts/invoke-url-action",
        method: "post",
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this2.apiDataObj = {};
        switch (_this2.urlInterface.action_name) {
          case "order_free_product":
            _this2.apiDataObj.userId = response.data.action_response.user_id;
            _this2.apiDataObj.product_id = response.data.action_response.product_id;
            _this2.apiDataObj.image_url = response.data.action_response.image_url;
            _this2.apiDataObj.header = response.data.action_response.header;
            _this2.apiDataObj.offer_detail = response.data.action_response.offer_detail;
            _this2.apiDataObj.button_caption = response.data.action_response.button_caption;
            _this2.apiDataObj.action_name = _this2.urlInterface.action_name;
            // console.log(response);
            // this.userInfo()
            break;
          default:
            break;
        }
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === "SUCCESS") {
          // alert("ok");
        }
      }).catch(function (e) {
        // alert("not ok");
      });
    },
    place_order: function place_order() {
      var _this3 = this;

      var params = new URLSearchParams();
      params.append("user_id", sessionStorage.getItem("userId"));
      params.append("product_id", this.productId);
      params.append("url_interface_id", this.urlInterface.url_interface_id);
      params.append("action_name", this.urlInterface.action_name);
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + "/accounts/update-url-user-response",
        method: "post",
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        if (response.data.status === "000000") {
          _this3.successMessage = response.data.msg;
          _this3.failMessage = ""; // Clear fail message
        } else {
          _this3.successMessage = ""; // Clear success message
          _this3.failMessage = response.data.msg;
        }
      }).catch(function (e) {
        _this3.successMessage = "";
        _this3.failMessage = "Error occurred while placing the order.";
      });
    }
  }
});

/***/ }),

/***/ "8O/4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import axios from 'axios'
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {},
  created: function created() {
    var fullUrl = document.URL;
    var splitUrl = fullUrl.split('r?');
    sessionStorage.setItem('urlstr', splitUrl[1]);
  },

  methods: {}
});

/***/ }),

/***/ "8dQ5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8rri":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "9/pl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Notifications")]),_vm._v(" "),_c('p',{staticClass:"card-category"},[_vm._v("Handcrafted by our friend "),_c('a',{attrs:{"target":"_blank","href":"https://github.com/cristijora"}},[_vm._v("Cristi Jora")]),_vm._v(". Please checkout the "),_c('a',{attrs:{"href":"https://github.com/cristijora/vue-notifyjs","target":"_blank"}},[_vm._v("full documentation.")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('h5',[_vm._v("Notifications Style")]),_vm._v(" "),_c('div',{staticClass:"alert alert-info"},[_c('span',[_vm._v("This is a plain notification")])]),_vm._v(" "),_c('div',{staticClass:"alert alert-info"},[_c('button',{staticClass:"close",attrs:{"type":"button","aria-hidden":"true"}},[_vm._v("×")]),_vm._v(" "),_c('span',[_vm._v("This is a notification with close button.")])]),_vm._v(" "),_c('div',{staticClass:"alert alert-info alert-with-icon",attrs:{"data-notify":"container"}},[_c('button',{staticClass:"close",attrs:{"type":"button","aria-hidden":"true"}},[_vm._v("×")]),_vm._v(" "),_c('span',{staticClass:"nc-icon nc-app",attrs:{"data-notify":"icon"}}),_vm._v(" "),_c('span',{attrs:{"data-notify":"message"}},[_vm._v("This is a notification with close button and icon.")])]),_vm._v(" "),_c('div',{staticClass:"alert alert-info alert-with-icon",attrs:{"data-notify":"container"}},[_c('button',{staticClass:"close",attrs:{"type":"button","aria-hidden":"true"}},[_vm._v("×")]),_vm._v(" "),_c('span',{staticClass:"nc-icon nc-app",attrs:{"data-notify":"icon"}}),_vm._v(" "),_c('span',{attrs:{"data-notify":"message"}},[_vm._v("This is a notification with close button and icon and have many lines. You can see that the icon and the close button are always vertically aligned. This is a beautiful notification. So you don't have to worry about the style.")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('h5',[_vm._v("Notification states")]),_vm._v(" "),_c('div',{staticClass:"alert alert-info"},[_c('button',{staticClass:"close",attrs:{"type":"button","aria-hidden":"true"}},[_vm._v("×")]),_vm._v(" "),_c('span',[_c('b',[_vm._v(" Info - ")]),_vm._v(" This is a regular notification made with \".alert-info\"")])]),_vm._v(" "),_c('div',{staticClass:"alert alert-success"},[_c('button',{staticClass:"close",attrs:{"type":"button","aria-hidden":"true"}},[_vm._v("×")]),_vm._v(" "),_c('span',[_c('b',[_vm._v(" Success - ")]),_vm._v(" This is a regular notification made with \".alert-success\"")])]),_vm._v(" "),_c('div',{staticClass:"alert alert-warning"},[_c('button',{staticClass:"close",attrs:{"type":"button","aria-hidden":"true"}},[_vm._v("×")]),_vm._v(" "),_c('span',[_c('b',[_vm._v(" Warning - ")]),_vm._v(" This is a regular notification made with \".alert-warning\"")])]),_vm._v(" "),_c('div',{staticClass:"alert alert-danger"},[_c('button',{staticClass:"close",attrs:{"type":"button","aria-hidden":"true"}},[_vm._v("×")]),_vm._v(" "),_c('span',[_c('b',[_vm._v(" Danger - ")]),_vm._v(" This is a regular notification made with \".alert-danger\"")])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"places-buttons"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-6 text-center"},[_c('h5',[_vm._v("Notifications Places\n              "),_c('p',{staticClass:"category"},[_vm._v("Click to view notifications")])])])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-3 col-md-offset-1"},[_c('button',{staticClass:"btn btn-default btn-block",on:{"click":function($event){_vm.notifyVue('top', 'left')}}},[_vm._v("Top Left")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('button',{staticClass:"btn btn-default btn-block",on:{"click":function($event){_vm.notifyVue('top', 'center')}}},[_vm._v("Top Center")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('button',{staticClass:"btn btn-default btn-block",on:{"click":function($event){_vm.notifyVue('top', 'right')}}},[_vm._v("Top Right")])])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-3 col-md-offset-1"},[_c('button',{staticClass:"btn btn-default btn-block",on:{"click":function($event){_vm.notifyVue('bottom', 'left')}}},[_vm._v("Bottom Left")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('button',{staticClass:"btn btn-default btn-block",on:{"click":function($event){_vm.notifyVue('bottom', 'center')}}},[_vm._v("Bottom Center")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('button',{staticClass:"btn btn-default btn-block",on:{"click":function($event){_vm.notifyVue('bottom', 'right')}}},[_vm._v("Bottom Right")])])])])],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "93fV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"url_valid"}},[_c('div',{attrs:{"id":"border"}},[_c('div',{staticClass:"survey-forms"},[_c('div',{staticClass:"row "},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12"}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.formSubmit),expression:"!formSubmit"}],staticClass:"col-xs-12 col-sm-12 col-md-12 survey-form",style:({ 'background-image': 'url(' + _vm.bgImage + ')' })},[_c('div',{staticClass:"survey-content"},[_c('div',{staticClass:"form-layout"},[_c('p',{attrs:{"id":"top-para"}},[_vm._v("Happy Milk Index(HMI) is an index created by Doodhvale to measure the happiness index of the milk you are consuming.  It is proven that a happier milk is a healthier milk.")]),_vm._v(" "),_c('p',{attrs:{"id":"question_para"}},[_vm._v("Please answer the following questions to find out your milk’s HMI score : ")]),_vm._v(" "),_c('form',[_c('b-field',{attrs:{"label":"Name"}},[_c('b-input',{staticStyle:{"width":"100%","height":"50px"},attrs:{"name":"name","type":"text","placeholder":"Name"},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1),_vm._v(" "),_c('b-field',{attrs:{"label":"Mobile Number"}},[_c('b-input',{staticStyle:{"width":"100%","height":"50px"},attrs:{"type":"text","name":"mobile","id":"mobile","placeholder":"Mobile Number","oninput":"this.value=this.value.replace(/[^0-9]/g,'');"},model:{value:(_vm.mobile_no),callback:function ($$v) {_vm.mobile_no=$$v},expression:"mobile_no"}})],1),_vm._v(" "),(_vm.error_mob.length>0)?_c('span',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.error_mob)+"\n                      ")]):_vm._e(),_vm._v(" "),_c('b-field',{attrs:{"label":"Address"}},[_c('b-input',{staticStyle:{"width":"100%","height":"50px"},attrs:{"type":"text","name":"address","placeholder":"Address"},model:{value:(_vm.address),callback:function ($$v) {_vm.address=$$v},expression:"address"}})],1),_vm._v(" "),_c('b-field',{attrs:{"label":"Pin Code"}},[_c('b-input',{staticStyle:{"width":"100%","height":"50px"},attrs:{"id":"pincode","type":"text","name":"pincode","placeholder":"Pin Code","oninput":"this.value=this.value.replace(/[^0-9]/g,'');"},model:{value:(_vm.pin_code),callback:function ($$v) {_vm.pin_code=$$v},expression:"pin_code"}})],1),_vm._v(" "),(_vm.error_pin.length>0)?_c('span',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.error_pin)+"\n                      ")]):_vm._e()],1)]),_vm._v(" "),_vm._l((_vm.questionArray),function(questionObj){return _c('div',{key:questionObj.id,staticClass:"card-layout"},[_c('div',{staticClass:"card-view"},[_c('div',{staticClass:"question",attrs:{"id":questionObj.id}},[_vm._v("\n                        "+_vm._s(questionObj.questions)+"\n                      ")]),_vm._v(" "),_c('div',{staticClass:"answer row"},[_c('div',{staticClass:"col-xs-4 col-sm-4 col-md-4"},[_c('b-radio',{attrs:{"native-value":"1"},model:{value:(questionObj.answer),callback:function ($$v) {_vm.$set(questionObj, "answer", $$v)},expression:"questionObj.answer"}},[_vm._v("\n                            Yes\n                          ")])],1),_vm._v(" "),_c('div',{staticClass:"col-xs-4 col-sm-4 col-md-4"},[_c('b-radio',{attrs:{"native-value":"0"},model:{value:(questionObj.answer),callback:function ($$v) {_vm.$set(questionObj, "answer", $$v)},expression:"questionObj.answer"}},[_vm._v("\n                            No\n                          ")])],1),_vm._v(" "),_c('div',{staticClass:"col-xs-4 col-sm-4 col-md-4"},[_c('b-radio',{attrs:{"native-value":"-1"},model:{value:(questionObj.answer),callback:function ($$v) {_vm.$set(questionObj, "answer", $$v)},expression:"questionObj.answer"}},[_vm._v("\n                            Don't Know\n                          ")])],1)]),_vm._v(" "),_c('span',{staticClass:"errormsg",attrs:{"id":'err_'+ questionObj.id}})])])}),_vm._v(" "),_c('div',{staticClass:"text-center submit-btn"},[_c('b-button',{staticClass:"btn btn-primary rounded",attrs:{"rounded":"true","type":"is-primary","size":"is-medium"},on:{"click":_vm.saveFormDetails}},[_vm._v("CHECK SCORE")])],1),_vm._v(" "),_c('p',{attrs:{"id":"disclaimer"}},[_vm._v("*Happy Milk Index is an index made and managed by Doodhvale itself to maintain their milk’s quality standards. HMI is not an industry standard metric and is not accredited by any of the certified bodies.")])],2)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.formSubmit),expression:"formSubmit"}],staticClass:"col-xs-12 col-sm-12 col-md-12 survey-result"},[_c('img',{staticClass:"result-image",attrs:{"src":_vm.getImage()}}),_vm._v(" "),_c('div',{staticClass:"succes-button"},[_c('b-button',{staticClass:"btn btn-success",on:{"click":_vm.downloadApp}},[_vm._v("Download App")])],1)]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12"})]),_vm._v(" "),_c('div')]),_vm._v(" "),_c('loading',{attrs:{"active":_vm.isLoading,"is-full-page":_vm.fullPage,"color":'#FFDE00'},on:{"update:active":function($event){_vm.isLoading=$event}}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "947H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A05z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pp_vue__ = __webpack_require__("rZMg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19c2f1ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pp_vue__ = __webpack_require__("GumB");
function injectStyle (ssrContext) {
  __webpack_require__("IsQq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19c2f1ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AH7q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      apiUrl: 'https://doodhvale.in/dv/',
      imgPreUrl: 'https://doodhvale.in',
      products: [],
      Productlist: []
    };
  },
  created: function created() {
    var _this = this;

    var params = new URLSearchParams();
    params.append('user_id', 0);
    params.append('cat_id', 2);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.apiUrl + 'doodhvale/api/web/v3/products/products-with-pre-post-price', params).then(function (response) {
      _this.products = response.data.product_list;
      // console.log("api loading");
      //  console.log("api called",this.products)
      // console.log("this.contents hi ")
    });
  }
});

/***/ }),

/***/ "AKoQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ae1M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Atwy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    LTable: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Table_vue__["a" /* default */],
    ChartCard: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */],
    StatsCard: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */]
  },
  data: function data() {
    return {
      deliveryFrequency: 3,
      quantity: 1,
      subscriptionType: 'Postpaid',
      type: 'Daily',
      alternate: 2,
      urlInterface: [],
      apiDataObj: [],
      userDetails: [],
      subscriptionObj: [],
      isServicePin: [],
      successfully_unsubscribe: false,
      imgPreUrl: 'https://doodhvale.in'
    };
  },
  created: function created() {
    this.fetchData();
  },

  methods: {
    fetchData: function fetchData() {
      var _this = this;

      var params = new URLSearchParams();
      var fullUrl = document.URL;
      var splitUrl = fullUrl.split('s?');
      sessionStorage.setItem('urlstr', splitUrl[1]);
      params.append('url_str', splitUrl[1]);
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/accounts/fetch-url-interface-data',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this.urlInterface = {};
        if (response.data.status === '000001' || response.data.status === '000002' || response.data.status === '000003') {
          _this.urlInterface.error_msg = response.data.msg;
          document.getElementById('url_valid').style.display = 'none';
        } else {
          document.getElementById('url_expired').style.display = 'none';
          _this.urlInterface.action_name = response.data.action_name;
          _this.urlInterface.url_interface_id = response.data.url_interface_id;
          _this.invokeUrlAction();
        }
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          _this.list = response.data.user_record;
          alert(_this.list);
        }
      }).catch(function (e) {
        alert('not ok');
      });
    },
    invokeUrlAction: function invokeUrlAction() {
      var _this2 = this;

      var params = new URLSearchParams();
      params.append('url_interface_id', this.urlInterface.url_interface_id);
      params.append('action_name', this.urlInterface.action_name);
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/accounts/invoke-url-action',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this2.apiDataObj = {};
        switch (_this2.urlInterface.action_name) {
          case 'remarketing_price_feedback_list':
          case 'remarketing_diff_prod_list':
          case 'remarketing_taste_feedback_list':
          case 'remarketing_service_feedback_list':
          case 'remarketing_quality_issue_list':
          case 'remarketing_unknown_feedback_list':
          case 'remarketing_white_list':
          case 'remarketing_all_unsubscribed_list':
          case 'new_user_subscription':
          case 'new_user_online_url':
          case 'remarketing_white_list_product':
          default:
            if (response.data.action_response.user_id === '0') {
              _this2.apiDataObj.userId = sessionStorage.getItem('userId');
            } else {
              _this2.apiDataObj.userId = response.data.action_response.user_id;
            }
            _this2.userInfo();
            if (response.data.action_response.offer_status === 'Expired') {
              _this2.apiDataObj.promocodeError = response.data.action_response.display_msg;
              document.getElementById('promo_valid').style.display = 'none';
            } else {
              document.getElementById('promo_expired').style.display = 'none';
              _this2.apiDataObj.promocodeId = response.data.action_response.promocode_id;
              _this2.apiDataObj.promocodeName = response.data.action_response.promo_code;
              _this2.apiDataObj.promocodeDesc = response.data.action_response.promocode_desc;
              _this2.apiDataObj.productId = response.data.action_response.product_id;
              if (_this2.apiDataObj.productId === 128 || _this2.apiDataObj.productId === 129) {
                _this2.quantity = 2;
              }
              _this2.apiDataObj.productName = response.data.action_response.product_name;
              _this2.apiDataObj.productPrice = response.data.action_response.product_price;
              _this2.apiDataObj.productDiscount = response.data.action_response.offered_discount;
              _this2.apiDataObj.productOfferedPrice = response.data.action_response.product_price - response.data.action_response.offered_discount;
              _this2.apiDataObj.productDesc = response.data.action_response.product_desc;
              _this2.apiDataObj.shortDescription = response.data.action_response.short_description;
              _this2.apiDataObj.longDescription = response.data.action_response.long_description;
              _this2.apiDataObj.showSchedule = response.data.action_response.show_schedule;
              _this2.apiDataObj.productImageUrl = response.data.action_response.product_image_url;
              _this2.apiDataObj.brandName = response.data.action_response.brand_name;
              _this2.apiDataObj.subscriptionType = response.data.action_response.subscription_type;
              sessionStorage.setItem('userId', _this2.apiDataObj.userId);
              sessionStorage.setItem('productId', _this2.apiDataObj.productId);
              sessionStorage.setItem('productName', _this2.apiDataObj.productName);
              sessionStorage.setItem('productImageUrl', _this2.imgPreUrl + _this2.apiDataObj.productImageUrl);
              sessionStorage.setItem('productShortDescription', _this2.apiDataObj.shortDescription);
              sessionStorage.setItem('productLongDescription', _this2.apiDataObj.longDescription);
              sessionStorage.setItem('brandName', _this2.apiDataObj.brandName);
              sessionStorage.setItem('isEditSubscription', 'no');
              sessionStorage.setItem('subscriptionId', 0);
              sessionStorage.setItem('subscriptionType', _this2.apiDataObj.subscriptionType);
              sessionStorage.setItem('promocodeName', _this2.apiDataObj.promocodeName);
              sessionStorage.setItem('promocodeDesc', _this2.apiDataObj.promocodeDesc);
              sessionStorage.setItem('productListUrl', response.data.action_response.product_list_url);
              // debugger
              sessionStorage.setItem('directLinkOfferedDiscount', response.data.action_response.offered_discount);
              _this2.$router.push('/a/editSubscription');
              // this.apiDataObj.showSchedule = "no"
              if (_this2.apiDataObj.showSchedule === 'yes') {
                _this2.type = 'Daily';
                document.getElementById('show_schedule').style.display = 'block';
                document.getElementById('show_start_date').style.display = 'block';
                document.getElementById('show_delivery_date').style.display = 'none';
              } else {
                _this2.type = 'One Time';
                document.getElementById('show_schedule').style.display = 'none';
                document.getElementById('show_start_date').style.display = 'none';
                document.getElementById('show_delivery_date').style.display = 'block';
              }
              _this2.apiDataObj.startDate = response.data.action_response.start_date;
              _this2.apiDataObj.displayedStartDate = _this2.apiDataObj.startDate.split('-').reverse().join('-');
              document.getElementById('subscribed').style.display = 'none';
            }
            break;
          // default:
          // break
        }
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          _this2.list = response.data.user_record;
          alert(_this2.list);
        }
      }).catch(function (e) {
        alert('not ok');
      });
    },
    userInfo: function userInfo() {
      var _this3 = this;

      var params = new URLSearchParams();
      var userId = this.apiDataObj.userId;
      params.append('user_id', userId);
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/users/user-info',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this3.userDetails = {};
        _this3.userDetails.userId = userId;
        _this3.userDetails.first_name = response.data.user_record.user_details.first_name;
        _this3.userDetails.mobile = response.data.user_record.user.username;
        _this3.userDetails.pincode = response.data.user_record.address.pincode;
        _this3.userDetails.address = response.data.user_record.address.address1 + ' ' + response.data.user_record.address.address2 + ' ' + response.data.user_record.address.city;
        _this3.userDetails.zombie = response.data.user_record.user_details.zombie;
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          _this3.list = response.data.user_record;
          alert(_this3.list);
        }
      }).catch(function (e) {
        alert('not ok');
      });
    },
    isServicePincode: function isServicePincode() {
      var _this4 = this;

      var params = new URLSearchParams();
      params.append('user_id', this.apiDataObj.userId);
      params.append('pincode', this.userDetails.pincode);
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/subscriptions/is-service-pincode',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this4.isServicePin = {};
        if (_this4.userDetails.zombie === 1 && _this4.userDetails.pincode === '000000') {
          _this4.$swal({
            title: 'Sorry!',
            text: 'We don\'t have your delivery address/location. Please update for uninterrupt service!',
            type: 'warning',
            showCancelButton: false,
            confirmButtonText: 'Update Address!'
            // showCloseButton: true,
            // showLoaderOnConfirm: true
          }).then(function (result) {
            if (result.value) {
              // this.$swal('Address', 'Update address', 'info')
              sessionStorage.setItem('userId', _this4.apiDataObj.userId);
              sessionStorage.setItem('isProfile', 1);
              _this4.$router.push('/a/location');
            } else {
              // this.$swal('Success', 'Thanks you!', 'success')
            }
          });
        } else if (_this4.userDetails.pincode === '000000' || _this4.userDetails.pincode === 0) {
          _this4.$swal({
            title: 'Sorry!',
            text: 'We don\'t have your delivery address/location. Please update for uninterrupt service!',
            type: 'warning',
            showCancelButton: false,
            confirmButtonText: 'Update Address!'
            // showCloseButton: true,
            // showLoaderOnConfirm: true
          }).then(function (result) {
            if (result.value) {
              // this.$swal('Address', 'Update address', 'info')
              sessionStorage.setItem('userId', _this4.apiDataObj.userId);
              sessionStorage.setItem('isProfile', 1);
              _this4.$router.push('/a/location');
            } else {
              // this.$swal('Success', 'Thanks you!', 'success')
            }
          });
        } else if (response.data.status === '000000') {
          _this4.subscribe();
        } else {
          // alert(response.data.msg)
          _this4.$swal({
            title: 'Sorry!',
            text: 'We don\'t have service in your area as of today. We will inform you once we start the service!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Change Address!',
            cancelButtonText: 'Notify me!',
            cancelButtonColor: '#3CB6C3'
            // showCloseButton: true,
            // showLoaderOnConfirm: true
          }).then(function (result) {
            if (result.value) {
              // this.$swal('Address', 'Update address', 'info')
              sessionStorage.setItem('userId', _this4.apiDataObj.userId);
              sessionStorage.setItem('isProfile', 1);
              _this4.$router.push('/a/location');
            } else {
              _this4.$swal('Success', 'We will inform you once we start the service', 'success');
            }
          });
        }
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          _this4.list = response.data.user_record;
          alert(_this4.list);
        }
      }).catch(function (e) {
        alert('not ok');
      });
    },
    subscribe: function subscribe() {
      var _this5 = this;

      var params = new URLSearchParams();
      params.append('user_id', this.apiDataObj.userId);
      params.append('product_id', this.apiDataObj.productId);
      params.append('start_date', this.apiDataObj.startDate);
      params.append('type', this.type);
      params.append('delivery_frequency', this.deliveryFrequency);
      params.append('subscription_type', this.subscriptionType);
      params.append('promo_code', this.apiDataObj.promocodeName);
      params.append('quantity', this.quantity);
      params.append('alternate', this.alternate);
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/subscriptions/add',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this5.subscriptionObj = {};
        if (response.data.status === '000000') {
          _this5.subscriptionObj.paymentUrl = response.data.payment_url;
          document.getElementById('subscribed').style.display = 'block';
          document.getElementById('not_subscribed').style.display = 'none';
        } else {
          alert(response.data.msg);
        }
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          _this5.list = response.data.user_record;
          alert(_this5.list);
        }
      }).catch(function (e) {
        alert('not ok');
      });
    }
  }
});

/***/ }),

/***/ "AxoN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeDropDown),expression:"closeDropDown"}],tag:"li",staticClass:"dropdown nav-item",class:{show: _vm.isOpen},attrs:{"aria-haspopup":"true","aria-expanded":_vm.isOpen},on:{"click":_vm.toggleDropDown}},[_c('a',{staticClass:"nav-link dropdown-toggle",attrs:{"data-toggle":"dropdown"}},[_vm._t("title",[_c('i',{class:_vm.icon}),_vm._v(" "),_c('span',{staticClass:"no-icon"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('b',{staticClass:"caret"})])],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],staticClass:"dropdown-menu"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "B2Q4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserProfile_vue__ = __webpack_require__("+a+j");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72e6d0e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserProfile_vue__ = __webpack_require__("/rfY");
function injectStyle (ssrContext) {
  __webpack_require__("YTiL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72e6d0e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "B2Xj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w3-content",staticStyle:{"max-width":"1100px"}},[_c('div',{staticClass:"w3-row w3-padding-34 w3-center",attrs:{"id":"about"}},[_c('form',{attrs:{"action":"#","target":"_blank"}},[_c('p',{staticClass:"w3-center"},[_c('router-link',{staticClass:"w3-button w3-light-grey w3-section",attrs:{"to":{path:'/a/reg'}}},[_vm._v("SUBSCRIBE MILK")])],1)]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"w3-container w3-padding-34",attrs:{"id":"contact"}},[_c('h1',[_vm._v("Contact")]),_c('br'),_vm._v(" "),_c('p',{staticClass:"w3-text-blue-grey w3-large"},[_vm._v("You can also contact us by phone 8010342342 or email care@doodhvale.in")]),_vm._v(" "),_c('p',{staticClass:"w3-text-blue-grey w3-large"},[_vm._v("Click below to subscribe milk")]),_vm._v(" "),_c('form',{attrs:{"action":"#","target":"_blank"}},[_c('p',{staticClass:"w3-center"},[_c('router-link',{staticClass:"w3-button w3-light-grey w3-section",attrs:{"to":{path:'/a/reg'}}},[_vm._v("SUBSCRIBE MILK")])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w6-col l6 w3-padding-large"},[_c('h1',{staticClass:"w3-center"},[_vm._v("About Doodhvale")]),_c('br'),_vm._v(" "),_c('p',{staticClass:"w3-large"},[_vm._v("Doodhvale.com is a brand which stands for providing organically produced farm fresh milk which is completely un-touch from human hands from its own farm setup and deliveres at your doorstep every morning. Doodvale.com has its own quality processes and checks to ensures the quality, hygine and hassle free ontime delivery of your orders. ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w3-row w3-padding-34",attrs:{"id":"menu"}},[_c('div',{staticClass:"w6-col l6 w3-padding-large"},[_c('h1',{staticClass:"w3-center"},[_vm._v("Our Products")]),_c('br'),_vm._v(" "),_c('h4',[_vm._v("Fresh Cow Milk")]),_vm._v(" "),_c('p',{staticClass:"w3-text-grey"},[_vm._v("70.00 rs. per 1 LITRE")]),_c('br'),_vm._v(" "),_c('div',{staticClass:"w3-col l6 w3-padding-large"},[_c('img',{staticClass:"w3-round w3-image",staticStyle:{"width":"100%"},attrs:{"src":"http://doodhvale.in//dv/doodhvale/backend/web/uploads/lgXr4oKrZc8DoA1xoMduJknO6Phu_iQs.JPG","alt":"Menu"}})]),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}}),_vm._v(" "),_c('h4',[_vm._v("Pure Cow Ghee")]),_vm._v(" "),_c('p',{staticClass:"w3-text-grey"},[_vm._v("850.00 rs. per 1 KG")]),_vm._v(" "),_c('div',{staticClass:"w3-col l6 w3-padding-large"},[_c('img',{staticClass:"w3-round w3-image",staticStyle:{"width":"100%"},attrs:{"src":"http://doodhvale.in//dv/doodhvale/backend/web/uploads/AY5jUzfRc0nzRo6eyppousaWopsZ7Hij.png","alt":"Menu"}})]),_vm._v(" "),_c('br')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BZRp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.profile === false)?_c('div',[(_vm.dispatcherLocationFlow === false || _vm.salesman_location_required == 1)?_c('div',{staticClass:"w3-center"},[_c('br'),_vm._v(" "),_c('div',{attrs:{"id":"floating-panel"},on:{"click":function($event){_vm.onClickCurrentLocationButtion();}}},[_c('img',{staticStyle:{"width":"17%"},attrs:{"src":__webpack_require__("4hQa")}})]),_vm._v(" "),_c('gmap-map',{staticStyle:{"height":"250px"},attrs:{"center":_vm.center,"zoom":14}},_vm._l((_vm.markers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":m.position,"clickable":true,"draggable":true},on:{"drag":_vm.updateCoordinates}})})),_c('br'),_vm._v(" "),_c('b',[_vm._v("Set Delivery Location on map and write complete address below")])],1):_vm._e(),_vm._v(" "),_c('div',[_c('form',[_c('div',{staticStyle:{"margin-left":"5%","margin-top":"5%","width":"90%"}},[(_vm.dispatcherLocationFlow === false || _vm.salesman_location_required == 1)?_c('div',[_c('textarea',{staticClass:"location_edit",staticStyle:{"color":"gray","font-style":"italic"},attrs:{"id":"del_loc","placeholder":"","readonly":"true"}})]):_c('div',{staticStyle:{"text-align":"center","font-size":"18px","margin-bottom":"1rem"}},[_vm._v("\n            Fill Delivery Address\n          ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address1),expression:"address1"}],staticClass:"location_edit",attrs:{"id":"address1","placeholder":"* H. NO | FLOOR | LOCALITY | AREA"},domProps:{"value":(_vm.address1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.address1=$event.target.value}}}),_c('br'),_c('hr',{staticStyle:{"display":"block","height":"1px","border":"0","border-top":"1px solid gray","margin":"0em 0%","padding":"0","margin-bottom":"5%"}}),_vm._v(" "),(_vm.dispatcherLocationFlow === true)?_c('div',[_c('span',{staticStyle:{"margin-bottom":"1rem"}},[_vm._v("City : \n              "),_c('b-select',{attrs:{"placeholder":"Select City"},model:{value:(_vm.city),callback:function ($$v) {_vm.city=$$v},expression:"city"}},_vm._l((_vm.cityList),function(location){return _c('option',{key:location.city_name,domProps:{"value":location.city_name}},[_vm._v("\n                  "+_vm._s(location.city_name)+"\n                ")])}))],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pincode),expression:"pincode"}],staticClass:"location_edit",staticStyle:{"margin-top":"1rem"},attrs:{"maxlength":"6","placeholder":"* PINCODE"},domProps:{"value":(_vm.pincode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.pincode=$event.target.value}}}),_c('br'),_c('hr',{staticStyle:{"display":"block","height":"1px","border":"0","border-top":"1px solid gray","margin":"0em 0%","padding":"0","margin-bottom":"5%"}})]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address2),expression:"address2"}],staticClass:"location_edit",attrs:{"id":"address2","placeholder":"LANDMARK[OPTIONAL]"},domProps:{"value":(_vm.address2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.address2=$event.target.value}}}),_c('br'),_c('hr',{staticStyle:{"display":"block","height":"1px","border":"0","border-top":"1px solid gray","margin":"0em 0%","padding":"0","margin-bottom":"5%"}})]),_vm._v(" "),_c('input',{staticClass:"subprofile",attrs:{"value":"NEXT","type":"button"},on:{"click":function($event){_vm.onSubmit();}}})])])]):_vm._e(),_vm._v(" "),(_vm.profile)?_c('div',[_c('div',{staticClass:"w3-center"},[_c('br'),_vm._v(" "),_c('img',{staticStyle:{"width":"35%"},attrs:{"src":__webpack_require__("zV0d")}}),_c('br'),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gender),expression:"gender"}],attrs:{"type":"radio","id":"male","value":"M"},domProps:{"checked":_vm._q(_vm.gender,"M")},on:{"change":function($event){_vm.gender="M"}}}),_vm._v(" "),_c('label',{attrs:{"for":"male"}},[_vm._v("Male")]),_vm._v("     \n      "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gender),expression:"gender"}],attrs:{"type":"radio","id":"female","value":"F"},domProps:{"checked":_vm._q(_vm.gender,"F")},on:{"change":function($event){_vm.gender="F"}}}),_vm._v(" "),_c('label',{attrs:{"for":"female"}},[_vm._v("Female")])]),_vm._v(" "),_c('div',[_c('form',[_c('div',{staticStyle:{"margin-left":"5%","margin-top":"5%","width":"90%"}},[_c('input',{staticClass:"profile_edit",attrs:{"id":"profile_name","placeholder":"* NAME"}}),_c('br'),_c('hr',{staticStyle:{"display":"block","height":"1px","border":"0","border-top":"1px solid gray","margin":"0em 0%","padding":"0","margin-bottom":"5%"}}),_vm._v(" "),_c('input',{staticClass:"profile_edit",attrs:{"id":"profile_email","placeholder":"* EMAIL"}}),_c('br'),_c('hr',{staticStyle:{"display":"block","height":"1px","border":"0","border-top":"1px solid gray","margin":"0em 0%","padding":"0","margin-bottom":"5%"}}),_vm._v(" "),(_vm.salesman_flow == 0)?_c('input',{staticClass:"profile_edit",attrs:{"id":"profile_referral","placeholder":"REFERRAL CODE[OPTIONAL]"}}):_vm._e(),_c('br'),(_vm.salesman_flow == 0)?_c('hr',{staticStyle:{"display":"block","height":"1px","border":"0","border-top":"1px solid gray","margin":"0em 0%","padding":"0","margin-bottom":"5%"}}):_vm._e(),_vm._v(" "),_c('br'),_c('br')]),_vm._v(" "),_c('input',{staticClass:"subprofile",attrs:{"value":"SUBMIT","type":"button"},on:{"click":function($event){_vm.profileSetApi();}}})])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ba8P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__("LVCB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6028de1b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__("6dQT");
function injectStyle (ssrContext) {
  __webpack_require__("kxy4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6028de1b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BdUF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BrJK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppLink_vue__ = __webpack_require__("kefX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04a40156_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppLink_vue__ = __webpack_require__("M7nQ");
function injectStyle (ssrContext) {
  __webpack_require__("vn/I")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04a40156_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppLink_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CO8C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  data: function data() {
    return {
      user: {
        company: 'Paper Dashboard',
        username: 'michael23',
        email: '',
        firstName: 'Mike',
        lastName: 'Andrew',
        address: 'Melbourne, Australia',
        city: 'melbourne',
        country: 'Australia',
        postalCode: '',
        aboutMe: 'Lamborghini Mercy, Your chick she so thirsty, I\'m in that two seat Lambo.'
      }
    };
  },

  methods: {
    updateProfile: function updateProfile() {
      alert('Your data: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.user));
    }
  }
});

/***/ }),

/***/ "ClWv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Crv8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SideBar_vue__ = __webpack_require__("R5Ta");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarLink_vue__ = __webpack_require__("7SdG");



var SidebarStore = {
  showSidebar: false,
  sidebarLinks: [{
    name: 'Dashboard',
    icon: 'ti-panel',
    path: '/admin/p'
  }],
  displaySidebar: function displaySidebar(value) {
    this.showSidebar = value;
  }
};

var SidebarPlugin = {
  install: function install(Vue) {
    Vue.mixin({
      data: function data() {
        return {
          sidebarStore: SidebarStore
        };
      }
    });

    Object.defineProperty(Vue.prototype, '$sidebar', {
      get: function get() {
        return this.$root.sidebarStore;
      }
    });
    Vue.component('side-bar', __WEBPACK_IMPORTED_MODULE_0__SideBar_vue__["a" /* default */]);
    Vue.component('sidebar-link', __WEBPACK_IMPORTED_MODULE_1__SidebarLink_vue__["a" /* default */]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (SidebarPlugin);

/***/ }),

/***/ "D2Ge":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DQ9D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DuYP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-us full-screen"},[_c('nav',{staticClass:"navbar navbar-ct-default",attrs:{"role":"navigation-demo"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-header"},[_vm._m(0),_vm._v(" "),_c('router-link',{staticClass:"navbar-brand",attrs:{"to":{path:'/'}}},[_vm._v("Doodhvale")])],1),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navigation-example-2"}},[_c('ul',{staticClass:"nav navbar-nav navbar-right"},[_c('li',[_c('router-link',{attrs:{"to":{path:'/'}}},[_vm._v("Home")])],1)])])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('footer',{staticClass:"footer-demo"},[_c('div',{staticClass:"container"},[_c('nav',{staticClass:"pull-left"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":{path:'/'}}},[_vm._v("Home")])],1)])]),_vm._v(" "),_vm._m(2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggle",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navigation-example-2"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper wrapper-full-page section content"},[_c('div',{},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-md-offset-2 text-center"},[_c('h2',{staticClass:"title text-danger"},[_vm._v("404 Not Found")]),_vm._v(" "),_c('h2',{staticClass:"title"},[_vm._v("Oops! It seems that this page does not exist.")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyright pull-right"},[_vm._v("\n        © 2020, made with\n        "),_c('i',{staticClass:"fa fa-heart heart"}),_vm._v(" by Subtlelabs Software Solutions Pvt. Ltd.\n      ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ERnB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostpaidNotice_vue__ = __webpack_require__("ZET8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50d2c79c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostpaidNotice_vue__ = __webpack_require__("sqji");
function injectStyle (ssrContext) {
  __webpack_require__("p8uF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostpaidNotice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50d2c79c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostpaidNotice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EhW6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ei4b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FGMu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FqlF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GOCq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"flyaway"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GRlf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sw_vue__ = __webpack_require__("I4w/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a23cb94_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sw_vue__ = __webpack_require__("xSBc");
function injectStyle (ssrContext) {
  __webpack_require__("dXEd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sw_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a23cb94_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sw_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GacN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: false,
      sendMail: false,
      isLoading: false,
      errors: ''
    };
  },
  created: function created() {},

  methods: {
    email: function email() {
      var _this = this;

      this.isLoading = true;
      var studentName = document.getElementById('stu-name').value;
      var fatherName = document.getElementById('fath-name').value;
      var mobile = document.getElementById('mobile').value;
      var classs = document.getElementById('classs').value;
      var address = document.getElementById('address').value;
      if (address === '') {
        address = 'not set';
      }
      if (studentName === '') {
        this.errors = 'Student’s Name not set';
        this.isActive = true;
      } else if (fatherName === '') {
        this.errors = 'Father’s Name not set';
        this.isActive = true;
      } else if (isNaN(mobile) || mobile.length !== 10 || mobile === '') {
        this.errors = 'Oops! Invalid Mobile No.';
        this.isActive = true;
      } else {
        var params = new URLSearchParams();
        params.append('student_name', studentName);
        params.append('father_name', fatherName);
        params.append('mobile', mobile);
        params.append('class', classs);
        params.append('address', address);
        __WEBPACK_IMPORTED_MODULE_0_axios___default()({
          url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/users/send-mail-for-gschool',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {}
        }).then(function (response) {
          if (response.data.status === '000000') {
            _this.isActive = false;
            _this.sendMail = true;
            _this.isLoading = false;
          } else {
            _this.errors = 'Oops! Something went wrong';
            _this.isActive = true;
            _this.isLoading = false;
          }
          // console.log(response)
          if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
            _this.list = response.data.user_record;
            alert(_this.list);
          }
        }).catch(function (e) {
          alert('not ok');
        });
      }
    },
    onAmmountChange: function onAmmountChange() {
      this.errors = '';
      this.isActive = false;
      document.getElementById('mobile').value = Number(document.getElementById('mobile').value);
    },

    isNumber: function isNumber(evt) {
      if (!evt) {
        evt = window.event;
      }
      // evt = (evt) ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    }
  }
});

/***/ }),

/***/ "GjBJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GumB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container is-fluid has-text-centered"},[_c('b-loading',{attrs:{"is-full-page":_vm.isFullPage,"active":_vm.isLoading},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"display":"none"},attrs:{"id":"bafore_checksum"}},[(_vm.userData)?_c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"url_valid"}},[_c('div',[_c('div',{attrs:{"id":"clear"}},[_c('h4',[_vm._v("No Dues")]),_vm._v(" "),_c('div',{staticClass:"pending_wallet"},[_c('i',{staticClass:"fa fa-rupee"}),_c('b',[_vm._v(_vm._s(_vm.apiDataObj.wallet_amount))])])]),_vm._v(" "),_c('div',{attrs:{"id":"pending"}},[_c('h4',[_vm._v("Pending Amount")]),_vm._v(" "),_c('div',{staticClass:"pending_wallet"},[_c('i',{staticClass:"fa fa-rupee"}),_c('b',[_vm._v(_vm._s(_vm.apiDataObj.pending_amount))])])]),_vm._v(" "),_c('div',{attrs:{"id":"not_pending"}},[_c('h4',[_vm._v("Wallet Balance")]),_vm._v(" "),_c('div',{staticClass:"pending_wallet"},[_c('i',{staticClass:"fa fa-rupee"}),_c('b',[_vm._v(_vm._s(_vm.apiDataObj.wallet_amount))])])]),_vm._v(" "),_c('div',{staticStyle:{"display":"inline-block"}},[_c('form',[_c('div',{staticClass:"pending_wallet"},[_c('h3',[_vm._v("Enter Amount")]),_vm._v(" "),_c('i',{staticClass:"fa fa-rupee"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.apiDataObj.default_amount),expression:"apiDataObj.default_amount"}],staticClass:"amount_text",attrs:{"id":"txn_amt","name":"TXN_AMOUNT","oninput":"this.value=this.value.replace(/[^0-9]/g,'');","type":"text","placeholder":"Amount","autofocus":""},domProps:{"value":(_vm.apiDataObj.default_amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.apiDataObj, "default_amount", $event.target.value)}}})]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('b-notification',{attrs:{"type":"is-danger","closable":false,"active":_vm.isActive},on:{"update:active":function($event){_vm.isActive=$event}}},[_vm._v("\n                "+_vm._s(this.errors)+"\n              ")]),_vm._v(" "),(_vm.isQuickPaymentButtonDisplay === 1)?_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.btnOneValue),expression:"btnOneValue"}],staticClass:"quickPaymentButton",attrs:{"type":"button"},domProps:{"value":(_vm.btnOneValue)},on:{"click":_vm.btnOneClick,"input":function($event){if($event.target.composing){ return; }_vm.btnOneValue=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.btnTwoValue),expression:"btnTwoValue"}],staticClass:"quickPaymentButton",staticStyle:{"margin-left":"10px"},attrs:{"type":"button"},domProps:{"value":(_vm.btnTwoValue)},on:{"click":_vm.btnTwoClick,"input":function($event){if($event.target.composing){ return; }_vm.btnTwoValue=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.btnThreeValue),expression:"btnThreeValue"}],staticClass:"quickPaymentButton",staticStyle:{"margin-left":"10px"},attrs:{"type":"button"},domProps:{"value":(_vm.btnThreeValue)},on:{"click":_vm.btnThreeClick,"input":function($event){if($event.target.composing){ return; }_vm.btnThreeValue=$event.target.value}}})]):_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sevenDeliveryAmountLabel),expression:"sevenDeliveryAmountLabel"}],staticClass:"quickPaymentButton",attrs:{"type":"button"},domProps:{"value":(_vm.sevenDeliveryAmountLabel)},on:{"click":_vm.sevenDeliveryBtnClick,"input":function($event){if($event.target.composing){ return; }_vm.sevenDeliveryAmountLabel=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fifteenDeliveryAmountLabel),expression:"fifteenDeliveryAmountLabel"}],staticClass:"quickPaymentButton",staticStyle:{"margin-left":"10px"},attrs:{"type":"button"},domProps:{"value":(_vm.fifteenDeliveryAmountLabel)},on:{"click":_vm.fifteenDeliveryBtnClick,"input":function($event){if($event.target.composing){ return; }_vm.fifteenDeliveryAmountLabel=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.thirtyDeliveryAmountLabel),expression:"thirtyDeliveryAmountLabel"}],staticClass:"quickPaymentButton",staticStyle:{"margin-left":"10px"},attrs:{"type":"button"},domProps:{"value":(_vm.thirtyDeliveryAmountLabel)},on:{"click":_vm.thirtyDeliveryBtnClick,"input":function($event){if($event.target.composing){ return; }_vm.thirtyDeliveryAmountLabel=$event.target.value}}}),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fourtyFiveDeliveryAmountLabel),expression:"fourtyFiveDeliveryAmountLabel"}],staticClass:"quickPaymentButton",attrs:{"type":"button"},domProps:{"value":(_vm.fourtyFiveDeliveryAmountLabel)},on:{"click":_vm.fourtyFiveDeliveryBtnClick,"input":function($event){if($event.target.composing){ return; }_vm.fourtyFiveDeliveryAmountLabel=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sixtyDeliveryAmountLabel),expression:"sixtyDeliveryAmountLabel"}],staticClass:"quickPaymentButton",staticStyle:{"margin-left":"10px"},attrs:{"type":"button"},domProps:{"value":(_vm.sixtyDeliveryAmountLabel)},on:{"click":_vm.sixtyDeliveryBtnClick,"input":function($event){if($event.target.composing){ return; }_vm.sixtyDeliveryAmountLabel=$event.target.value}}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{staticClass:"button3",attrs:{"value":"Payment Now","type":"button"},on:{"click":_vm.generateChecksum}})],1)])])])]):_vm._e(),_vm._v(" "),(_vm.after_checksum)?_c('div',[_c('div',[_c('br'),_vm._v("\n        Dear "+_vm._s(_vm.userDetails.first_name)+"\n        "),_c('br'),_vm._v("\n        Please press button to continue\n        "),_c('br'),_c('br'),_vm._v("\n        Amount"),_c('i',{staticClass:"fa fa-rupee"}),_c('b',[_vm._v(_vm._s(_vm.genChecksum.TXN_AMOUNT))]),_c('br'),_c('br'),_vm._v(" "),_c('div',[_c('form',{attrs:{"method":"post","action":"https://securegw.paytm.in/theia/processTransaction"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.genChecksum.MID),expression:"genChecksum.MID"}],attrs:{"type":"hidden","name":"MID"},domProps:{"value":(_vm.genChecksum.MID)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.genChecksum, "MID", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.genChecksum.ORDER_ID),expression:"genChecksum.ORDER_ID"}],attrs:{"type":"hidden","name":"ORDER_ID"},domProps:{"value":(_vm.genChecksum.ORDER_ID)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.genChecksum, "ORDER_ID", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.genChecksum.CUST_ID),expression:"genChecksum.CUST_ID"}],attrs:{"type":"hidden","name":"CUST_ID"},domProps:{"value":(_vm.genChecksum.CUST_ID)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.genChecksum, "CUST_ID", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.genChecksum.INDUSTRY_TYPE_ID),expression:"genChecksum.INDUSTRY_TYPE_ID"}],attrs:{"type":"hidden","name":"INDUSTRY_TYPE_ID"},domProps:{"value":(_vm.genChecksum.INDUSTRY_TYPE_ID)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.genChecksum, "INDUSTRY_TYPE_ID", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.genChecksum.CHANNEL_ID),expression:"genChecksum.CHANNEL_ID"}],attrs:{"type":"hidden","name":"CHANNEL_ID"},domProps:{"value":(_vm.genChecksum.CHANNEL_ID)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.genChecksum, "CHANNEL_ID", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.genChecksum.WEBSITE),expression:"genChecksum.WEBSITE"}],attrs:{"type":"hidden","name":"WEBSITE"},domProps:{"value":(_vm.genChecksum.WEBSITE)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.genChecksum, "WEBSITE", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.genChecksum.CALLBACK_URL),expression:"genChecksum.CALLBACK_URL"}],attrs:{"type":"hidden","name":"CALLBACK_URL"},domProps:{"value":(_vm.genChecksum.CALLBACK_URL)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.genChecksum, "CALLBACK_URL", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.genChecksum.checksum),expression:"genChecksum.checksum"}],attrs:{"type":"hidden","name":"CHECKSUMHASH"},domProps:{"value":(_vm.genChecksum.checksum)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.genChecksum, "checksum", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.genChecksum.TXN_AMOUNT),expression:"genChecksum.TXN_AMOUNT"}],attrs:{"type":"hidden","name":"TXN_AMOUNT"},domProps:{"value":(_vm.genChecksum.TXN_AMOUNT)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.genChecksum, "TXN_AMOUNT", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.genChecksum.MERC_UNQ_REF),expression:"genChecksum.MERC_UNQ_REF"}],attrs:{"type":"hidden","name":"MERC_UNQ_REF"},domProps:{"value":(_vm.genChecksum.MERC_UNQ_REF)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.genChecksum, "MERC_UNQ_REF", $event.target.value)}}}),_vm._v(" "),_c('input',{staticClass:"button5",attrs:{"id":"pay","value":"Continue","type":"submit"},on:{"click":function($event){_vm.isLoading = true}}})])])])]):_vm._e(),_vm._v(" "),(_vm.app_payment_gate)?_c('div',{staticStyle:{"display":"none !important"}},[_c('div',[_c('br'),_vm._v("\n        Dear "+_vm._s(_vm.userDetails.first_name)+"\n        "),_c('br'),_vm._v("\n        Please press button to continue\n        "),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n        Amount"),_c('i',{staticClass:"fa fa-rupee"}),_c('b',[_vm._v(_vm._s(_vm.appPaymentGateway.TXN_AMOUNT))]),_c('br'),_c('br'),_vm._v(" "),_c('div',[_c('form',{attrs:{"method":"post","name":"hdfcform","id":"hdfcform","action":"https://doodhvale.in/dv/doodhvale/api/modules/v3/controllers/ccavRequestHandler.php"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.appPaymentGateway.TID),expression:"appPaymentGateway.TID"}],attrs:{"type":"hidden","name":"tid"},domProps:{"value":(_vm.appPaymentGateway.TID)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.appPaymentGateway, "TID", $event.target.value)}}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"merchant_id","value":"242357"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.appPaymentGateway.ORDER_ID),expression:"appPaymentGateway.ORDER_ID"}],attrs:{"type":"hidden","name":"order_id"},domProps:{"value":(_vm.appPaymentGateway.ORDER_ID)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.appPaymentGateway, "ORDER_ID", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.appPaymentGateway.TXN_AMOUNT),expression:"appPaymentGateway.TXN_AMOUNT"}],attrs:{"type":"hidden","name":"amount"},domProps:{"value":(_vm.appPaymentGateway.TXN_AMOUNT)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.appPaymentGateway, "TXN_AMOUNT", $event.target.value)}}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"currency","value":"INR"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.appPaymentGateway.responseUrl),expression:"appPaymentGateway.responseUrl"}],attrs:{"type":"hidden","name":"redirect_url"},domProps:{"value":(_vm.appPaymentGateway.responseUrl)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.appPaymentGateway, "responseUrl", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.appPaymentGateway.responseUrl),expression:"appPaymentGateway.responseUrl"}],attrs:{"type":"hidden","name":"cancel_url"},domProps:{"value":(_vm.appPaymentGateway.responseUrl)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.appPaymentGateway, "responseUrl", $event.target.value)}}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"language","value":"EN"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.fullName),expression:"userDetails.fullName"}],attrs:{"type":"hidden","name":"delivery_name"},domProps:{"value":(_vm.userDetails.fullName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "fullName", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.address),expression:"userDetails.address"}],attrs:{"type":"hidden","name":"delivery_address"},domProps:{"value":(_vm.userDetails.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "address", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.city),expression:"userDetails.city"}],attrs:{"type":"hidden","name":"delivery_city"},domProps:{"value":(_vm.userDetails.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "city", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.state),expression:"userDetails.state"}],attrs:{"type":"hidden","name":"delivery_state"},domProps:{"value":(_vm.userDetails.state)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "state", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.pincode),expression:"userDetails.pincode"}],attrs:{"type":"hidden","name":"delivery_zip"},domProps:{"value":(_vm.userDetails.pincode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "pincode", $event.target.value)}}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"delivery_country","value":"India"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.mobile),expression:"userDetails.mobile"}],attrs:{"type":"hidden","name":"delivery_tel"},domProps:{"value":(_vm.userDetails.mobile)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "mobile", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.apiDataObj.userId),expression:"apiDataObj.userId"}],attrs:{"type":"hidden","name":"merchant_param1"},domProps:{"value":(_vm.apiDataObj.userId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.apiDataObj, "userId", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.appPaymentGateway.CALLBACK_URL),expression:"appPaymentGateway.CALLBACK_URL"}],attrs:{"type":"hidden","name":"merchant_param2"},domProps:{"value":(_vm.appPaymentGateway.CALLBACK_URL)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.appPaymentGateway, "CALLBACK_URL", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.appPaymentGateway.APP_PAYMENT_GATEWAY),expression:"appPaymentGateway.APP_PAYMENT_GATEWAY"}],attrs:{"type":"hidden","name":"merchant_param3"},domProps:{"value":(_vm.appPaymentGateway.APP_PAYMENT_GATEWAY)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.appPaymentGateway, "APP_PAYMENT_GATEWAY", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.appPaymentGateway.apiUrl),expression:"appPaymentGateway.apiUrl"}],attrs:{"type":"hidden","name":"merchant_param4"},domProps:{"value":(_vm.appPaymentGateway.apiUrl)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.appPaymentGateway, "apiUrl", $event.target.value)}}}),_vm._v(" "),_c('input',{staticClass:"button5",attrs:{"id":"pay","value":"Continue","type":"submit"},on:{"click":function($event){_vm.isLoading = true}}})])])])]):_vm._e(),_vm._v(" "),(_vm.payu_payment_gate)?_c('div',{staticStyle:{"display":"none !important"}},[_c('div',[_c('div',[_c('form',{attrs:{"method":"post","action":_vm.appPaymentGateway.actionUrl,"name":"payuform","id":"payuform"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.appPaymentGateway.HASH),expression:"appPaymentGateway.HASH"}],attrs:{"type":"hidden","name":"hash"},domProps:{"value":(_vm.appPaymentGateway.HASH)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.appPaymentGateway, "HASH", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.appPaymentGateway.ORDER_ID),expression:"appPaymentGateway.ORDER_ID"}],attrs:{"type":"hidden","name":"txnid"},domProps:{"value":(_vm.appPaymentGateway.ORDER_ID)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.appPaymentGateway, "ORDER_ID", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.appPaymentGateway.TXN_AMOUNT),expression:"appPaymentGateway.TXN_AMOUNT"}],attrs:{"type":"hidden","name":"amount"},domProps:{"value":(_vm.appPaymentGateway.TXN_AMOUNT)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.appPaymentGateway, "TXN_AMOUNT", $event.target.value)}}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"currency","value":"INR"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.appPaymentGateway.responseUrl),expression:"appPaymentGateway.responseUrl"}],attrs:{"type":"hidden","name":"surl"},domProps:{"value":(_vm.appPaymentGateway.responseUrl)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.appPaymentGateway, "responseUrl", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.appPaymentGateway.responseUrl),expression:"appPaymentGateway.responseUrl"}],attrs:{"type":"hidden","name":"furl"},domProps:{"value":(_vm.appPaymentGateway.responseUrl)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.appPaymentGateway, "responseUrl", $event.target.value)}}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"language","value":"EN"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.first_name),expression:"userDetails.first_name"}],attrs:{"type":"hidden","name":"firstname"},domProps:{"value":(_vm.userDetails.first_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "first_name", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.address),expression:"userDetails.address"}],attrs:{"type":"hidden","name":"address1"},domProps:{"value":(_vm.userDetails.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "address", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.city),expression:"userDetails.city"}],attrs:{"type":"hidden","name":"city"},domProps:{"value":(_vm.userDetails.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "city", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.state),expression:"userDetails.state"}],attrs:{"type":"hidden","name":"state"},domProps:{"value":(_vm.userDetails.state)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "state", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.pincode),expression:"userDetails.pincode"}],attrs:{"type":"hidden","name":"Zipcode"},domProps:{"value":(_vm.userDetails.pincode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "pincode", $event.target.value)}}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"country","value":"India"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.mobile),expression:"userDetails.mobile"}],attrs:{"type":"hidden","name":"phone"},domProps:{"value":(_vm.userDetails.mobile)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "mobile", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.apiDataObj.userId),expression:"apiDataObj.userId"}],attrs:{"type":"hidden","name":"merchant_param1"},domProps:{"value":(_vm.apiDataObj.userId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.apiDataObj, "userId", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.appPaymentGateway.CALLBACK_URL),expression:"appPaymentGateway.CALLBACK_URL"}],attrs:{"type":"hidden","name":"merchant_param2"},domProps:{"value":(_vm.appPaymentGateway.CALLBACK_URL)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.appPaymentGateway, "CALLBACK_URL", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.appPaymentGateway.APP_PAYMENT_GATEWAY),expression:"appPaymentGateway.APP_PAYMENT_GATEWAY"}],attrs:{"type":"hidden","name":"merchant_param3"},domProps:{"value":(_vm.appPaymentGateway.APP_PAYMENT_GATEWAY)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.appPaymentGateway, "APP_PAYMENT_GATEWAY", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.appPaymentGateway.apiUrl),expression:"appPaymentGateway.apiUrl"}],attrs:{"type":"hidden","name":"merchant_param4"},domProps:{"value":(_vm.appPaymentGateway.apiUrl)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.appPaymentGateway, "apiUrl", $event.target.value)}}}),_vm._v(" "),_c('input',{staticClass:"button5",attrs:{"id":"pay","value":"Continue","type":"submit"},on:{"click":function($event){_vm.isLoading = true}}})])])])]):_vm._e()]),_vm._v(" "),(_vm.afterPaymentMsgShow)?_c('div',{staticClass:"row align-items-center h-100"},[_c('div',{staticClass:"col-sm-12 my-auto"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n      Press continue button to subscribe the product.\n      "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{staticClass:"button5",attrs:{"id":"SubContinue","value":"Continue to subscribe","type":"button"},on:{"click":function () { return _vm.$router.push('/a/editSubscription'); }}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"url_expired"}},[_c('h4',[_vm._v("Welcome to Doodhvale, Please wait...")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I4w/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    LTable: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Table_vue__["a" /* default */],
    ChartCard: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */],
    StatsCard: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */]
  },
  data: function data() {
    return {
      urlInterface: [],
      apiDataObj: [],
      userDetails: [],
      disagreeResponse: [],
      successfully_feedback: false,
      pre_prod: false,
      items: null
    };
  },
  created: function created() {
    this.fetchData();
  },

  methods: {
    fetchData: function fetchData() {
      var _this = this;

      var params = new URLSearchParams();
      var fullUrl = document.URL;
      var splitUrl = fullUrl.split('sw?');
      params.append('url_str', splitUrl[1]);
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/accounts/fetch-url-interface-data',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this.urlInterface = {};
        if (response.data.status === '000001' || response.data.status === '000002' || response.data.status === '000003') {
          _this.urlInterface.error_msg = response.data.msg;
          document.getElementById('url_valid').style.display = 'none';
        } else {
          document.getElementById('url_expired').style.display = 'none';
          _this.urlInterface.action_name = response.data.action_name;
          _this.urlInterface.url_interface_id = response.data.url_interface_id;
          _this.invokeUrlAction();
        }
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          _this.list = response.data.user_record;
          alert(_this.list);
        }
      }).catch(function (e) {
        alert('not ok');
      });
    },
    invokeUrlAction: function invokeUrlAction() {
      var _this2 = this;

      var params = new URLSearchParams();
      params.append('url_interface_id', this.urlInterface.url_interface_id);
      params.append('action_name', this.urlInterface.action_name);
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/accounts/invoke-url-action',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this2.apiDataObj = {};
        switch (_this2.urlInterface.action_name) {
          case 'switch_subscription':
            _this2.apiDataObj.userId = response.data.action_response.user_id;
            _this2.items = response.data.action_response.prepaid_subs_product_list;
            // this.items = ['Pro1','Pro2']
            _this2.apiDataObj.isPreProds = response.data.action_response.is_pre_prods;
            if (_this2.apiDataObj.isPreProds === 1) {
              _this2.apiDataObj.titleMsg = 'Here are your all prepaid subscription if you want to switch to Postpaid then press below';
              _this2.pre_prod = true;
            } else {
              _this2.apiDataObj.titleMsg = 'You have not any prepaid product';
            }
            _this2.userInfo();
            break;
          default:
            break;
        }
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          _this2.list = response.data.user_record;
          alert(_this2.list);
        }
      }).catch(function (e) {
        alert('not ok');
      });
    },
    userInfo: function userInfo() {
      var _this3 = this;

      var params = new URLSearchParams();
      var userId = this.apiDataObj.userId;
      params.append('user_id', userId);
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/users/user-info',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this3.userDetails = {};
        _this3.userDetails.userId = userId;
        _this3.userDetails.first_name = response.data.user_record.user_details.first_name;
        _this3.userDetails.mobile = response.data.user_record.user.username;
        _this3.userDetails.address = response.data.user_record.address.address1 + ' ' + response.data.user_record.address.address2 + ' ' + response.data.user_record.address.city;
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          _this3.list = response.data.user_record;
          alert(_this3.list);
        }
      }).catch(function (e) {
        alert('not ok');
      });
    },
    switchToPostpaid: function switchToPostpaid() {
      var _this4 = this;

      var params = new URLSearchParams();
      params.append('url_interface_id', this.urlInterface.url_interface_id);
      params.append('user_id', this.apiDataObj.userId);
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/accounts/update-url-user-response',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this4.disagreeResponse = {};
        if (response.data.status === '000000') {
          _this4.apiDataObj.titleMsg = 'You have successfully changed your all prepaid subscription to Postpaid';
          _this4.pre_prod = false;
          _this4.items = null;
        }
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          _this4.list = response.data.user_record;
          alert(_this4.list);
        }
      }).catch(function (e) {
        alert('not ok');
      });
    }
  }
});

/***/ }),

/***/ "IPhC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'nav-open': _vm.$sidebar.showSidebar }},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IsQq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Iudz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import axios from 'axios'
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {},
  created: function created() {
    var fullUrl = document.URL;
    var splitUrl = fullUrl.split('r?');
    sessionStorage.setItem('urlstr', splitUrl[1]);
  },

  methods: {}
});

/***/ }),

/***/ "Izxk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Layout_CouponAnimation_vue__ = __webpack_require__("rChP");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









// import VueAxios from 'vue-axios'
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    LTable: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Table_vue__["a" /* default */],
    ChartCard: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */],
    StatsCard: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */],
    CouponAnimation: __WEBPACK_IMPORTED_MODULE_6__Layout_CouponAnimation_vue__["a" /* default */]
  },
  data: function data() {
    return {
      urlInterface: [],
      apiDataObj: [],
      userDetails: [],
      genChecksum: [],
      appPaymentGateway: [],
      after_checksum: false,
      userData: true,
      app_payment_gate: false,
      payu_payment_gate: false,
      payment_type: "cc",
      errors: "",
      isActive: false,
      isLoading: true,
      isLoaded: false,
      isFullPage: true,
      btnOneValue: 500,
      btnTwoValue: 1000,
      btnThreeValue: 1500,
      isQuickPaymentButtonDisplay: 1,
      fiveDeliveryAmount: 100,
      sevenDeliveryAmount: 200,
      fifteenDeliveryAmount: 400,
      thirtyDeliveryAmount: 800,
      fourtyFiveDeliveryAmount: 1200,
      sixtyDeliveryAmount: 1600,
      ninetyDeliveryAmount: 2400,
      custName: "",
      custAddress: "",
      fiveDeliveryAmountLabel: "5 Deliveries",
      sevenDeliveryAmountLabel: "7 Deliveries",
      fifteenDeliveryAmountLabel: "15 Deliveries",
      thirtyDeliveryAmountLabel: "30 Deliveries",
      fourtyFiveDeliveryAmountLabel: "45 Deliveries",
      sixtyDeliveryAmountLabel: "60 Deliveries",
      ninetyDeliveryAmountLabel: "90 Deliveries",
      // priya
      isCouponApplied: false,
      applyCouponImg: 1,
      couponCode: "",
      verifyWalletResponse: {},
      couponMsg: "",
      isGreen: 1,
      walletCouponMsg: "Avail Offers / Coupons",
      rechargeAmount: 0,
      showDialog: false,
      showCouponAlertBox: false,
      alertHeading: "",
      alertMessage: "",
      showToast: false,
      toastMessage: "",
      promoCodeId: "0",
      promoCodeStr: "",
      cashback: "0"
    };
  },
  created: function created() {
    if (sessionStorage.getItem("paymentFlow") === "editSubscription") {
      sessionStorage.removeItem("paymentFlow");
      this.$router.push("/a/editSubscription");
    } else {
      this.fetchData();
    }
  },

  // priya
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      if (sessionStorage.getItem("couponClicked") == 1) {
        vm.checkCouponApplied(from.params);
        sessionStorage.removeItem("couponClicked");
        setTimeout(function () {
          vm.$nextTick(function () {
            vm.scrollToBottom();
          });
        }, 13000);
      } else {
        vm.rechargeAmount = sessionStorage.getItem("rechargeAmount") ? sessionStorage.getItem("rechargeAmount") : 0;
        // console.log("coupon not applied")
      }
    });
  },

  methods: {
    fetchData: function fetchData() {
      var _this = this;

      var params = new URLSearchParams();
      var fullUrl = document.URL;
      var splitUrl = fullUrl.split("p?");
      params.append("url_str", splitUrl[1]);
      sessionStorage.setItem("paymentUrl", splitUrl[1]);
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + "/accounts/fetch-url-interface-data",
        method: "post",
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this.urlInterface = {};
        if (response.data.status === "000001" || response.data.status === "000002" || response.data.status === "000003") {
          _this.urlInterface.error_msg = response.data.msg;
          if (document.getElementById("url_valid") !== null) {
            document.getElementById("url_valid").style.display = "none";
          }
        } else {
          if (document.getElementById("url_expired") !== null) {
            document.getElementById("url_expired").style.display = "none";
          }
          _this.urlInterface.action_name = response.data.action_name;
          _this.urlInterface.url_interface_id = response.data.url_interface_id;
          _this.urlInterface.vue_url = fullUrl;
          _this.urlInterface.callback_url = "https://doodhvale.in/dv/doodhvale/api/modules/v3" + "/controllers/pgResponse.php";
          _this.invokeUrlAction();
        }
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === "SUCCESS") {
          _this.list = response.data.user_record;
          alert(_this.list);
        }
        setTimeout(function () {
          if (document.getElementById("bafore_checksum") !== null) {
            document.getElementById("bafore_checksum").style.display = "block";
          }
          _this.isLoading = false;
        }, 10000);
      }).catch(function (e) {
        if (document.getElementById("bafore_checksum") !== null) {
          document.getElementById("bafore_checksum").style.display = "block";
        }
        _this.isLoading = false;
        alert("not ok");
      });
    },
    invokeUrlAction: function invokeUrlAction() {
      var _this2 = this;

      var params = new URLSearchParams();
      params.append("url_interface_id", this.urlInterface.url_interface_id);
      params.append("action_name", this.urlInterface.action_name);
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + "/accounts/invoke-url-action",
        method: "post",
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        if (response.data.action_response.user_id === null || response.data.action_response.user_id === 0 || response.data.action_response.user_id === "0" || response.data.action_response.user_id === "undefined") {
          window.location.reload();
        }
        _this2.apiDataObj = {};
        switch (_this2.urlInterface.action_name) {
          case "cow_milk_bill":
            // for cow milk billing
            break;
          case "pending_bill_payment":
            // console.log(response)
            _this2.apiDataObj.userId = response.data.action_response.user_id;
            _this2.apiDataObj.payment_gateway = response.data.action_response.app_payment_gateway_v2;
            _this2.apiDataObj.app_payment_gateway = response.data.action_response.app_payment_gateway_v2;
            // ///////// start for payment option //////
            _this2.apiDataObj.cc = response.data.action_response.app_payment_cc;
            _this2.apiDataObj.upi = response.data.action_response.app_payment_upi;
            _this2.apiDataObj.paytm = response.data.action_response.app_payment_wallet_paytm;
            _this2.apiDataObj.mobikwik = response.data.action_response.app_payment_wallet_mobikwik;
            _this2.apiDataObj.ola = response.data.action_response.app_payment_wallet_olamoney;
            _this2.apiDataObj.jio = response.data.action_response.app_payment_wallet_jiomoney;
            _this2.apiDataObj.freecharge = response.data.action_response.app_payment_wallet_freecharge;
            // ///////// end for payment option //////
            _this2.apiDataObj.pending_amount = Math.ceil(response.data.action_response.pending_amount);
            // console.log(response.data.action_response.is_quick_payment_button_display)
            _this2.isQuickPaymentButtonDisplay = response.data.action_response.is_quick_payment_button_display;
            if (_this2.isQuickPaymentButtonDisplay === 0) {
              _this2.fiveDeliveryAmount = response.data.action_response.five_deliveries_amount;
              _this2.sevenDeliveryAmount = response.data.action_response.seven_deliveries_amount;
              _this2.fifteenDeliveryAmount = response.data.action_response.fifteen_deliveries_amount;
              _this2.thirtyDeliveryAmount = response.data.action_response.thirty_deliveries_amount;
              _this2.fourtyFiveDeliveryAmount = response.data.action_response.fourty_five_deliveries_amount;
              _this2.sixtyDeliveryAmount = response.data.action_response.sixty_deliveries_amount;
              _this2.ninetyDeliveryAmount = response.data.action_response.ninety_deliveries_amount;
            }
            // this.apiDataObj.pending_amount = -5
            _this2.apiDataObj.wallet_amount = 0;
            if (_this2.apiDataObj.pending_amount > 0) {
              if (document.getElementById("not_pending") !== null) {
                document.getElementById("not_pending").style.display = "none";
              }
              if (document.getElementById("clear") !== null) {
                document.getElementById("clear").style.display = "none";
              }
            } else {
              if (document.getElementById("pending") !== null) {
                document.getElementById("pending").style.display = "none";
              }
              if (document.getElementById("clear") !== null) {
                document.getElementById("clear").style.display = "none";
              }
              _this2.apiDataObj.wallet_amount = Math.abs(_this2.apiDataObj.pending_amount);
              _this2.apiDataObj.pending_amount = 0;
            }
            _this2.apiDataObj.default_amount = _this2.apiDataObj.pending_amount;
            // ch
            // this.rechargeAmount = this.apiDataObj.pending_amount
            _this2.pendingBillPayment();
            break;
          case "order_flow_payment":
            // console.log(response)
            _this2.apiDataObj.userId = response.data.action_response.user_id;
            _this2.apiDataObj.payment_gateway = response.data.action_response.app_payment_gateway_v2;
            _this2.apiDataObj.app_payment_gateway = response.data.action_response.app_payment_gateway_v2;
            // ///////// start for payment option //////

            _this2.apiDataObj.cc = response.data.action_response.app_payment_cc;
            _this2.apiDataObj.upi = response.data.action_response.app_payment_upi;
            _this2.apiDataObj.paytm = response.data.action_response.app_payment_wallet_paytm;
            _this2.apiDataObj.mobikwik = response.data.action_response.app_payment_wallet_mobikwik;
            _this2.apiDataObj.ola = response.data.action_response.app_payment_wallet_olamoney;
            _this2.apiDataObj.jio = response.data.action_response.app_payment_wallet_jiomoney;
            _this2.apiDataObj.freecharge = response.data.action_response.app_payment_wallet_freecharge;

            // ///////// end for payment option //////
            _this2.apiDataObj.pending_amount = Math.ceil(response.data.action_response.pending_amount);
            _this2.apiDataObj.default_amount = Math.ceil(response.data.action_response.default_amount);
            // ch
            // this.rechargeAmount = Math.ceil(response.data.action_response.default_amount)
            // this.apiDataObj.pending_amount = -5
            _this2.apiDataObj.wallet_amount = 0;
            if (_this2.apiDataObj.pending_amount > 0) {
              if (document.getElementById("not_pending") !== null) {
                document.getElementById("not_pending").style.display = "none";
              }
              if (document.getElementById("clear") !== null) {
                document.getElementById("clear").style.display = "none";
              }
            } else {
              if (document.getElementById("pending") !== null) {
                document.getElementById("pending").style.display = "none";
              }
              if (document.getElementById("clear") !== null) {
                document.getElementById("clear").style.display = "none";
              }
              _this2.apiDataObj.wallet_amount = Math.abs(_this2.apiDataObj.pending_amount);
              _this2.apiDataObj.pending_amount = 0;
            }
            _this2.pendingBillPayment();
            break;
          default:
            break;
        }
        // if (this.apiDataObj.default_amount > 0) {
        //   this.btnOneValue = ((parseInt(this.apiDataObj.default_amount / 500)) + 1) * 500
        if (_this2.rechargeAmount > 0) {
          _this2.btnOneValue = (parseInt(_this2.rechargeAmount / 500) + 1) * 500;
          _this2.btnTwoValue = _this2.btnOneValue + 500;
          _this2.btnThreeValue = _this2.btnOneValue + 1000;
        }
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === "SUCCESS") {
          _this2.list = response.data.user_record;
          alert(_this2.list);
        }
      }).catch(function (e) {
        alert("not ok");
      });
    },
    btnOneClick: function btnOneClick() {
      document.getElementById("txn_amt").value = this.btnOneValue;
      // this.apiDataObj.default_amount = this.btnOneValue
      this.rechargeAmount = this.btnOneValue;
    },
    btnTwoClick: function btnTwoClick() {
      document.getElementById("txn_amt").value = this.btnTwoValue;
      // this.apiDataObj.default_amount = this.btnTwoValue
      this.rechargeAmount = this.btnTwoValue;
    },
    btnThreeClick: function btnThreeClick() {
      document.getElementById("txn_amt").value = this.btnThreeValue;
      // this.apiDataObj.default_amount = this.btnThreeValue
      this.rechargeAmount = this.btnThreeValue;
    },
    fiveDeliveryBtnClick: function fiveDeliveryBtnClick() {
      document.getElementById("txn_amt").value = this.fiveDeliveryAmount;
    },
    sevenDeliveryBtnClick: function sevenDeliveryBtnClick() {
      document.getElementById("txn_amt").value = this.sevenDeliveryAmount;
    },
    fifteenDeliveryBtnClick: function fifteenDeliveryBtnClick() {
      document.getElementById("txn_amt").value = this.fifteenDeliveryAmount;
    },
    thirtyDeliveryBtnClick: function thirtyDeliveryBtnClick() {
      document.getElementById("txn_amt").value = this.thirtyDeliveryAmount;
    },
    fourtyFiveDeliveryBtnClick: function fourtyFiveDeliveryBtnClick() {
      document.getElementById("txn_amt").value = this.fourtyFiveDeliveryAmount;
    },
    sixtyDeliveryBtnClick: function sixtyDeliveryBtnClick() {
      document.getElementById("txn_amt").value = this.sixtyDeliveryAmount;
    },
    ninetyDeliveryBtnClick: function ninetyDeliveryBtnClick() {
      document.getElementById("txn_amt").value = this.ninetyDeliveryAmount;
    },
    pendingBillPayment: function pendingBillPayment() {
      var _this3 = this;

      var params = new URLSearchParams();
      var userId = this.apiDataObj.userId;
      params.append("user_id", userId);
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + "/users/user-info",
        method: "post",
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        if (document.getElementById("txn_amt") !== null) {
          document.getElementById("txn_amt").focus();
        }
        _this3.userDetails = {};
        _this3.userDetails.userId = userId;
        _this3.userDetails.first_name = response.data.user_record.user_details.first_name;
        _this3.userDetails.mobile = response.data.user_record.user.username;
        _this3.userDetails.address = response.data.user_record.address.address1 + " " + response.data.user_record.address.address2 + " " + response.data.user_record.address.city;
        _this3.userDetails.pincode = response.data.user_record.address.pincode;
        _this3.userDetails.city = response.data.user_record.address.city;
        _this3.userDetails.state = response.data.user_record.address.state;
        _this3.userDetails.fullName = response.data.user_record.user_details.first_name + " " + response.data.user_record.user_details.last_name;
        _this3.custName = _this3.userDetails.fullName;
        _this3.custAddress = _this3.userDetails.address;
        _this3.userDetails.fullName = _this3.userDetails.fullName.replace(/[^a-zA-Z0-9 ]/g, "");
        _this3.userDetails.address = _this3.userDetails.address.replace(/[^a-zA-Z0-9 ]/g, "");
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === "SUCCESS") {
          _this3.list = response.data.user_record;
          alert(_this3.list);
        }
      }).catch(function (e) {
        alert("not ok");
      });
    },
    onAmmountChange: function onAmmountChange() {
      this.errors = "";
      this.isActive = false;
      document.getElementById("txn_amt").value = Number(document.getElementById("txn_amt").value);
    },
    generateChecksum: function generateChecksum() {
      if (sessionStorage.getItem("paymentFlow") !== null) {
        sessionStorage.setItem("paymentFlow", "editSubscription");
      }
      /* var paymentType = '2'
          switch (this.payment_type) {
            case 'cc':
              paymentType = this.apiDataObj.cc
              break
            case 'upi':
              paymentType = this.apiDataObj.upi
              break
            case 'paytm':
              paymentType = this.apiDataObj.paytm
              break
            case 'mobikwik':
              paymentType = this.apiDataObj.mobikwik
              break
            case 'ola':
              paymentType = this.apiDataObj.ola
              break
            case 'jio':
              paymentType = this.apiDataObj.jio
              break
            case 'freecharge':
              paymentType = this.apiDataObj.freecharge
              break
            default:
          }
          this.apiDataObj.app_payment_gateway = paymentType
          if (paymentType === '1') {
            this.paytm()
          } else {
            if (this.apiDataObj.app_payment_gateway === '1') {
              this.paytm()
            } else {
              this.hdfc()
            }
          } */
      if (this.apiDataObj.app_payment_gateway == "payu") {
        this.payumoney();
      } else {
        this.hdfc();
      }
    },
    paytm: function paytm() {
      var _this4 = this;

      var orderId = "";
      var params = new URLSearchParams();
      var userId = this.apiDataObj.userId;
      params.append("user_id", userId);
      params.append("gateway_name", "paytm");
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + "/accounts/generate-unique-order-id",
        method: "post",
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        if (response.data.msg.trim().toUpperCase() === "SUCCESS") {
          orderId = response.data.unique_order_id;
          var _params = new URLSearchParams();
          // var userId = this.apiDataObj.userId
          var txnAmount = document.getElementById("txn_amt").value;
          if (isNaN(txnAmount) || txnAmount <= 0 || txnAmount === "") {
            document.getElementById("txn_amt").focus();
            _this4.errors = "Oops! Invalid Amount.";
            _this4.isActive = true;
            setTimeout(function () {
              _this4.errors = "";
              _this4.isActive = false;
            }, 10000);
          } else {
            _this4.isLoading = false;
            // var orderId = 'DVWP' + Math.floor(Math.random() * 10000000)
            _params.append("CUST_ID", userId);
            _params.append("ORDER_ID", orderId);
            _params.append("CHANNEL_ID", "WEB");
            _params.append("WEBSITE", "SanjeeWEB");
            // params.append('WEBSITE', 'APP_STAGING')// staging
            _params.append("TXN_AMOUNT", txnAmount);
            _params.append("MERC_UNQ_REF", userId + "br" + _this4.urlInterface.vue_url + "br" + "https://doodhvale.in/dv/doodhvale/api/web/v3" + "/accounts/verify-transaction");
            _params.append("CALLBACK_URL", _this4.urlInterface.callback_url);
            // priya
            _params.append("promo_code_id", _this4.promoCodeId);
            _params.append("promo_code_str", _this4.promoCodeStr);
            _params.append("cashback_amount", _this4.cashback);
            __WEBPACK_IMPORTED_MODULE_5_axios___default()({
              url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + "/accounts/generate-checksum",
              method: "post",
              data: _params,
              withCredentials: false,
              headers: {}
            }).then(function (response) {
              _this4.genChecksum = {};
              _this4.genChecksum.MID = response.data.post_value.MID;
              _this4.genChecksum.ORDER_ID = response.data.post_value.ORDER_ID;
              _this4.genChecksum.CUST_ID = response.data.post_value.CUST_ID;
              _this4.genChecksum.INDUSTRY_TYPE_ID = response.data.post_value.INDUSTRY_TYPE_ID;
              _this4.genChecksum.CHANNEL_ID = response.data.post_value.CHANNEL_ID;
              _this4.genChecksum.WEBSITE = response.data.post_value.WEBSITE;
              _this4.genChecksum.TXN_AMOUNT = response.data.post_value.TXN_AMOUNT;
              _this4.genChecksum.CALLBACK_URL = response.data.post_value.CALLBACK_URL;
              _this4.genChecksum.MERC_UNQ_REF = response.data.post_value.MERC_UNQ_REF;
              _this4.genChecksum.checksum = response.data.checkSum;
              _this4.after_checksum = true;
              _this4.userData = false;
              _this4.app_payment_gate = false;
              _this4.payu_payment_gate = false;
              // console.log(response)
              if (response.data.status.trim().toUpperCase() === "SUCCESS") {
                _this4.list = response.data.user_record;
                alert(_this4.list);
              }
            }).catch(function (e) {
              alert("not ok");
            });
          }
        }
      }).catch(function (e) {
        _this4.errors = "Server error, Try again!";
        _this4.isActive = true;
      });
    },
    hdfc: function hdfc() {
      var _this5 = this;

      var orderId = "";
      var userId = this.apiDataObj.userId;
      var params = new URLSearchParams();
      params.append("user_id", userId);
      params.append("gateway_name", "hdfc");
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + "/accounts/generate-unique-order-id",
        method: "post",
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        if (response.data.msg.trim().toUpperCase() === "SUCCESS") {
          orderId = response.data.unique_order_id;
          // var userId = this.apiDataObj.userId
          var txnAmount = Number(document.getElementById("txn_amt").value);
          if (isNaN(txnAmount) || txnAmount <= 0 || txnAmount === "") {
            document.getElementById("txn_amt").focus();
            _this5.errors = "Oops! Invalid Amount.";
            _this5.isActive = true;
          } else {
            _this5.after_checksum = false;
            _this5.userData = false;
            _this5.app_payment_gate = true;
            _this5.payu_payment_gate = false;
            _this5.appPaymentGateway = {};
            _this5.appPaymentGateway.TXN_AMOUNT = txnAmount;
            _this5.appPaymentGateway.ORDER_ID = orderId; // 'DVWH' + Math.floor(Math.random() * 10000000)
            _this5.appPaymentGateway.TID = new Date().getTime();
            _this5.appPaymentGateway.CALLBACK_URL = _this5.urlInterface.vue_url;
            _this5.appPaymentGateway.APP_PAYMENT_GATEWAY = _this5.apiDataObj.app_payment_gateway;
            _this5.appPaymentGateway.actionUrl = "https://doodhvale.in/dv/doodhvale/api/modules/v3" + "/controllers/ccavRequestHandler.php";
            _this5.appPaymentGateway.responseUrl = "https://doodhvale.in/dv/doodhvale/api/modules/v3" + "/controllers/ccavResponseHandler.php";
            _this5.appPaymentGateway.apiUrl = "https://doodhvale.in/dv/doodhvale/api/web/v3" + "/accounts/payment-gateway-transaction";
            setTimeout(function () {
              document.getElementById("hdfcform").submit();
            }, 300);
          }
        }
      }).catch(function (e) {
        _this5.errors = "Server error, Try again!";
        _this5.isActive = true;
      });
      this.isLoading = false;
    },
    payumoney: function payumoney() {
      var _this6 = this;

      var orderId = "";
      var params = new URLSearchParams();
      var userId = this.apiDataObj.userId;
      params.append("user_id", userId);
      params.append("gateway_name", "payu");
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + "/accounts/generate-unique-order-id",
        method: "post",
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        if (response.data.msg.trim().toUpperCase() === "SUCCESS") {
          orderId = response.data.unique_order_id;
          _this6.appPaymentGateway = {};
          _this6.appPaymentGateway.user_id = userId;
          var _params2 = new URLSearchParams();
          var txnAmount = document.getElementById("txn_amt").value;
          if (isNaN(txnAmount) || txnAmount <= 0 || txnAmount === "") {
            document.getElementById("txn_amt").focus();
            _this6.errors = "Oops! Invalid Amount.";
            _this6.isActive = true;
          } else {
            _this6.appPaymentGateway.TXN_AMOUNT = txnAmount;
            _this6.isLoading = false;
            _params2.append("merchant_param1", userId);
            _params2.append("order_id", orderId);
            var firstname = _this6.userDetails.first_name;
            _params2.append("amount", txnAmount);
            _params2.append("delivery_name", firstname);
            _params2.append("merchant_param2", _this6.urlInterface.vue_url);
            _params2.append("merchant_param4", "https://doodhvale.in/dv/doodhvale/api/web/v3" + "/accounts/payment-gateway-transaction");
            _params2.append("CALLBACK_URL", _this6.urlInterface.vue_url);
            _params2.append("promo_code_id", _this6.promoCodeId);
            _params2.append("promo_code_str", _this6.promoCodeStr);
            _params2.append("cashback_amount", _this6.cashback);
            __WEBPACK_IMPORTED_MODULE_5_axios___default()({
              url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + "/payumoneypayments/payment-initiate",
              method: "post",
              data: _params2,
              withCredentials: false,
              headers: {}
            }).then(function (response) {
              _this6.after_checksum = false;
              _this6.userData = false;
              _this6.app_payment_gate = false;
              _this6.payu_payment_gate = true;
              // this.appPaymentGateway = {};
              _this6.appPaymentGateway.HASH = response.data.hash;
              _this6.appPaymentGateway.ORDER_ID = response.data.order_id;
              _this6.appPaymentGateway.CALLBACK_URL = _this6.urlInterface.vue_url;
              _this6.appPaymentGateway.APP_PAYMENT_GATEWAY = _this6.apiDataObj.app_payment_gateway_v2;
              _this6.appPaymentGateway.actionUrl = "https://doodhvale.in/dv/doodhvale/api/modules/v3" + "/controllers/payuRequestHandler.php";
              _this6.appPaymentGateway.responseUrl = "https://doodhvale.in/dv/doodhvale/api/modules/v3" + "/controllers/payuResponseHandler.php";
              setTimeout(function () {
                document.getElementById("payuform").submit();
              }, 300);
            }).catch(function (e) {
              alert("not ok");
            });
          }
        }
      }).catch(function (e) {
        _this6.errors = "Server error, Try again!";
        _this6.isActive = true;
      });
    },

    isNumber: function isNumber(evt) {
      if (!evt) {
        evt = window.event;
      }
      // evt = (evt) ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    // priya
    scrollToBottom: function scrollToBottom() {
      this.$nextTick(function () {
        var currentScroll = 0;
        var totalHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        var interval = setInterval(function () {
          if (currentScroll >= totalHeight) {
            clearInterval(interval);
          } else {
            currentScroll += 12;
            window.scrollTo(0, currentScroll - 100);
          }
        }, 6);
      });
    },
    selectContent: function selectContent(event) {
      if (this.rechargeAmount == 0) {
        event.target.select();
      }
    },
    applyCouponClick: function applyCouponClick() {
      var _this7 = this;

      // console.log(this.apiDataObj.userId)
      if (this.applyCouponImg == 0) {
        this.removeCoupon();
      } else {
        if (this.rechargeAmount == 0) {
          this.showToast = true;
          this.toastMessage = "Please enter amount";
          setTimeout(function () {
            _this7.showToast = false;
          }, 2000);
        } else {
          window.location.href = "https://v.doodhvale.in" + "/a/wc";
          //window.location.href = "http://localhost:4000/a/wc";
          sessionStorage.setItem("rechargeAmount", this.rechargeAmount);
          sessionStorage.setItem("userId", this.apiDataObj.userId);
        }
      }
    },
    checkCouponApplied: function checkCouponApplied() {
      var _this8 = this;

      this.isCouponApplied = true;
      this.couponCode = sessionStorage.getItem("promoStr");
      if (this.couponCode != "") {
        this.setWalletData();
      }
      if (sessionStorage.getItem("showDialog") == "true") {
        this.showDialog = true;
        setTimeout(function () {
          _this8.showDialog = false;
        }, 15000);
      }
    },
    setWalletData: function setWalletData() {
      this.verifyWalletResponse = JSON.parse(sessionStorage.getItem("verifyWalletResponse"));
      this.applyCouponImg = 0;
      this.couponMsg = "Rs " + this.verifyWalletResponse.cashback + "/- cashback applied.";
      this.isGreen = 1;
      this.walletCouponMsg = "Code " + this.couponCode + " Applied";

      this.rechargeAmount = sessionStorage.getItem("rechargeAmount") ? sessionStorage.getItem("rechargeAmount") : 0;
      if (this.verifyWalletResponse.original_offer_min_recharge_amount != null) {
        if (this.rechargeAmount < this.verifyWalletResponse.original_offer_min_recharge_amount) {
          var inputElement = document.getElementById("txn_amt");
          inputElement.value = this.verifyWalletResponse.original_offer_min_recharge_amount;
          this.rechargeAmount = this.verifyWalletResponse.original_offer_min_recharge_amount;
          sessionStorage.setItem("rechargeAmount", this.rechargeAmount);
          // console.log(inputElement.value)
        }
      } else {
        var txnAmountInput = document.getElementById("txn_amt");
        txnAmountInput.value = Number(this.rechargeAmount);
      }
      // console.log(this.verifyWalletResponse)
    },
    checkCorrectCouponApplied: function checkCorrectCouponApplied() {
      // priya
      if (document.getElementById("txn_amt").value < this.verifyWalletResponse.original_offer_min_recharge_amount) {
        this.showCouponAlert();
      } else {
        this.promoCodeId = this.verifyWalletResponse.promo_code_id;
        this.promoCodeStr = this.verifyWalletResponse.promo_code_str;
        this.cashback = this.verifyWalletResponse.cashback;
        this.generateChecksum();
      }
    },
    showCouponAlert: function showCouponAlert() {
      this.showCouponAlertBox = true;
      this.alertHeading = this.couponCode + " Coupon";
      this.alertMessage = "You have applied " + this.couponCode + " Coupon. Please enter Recharge Amount more than Rs " + this.verifyWalletResponse.original_offer_min_recharge_amount + "/-";
    },
    handleRetry: function handleRetry(event) {
      this.showCouponAlertBox = false;
      event.preventDefault();
      this.$refs.amountInput.focus();
    },
    handleIgnoreCoupon: function handleIgnoreCoupon(event) {
      this.walletCouponMsg = "Avail Offers / Coupons";
      this.removeCoupon();
      this.generateChecksum();
      event.preventDefault();
    },
    removeCoupon: function removeCoupon() {
      var _this9 = this;

      this.showCouponAlertBox = false;
      this.isCouponApplied = false;
      this.applyCouponImg = 1;
      this.couponMsg = "";
      this.isGreen = 0;
      this.walletCouponMsg = "Avail Offers / Coupons";
      this.promoCodeId = "0";
      this.promoCodeStr = "";
      this.cashback = "0";
      sessionStorage.removeItem("verifyWalletResponse");
      sessionStorage.removeItem("rechargeAmount");
      sessionStorage.removeItem("showDialog");
      sessionStorage.removeItem("promoStr");
      this.showToast = true;
      this.toastMessage = "Coupon is removed";
      setTimeout(function () {
        _this9.showToast = false;
      }, 2000);
    }
  }
});

/***/ }),

/***/ "J11u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_U_vue__ = __webpack_require__("3bSs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15a462f3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_U_vue__ = __webpack_require__("72+V");
function injectStyle (ssrContext) {
  __webpack_require__("6a1u")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_U_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15a462f3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_U_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "J9Ud":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}),_vm._v(" "),_c('input',{ref:"input",class:_vm.className,attrs:{"type":"text","placeholder":_vm.placeholder}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JLYD":
/***/ (function(module, exports) {

module.exports = {"v":"5.5.6","fr":30,"ip":0,"op":300,"w":1827,"h":2436,"nm":"lottie (mobile)","ddd":0,"assets":[{"id":"comp_0","layers":[{"ddd":0,"ind":1,"ty":0,"nm":"_small-side","refId":"comp_1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[218,320,0],"ix":2},"a":{"a":0,"k":[400,400,0],"ix":1},"s":{"a":0,"k":[-100,100,100],"ix":6}},"ao":0,"w":800,"h":800,"ip":15,"op":234,"st":15,"bm":0}]},{"id":"comp_1","layers":[{"ddd":0,"ind":1,"ty":4,"nm":"streamer b","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":166,"ix":10},"p":{"a":0,"k":[554,664,0],"ix":2},"a":{"a":0,"k":[-157,-245,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-1.685,-13.314],[0,-14.907],[0,-15.206],[0,-14.907],[0,-14.907],[0,-15.206],[1.754,-14.206],[-3.934,-9.465]],"o":[[-3.895,8.562],[1.872,14.789],[0,15.206],[0,14.907],[0,14.907],[0,15.206],[0,14.314],[-1.803,14.605],[0,0]],"v":[[-156.5,-406],[-166.5,-367],[-146.5,-327],[-166.5,-286],[-146.5,-246],[-166.5,-206],[-146.5,-165],[-166.5,-127],[-156.5,-84]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.16470588235294117,0.6745098039215687,0.49411764705882355,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":9,"s":[4]},{"t":57,"s":[0.5]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":14,"s":[0]},{"t":57,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":9,"s":[0]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":14,"s":[35]},{"t":57,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":9,"op":58,"st":9,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"streamer a","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":167,"ix":10},"p":{"a":0,"k":[532,582,0],"ix":2},"a":{"a":0,"k":[-157,-245,0],"ix":1},"s":{"a":0,"k":[-100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-1.685,-13.314],[0,-14.907],[0,-15.206],[0,-14.907],[0,-14.907],[0,-15.206],[1.754,-14.206],[-3.934,-9.465]],"o":[[-3.895,8.562],[1.872,14.789],[0,15.206],[0,14.907],[0,14.907],[0,15.206],[0,14.314],[-1.803,14.605],[0,0]],"v":[[-156.5,-406],[-166.5,-367],[-146.5,-327],[-166.5,-286],[-146.5,-246],[-166.5,-206],[-146.5,-165],[-166.5,-127],[-156.5,-84]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.050980392156862744,0.050980392156862744,0.5019607843137255,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":5,"s":[4]},{"t":48,"s":[0.5]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":10,"s":[0]},{"t":48,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":5,"s":[0]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":10,"s":[35]},{"t":48,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":5,"op":49,"st":5,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"circle a","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":1,"s":[0]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.333],"y":[0]},"t":29,"s":[321.019]},{"t":158,"s":[1800]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.167,"y":0.167},"t":1,"s":[599.5,838,0],"to":[-30,-106.667,0],"ti":[46.667,0,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.333,"y":0},"t":29,"s":[419.5,198,0],"to":[-46.667,0,0],"ti":[0,0,0]},{"t":158,"s":[319.5,838,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0,0]},"t":1,"s":[50,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,0.833,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":29,"s":[100,100,100]},{"t":128,"s":[100,50,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[16,16],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.5843137254901961,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":1,"op":159,"st":1,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"circle b","sr":1,"ks":{"o":{"a":0,"k":50,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":3,"s":[0]},{"t":128,"s":[1440]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.167,"y":0.167},"t":3,"s":[599.5,838,0],"to":[-26.667,-93.333,0],"ti":[66.667,0,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.333,"y":0},"t":21,"s":[439.5,278,0],"to":[-66.667,0,0],"ti":[0,0,0]},{"t":128,"s":[199.5,838,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0,0]},"t":3,"s":[50,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,0.833,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":21,"s":[100,100,100]},{"t":98,"s":[100,50,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[16,16],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[0.050980392156862744,0.050980392156862744,0.5019607843137255,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":3,"op":129,"st":3,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"star a","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":1,"s":[0]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.333],"y":[0]},"t":31,"s":[343.949]},{"t":158,"s":[1800]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.167,"y":0.167},"t":1,"s":[596.087,836.292,0],"to":[-36.098,-100,0],"ti":[52.765,0,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.333,"y":0},"t":31,"s":[379.5,236.292,0],"to":[-52.765,0,0],"ti":[0,0,0]},{"t":158,"s":[279.5,836.292,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0,0]},"t":1,"s":[50,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,0.833,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":31,"s":[100,100,100]},{"t":128,"s":[100,50,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"sr","sy":1,"d":1,"pt":{"a":0,"k":5,"ix":3},"p":{"a":0,"k":[0,0],"ix":4},"r":{"a":0,"k":0,"ix":5},"ir":{"a":0,"k":5,"ix":6},"is":{"a":0,"k":0,"ix":8},"or":{"a":0,"k":12,"ix":7},"os":{"a":0,"k":0,"ix":9},"ix":1,"nm":"Polystar Path 1","mn":"ADBE Vector Shape - Star","hd":false},{"ty":"fl","c":{"a":0,"k":[0.16470588235294117,0.6745098039215687,0.49411764705882355,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Polystar 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":1,"op":159,"st":1,"bm":0},{"ddd":0,"ind":6,"ty":4,"nm":"star b","sr":1,"ks":{"o":{"a":0,"k":50,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":3,"s":[0]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.333],"y":[0]},"t":23,"s":[288]},{"t":128,"s":[1800]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.167,"y":0.167},"t":3,"s":[596.087,836.292,0],"to":[-39.431,-113.333,0],"ti":[66.098,1.667,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.333,"y":0},"t":23,"s":[359.5,156.292,0],"to":[-66.098,-1.667,0],"ti":[0,0,0]},{"t":128,"s":[199.5,826.292,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0,0]},"t":3,"s":[50,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,0.833,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":23,"s":[100,100,100]},{"t":98,"s":[100,50,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"sr","sy":1,"d":1,"pt":{"a":0,"k":5,"ix":3},"p":{"a":0,"k":[0,0],"ix":4},"r":{"a":0,"k":0,"ix":5},"ir":{"a":0,"k":5,"ix":6},"is":{"a":0,"k":0,"ix":8},"or":{"a":0,"k":12,"ix":7},"os":{"a":0,"k":0,"ix":9},"ix":1,"nm":"Polystar Path 1","mn":"ADBE Vector Shape - Star","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.23137254901960785,0.18823529411764706,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Polystar 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":3,"op":129,"st":3,"bm":0},{"ddd":0,"ind":7,"ty":4,"nm":"rec a","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[0]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.333],"y":[0]},"t":33,"s":[381.468]},{"t":218,"s":[2520]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.167,"y":0.167},"t":0,"s":[599.5,842,0],"to":[-23.333,-100,0],"ti":[41.333,1.333,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.333,"y":0},"t":33,"s":[459.5,242,0],"to":[-41.333,-1.333,0],"ti":[0,0,0]},{"t":218,"s":[351.5,834,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0,0]},"t":0,"s":[50,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,0.833,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":33,"s":[100,100,100]},{"t":188,"s":[100,50,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[16,8],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.5843137254901961,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":219,"st":0,"bm":0},{"ddd":0,"ind":8,"ty":4,"nm":"rec b","sr":1,"ks":{"o":{"a":0,"k":50,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":2,"s":[0]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.333],"y":[0]},"t":25,"s":[262.857]},{"t":191,"s":[2160]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.167,"y":0.167},"t":2,"s":[599.5,842,0],"to":[-23.333,-113.333,0],"ti":[74,5,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.333,"y":0},"t":25,"s":[459.5,162,0],"to":[-74,-5,0],"ti":[0,0,0]},{"t":191,"s":[155.5,812,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0,0]},"t":2,"s":[50,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,0.833,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":25,"s":[100,100,100]},{"t":161,"s":[100,50,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[16,8],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"fl","c":{"a":0,"k":[0.050980392156862744,0.050980392156862744,0.5019607843137255,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":2,"op":192,"st":2,"bm":0},{"ddd":0,"ind":9,"ty":4,"nm":"square a","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[0]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.333],"y":[0]},"t":35,"s":[462.385]},{"t":218,"s":[2880]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.167,"y":0.167},"t":0,"s":[599.5,838,0],"to":[-43.333,-123.333,0],"ti":[60,0,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.333,"y":0},"t":35,"s":[339.5,98,0],"to":[-60,0,0],"ti":[0,0,0]},{"t":218,"s":[239.5,838,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0,0]},"t":0,"s":[50,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,0.833,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":35,"s":[100,100,100]},{"t":188,"s":[100,50,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[16,16],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"fl","c":{"a":0,"k":[0.16470588235294117,0.6745098039215687,0.49411764705882355,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":219,"st":0,"bm":0},{"ddd":0,"ind":10,"ty":4,"nm":"square b","sr":1,"ks":{"o":{"a":0,"k":50,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":2,"s":[0]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.333],"y":[0]},"t":27,"s":[285.714]},{"t":191,"s":[2160]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.167,"y":0.167},"t":2,"s":[599.5,838,0],"to":[-30,-120,0],"ti":[75,3.333,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.333,"y":0},"t":27,"s":[419.5,118,0],"to":[-75,-3.333,0],"ti":[0,0,0]},{"t":191,"s":[149.5,818,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0,0]},"t":2,"s":[50,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,0.833,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":27,"s":[100,100,100]},{"t":161,"s":[100,50,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[16,16],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"fl","c":{"a":0,"k":[0.050980392156862744,0.050980392156862744,0.5019607843137255,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":2,"op":192,"st":2,"bm":0},{"ddd":0,"ind":11,"ty":4,"nm":"streamer b 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":171,"ix":10},"p":{"a":0,"k":[543,427,0],"ix":2},"a":{"a":0,"k":[-157,-245,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-1.685,-13.314],[0,-14.907],[0,-15.206],[0,-14.907],[0,-14.907],[0,-15.206],[1.754,-14.206],[-3.934,-9.465]],"o":[[-3.895,8.562],[1.872,14.789],[0,15.206],[0,14.907],[0,14.907],[0,15.206],[0,14.314],[-1.803,14.605],[0,0]],"v":[[-156.5,-406],[-166.5,-367],[-146.5,-327],[-166.5,-286],[-146.5,-246],[-166.5,-206],[-146.5,-165],[-166.5,-127],[-156.5,-84]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,0.5843137254901961,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":13,"s":[4]},{"t":61,"s":[0.5]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":18,"s":[0]},{"t":61,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":13,"s":[0]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":18,"s":[35]},{"t":61,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":13,"op":62,"st":13,"bm":0},{"ddd":0,"ind":12,"ty":4,"nm":"streamer a 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":151,"ix":10},"p":{"a":0,"k":[454,444,0],"ix":2},"a":{"a":0,"k":[-157,-245,0],"ix":1},"s":{"a":0,"k":[-100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-1.685,-13.314],[0,-14.907],[0,-15.206],[0,-14.907],[0,-14.907],[0,-15.206],[1.754,-14.206],[-3.934,-9.465]],"o":[[-3.895,8.562],[1.872,14.789],[0,15.206],[0,14.907],[0,14.907],[0,15.206],[0,14.314],[-1.803,14.605],[0,0]],"v":[[-156.5,-406],[-166.5,-367],[-146.5,-327],[-166.5,-286],[-146.5,-246],[-166.5,-206],[-146.5,-165],[-166.5,-127],[-156.5,-84]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.16470588235294117,0.6745098039215687,0.49411764705882355,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":10,"s":[4]},{"t":53,"s":[0.5]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":15,"s":[0]},{"t":53,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":10,"s":[0]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":15,"s":[35]},{"t":53,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":10,"op":54,"st":10,"bm":0},{"ddd":0,"ind":13,"ty":4,"nm":"circle a 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":1,"s":[0]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.333],"y":[0]},"t":29,"s":[-371.368]},{"t":191,"s":[-2520]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.167,"y":0.167},"t":1,"s":[599.5,838,0],"to":[-53.333,-113.333,0],"ti":[56.667,-3.333,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.333,"y":0},"t":29,"s":[279.5,158,0],"to":[-56.667,3.333,0],"ti":[0,0,0]},{"t":191,"s":[259.5,858,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0.167,0]},"t":1,"s":[100,50,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":29,"s":[100,100,100]},{"t":161,"s":[50,100,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[16,16],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.5843137254901961,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":1,"op":192,"st":1,"bm":0},{"ddd":0,"ind":14,"ty":4,"nm":"circle b 2","sr":1,"ks":{"o":{"a":0,"k":50,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":3,"s":[0]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.333],"y":[0]},"t":21,"s":[-250.839]},{"t":158,"s":[-2160]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.167,"y":0.167},"t":3,"s":[599.5,838,0],"to":[-53.333,-100,0],"ti":[63,-7,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.333,"y":0},"t":21,"s":[279.5,238,0],"to":[-63,7,0],"ti":[0,0,0]},{"t":158,"s":[221.5,880,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0.167,0]},"t":3,"s":[100,50,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":21,"s":[100,100,100]},{"t":128,"s":[50,100,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[16,16],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.23137254901960785,0.18823529411764706,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":3,"op":159,"st":3,"bm":0},{"ddd":0,"ind":15,"ty":4,"nm":"star a 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":1,"s":[0]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.333],"y":[0]},"t":31,"s":[-397.895]},{"t":191,"s":[-2520]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.167,"y":0.167},"t":1,"s":[596.087,836.292,0],"to":[-9.431,-113.333,0],"ti":[42.765,-3.333,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.333,"y":0},"t":31,"s":[539.5,156.292,0],"to":[-42.765,3.333,0],"ti":[0,0,0]},{"t":191,"s":[339.5,856.292,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0.167,0]},"t":1,"s":[100,50,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":31,"s":[100,100,100]},{"t":161,"s":[50,100,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"sr","sy":1,"d":1,"pt":{"a":0,"k":5,"ix":3},"p":{"a":0,"k":[0,0],"ix":4},"r":{"a":0,"k":0,"ix":5},"ir":{"a":0,"k":5,"ix":6},"is":{"a":0,"k":0,"ix":8},"or":{"a":0,"k":12,"ix":7},"os":{"a":0,"k":0,"ix":9},"ix":1,"nm":"Polystar Path 1","mn":"ADBE Vector Shape - Star","hd":false},{"ty":"fl","c":{"a":0,"k":[0.16470588235294117,0.6745098039215687,0.49411764705882355,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Polystar 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":1,"op":192,"st":1,"bm":0},{"ddd":0,"ind":16,"ty":4,"nm":"star b 2","sr":1,"ks":{"o":{"a":0,"k":50,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":3,"s":[0]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.333],"y":[0]},"t":23,"s":[-278.71]},{"t":158,"s":[-2160]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.167,"y":0.167},"t":3,"s":[596.087,836.292,0],"to":[-12.765,-96.667,0],"ti":[52.765,-3.333,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.333,"y":0},"t":23,"s":[519.5,256.292,0],"to":[-52.765,3.333,0],"ti":[0,0,0]},{"t":158,"s":[279.5,856.292,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0.167,0]},"t":3,"s":[100,50,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":23,"s":[100,100,100]},{"t":128,"s":[50,100,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"sr","sy":1,"d":1,"pt":{"a":0,"k":5,"ix":3},"p":{"a":0,"k":[0,0],"ix":4},"r":{"a":0,"k":0,"ix":5},"ir":{"a":0,"k":5,"ix":6},"is":{"a":0,"k":0,"ix":8},"or":{"a":0,"k":12,"ix":7},"os":{"a":0,"k":0,"ix":9},"ix":1,"nm":"Polystar Path 1","mn":"ADBE Vector Shape - Star","hd":false},{"ty":"fl","c":{"a":0,"k":[0.050980392156862744,0.050980392156862744,0.5019607843137255,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Polystar 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":3,"op":159,"st":3,"bm":0},{"ddd":0,"ind":17,"ty":4,"nm":"rec a 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[0]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.333],"y":[0]},"t":33,"s":[-556.875]},{"t":128,"s":[-2160]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.167,"y":0.167},"t":0,"s":[599.5,842,0],"to":[-16.667,-120,0],"ti":[66.667,0,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.333,"y":0},"t":33,"s":[499.5,122,0],"to":[-66.667,0,0],"ti":[0,0,0]},{"t":128,"s":[199.5,842,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0.167,0]},"t":0,"s":[100,50,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,0.833,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":33,"s":[100,100,100]},{"t":98,"s":[100,50,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[16,8],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"fl","c":{"a":0,"k":[0.16470588235294117,0.6745098039215687,0.49411764705882355,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":129,"st":0,"bm":0},{"ddd":0,"ind":18,"ty":4,"nm":"rec b 2","sr":1,"ks":{"o":{"a":0,"k":50,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":2,"s":[0]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.333],"y":[0]},"t":25,"s":[-306.667]},{"t":218,"s":[-2880]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.167,"y":0.167},"t":2,"s":[599.5,842,0],"to":[-22.62,-109.87,0],"ti":[2.877,-2.055,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.333,"y":0},"t":25,"s":[339.5,262,0],"to":[-51.333,36.667,0],"ti":[0,0,0]},{"t":218,"s":[219.5,862,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0.167,0]},"t":2,"s":[100,50,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":25,"s":[100,100,100]},{"t":188,"s":[50,100,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[16,8],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.5843137254901961,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":2,"op":219,"st":2,"bm":0},{"ddd":0,"ind":19,"ty":4,"nm":"square a 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[0]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.333],"y":[0]},"t":35,"s":[-590.625]},{"t":128,"s":[-2160]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.167,"y":0.167},"t":0,"s":[599.5,838,0],"to":[-20,-90,0],"ti":[36.667,0,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.333,"y":0},"t":35,"s":[479.5,298,0],"to":[-36.667,0,0],"ti":[0,0,0]},{"t":128,"s":[379.5,838,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0.167,0]},"t":0,"s":[100,50,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":35,"s":[100,100,100]},{"t":98,"s":[50,100,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[16,16],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.5843137254901961,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":129,"st":0,"bm":0},{"ddd":0,"ind":20,"ty":4,"nm":"square b 2","sr":1,"ks":{"o":{"a":0,"k":50,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":2,"s":[0]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.333],"y":[0]},"t":27,"s":[-333.333]},{"t":218,"s":[-2880]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.167,"y":0.167},"t":2,"s":[599.5,838,0],"to":[-10,-103.333,0],"ti":[50,0,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.333,"y":0},"t":27,"s":[539.5,218,0],"to":[-50,0,0],"ti":[0,0,0]},{"t":218,"s":[299.5,838,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0.167,0]},"t":2,"s":[100,50,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":27,"s":[100,100,100]},{"t":188,"s":[50,100,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[16,16],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"fl","c":{"a":0,"k":[0.050980392156862744,0.050980392156862744,0.5019607843137255,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":2,"op":219,"st":2,"bm":0}]},{"id":"comp_2","layers":[{"ddd":0,"ind":1,"ty":0,"nm":"_small-side","refId":"comp_1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[260,320,0],"ix":2},"a":{"a":0,"k":[400,400,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"w":800,"h":800,"ip":0,"op":219,"st":0,"bm":0}]},{"id":"comp_3","layers":[{"ddd":0,"ind":1,"ty":0,"nm":"left","refId":"comp_4","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[400,400,0],"ix":2},"a":{"a":0,"k":[400,400,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"w":800,"h":800,"ip":13,"op":313,"st":13,"bm":0},{"ddd":0,"ind":2,"ty":0,"nm":"right","refId":"comp_4","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[400,400,0],"ix":2},"a":{"a":0,"k":[400,400,0],"ix":1},"s":{"a":0,"k":[-100,100,100],"ix":6}},"ao":0,"w":800,"h":800,"ip":30,"op":330,"st":30,"bm":0}]},{"id":"comp_4","layers":[{"ddd":0,"ind":1,"ty":4,"nm":"streamer a 4","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":14,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":13,"s":[219.178,-190.096,0],"to":[-95.333,426.667,0],"ti":[167.333,-560.667,0]},{"t":173,"s":[179.178,989.904,0]}],"ix":2},"a":{"a":0,"k":[-157,-245,0],"ix":1},"s":{"a":0,"k":[-100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-1.685,-13.314],[0,-14.907],[0,-15.206],[0,-14.907],[0,-14.907],[0,-15.206],[1.754,-14.206],[-3.934,-9.465]],"o":[[-3.895,8.562],[1.872,14.789],[0,15.206],[0,14.907],[0,14.907],[0,15.206],[0,14.314],[-1.803,14.605],[0,0]],"v":[[-156.5,-406],[-166.5,-367],[-146.5,-327],[-166.5,-286],[-146.5,-246],[-166.5,-206],[-146.5,-165],[-166.5,-127],[-156.5,-84]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.050980392156862744,0.050980392156862744,0.5019607843137255,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":13,"s":[4]},{"t":176,"s":[0.5]}],"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":18,"s":[0]},{"t":176,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":13,"s":[0]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":18,"s":[40]},{"t":176,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":13,"op":174,"st":13,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"streamer b 4","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":-1.458,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":5,"s":[269.863,-175.455,0],"to":[-110,415.333,0],"ti":[216,-599.333,0]},{"t":173,"s":[69.863,984.545,0]}],"ix":2},"a":{"a":0,"k":[-157,-245,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-1.685,-13.314],[0,-14.907],[0,-15.206],[0,-14.907],[0,-14.907],[0,-15.206],[1.754,-14.206],[-3.934,-9.465]],"o":[[-3.895,8.562],[1.872,14.789],[0,15.206],[0,14.907],[0,14.907],[0,15.206],[0,14.314],[-1.803,14.605],[0,0]],"v":[[-156.5,-406],[-166.5,-367],[-146.5,-327],[-166.5,-286],[-146.5,-246],[-166.5,-206],[-146.5,-165],[-166.5,-127],[-156.5,-84]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.16470588235294117,0.6745098039215687,0.49411764705882355,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":5,"s":[4]},{"t":173,"s":[0.5]}],"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":10,"s":[0]},{"t":173,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":5,"s":[0]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":10,"s":[40]},{"t":173,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":5,"op":174,"st":5,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"circle a 4","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":8,"s":[0]},{"t":155,"s":[1800]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":8,"s":[325.643,-26.292,0],"to":[-101.333,75.667,0],"ti":[15.333,-507.667,0]},{"t":155,"s":[125.643,835.708,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":8,"s":[50,100,100]},{"t":155,"s":[100,50,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[16,16],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.5843137254901961,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":8,"op":156,"st":-7,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"circle b 4","sr":1,"ks":{"o":{"a":0,"k":50,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":2,"s":[0]},{"t":215,"s":[2520]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":2,"s":[619.5,-26.292,0],"to":[-138,77.667,0],"ti":[-2,-497.667,0]},{"t":215,"s":[259.5,835.708,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":2,"s":[50,100,100]},{"t":215,"s":[100,50,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[16,16],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[0.050980392156862744,0.050980392156862744,0.5019607843137255,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":2,"op":216,"st":-13,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"star a 4","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":6,"s":[0]},{"t":245,"s":[2880]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":6,"s":[376.929,-28,0],"to":[-213.333,157.667,0],"ti":[173.333,-127.667,0]},{"t":245,"s":[116.929,834,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":6,"s":[50,100,100]},{"t":245,"s":[100,50,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"sr","sy":1,"d":1,"pt":{"a":0,"k":5,"ix":3},"p":{"a":0,"k":[0,0],"ix":4},"r":{"a":0,"k":0,"ix":5},"ir":{"a":0,"k":5,"ix":6},"is":{"a":0,"k":0,"ix":8},"or":{"a":0,"k":12,"ix":7},"os":{"a":0,"k":0,"ix":9},"ix":1,"nm":"Polystar Path 1","mn":"ADBE Vector Shape - Star","hd":false},{"ty":"fl","c":{"a":0,"k":[0.16470588235294117,0.6745098039215687,0.49411764705882355,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Polystar 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":6,"op":246,"st":-9,"bm":0},{"ddd":0,"ind":6,"ty":4,"nm":"star b 4","sr":1,"ks":{"o":{"a":0,"k":50,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":2,"s":[0]},{"t":125,"s":[1800]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":2,"s":[171.786,-28,0],"to":[0,0,0],"ti":[-161.333,-275.667,0]},{"t":125,"s":[251.786,834,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":2,"s":[50,100,100]},{"t":125,"s":[100,50,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"sr","sy":1,"d":1,"pt":{"a":0,"k":5,"ix":3},"p":{"a":0,"k":[0,0],"ix":4},"r":{"a":0,"k":0,"ix":5},"ir":{"a":0,"k":5,"ix":6},"is":{"a":0,"k":0,"ix":8},"or":{"a":0,"k":12,"ix":7},"os":{"a":0,"k":0,"ix":9},"ix":1,"nm":"Polystar Path 1","mn":"ADBE Vector Shape - Star","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.23137254901960785,0.18823529411764706,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Polystar 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":2,"op":126,"st":-13,"bm":0},{"ddd":0,"ind":7,"ty":4,"nm":"rec a 4","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":4,"s":[0]},{"t":185,"s":[2520]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":4,"s":[428.214,-22.292,0],"to":[-167.333,119.667,0],"ti":[-130.667,-315.667,0]},{"t":185,"s":[228.214,839.708,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":4,"s":[50,100,100]},{"t":185,"s":[100,50,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[16,8],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.5843137254901961,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":4,"op":186,"st":-11,"bm":0},{"ddd":0,"ind":8,"ty":4,"nm":"rec b 4","sr":1,"ks":{"o":{"a":0,"k":50,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":6,"s":[0]},{"t":245,"s":[2880]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":6,"s":[223.071,-22.292,0],"to":[0,0,0],"ti":[-92.571,-383.708,0]},{"t":245,"s":[223.071,839.708,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":6,"s":[50,100,100]},{"t":245,"s":[100,50,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[16,8],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"fl","c":{"a":0,"k":[0.050980392156862744,0.050980392156862744,0.5019607843137255,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":6,"op":246,"st":-9,"bm":0},{"ddd":0,"ind":9,"ty":4,"nm":"square a 4","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":4,"s":[0]},{"t":217,"s":[2520]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":4,"s":[120.5,-26.292,0],"to":[13,430.305,0],"ti":[52.221,-418.892,0]},{"t":217,"s":[198.5,833.708,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":4,"s":[50,100,100]},{"t":217,"s":[100,50,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[16,16],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"fl","c":{"a":0,"k":[0.16470588235294117,0.6745098039215687,0.49411764705882355,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":4,"op":218,"st":-11,"bm":0},{"ddd":0,"ind":10,"ty":4,"nm":"square b 4","sr":1,"ks":{"o":{"a":0,"k":50,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":8,"s":[0]},{"t":215,"s":[2520]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":8,"s":[274.357,-26.292,0],"to":[157.333,415.667,0],"ti":[22.667,-253.667,0]},{"t":215,"s":[114.357,835.708,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":8,"s":[50,100,100]},{"t":215,"s":[100,50,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[16,16],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"fl","c":{"a":0,"k":[0.16470588235294117,0.6745098039215687,0.49411764705882355,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":8,"op":216,"st":-7,"bm":0},{"ddd":0,"ind":11,"ty":4,"nm":"streamer a 3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":3,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":0,"s":[275.178,-173.096,0],"to":[-87.333,413.333,0],"ti":[177.333,-643.333,0]},{"t":185,"s":[219.178,974.904,0]}],"ix":2},"a":{"a":0,"k":[-157,-245,0],"ix":1},"s":{"a":0,"k":[-100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-1.685,-13.314],[0,-14.907],[0,-15.206],[0,-14.907],[0,-14.907],[0,-15.206],[1.754,-14.206],[-3.934,-9.465]],"o":[[-3.895,8.562],[1.872,14.789],[0,15.206],[0,14.907],[0,14.907],[0,15.206],[0,14.314],[-1.803,14.605],[0,0]],"v":[[-156.5,-406],[-166.5,-367],[-146.5,-327],[-166.5,-286],[-146.5,-246],[-166.5,-206],[-146.5,-165],[-166.5,-127],[-156.5,-84]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.16470588235294117,0.6745098039215687,0.49411764705882355,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[4]},{"t":177,"s":[0.5]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":5,"s":[0]},{"t":177,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[0]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":5,"s":[40]},{"t":177,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":186,"st":0,"bm":0},{"ddd":0,"ind":12,"ty":4,"nm":"streamer b 3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":9,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":11,"s":[199.863,74.545,0],"to":[-13.363,405.455,0],"ti":[179.333,-430.667,0]},{"t":217,"s":[139.863,834.545,0]}],"ix":2},"a":{"a":0,"k":[-157,-245,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-1.685,-13.314],[0,-14.907],[0,-15.206],[0,-14.907],[0,-14.907],[0,-15.206],[1.754,-14.206],[-3.934,-9.465]],"o":[[-3.895,8.562],[1.872,14.789],[0,15.206],[0,14.907],[0,14.907],[0,15.206],[0,14.314],[-1.803,14.605],[0,0]],"v":[[-156.5,-406],[-166.5,-367],[-146.5,-327],[-166.5,-286],[-146.5,-246],[-166.5,-206],[-146.5,-165],[-166.5,-127],[-156.5,-84]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,0.5843137254901961,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":11,"s":[4]},{"t":199,"s":[0.5]}],"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":16,"s":[0]},{"t":199,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":11,"s":[0]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":16,"s":[40]},{"t":199,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":11,"op":218,"st":11,"bm":0},{"ddd":0,"ind":13,"ty":4,"nm":"circle a 3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":2,"s":[0]},{"t":125,"s":[-1800]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":2,"s":[365.643,-26.292,0],"to":[-101.333,75.667,0],"ti":[15.333,-507.667,0]},{"t":125,"s":[165.643,835.708,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":2,"s":[100,50,100]},{"t":125,"s":[50,100,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[16,16],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.5843137254901961,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":2,"op":126,"st":-13,"bm":0},{"ddd":0,"ind":14,"ty":4,"nm":"circle b 3","sr":1,"ks":{"o":{"a":0,"k":50,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":8,"s":[0]},{"t":245,"s":[-2880]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":8,"s":[519.5,-26.292,0],"to":[-138,77.667,0],"ti":[-2,-497.667,0]},{"t":245,"s":[159.5,835.708,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":8,"s":[100,50,100]},{"t":245,"s":[50,100,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[16,16],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.23137254901960785,0.18823529411764706,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":8,"op":246,"st":-7,"bm":0},{"ddd":0,"ind":15,"ty":4,"nm":"star a 3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":6,"s":[0]},{"t":245,"s":[-2880]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":6,"s":[416.929,-28,0],"to":[-213.333,157.667,0],"ti":[173.333,-127.667,0]},{"t":245,"s":[156.929,834,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":6,"s":[100,50,100]},{"t":245,"s":[50,100,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"sr","sy":1,"d":1,"pt":{"a":0,"k":5,"ix":3},"p":{"a":0,"k":[0,0],"ix":4},"r":{"a":0,"k":0,"ix":5},"ir":{"a":0,"k":5,"ix":6},"is":{"a":0,"k":0,"ix":8},"or":{"a":0,"k":12,"ix":7},"os":{"a":0,"k":0,"ix":9},"ix":1,"nm":"Polystar Path 1","mn":"ADBE Vector Shape - Star","hd":false},{"ty":"fl","c":{"a":0,"k":[0.16470588235294117,0.6745098039215687,0.49411764705882355,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Polystar 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":6,"op":246,"st":-9,"bm":0},{"ddd":0,"ind":16,"ty":4,"nm":"star b 3","sr":1,"ks":{"o":{"a":0,"k":50,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":8,"s":[0]},{"t":155,"s":[-2160]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":8,"s":[211.786,-28,0],"to":[0,0,0],"ti":[-161.333,-275.667,0]},{"t":155,"s":[291.786,834,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":8,"s":[100,50,100]},{"t":155,"s":[50,100,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"sr","sy":1,"d":1,"pt":{"a":0,"k":5,"ix":3},"p":{"a":0,"k":[0,0],"ix":4},"r":{"a":0,"k":0,"ix":5},"ir":{"a":0,"k":5,"ix":6},"is":{"a":0,"k":0,"ix":8},"or":{"a":0,"k":12,"ix":7},"os":{"a":0,"k":0,"ix":9},"ix":1,"nm":"Polystar Path 1","mn":"ADBE Vector Shape - Star","hd":false},{"ty":"fl","c":{"a":0,"k":[0.050980392156862744,0.050980392156862744,0.5019607843137255,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Polystar 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":8,"op":156,"st":-7,"bm":0},{"ddd":0,"ind":17,"ty":4,"nm":"rec a 3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":4,"s":[0]},{"t":185,"s":[-2160]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":4,"s":[468.214,-22.292,0],"to":[-167.333,119.667,0],"ti":[-130.667,-315.667,0]},{"t":185,"s":[268.214,839.708,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":4,"s":[100,50,100]},{"t":185,"s":[50,100,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[16,8],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"fl","c":{"a":0,"k":[0.16470588235294117,0.6745098039215687,0.49411764705882355,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":4,"op":186,"st":-11,"bm":0},{"ddd":0,"ind":18,"ty":4,"nm":"rec b 3","sr":1,"ks":{"o":{"a":0,"k":50,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":6,"s":[0]},{"t":245,"s":[-2880]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":6,"s":[263.071,-22.292,0],"to":[0,143.667,0],"ti":[-114.571,-267.708,0]},{"t":245,"s":[263.071,839.708,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":6,"s":[100,50,100]},{"t":245,"s":[50,100,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[16,8],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.5843137254901961,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":6,"op":246,"st":-9,"bm":0},{"ddd":0,"ind":19,"ty":4,"nm":"square a 3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":2,"s":[0]},{"t":217,"s":[-2520]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":2,"s":[160.5,-26.292,0],"to":[13,430.305,0],"ti":[52.221,-418.892,0]},{"t":217,"s":[238.5,833.708,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":2,"s":[100,50,100]},{"t":217,"s":[50,100,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[16,16],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.5843137254901961,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":2,"op":218,"st":-13,"bm":0},{"ddd":0,"ind":20,"ty":4,"nm":"square b 3","sr":1,"ks":{"o":{"a":0,"k":50,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":4,"s":[0]},{"t":185,"s":[-2160]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":4,"s":[314.357,-26.292,0],"to":[157.333,415.667,0],"ti":[22.667,-253.667,0]},{"t":185,"s":[154.357,835.708,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":4,"s":[100,50,100]},{"t":185,"s":[50,100,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[16,16],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"fl","c":{"a":0,"k":[0.050980392156862744,0.050980392156862744,0.5019607843137255,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":4,"op":186,"st":-11,"bm":0}]}],"layers":[{"ddd":0,"ind":1,"ty":0,"nm":"cannon (small - left)","refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[228,1355.9999999999998,0],"ix":2},"a":{"a":0,"k":[0,360,0],"ix":1},"s":{"a":0,"k":[300,300,100],"ix":6}},"ao":0,"w":480,"h":720,"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":0,"nm":"cannon (small - right)","refId":"comp_2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1599,1355.9999999999998,0],"ix":2},"a":{"a":0,"k":[479.994,360,0],"ix":1},"s":{"a":0,"k":[300,300,100],"ix":6}},"ao":0,"w":480,"h":720,"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":0,"nm":"cannon (small - top)","refId":"comp_3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[912,1224,0],"ix":2},"a":{"a":0,"k":[400,400,0],"ix":1},"s":{"a":0,"k":[306,306,100],"ix":6}},"ao":0,"w":800,"h":800,"ip":0,"op":300,"st":0,"bm":0}],"markers":[]}

/***/ }),

/***/ "Jhqu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      subscriptionType: 'Postpaid',
      deliveryFrequency: 3,
      quantity: 1,
      productId: 1,
      type: 'Daily',
      alternate: 2, // fix for every second day in alternate
      userDetails: [],
      subscriptionObj: []
    };
  },
  created: function created() {
    if (sessionStorage.getItem('userId') === null) {
      this.$router.push('/a/reg');
    } else {
      this.userInfo();
    }
    // this.userInfo()
  },

  methods: {
    userInfo: function userInfo() {
      var _this = this;

      var params = new URLSearchParams();
      var userId = sessionStorage.getItem('userId');
      params.append('user_id', userId);
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/users/user-info',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        document.getElementById('subscribed').style.display = 'none';
        document.getElementById('not_subscribed').style.display = 'block';
        _this.userDetails = {};
        _this.userDetails.userId = userId;
        _this.userDetails.first_name = response.data.user_record.user_details.first_name;
        _this.userDetails.mobile = response.data.user_record.user.username;
        _this.userDetails.address = response.data.user_record.address.address1 + ' ' + response.data.user_record.address.address2 + ' ' + response.data.user_record.address.city;
        _this.userDetails.startDate = response.data.today_date;
        _this.userDetails.displayedStartDate = _this.userDetails.startDate.split('-').reverse().join('-');
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          _this.list = response.data.user_record;
          alert(_this.list);
        }
      }).catch(function (e) {
        alert('not ok');
      });
    },
    subscribe: function subscribe() {
      var _this2 = this;

      var params = new URLSearchParams();
      params.append('user_id', sessionStorage.getItem('userId'));
      params.append('product_id', this.productId);
      params.append('start_date', this.userDetails.startDate);
      params.append('type', this.type);
      params.append('delivery_frequency', this.deliveryFrequency);
      params.append('subscription_type', this.subscriptionType);
      params.append('quantity', this.quantity);
      params.append('alternate', this.alternate);
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/subscriptions/add',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this2.subscriptionObj = {};
        if (response.data.status === '000000') {
          _this2.subscriptionObj.paymentUrl = response.data.payment_url;
          document.getElementById('subscribed').style.display = 'block';
          document.getElementById('not_subscribed').style.display = 'none';
        } else {
          alert(response.data.msg);
        }
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          _this2.list = response.data.user_record;
          alert(_this2.list);
        }
      }).catch(function (e) {
        alert('not ok');
      });
    }
  }
});

/***/ }),

/***/ "Jmt5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JuSb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "K5TN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dispatcherLocationFlow: false,
      salesman_flow: 0,
      salesman_location_required: 0,
      pincode: '000000',
      city: 'North Delhi',
      country: '',
      state: '',
      locality: '',
      formattedAddress: '',
      profileSet: [],
      userDetails: [],
      cityList: [],
      gender: 'M',
      profile: false,
      address1: '',
      address2: '',
      center: { lat: 0, lng: 0 },
      markers: [{
        position: { lat: 0, lng: 0 }
      }]
    };
  },
  created: function created() {
    var _this = this;

    if (sessionStorage.getItem('salesman_flow') !== null) {
      this.salesman_flow = sessionStorage.getItem('salesman_flow');
    }
    if (sessionStorage.getItem('dispatcherId') !== null) {
      this.dispatcherLocationFlow = true;
      this.pincode = '';
      // call api to get cities
      this.getCities();
    }
    if (sessionStorage.getItem('salesman_location_required') !== null) {
      this.salesman_location_required = sessionStorage.getItem('salesman_location_required');
    }
    if (sessionStorage.getItem('actionName') === 'subscription' && sessionStorage.getItem('locationAction') === 'getOldLocation') {
      var params = new URLSearchParams();
      var userId = sessionStorage.getItem('userId');
      params.append('user_id', userId);
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/users/user-info',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        // console.log(response)
        _this.address1 = response.data.user_record.address.address1;
        _this.address2 = response.data.user_record.address.address2;
        sessionStorage.setItem('custAddress1', _this.address1);
        sessionStorage.setItem('custAddress2', _this.address2);
        _this.markers[0].position.lat = parseFloat(response.data.user_record.address.latitude);
        _this.markers[0].position.lng = parseFloat(response.data.user_record.address.longitude);
        _this.center.lat = parseFloat(response.data.user_record.address.latitude);
        _this.center.lng = parseFloat(response.data.user_record.address.longitude);
        _this.address(_this.markers[0].position.lat, _this.markers[0].position.lng);
      }).catch(function (e) {
        alert('not ok');
      });
    }
    if (sessionStorage.getItem('custAddress1') !== null) {
      this.address1 = sessionStorage.getItem('custAddress1');
    }
    if (sessionStorage.getItem('custAddress2') !== null) {
      this.address2 = sessionStorage.getItem('custAddress2');
    }
    // alert(sessionStorage.getItem("userId"))
    // alert(sessionStorage.getItem('isProfile'))
    if (sessionStorage.getItem('userId') === null) {
      this.$router.push('/a/reg');
    } else if (sessionStorage.getItem('isProfile') === '0' || sessionStorage.getItem('isProfile') === 0) {
      this.userInfo();
    } else {
      this.fetchCurrentLocation();
    }
  },

  methods: {
    fetchCurrentLocation: function fetchCurrentLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
          var pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          this.center.lat = pos.lat;
          this.center.lng = pos.lng;
          this.markers[0].position.lat = pos.lat;
          this.markers[0].position.lng = pos.lng;
          this.address(this.markers[0].position.lat, this.markers[0].position.lng);
        }.bind(this));
      }
    },
    onClickCurrentLocationButtion: function onClickCurrentLocationButtion() {
      sessionStorage.setItem('locationAction', 'currentLocation');
      window.location.reload();
    },
    updateCoordinates: function updateCoordinates(location) {
      this.markers[0].position.lat = location.latLng.lat();
      this.markers[0].position.lng = location.latLng.lng();
      this.address(this.markers[0].position.lat, this.markers[0].position.lng);
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      if (document.getElementById('address1').value !== '') {
        this.address1 = document.getElementById('address1').value;
        this.address2 = document.getElementById('address2').value;
        if (sessionStorage.getItem('actionName') === 'subscription') {
          var params = new URLSearchParams();
          var userId = sessionStorage.getItem('userId');
          params.append('user_id', userId);
          __WEBPACK_IMPORTED_MODULE_0_axios___default()({
            url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/users/user-info',
            method: 'post',
            data: params,
            withCredentials: false,
            headers: {}
          }).then(function (response) {
            // console.log(response)
            var params = new URLSearchParams();
            params.append('user_id', userId);
            params.append('first_name', response.data.user_record.user_details.first_name);
            params.append('pincode', _this2.pincode);
            params.append('deviceId', response.data.user_record.user.mobile);
            params.append('address1', _this2.address1);
            params.append('address2', _this2.address2);
            params.append('state', _this2.state);
            params.append('gps_address', _this2.formattedAddress);
            if (_this2.dispatcherLocationFlow === false || _this2.salesman_location_required === '1') {
              params.append('latitude', _this2.markers[0].position.lat);
              params.append('longitude', _this2.markers[0].position.lng);
            } else {
              params.append('latitude', 0.0);
              params.append('longitude', 0.0);
            }
            params.append('locality', _this2.locality);
            params.append('region_code', _this2.pincode);
            params.append('gender', response.data.user_record.user_details.gender);
            params.append('phone', response.data.user_record.user.mobile);
            params.append('email', response.data.user_record.user_details.email);
            params.append('zombie', 0);
            params.append('country_id', 1);
            __WEBPACK_IMPORTED_MODULE_0_axios___default()({
              url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/users/profile',
              method: 'post',
              data: params,
              withCredentials: false,
              headers: {}
            }).then(function (response) {
              // console.log(response)
              if (response.data.status === '000000') {
                window.location.href = sessionStorage.getItem('callbackUrlForSubscription');
              } else {
                alert(response.data.msg);
              }
            }).catch(function (e) {
              alert('not ok');
            });
          }).catch(function (e) {
            alert('not ok');
          });
        } else {
          if (sessionStorage.getItem('dispatcherId') !== null) {
            if (isNaN(this.pincode) || this.pincode.length !== 6 || this.pincode === '') {
              this.$swal.fire({ text: 'Please enter valid pincode!' });
            } else {
              this.profile = true;
            }
          } else {
            this.profile = true;
          }
          // this.profile = true
        }
      } else {
        // alert('Please fill address')
        this.$swal.fire({ text: 'Please fill address!' });
      }
    },
    address: function address(lats, lngs) {
      var latlng = { lat: lats, lng: lngs };
      var google = window.google;
      // alert(google)
      if (google !== undefined) {
        var geocoder = new google.maps.Geocoder();
        var myScope = this;
        geocoder.geocode({ 'location': latlng }, function (results, status) {
          if (status === 'OK') {
            if (results[0]) {
              if (document.getElementById('del_loc')) {
                document.getElementById('del_loc').value = results[0].formatted_address;
              }
              var length = results[0].address_components.length;
              length = length - 1;
              myScope.pincode = results[0].address_components[length].long_name;
              if (sessionStorage.getItem('dispatcherId') !== null) {
                myScope.pincode = '';
              }
              length = length - 1;
              myScope.country = results[0].address_components[length].long_name;
              length = length - 1;
              myScope.state = results[0].address_components[length].long_name;
              length = length - 1;
              myScope.locality = results[0].address_components[length].long_name;
              length = length - 1;
              myScope.formattedAddress = results[0].formatted_address;
            } else {
              window.alert('No results found');
            }
          } else {
            // window.alert('Geocoder failed due to: ' + status);
          }
        });
      } else {
        window.location.reload();
      }
    },
    profileSetApi: function profileSetApi() {
      var _this3 = this;

      var firstName = document.getElementById('profile_name').value;
      var email = document.getElementById('profile_email').value;
      var userid = sessionStorage.getItem('userId');
      if (this.validateEmail(email) && firstName !== '') {
        /* alert('user_id' + userid)
        alert('first_name' + firstName)
        alert('pincode' + this.pincode)
        if (document.getElementById('profile_referral').value !== '') {
          alert('referral_code' + document.getElementById('profile_referral').value)
        }
        alert('deviceId' + sessionStorage.getItem('userMobile'))
        alert('address1' + this.address1)
        alert('address2' + this.address2)
        alert('state' + this.state)
        alert('gps_address' + this.formattedAddress)
        alert('latitude' + this.markers[0].position.lat)
        alert('longitude' + this.markers[0].position.lng)
        alert('locality' + this.locality)
        alert('region_code' + this.pincode)
        alert('gender' + this.gender)
        alert('phone' + sessionStorage.getItem('userMobile'))
        alert('email' + email)
        alert('country_id' + 1) */
        var params = new URLSearchParams();
        params.append('user_id', userid);
        params.append('first_name', firstName);
        params.append('pincode', this.pincode);
        if (sessionStorage.getItem('dispatcherId') !== null) {
          params.append('city', this.city);
        }
        if (this.salesman_flow === 0) {
          params.append('referral_code', document.getElementById('profile_referral').value);
        }
        params.append('deviceId', sessionStorage.getItem('userMobile'));
        params.append('address1', this.address1);
        params.append('address2', this.address2);
        params.append('state', this.state);
        params.append('gps_address', this.formattedAddress);
        // params.append('latitude', this.markers[0].position.lat)
        // params.append('longitude', this.markers[0].position.lng)
        if (this.salesman_location_required === '1') {
          params.append('latitude', this.markers[0].position.lat);
          params.append('longitude', this.markers[0].position.lng);
        } else {
          params.append('latitude', 0.0);
          params.append('longitude', 0.0);
        }
        params.append('locality', this.locality);
        params.append('region_code', this.pincode);
        params.append('gender', this.gender);
        params.append('phone', sessionStorage.getItem('userMobile'));
        params.append('email', email);
        params.append('zombie', 0);
        params.append('country_id', 1);
        if (sessionStorage.getItem('dispatcherId') !== null) {
          params.append('dispatcher_id', sessionStorage.getItem('dispatcherId'));
        }
        __WEBPACK_IMPORTED_MODULE_0_axios___default()({
          url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/users/profile',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {}
        }).then(function (response) {
          _this3.profileSet = {};
          if (response.data.status === '000000') {
            // this.$router.push('/a/subscription')
            sessionStorage.setItem('isProfile', 0);
            if (sessionStorage.getItem('urlstr') === 'undefined' || sessionStorage.getItem('urlstr') === null) {
              // this.$router.push('/a/subscription')
              sessionStorage.setItem('productListUrl', response.data.product_list_url);
              window.location.href = response.data.product_list_url;
              // window.location.href = 'http://localhost:4000/#/a/productList?4t43'
            } else {
              _this3.$router.push('/a/s?' + sessionStorage.getItem('urlstr'));
            }
          } else {
            alert(response.data.msg);
          }
          // console.log(response)
          if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
            _this3.list = response.data.user_record;
            alert(_this3.list);
          }
        }).catch(function (e) {
          alert('not ok');
        });
      } else {
        alert('please fill name and email correctly');
      }
    },
    validateEmail: function validateEmail(email) {
      if (this.dispatcherLocationFlow === false) {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      } else {
        return true;
      }
    },
    userInfo: function userInfo() {
      var _this4 = this;

      var params = new URLSearchParams();
      var userId = sessionStorage.getItem('userId');
      params.append('user_id', userId);
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/users/user-info',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this4.userDetails = {};
        _this4.userDetails.lat = response.data.user_record.address.latitude;
        _this4.userDetails.lng = response.data.user_record.address.longitude;
        if (_this4.userDetails.lat === 'null' || _this4.userDetails.lat === '0' || _this4.userDetails.lat === '0.0' || _this4.userDetails.lat === null || _this4.userDetails.lng === 'null' || _this4.userDetails.lng === '0' || _this4.userDetails.lng === '0.0' || _this4.userDetails.lng === null) {
          _this4.fetchCurrentLocation();
        } else {
          if (sessionStorage.getItem('urlstr') === 'undefined' || sessionStorage.getItem('urlstr') === null) {
            // this.$router.push('/a/subscription')
            if (sessionStorage.getItem('productListUrl') !== null) {
              window.location.href = sessionStorage.getItem('productListUrl');
            } else {
              // this.$router.push('/a/subscription')
            }
          } else {
            _this4.$router.push('/a/s?' + sessionStorage.getItem('urlstr'));
          }
        }
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          _this4.list = response.data.user_record;
          alert(_this4.list);
        }
      }).catch(function (e) {
        alert('not ok');
      });
    },
    getCities: function getCities() {
      var _this5 = this;

      var params = new URLSearchParams();
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/users/cities',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this5.cityList = response.data.city_list;
        console.log(_this5.cityList);
      }).catch(function (e) {
        alert('not ok');
      });
    }
  }
});

/***/ }),

/***/ "K5hE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"url_valid"}},[_c('div',{attrs:{"id":"Display_page"}},[_c('br'),_vm._v(" "),_vm._m(0),_vm._v(" "),(!_vm.failMessage)?_c('div',[(!_vm.successMessage)?_c('div',[_c('div',{attrs:{"id":"url_valid"}},[_c('div',[_c('center',[_c('img',{attrs:{"src":_vm.apiDataObj.image_url ? _vm.apiDataObj.image_url : ''}}),_vm._v(" "),_c('b',[_c('h3',[_vm._v(_vm._s(_vm.apiDataObj.header))])]),_vm._v(" "),_c('p',{staticClass:"discription"},[_vm._v(_vm._s(_vm.apiDataObj.offer_detail))]),_vm._v(" "),_c('form',[_c('b',[_c('button',{staticClass:"subs",staticStyle:{"background-color":"#74c7fc","border":"none","size":"3px","color":"#ffffff","border-radius":"4px","text-align":"center"},attrs:{"type":"button"},on:{"click":function($event){_vm.place_order()}}},[_vm._v("\n                      "+_vm._s(_vm.apiDataObj.button_caption)+"\n                    ")])])])]),_vm._v(" "),_c('br')],1)])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.successMessage)?_c('div',{staticClass:"success-message"},[_c('center',[_c('img',{staticClass:"msg-icon",attrs:{"src":"static/img/icons/thumb-up.png"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"messg"},[_vm._v(_vm._s(_vm.successMessage))])])],1):_vm._e(),_vm._v(" "),(_vm.failMessage)?_c('div',{staticClass:"fail-message"},[_c('center',[_c('img',{staticClass:"msg-icon",attrs:{"src":"static/img/icons/warning.png"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"messg"},[_vm._v(_vm._s(_vm.failMessage))])])],1):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container is-fluid has-text-centered",attrs:{"id":"url_expired"}},[_c('h4',[_vm._v("Welcome to Doodhvale, Please wait...")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KBIF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__ = __webpack_require__("Pn7K");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_408bd34e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__ = __webpack_require__("nfaN");
function injectStyle (ssrContext) {
  __webpack_require__("ptyN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_408bd34e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KEEg":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjUxMnB4IiBoZWlnaHQ9IjUxMnB4IiB2aWV3Qm94PSIwIDAgNTEwIDUxMCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEwIDUxMDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8Zz4KCTxnIGlkPSJzaG9wcGluZy1jYXJ0Ij4KCQk8cGF0aCBkPSJNMTUzLDQwOGMtMjguMDUsMC01MSwyMi45NS01MSw1MXMyMi45NSw1MSw1MSw1MXM1MS0yMi45NSw1MS01MVMxODEuMDUsNDA4LDE1Myw0MDh6IE0wLDB2NTFoNTFsOTEuOCwxOTMuOEwxMDcuMSwzMDYgICAgYy0yLjU1LDcuNjUtNS4xLDE3Ljg1LTUuMSwyNS41YzAsMjguMDUsMjIuOTUsNTEsNTEsNTFoMzA2di01MUgxNjMuMmMtMi41NSwwLTUuMS0yLjU1LTUuMS01LjF2LTIuNTUxbDIyLjk1LTQzLjM1aDE4OC43ICAgIGMyMC40LDAsMzUuNy0xMC4yLDQzLjM1LTI1LjVMNTA0LjksODkuMjVjNS4xLTUuMSw1LjEtNy42NSw1LjEtMTIuNzVjMC0xNS4zLTEwLjItMjUuNS0yNS41LTI1LjVIMTA3LjFMODQuMTUsMEgweiBNNDA4LDQwOCAgICBjLTI4LjA1LDAtNTEsMjIuOTUtNTEsNTFzMjIuOTUsNTEsNTEsNTFzNTEtMjIuOTUsNTEtNTFTNDM2LjA1LDQwOCw0MDgsNDA4eiIgZmlsbD0iI0ZGRkZGRiIvPgoJPC9nPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "KGkr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"walletCouponPage"},[_c('div',{staticClass:"couponField"},[_vm._m(0),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"column"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customCouponCode),expression:"customCouponCode"}],staticClass:"coupon_text",attrs:{"id":"coupon_code","name":"COUPON_CODE","type":"text","placeholder":"Enter Coupon Code"},domProps:{"value":(_vm.customCouponCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.customCouponCode=$event.target.value}}}),_vm._v(" "),_c('p',{staticClass:"invalid_coupon"},[_vm._v(_vm._s(_vm.invalidCouponMsg))])]),_vm._v(" "),_c('button',{staticClass:"apply no-select",on:{"click":function($event){_vm.verifyPromoCode(_vm.customCouponCode)}}},[_vm._v("\n      APPLY\n    ")])]),_vm._v(" "),(_vm.codeLists.length === 0)?_c('div',{staticClass:"couponAvailability"},[_c('p',[_vm._v("No Available Coupon")])]):_c('div',{staticClass:"wallet_codes_wrapper"},[_vm._m(1),_vm._v(" "),_vm._l((_vm.codeLists),function(code){return _c('div',{key:code.id,staticClass:"wallet_code"},[_c('div',{staticClass:"flex"},[_c('div',{staticStyle:{"color":"#3cb6c3","font-weight":"bold"}},[_vm._v("\n          "+_vm._s(code.promo_str)+"\n        ")]),_vm._v(" "),_c('button',{staticClass:"apply no-select",style:({ color: code.is_enable ? '#ff8080' : 'gray' }),on:{"click":function($event){code.is_enable ? _vm.verifyPromoCode(code.promo_str) : ''}}},[_vm._v("\n          APPLY\n        ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px"}},[_c('h5',[_vm._v(_vm._s(code.header))])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{class:{ 'error-margin': code.error_msg },staticStyle:{"color":"#ff8080","font-weight":"bold"}},[_vm._v("\n        "+_vm._s(code.error_msg)+"\n      ")]),_vm._v(" "),_c('div',{staticStyle:{"color":"#a9a9a9"},domProps:{"innerHTML":_vm._s(_vm.formattedDescription(code.description))}})])})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":__webpack_require__("VuyX"),"alt":"sale_img","title":"sale_img"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"couponAvailability"},[_c('p',[_vm._v("Available Coupons")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KYlc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaytmContd_vue__ = __webpack_require__("SpZ/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_691f9df7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaytmContd_vue__ = __webpack_require__("wv4A");
function injectStyle (ssrContext) {
  __webpack_require__("EhW6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaytmContd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_691f9df7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaytmContd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KjHH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reg_vue__ = __webpack_require__("wJGD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67e0e344_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reg_vue__ = __webpack_require__("L9GJ");
function injectStyle (ssrContext) {
  __webpack_require__("Ei4b")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reg_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67e0e344_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reg_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Kxwc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isEditable: false,
      popImage: 'https://www.doodhvale.com/hmi_images/popup-img.png'
    };
  },
  created: function created() {
    this.fetchData();
  },

  methods: {
    fetchData: function fetchData() {
      /* const params = new URLSearchParams()
      var fullUrl = document.URL
      var splitUrl = fullUrl.split('appLink?')
      if (splitUrl[1] != null) {
        params.append('source_name', splitUrl[1])
        axios({
          url: process.env.BASE_API + '/accounts/app-download-source-name',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        })
      } */
      if (navigator.userAgent.indexOf('Android') !== -1) {
        location.replace('https://play.google.com/store/apps/details?id=com.pharma.medcobox');
      } else if (navigator.userAgent.indexOf('like Mac') !== -1) {
        location.replace('https://apps.apple.com/in/app/medcobox/id1574849872');
      } else {
        location.replace('https://www.medcobox.com');
      }
    },
    closeModal: function closeModal() {
      this.isEditable = false;
      this.fetchData();
    }
  }
});

/***/ }),

/***/ "L9GJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.otp === false)?_c('div',[_c('div',{staticClass:"row",staticStyle:{"margin-top":"18%","margin-bottom":"20%","margin-right":"3%","margin-left":"3%"}},[_c('div',{staticClass:"col-sm-1 col-md-3"}),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-sm-10"},[_c('form',[_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"mobile",staticStyle:{"width":"100%"},attrs:{"id":"mobile","maxlength":"10","placeholder":"Enter mobile number","required":""},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.signup()}}}),_vm._v(" "),_c('hr',{staticStyle:{"display":"block","height":"1px","border":"0","border-top":"1px solid #3cb6c3","margin":"0em 0%","padding":"0"}})]),_vm._v(" "),_c('div',{staticClass:"w3-center"},[_c('input',{staticClass:"regbutton",staticStyle:{"width":"100%"},attrs:{"value":"NEXT","type":"button"},on:{"click":function($event){_vm.signup()}}})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-1 col-md-3"})])]):_vm._e(),_vm._v(" "),(_vm.otp)?_c('div',[_c('div',{staticClass:"row",staticStyle:{"margin-top":"18%","margin-bottom":"20%","margin-right":"3%","margin-left":"3%"}},[_c('div',{staticClass:"col-sm-1 col-md-3"}),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-sm-10"},[_c('form',[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signUp.disMobile),expression:"signUp.disMobile"}],staticClass:"mobile",attrs:{"id":"mobile","maxlength":"10","disabled":"true"},domProps:{"value":(_vm.signUp.disMobile)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.signUp, "disMobile", $event.target.value)}}}),_vm._v(" "),_c('hr',{staticStyle:{"display":"block","height":"1px","border":"0","border-top":"1px solid #3cb6c3","margin":"0em 0%","padding":"0"}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"mobile",attrs:{"id":"otp","maxlength":"4","placeholder":"Enter OTP","required":""},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.verifyotp()}}}),_vm._v(" "),_c('hr',{staticStyle:{"display":"block","height":"1px","border":"0","border-top":"1px solid #3cb6c3","margin":"0em 0%","padding":"0"}})]),_vm._v(" "),_c('div',{staticClass:"w3-center"},[_c('input',{staticClass:"regbutton",staticStyle:{"width":"100%"},attrs:{"value":"REGISTER","type":"button"},on:{"click":function($event){_vm.verifyotp()}}})]),_vm._v(" "),_c('div',{staticStyle:{"color":"#11a4e0","margin-top":"2%","margin-bottom":"2%","text-align":"center"}},[_vm._v("\n            If you do not receive your OTP within 1 minute, click the Resend\n            Otp button to resend otp\n          ")]),_vm._v(" "),_c('div',{staticClass:"w3-center"},[_c('input',{staticClass:"regbutton",staticStyle:{"width":"100%"},attrs:{"value":"RESEND OTP","type":"button"},on:{"click":function($event){_vm.resendotp()}}})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-1 col-md-3"})])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LEMU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    LTable: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Table_vue__["a" /* default */],
    ChartCard: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */],
    StatsCard: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */]
  },
  data: function data() {
    return {
      urlInterface: [],
      apiDataObj: [],
      userDetails: [],
      disagreeResponse: [],
      successfully_feedback: false,
      isLoading: true,
      isFullPage: true,
      text1: '',
      text2: '',
      imageFormat: '',
      imageContent: ''
    };
  },
  created: function created() {
    this.fetchData();
  },

  methods: {
    fetchData: function fetchData() {
      var _this = this;

      var params = new URLSearchParams();
      var fullUrl = document.URL;
      var splitUrl = fullUrl.split('f2?');
      params.append('url_str', splitUrl[1]);
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/accounts/fetch-url-interface-data',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this.urlInterface = {};
        if (response.data.status === '000001' || response.data.status === '000002' || response.data.status === '000003') {
          _this.urlInterface.error_msg = response.data.msg;
          document.getElementById('url_valid').style.display = 'none';
          _this.isLoading = false;
        } else {
          document.getElementById('url_expired').style.display = 'none';
          _this.urlInterface.action_name = response.data.action_name;
          _this.urlInterface.url_interface_id = response.data.url_interface_id;
          _this.invokeUrlAction();
          _this.isLoading = false;
        }
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          _this.list = response.data.user_record;
          alert(_this.list);
        }
      }).catch(function (e) {
        alert('not ok');
      });
    },
    invokeUrlAction: function invokeUrlAction() {
      var _this2 = this;

      var params = new URLSearchParams();
      params.append('url_interface_id', this.urlInterface.url_interface_id);
      params.append('action_name', this.urlInterface.action_name);
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/accounts/invoke-url-action',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this2.apiDataObj = {};
        switch (_this2.urlInterface.action_name) {
          case 'all_not_taken_cust_loc_set_db_not_in_range':
          case 'all_not_taken_cust_loc_not_set':
          case 'not_open_cust_loc_set_db_not_in_range':
          case 'not_open_cust_loc_not_set':
            _this2.apiDataObj.userId = response.data.action_response.user_id;
            _this2.apiDataObj.deliveryDate = response.data.action_response.delivery_date;
            _this2.apiDataObj.deliveryId = response.data.action_response.delivery_id;
            _this2.text1 = response.data.action_response.text1;
            _this2.text2 = response.data.action_response.text2;
            _this2.imageFormat = response.data.action_response.image_format;
            _this2.imageContent = response.data.action_response.image_content;
            _this2.userInfo();
            _this2.isLoading = false;
            break;
          default:
            break;
        }
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          _this2.list = response.data.user_record;
          alert(_this2.list);
        }
      }).catch(function (e) {
        alert('not ok');
      });
    },
    userInfo: function userInfo() {
      var _this3 = this;

      var params = new URLSearchParams();
      var userId = this.apiDataObj.userId;
      params.append('user_id', userId);
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/users/user-info',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this3.userDetails = {};
        _this3.userDetails.userId = userId;
        _this3.userDetails.first_name = response.data.user_record.user_details.first_name;
        _this3.userDetails.mobile = response.data.user_record.user.username;
        _this3.userDetails.address = response.data.user_record.address.address1 + ' ' + response.data.user_record.address.address2 + ' ' + response.data.user_record.address.city;
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          _this3.list = response.data.user_record;
          alert(_this3.list);
        }
      }).catch(function (e) {
        alert('not ok');
      });
    },
    locationModule: function locationModule() {
      // alert('location')
      sessionStorage.setItem('userId', this.userDetails.userId);
      sessionStorage.setItem('isProfile', 1);
      sessionStorage.setItem('actionName', 'subscription');
      sessionStorage.setItem('callbackUrlForSubscription', document.URL);
      sessionStorage.setItem('locationAction', 'getOldLocation');
      this.$router.push('/a/location');
    },
    disagree: function disagree() {
      var _this4 = this;

      var params = new URLSearchParams();
      params.append('url_interface_id', this.urlInterface.url_interface_id);
      params.append('delivery_id', this.apiDataObj.deliveryId);
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/accounts/update-url-user-response',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this4.disagreeResponse = {};
        _this4.successfully_feedback = true;
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          _this4.list = response.data.user_record;
          alert(_this4.list);
        }
      }).catch(function (e) {
        alert('not ok');
      });
    }
  }
});

/***/ }),

/***/ "LVCB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import axios from 'axios'
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      signUp: [],
      otp: false,
      gender: 'M'
    };
  },
  created: function created() {
    if (sessionStorage.getItem('userId') === null) {
      this.$router.push('/a/reg');
    } else {}
  },

  methods: {}
});

/***/ }),

/***/ "LngK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w3-content",staticStyle:{"max-width":"90%"}},[_c('h2',{staticStyle:{"text-align":"center"}},[_vm._v("Terms & Conditions")]),_vm._v("\n    The terms “We” / “Us” / “Our”/”Company” individually and collectively refer to Sanjeevani Dairy Farms Pvt. Ltd. and the terms “Visitor” ”User” refer to the users.\nThis page states the Terms and Conditions under which you (Visitor) may visit this website (“www.sanjeevanidairyfarms.com or www.doodhvale.com or www.v.doodhvale.in or www.t.doodhvale.in”). Please read this page carefully. If you do not accept the Terms and Conditions stated here, we would request you to exit this site. The business, any of its business divisions and / or its subsidiaries, associate companies or subsidiaries to subsidiaries or such other investment companies (in India or abroad) reserve their respective rights to revise these Terms and Conditions at any time by updating this posting. You should visit this page periodically to re-appraise yourself of the Terms and Conditions, because they are binding on all users of this Website.\n\n"),_c('br'),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("USE OF CONTENT")]),_c('br'),_c('br'),_vm._v("\n\nAll logos, brands, marks headings, labels, names, signatures, numerals, shapes or any combinations thereof, appearing in this site, except as otherwise noted, are properties either owned, or used under license, by the business and / or its associate entities who feature on this Website. The use of these properties or any other content on this site, except as provided in these terms and conditions or in the site content, is strictly prohibited."),_c('br'),_c('br'),_vm._v("\n\nYou may not sell or modify the content of this Website  or reproduce, display, publicly perform, distribute, or otherwise use the materials in any way for any public or commercial purpose without the respective organization’s or entity’s written permission.\n\n"),_c('br'),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("ACCEPTABLE WEBSITE USE")]),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("(A) Security Rules")]),_c('br'),_vm._v("\nVisitors are prohibited from violating or attempting to violate the security of the Web site, including, without limitation, (1) accessing data not intended for such user or logging into a server or account which the user is not authorized to access, (2) attempting to probe, scan or test the vulnerability of a system or network or to breach security or authentication measures without proper authorization, (3) attempting to interfere with service to any user, host or network, including, without limitation, via means of submitting a virus or “Trojan horse” to the Website, overloading, “flooding”, “mail bombing” or “crashing”, or (4) sending unsolicited electronic mail, including promotions and/or advertising of products or services. Violations of system or network security may result in civil or criminal liability. The business and / or its associate entities will have the right to investigate occurrences that they suspect as involving such violations and will have the right to involve, and cooperate with, law enforcement authorities in prosecuting users who are involved in such violations."),_c('br'),_c('br'),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("(B) General Rules")]),_c('br'),_vm._v("\nVisitors may not use the Web Site in order to transmit, distribute, store or destroy material (a) that could constitute or encourage conduct that would be considered a criminal offence or violate any applicable law or regulation, (b) in a manner that will infringe the copyright, trademark, trade secret or other intellectual property rights of others or violate the privacy or publicity of other personal rights of others, or (c) that is libelous, defamatory, pornographic, profane, obscene, threatening, abusive or hateful.\n\n"),_c('br'),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("INDEMNITY")]),_c('br'),_c('br'),_vm._v("\n\nThe User unilaterally agree to indemnify and hold harmless, without objection, the Company, its officers, directors, employees and agents from and against any claims, actions and/or demands and/or liabilities and/or losses and/or damages whatsoever arising from or resulting from their use ofsanjeevanidairyfarms.com or doodhvale.com and or their breach of the terms .\n\n \n\n"),_c('br'),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("LIABILITY")]),_c('br'),_c('br'),_vm._v("  \n\nUser agrees that neither Company nor its group companies, directors, officers or employee shall be liable for any direct or/and indirect or/and incidental or/and special or/and consequential or/and exemplary damages, resulting from the use or/and the inability to use the service or/and for cost of procurement of substitute goods or/and services or resulting from any goods or/and data or/and information or/and services purchased or/and obtained or/and messages received or/and transactions entered into through or/and from the service or/and resulting from unauthorized access to or/and alteration of user’s transmissions or/and data or/and arising from any other matter relating to the service, including but not limited to, damages for loss of profits or/and use or/and data or other intangible, even if Company has been advised of the possibility of such damages."),_c('br'),_c('br'),_vm._v("\n\nUser further agrees that Company shall not be liable for any damages arising from interruption, suspension or termination of service, including but not limited to direct or/and indirect or/and incidental or/and special consequential or/and exemplary damages, whether such interruption or/and suspension or/and termination was justified or not, negligent or intentional, inadvertent or advertent."),_c('br'),_c('br'),_vm._v("\n\nUser agrees that Company shall not be responsible or liable to user, or anyone, for the statements or conduct of any third party of the service. In sum, in no event shall Company’s total liability to the User for all damages or/and losses or/and causes of action exceed the amount paid by the User to Company, if any, that is related to the cause of action.\n"),_c('br'),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("DISCLAIMER OF CONSEQUENTIAL DAMAGES")]),_c('br'),_c('br'),_vm._v("\n\nIn no event shall Company or any parties, organizations or entities associated with the corporate brand name us or otherwise, mentioned at this Website be liable for any damages whatsoever (including, without limitations, incidental and consequential damages, lost profits, or damage to computer hardware or loss of data information or business interruption) resulting from the use or inability to use the Website and the Website material, whether based on warranty, contract, tort, or any other legal theory, and whether or not, such organization or entities were advised of the possibility of such damages.\n\n"),_c('br'),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("Pricing and Availability of Products and/or Services ")]),_c('br'),_c('br'),_vm._v("\nAll pricing on www.sanjeevanidairyfarms.com or www.doodhvale.com or www.doodhvale.in or www.v.doodhvale.in or www.t.doodhvale.in is displayed in Indian Rupee (INR) and is exclusive of any Tax unless otherwise stated. Any pricing and availability of products, services and offers displayed online are subject to change without notice. All products and services are subject to availability and we give no guarantee in this regard. You acknowledge and accept that the website information is subject to change at any time and may not necessarily be up to date or accurate at the time of your visit.\n\n"),_c('br'),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("Intellectual Property and Copyright")]),_c('br'),_c('br'),_vm._v("\nAll material appearing on www.sanjeevanidairyfarms.com or www.doodhvale.com or www.doodhvale.in or www.v.doodhvale.in or www.t.doodhvale.in is protected by copyright and other intellectual property laws within India and also covered via international treaties with other countries. Protected material includes but is not limited to graphic and text content, design principals, emails, and all forms of files hosted on these domains. You agree not to publicly display, broadcast, publish, sell, reproduce, link to, or circulate in any other manner the material on this site without the express written consent of the company. You hereby acknowledge Sanjeevani Dairy Farms Pvt. Ltd. ownership of all intellectual property and copyright of all content within this domain.\n\n"),_c('br'),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("Website Availability")]),_c('br'),_c('br'),_vm._v("\nThe Sanjeevani Dairy Farms Pvt. Ltd. entrusts the hosting of our sites to a specialist company and we are committed to proving this on a continual basis, however we do not warrant that the site will be continuously available at all times. It is expected that at times unforeseeable interruptions to this service may occur. Such activities are potentially outside our control.\n\n"),_c('br'),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("External Links")]),_c('br'),_c('br'),_vm._v("\nThe Sanjeevani Dairy Farms Pvt. Ltd. may provide external links to sites with recommended products or services. Clicking on any external link will lead you to external websites which are outside of our control. The Sanjeevani Dairy Farms Pvt. Ltd. only links to businesses or resources which we believe meet our high standards at the time of posting a link; however we have no control over external sites and will accept no responsibility or liability in relation to the content or any other aspect of your visit to any external site.\n\n"),_c('br'),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("Linking to Us")]),_c('br'),_c('br'),_vm._v("\nThe Sanjeevani Dairy Farms Pvt. Ltd. permits website owners to link from your website to our home page, provided the link includes our full trading name Doodhvale.com. Any additional text included in the link must be directly related to one or more of the services and/or products we provide. You agree to remove any links to our site on our request, within seven (7) days of notice.\n\n"),_c('br'),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("Anti-social Behavior")]),_c('br'),_c('br'),_vm._v("\nYou agree not to attempt to change, add to, remove, modify, deface, redirect, hack, decompile, block access to, cause unnecessary bandwidth loads or otherwise interfere with company website, the domain, associated email, or any material, images or content display on this website. Any such activity will be deemed an attack on the site or server, and logs will be handed to Indian Law Enforcement agencies for investigation and prosecution to the fullest extent permissible by law.\n\n"),_c('br'),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("Governing Law")]),_c('br'),_c('br'),_vm._v("\nThese Terms and Conditions are governed by and construed in accordance with the Indian Panel Code. In the event that a dispute arises from these Terms of Use, you agree to submit to the non-exclusive jurisdiction of the courts of Delhi, India. If any part of these Terms of Use is found to be invalid or unenforceable, it shall be severed without affecting the remainder.\n\n"),_c('br'),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("Logos, Trademarks & Service Marks")]),_c('br'),_c('br'),_vm._v("\nThe Sanjeevani Dairy Farms Pvt. Ltd, doodvale.com and their respective logos and all other distinctive site logos, marks and graphic elements on our web sites are trademarks of and are registered to Sanjeevani Dairy Farms Pvt. Ltd. and are subject to applicable trademark protections. All other company, product, and service logos, marks and names may be trademarks or service marks of the companies and organizations mentioned. All trademarks and registered trademarks are used to benefit, without intent to infringe on, the holder of said trademark.\n\n"),_c('br'),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("Accessories Not Included")]),_c('br'),_c('br'),_vm._v("\nAll product photos are for reference only and any accessories etc shown are for display purposes unless otherwise stated. Accessories etc are not included unless specified in the product description text. Some photos may show two or more items to allow you to see the product from different angles. Products are all sold individually unless otherwise stated in the product description.\n\n\n"),_c('br'),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("Product Variations")]),_c('br'),_c('br'),_vm._v("\nProducts may vary to the pictures shown. From time to time manufacturers may alter a product specifications, colour or dimensions. In the event of a slight variation, we will ship a product which may differ slightly to the sample shown. In the event of a major variation we will contact you for approval before shipping the goods. If we ship an item different to the sample shown you are entitled by law to return the item for a full refund including the cost of postage.\n  ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LvYP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[(_vm.$slots.header)?_c('div',{staticClass:"card-header"},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"ct-chart",attrs:{"id":_vm.chartId}})]),_vm._v(" "),(_vm.$slots.footer)?_c('div',{staticClass:"card-footer"},[_vm._t("footer")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M7nQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"url_valid"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d49860bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("IPhC");
function injectStyle (ssrContext) {
  __webpack_require__("0QOX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d49860bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MDnB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Dropdown_vue__ = __webpack_require__("ZQf1");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DropDown: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Dropdown_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "MNEg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      urlInterface: [],
      apiDataObj: [],
      isFullPage: true,
      isLoading: true,
      urlValid: false,
      dispatcherId: 0,
      salesman_otp_required: 0,
      salesman_location_required: 0,
      otp: false,
      signUp: [],
      resendOtp: [],
      verifyOtp: [],
      masterOtp: 1234,
      userMobile: '',
      role: 4
    };
  },
  created: function created() {
    sessionStorage.clear();
    this.fetchData();
  },

  methods: {
    fetchData: function fetchData() {
      var _this = this;

      var params = new URLSearchParams();
      var fullUrl = document.URL;
      var splitUrl = fullUrl.split('dispnewcust?');
      params.append('url_str', splitUrl[1]);
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/accounts/fetch-url-interface-data',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this.urlInterface = {};
        if (response.data.status === '000001' || response.data.status === '000002' || response.data.status === '000003') {
          _this.urlInterface.error_msg = response.data.msg;
          _this.urlValid = false;
        } else {
          // this.urlValid = true
          _this.urlInterface.action_name = response.data.action_name;
          _this.urlInterface.url_interface_id = response.data.url_interface_id;
          _this.invokeUrlAction();
        }
        _this.isLoading = false;
        // console.log(response)
      }).catch(function (e) {
        alert('not ok');
      });
    },
    invokeUrlAction: function invokeUrlAction() {
      var _this2 = this;

      var params = new URLSearchParams();
      params.append('url_interface_id', this.urlInterface.url_interface_id);
      params.append('action_name', this.urlInterface.action_name);
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/accounts/invoke-url-action',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        // console.log(response)
        _this2.apiDataObj = {};
        switch (_this2.urlInterface.action_name) {
          case 'dispatcher_new_customer_flow':
            _this2.dispatcherId = response.data.action_response.dispatcher_id;
            _this2.masterOtp = response.data.action_response.master_otp;
            _this2.role = response.data.action_response.role;
            _this2.urlValid = true;
            _this2.salesman_otp_required = response.data.action_response.salesman_otp_required;
            _this2.salesman_location_required = response.data.action_response.salesman_location_required;
            sessionStorage.setItem('salesman_otp_required', response.data.action_response.salesman_otp_required);
            sessionStorage.setItem('role', _this2.role);
            sessionStorage.setItem('salesman_location_required', response.data.action_response.salesman_location_required);
            sessionStorage.setItem('dispatcherId', _this2.dispatcherId);
            sessionStorage.setItem('salesman_flow', response.data.action_response.salesman_flow);
            break;
          default:
            break;
        }
        _this2.isLoading = false;
      }).catch(function (e) {
        alert('not ok');
      });
    },
    signup: function signup() {
      var _this3 = this;

      var params = new URLSearchParams();
      var mobile = document.getElementById('mobile').value;
      var deviceID = document.getElementById('mobile').value;
      if (isNaN(mobile) || mobile.length !== 10 || mobile === '') {
        alert('Oops! Invalid Mobile Number.');
      } else {
        params.append('mobile', mobile);
        params.append('deviceId', deviceID);
        params.append('flow_type', 'salesman');
        __WEBPACK_IMPORTED_MODULE_0_axios___default()({
          url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/users/signup',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {}
        }).then(function (response) {
          _this3.signUp = {};
          if (response.data.status === '000000' || response.data.status === '000001' || response.data.status === '000002' || response.data.status === '000007' || response.data.status === '000012') {
            _this3.signUp.disMobile = mobile;
            _this3.otp = true;
            if (response.data.status === '000000' && response.data.is_profile === 1) {} else {
              _this3.resendotp();
            }
          } else {
            alert(response.data.msg);
          }
          // console.log(response)
          if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
            _this3.list = response.data.user_record;
            alert(_this3.list);
          }
        }).catch(function (e) {
          alert('not ok');
        });
      }
    },
    resendotp: function resendotp() {
      var _this4 = this;

      var params = new URLSearchParams();
      params.append('mobile', this.signUp.disMobile);
      params.append('deviceId', this.signUp.disMobile);
      params.append('flow_type', 'salesman');
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/users/resend-otp',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this4.resendOtp = {};
        if (response.data.status !== '000000') {
          alert(response.data.msg);
        }
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          _this4.list = response.data.user_record;
          alert(_this4.list);
        }
      }).catch(function (e) {
        alert('not ok');
      });
    },
    verifyotp: function verifyotp() {
      var _this5 = this;

      var params = new URLSearchParams();
      var otp = document.getElementById('otp').value;
      var mobile = this.signUp.disMobile;
      var deviceID = this.signUp.disMobile;
      if (isNaN(otp) || otp.length !== 4 || otp === '') {
        alert('Oops! Invalid OTP.');
      } else {
        params.append('otp', otp);
        params.append('mobile', mobile);
        params.append('deviceId', deviceID);
        __WEBPACK_IMPORTED_MODULE_0_axios___default()({
          url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/users/verify-otp',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {}
        }).then(function (response) {
          _this5.verifyOtp = {};
          if (response.data.status === '000000') {
            /* this.verifyOtp.userId = response.data.user_id
            this.verifyOtp.roleId = response.data.role_id
            this.verifyOtp.isProfile = response.data.is_profile
            this.verifyOtp.userMobile = response.data.user_mobile */
            sessionStorage.setItem('userId', response.data.user_id);
            sessionStorage.setItem('roleId', response.data.role_id);
            sessionStorage.setItem('isProfile', response.data.is_profile);
            sessionStorage.setItem('userMobile', response.data.user_mobile);
            if (response.data.is_profile === 0) {
              if (sessionStorage.getItem('urlstr') === 'undefined' || sessionStorage.getItem('urlstr') === null) {
                // this.$router.push('/a/subscription')
                sessionStorage.setItem('productListUrl', response.data.product_list_url);
                window.location.href = response.data.product_list_url;
              } else {
                _this5.$router.push('/a/s?' + sessionStorage.getItem('urlstr'));
              }
            } else {
              _this5.$router.push('/a/location');
            }
          } else {
            alert(response.data.msg);
          }
          // console.log(response)
          if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
            _this5.list = response.data.user_record;
            alert(_this5.list);
          }
        }).catch(function (e) {
          alert('not ok');
        });
      }
    },
    createUser: function createUser() {
      var _this6 = this;

      var params = new URLSearchParams();
      var otp = this.masterOtp;
      var mobile = this.userMobile;
      var deviceID = this.userMobile;
      if (isNaN(mobile) || mobile.length !== 10 || mobile === '') {
        alert('Oops! Invalid Mobile Number.');
      } else {
        this.$swal({
          text: 'Are you sure? Customer mobile no is ' + mobile,
          showCancelButton: true,
          confirmButtonText: 'Cancel',
          cancelButtonText: 'OK',
          cancelButtonColor: '#3CB6C3',
          confirmButtonColor: '#e55a5a'
        }).then(function (result) {
          if (result.value) {
            // this.$swal('Success', 'Thanks you Cancel!', 'success')
          } else {
            params.append('mobile', mobile);
            params.append('deviceId', deviceID);
            params.append('dispatcher_id', _this6.dispatcherId);
            params.append('flow_type', 'dispatcher');
            __WEBPACK_IMPORTED_MODULE_0_axios___default()({
              url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/users/signup',
              method: 'post',
              data: params,
              withCredentials: false,
              headers: {}
            }).then(function (response) {
              _this6.signUp = {};
              if (response.data.status === '000000' || response.data.status === '000001' || response.data.status === '000002' || response.data.status === '000007' || response.data.status === '000012') {
                params.append('otp', otp);
                params.append('mobile', mobile);
                params.append('deviceId', deviceID);
                params.append('flow_type', 'dispatcher');
                __WEBPACK_IMPORTED_MODULE_0_axios___default()({
                  url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/users/verify-otp',
                  method: 'post',
                  data: params,
                  withCredentials: false,
                  headers: {}
                }).then(function (response) {
                  // console.log(this.dispatcherId)
                  // console.log(response)
                  _this6.verifyOtp = {};
                  if (response.data.status === '000000') {
                    sessionStorage.setItem('userId', response.data.user_id);
                    sessionStorage.setItem('roleId', response.data.role_id);
                    sessionStorage.setItem('isProfile', response.data.is_profile);
                    sessionStorage.setItem('userMobile', response.data.user_mobile);
                    sessionStorage.setItem('blockNewCustByDispatcher', response.data.block_new_cust_by_dispatcher);
                    sessionStorage.setItem('dispatcherId', _this6.dispatcherId);
                    sessionStorage.setItem('role', _this6.role);
                    // console.log(response.data.dispatcher_id)
                    if (parseInt(response.data.dispatcher_id) !== parseInt(_this6.dispatcherId) && (sessionStorage.getItem('role') === 4 || sessionStorage.getItem('role') === '4')) {
                      // this.$swal.fire('Sorry! This customer is not in your circle')
                      _this6.$swal.fire({ text: 'Sorry! This customer is not in your circle' });
                    } else if (response.data.block_new_cust_by_dispatcher === 1 && response.data.is_profile === 0) {
                      // this.$swal.fire('Customer Already registered, You can create only new customer!')
                      _this6.$swal.fire({ text: 'Customer Already registered, You can create only new customer!' });
                    } else if (response.data.is_profile === 0) {
                      // send directly to productList
                      sessionStorage.setItem('productListUrl', response.data.product_list_url);
                      window.location.href = response.data.product_list_url;
                      // window.location.href = 'http://localhost:4000/#/a/productList?4t44'
                    } else {
                      // create profile
                      _this6.$router.push('/a/location');
                    }
                    /* if (response.data.is_profile === 0) {
                      if (sessionStorage.getItem('urlstr') === 'undefined' || sessionStorage.getItem('urlstr') === null) {
                        this.$router.push('/a/subscription')
                      } else {
                        this.$router.push('/a/s?' + sessionStorage.getItem('urlstr'))
                      }
                    } else {
                      this.$router.push('/a/location')
                    } */
                  } else {
                    alert(response.data.msg);
                  }
                  // console.log(response)
                }).catch(function (e) {
                  alert('not ok');
                });
              } else {
                alert(response.data.msg);
              }
              // console.log(response)
            }).catch(function (e) {
              alert('not ok');
            });
          }
        });
        /* alert(otp)
        alert(mobile)
        alert(deviceID) */
      }
    }
  }
});

/***/ }),

/***/ "MZ8R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentFooter_vue__ = __webpack_require__("0FOK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2544a786_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentFooter_vue__ = __webpack_require__("5qur");
function injectStyle (ssrContext) {
  __webpack_require__("a9Yf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2544a786_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mca5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarLink_vue__ = __webpack_require__("7SdG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    SidebarLink: __WEBPACK_IMPORTED_MODULE_0__SidebarLink_vue__["a" /* default */]
  },
  props: {
    title: {
      type: String,
      default: 'Doodhvale'
    },
    backgroundColor: {
      type: String,
      default: 'black',
      validator: function validator(value) {
        var acceptedValues = ['', 'blue', 'azure', 'green', 'orange', 'red', 'purple', 'black'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    backgroundImage: {
      type: String,
      default: 'static/img/sidebar-5.jpg'
    },
    activeColor: {
      type: String,
      default: 'success',
      validator: function validator(value) {
        var acceptedValues = ['primary', 'info', 'success', 'warning', 'danger'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    sidebarLinks: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    autoClose: {
      type: Boolean,
      default: true
    }
  },
  provide: function provide() {
    return {
      autoClose: this.autoClose
    };
  },

  computed: {
    sidebarStyle: function sidebarStyle() {
      return {
        backgroundImage: 'url(' + this.backgroundImage + ')'
      };
    }
  }
});

/***/ }),

/***/ "MqDG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// import VueAxios from 'vue-axios'
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    LTable: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Table_vue__["a" /* default */],
    ChartCard: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */],
    StatsCard: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */]
  },
  data: function data() {
    return {
      isLoading: true,
      isFullPage: true,
      urlInterface: [],
      successfully_feedback: false,
      obj: {},
      test_date: String,
      cow_test: {
        fat: 0,
        clr: 0,
        snf: 0
      },
      buff_test: {
        fat: 0,
        clr: 0,
        snf: 0
      },
      lock_report: 0,
      lock: 0
    };
  },
  created: function created() {
    this.fetchData();
  },

  methods: {
    fetchData: function fetchData() {
      var _this = this;

      // console.log(process.env.BASE_API+ '/accounts/fetch-url-interface-data')
      var params = new URLSearchParams();
      var fullUrl = document.URL;
      var splitUrl = fullUrl.split('uploadDailyMilkTestReport?');
      params.append('url_str', splitUrl[1]);
      // console.log(splitUrl[1])
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/accounts/fetch-url-interface-data',
        method: 'post',
        data: params
      }).then(function (response) {
        _this.urlInterface = {};
        if (response.data.status === '000001' || response.data.status === '000002' || response.data.status === '000003') {
          _this.urlInterface.error_msg = response.data.msg;
          document.getElementById('url_valid').style.display = 'none';
          _this.isLoading = false;
        } else {
          document.getElementById('url_expired').style.display = 'none';
          _this.urlInterface.action_name = response.data.action_name;
          _this.urlInterface.url_interface_id = response.data.url_interface_id;
          _this.urlInterface.sub_action_name = 'load';
          _this.urlInterface.vue_url = fullUrl;
          _this.invokeUrlAction();
        }
        setTimeout(function () {
          _this.isLoading = false;
        }, 10000);
      }).catch(function (e) {
        _this.isLoading = false;
      });
    },
    invokeUrlAction: function invokeUrlAction() {
      var _this2 = this;

      var params = new URLSearchParams();
      params.append('url_interface_id', this.urlInterface.url_interface_id);
      params.append('action_name', this.urlInterface.action_name);
      params.append('sub_action_name', this.urlInterface.sub_action_name);
      switch (this.urlInterface.sub_action_name) {
        case 'load':
          break;
        case 'update':

          params.append('cow_test_snf', this.cow_test.snf);
          params.append('cow_test_clr', this.cow_test.clr);
          params.append('cow_test_fat', this.cow_test.fat);
          params.append('cow_test_urea', this.cow_test.urea ? 1 : 0);
          params.append('cow_test_starch', this.cow_test.starch ? 1 : 0);
          params.append('cow_test_detergent', this.cow_test.detergent ? 1 : 0);
          params.append('cow_test_caustic', this.cow_test.caustic ? 1 : 0);
          params.append('cow_test_antibiotic', this.cow_test.antibiotic ? 1 : 0);
          params.append('cow_test_alcohol', this.cow_test.alcohol ? 1 : 0);

          params.append('buff_test_snf', this.buff_test.snf);
          params.append('buff_test_clr', this.buff_test.clr);
          params.append('buff_test_fat', this.buff_test.fat);
          params.append('buff_test_urea', this.buff_test.urea ? 1 : 0);
          params.append('buff_test_starch', this.buff_test.starch ? 1 : 0);
          params.append('buff_test_detergent', this.buff_test.detergent ? 1 : 0);
          params.append('buff_test_caustic', this.buff_test.caustic ? 1 : 0);
          params.append('buff_test_antibiotic', this.buff_test.antibiotic ? 1 : 0);
          params.append('buff_test_alcohol', this.buff_test.alcohol ? 1 : 0);
          params.append('lock_report', this.lock_report ? 1 : 0);
          break;
        default:
          break;
      }
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/accounts/invoke-url-action',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this2.obj = response.data.action_response;
        switch (_this2.urlInterface.sub_action_name) {
          case 'load':

            _this2.test_date = _this2.obj.test_date;
            _this2.cow_test.fat = _this2.obj.cow_test_fat;
            _this2.cow_test.snf = _this2.obj.cow_test_snf;
            _this2.cow_test.clr = _this2.obj.cow_test_clr;
            _this2.cow_test.urea = _this2.obj.cow_test_urea;
            _this2.cow_test.starch = _this2.obj.cow_test_starch;
            _this2.cow_test.detergent = _this2.obj.cow_test_detergent;
            _this2.cow_test.caustic = _this2.obj.cow_test_caustic;
            _this2.cow_test.antibiotic = _this2.obj.cow_test_antibiotic;
            _this2.cow_test.alcohol = _this2.obj.cow_test_alcohol;
            _this2.buff_test.snf = _this2.obj.buff_test_snf;
            _this2.buff_test.clr = _this2.obj.buff_test_clr;
            _this2.buff_test.fat = _this2.obj.buff_test_fat;
            _this2.buff_test.urea = _this2.obj.buff_test_urea;
            _this2.buff_test.starch = _this2.obj.buff_test_starch;
            _this2.buff_test.detergent = _this2.obj.buff_test_detergent;
            _this2.buff_test.caustic = _this2.obj.buff_test_caustic;
            _this2.buff_test.antibiotic = _this2.obj.buff_test_antibiotic;
            _this2.buff_test.alcohol = _this2.obj.buff_test_alcohol;
            _this2.lock_report = _this2.obj.lock_report;
            if (_this2.lock_report === 1) {
              _this2.lock = 1;
            }
            break;
          case 'update':
            break;
          default:
            break;
        }
        setTimeout(function () {
          _this2.isLoading = false;
        }, 10000);
      }).catch(function (e) {});
    },


    calCowSNF: function calCowSNF() {
      this.cow_test.snf = (this.cow_test.fat / 5 + this.cow_test.clr / 4 + 0.6).toFixed(2);
    },

    calBuffSNF: function calBuffSNF() {
      this.buff_test.snf = (this.buff_test.fat / 5 + this.buff_test.clr / 4 + 0.6).toFixed(2);
    },

    submitDailyMilkTestReportData: function submitDailyMilkTestReportData() {
      this.urlInterface.sub_action_name = 'update';
      this.invokeUrlAction();
    }
  }
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__dirname) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_vue__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_url_search_params__ = __webpack_require__("5mUy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_url_search_params___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_url_search_params__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_buefy__ = __webpack_require__("O3Oo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_buefy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_buefy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_buefy_dist_buefy_css__ = __webpack_require__("/KV2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_buefy_dist_buefy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_buefy_dist_buefy_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_sweetalert2__ = __webpack_require__("oYt9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__light_bootstrap_main__ = __webpack_require__("28ys");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_google_maps__ = __webpack_require__("sA6N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_browser_geolocation__ = __webpack_require__("29Pn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_browser_geolocation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_browser_geolocation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__routes_routes__ = __webpack_require__("T1vP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_toast_notification__ = __webpack_require__("+4za");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_toast_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_toast_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_toast_notification_dist_index_css__ = __webpack_require__("WC7W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_toast_notification_dist_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_toast_notification_dist_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_numeric_input__ = __webpack_require__("iyer");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_numeric_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_numeric_input__);






// LightBootstrap plugin

var options = {
  confirmButtonColor: '#41b882',
  cancelButtonColor: '#ff7674'
};
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_vue_sweetalert2__["a" /* default */], options);


__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_vue2_google_maps__, { load: { key: 'AIzaSyDmky5VANrOWXcBoXmP3JpusSZIx5-k8M8' } });

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_vue_browser_geolocation___default.a);
// router setup

// plugin setup
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7__light_bootstrap_main__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_buefy___default.a);


__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_vue_toast_notification___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_vue_numeric_input___default.a);
// configure router
var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  base: __dirname,
  mode: 'history',
  routes: __WEBPACK_IMPORTED_MODULE_10__routes_routes__["a" /* default */], // short for routes: routes
  linkActiveClass: 'nav-item active'
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_2__App_vue__["a" /* default */]);
  },
  router: router
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "/"))

/***/ }),

/***/ "NINg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NNqC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-loading',{attrs:{"is-full-page":_vm.isFullPage,"active":_vm.isLoading},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"url_valid"}},[_c('div',{attrs:{"id":"unsubscribed"}},[_c('div',{staticStyle:{"text-align":"center"}},[_c('div',[_c('h4',[_vm._v("Unsubscribed from Promotional Emails. To Subscribe "),_c('input',{staticClass:"button5",attrs:{"id":"SubContinue","value":"Click again","type":"button"},on:{"click":_vm.reloadPage}})])])])]),_vm._v(" "),_c('div',{attrs:{"id":"subscribed"}},[_c('div',{staticStyle:{"text-align":"center"}},[_c('div',[_c('h4',[_vm._v("Subscribed for Promotional Emails. To Unsubscribe "),_c('input',{staticClass:"button5",attrs:{"id":"SubContinue","value":"Click again","type":"button"},on:{"click":_vm.reloadPage}})])])])]),_vm._v(" "),_vm._m(1)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container is-fluid has-text-centered",attrs:{"id":"url_expired"}},[_c('h4',[_vm._v("Welcome to Doodhvale, Please wait...")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"error"}},[_c('div',{staticStyle:{"text-align":"center"}},[_c('div',[_c('h4',[_vm._v("Oops! We encountered an error. Please retry after sometime.")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NxSr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"main-panel"},[_c('top-navbar'),_vm._v(" "),_c('dashboard-content',{on:{"click":_vm.toggleSidebar}}),_vm._v(" "),_c('content-footer')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OIzV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OaMs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Card_vue__ = __webpack_require__("jEp+");


//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'chart-card',
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_2__Card_vue__["a" /* default */]
  },
  props: {
    chartType: {
      type: String,
      default: 'Line' // Line | Pie | Bar
    },
    chartOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    chartData: {
      type: Object,
      default: function _default() {
        return {
          labels: [],
          series: []
        };
      }
    },
    responsiveOptions: [Object, Array]
  },
  data: function data() {
    return {
      chartId: 'no-id',
      $Chartist: null,
      chart: null
    };
  },

  methods: {
    /***
     * Initializes the chart by merging the chart options sent via props and the default chart options
     */
    initChart: function initChart() {
      var chartIdQuery = '#' + this.chartId;
      this.chart = this.$Chartist[this.chartType](chartIdQuery, this.chartData, this.chartOptions, this.responsiveOptions);
      this.$emit('initialized', this.chart);
      if (this.chartType === 'Line') {
        this.animateLineChart();
      }
      if (this.chartType === 'Bar') {
        this.animateBarChart();
      }
    },

    /***
     * Assigns a random id to the chart
     */
    updateChartId: function updateChartId() {
      var currentTime = new Date().getTime().toString();
      var randomInt = this.getRandomInt(0, currentTime);
      this.chartId = 'div_' + randomInt;
    },
    getRandomInt: function getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    animateLineChart: function animateLineChart() {
      var _this = this;

      var seq = 0;
      var durations = 500;
      var delays = 80;
      this.chart.on('draw', function (data) {
        if (data.type === 'line' || data.type === 'area') {
          data.element.animate({
            d: {
              begin: 600,
              dur: 700,
              from: data.path.clone().scale(1, 0).translate(0, data.chartRect.height()).stringify(),
              to: data.path.clone().stringify(),
              easing: _this.$Chartist.Svg.Easing.easeOutQuint
            }
          });
        } else if (data.type === 'point') {
          seq++;
          data.element.animate({
            opacity: {
              begin: seq * delays,
              dur: durations,
              from: 0,
              to: 1,
              easing: 'ease'
            }
          });
        }
      });
      seq = 0;
    },
    animateBarChart: function animateBarChart() {
      var seq = 0;
      var durations = 500;
      var delays = 80;
      this.chart.on('draw', function (data) {
        if (data.type === 'bar') {
          seq++;
          data.element.animate({
            opacity: {
              begin: seq * delays,
              dur: durations,
              from: 0,
              to: 1,
              easing: 'ease'
            }
          });
        }
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var Chartist;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this2.updateChartId();
              _context.next = 3;
              return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "715g"));

            case 3:
              Chartist = _context.sent;

              _this2.$Chartist = Chartist;
              _this2.initChart();

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  }
});

/***/ }),

/***/ "OjXr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tr1_vue__ = __webpack_require__("Q4lU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f29250b6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tr1_vue__ = __webpack_require__("vzx8");
function injectStyle (ssrContext) {
  __webpack_require__("OIzV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tr1_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f29250b6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tr1_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ojch":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ond/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formGroupInput_vue__ = __webpack_require__("eU1q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3988f6ab_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formGroupInput_vue__ = __webpack_require__("WOE+");
function injectStyle (ssrContext) {
  __webpack_require__("fuBC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formGroupInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3988f6ab_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formGroupInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PG13":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PVy+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_R_old_vue__ = __webpack_require__("+l2j");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52a28b3f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_R_old_vue__ = __webpack_require__("B2Xj");
function injectStyle (ssrContext) {
  __webpack_require__("svx4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_R_old_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52a28b3f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_R_old_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PhT9":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "PlqC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container is-fluid has-text-centered"},[_c('b-loading',{attrs:{"is-full-page":_vm.isFullPage,"active":_vm.isLoading},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"url_valid"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-1"}),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('div',{staticClass:"col-sm-5",staticStyle:{"float":"left","text-align":"justify"}},[_c('p',{staticClass:"bill-header-content"},[_c('b',[_vm._v(" Bill No. : ")]),_vm._v(" "+_vm._s(_vm.apiDataObj.bill_no))]),_vm._v(" "),_c('p',{staticClass:"bill-header-content"},[_c('b',[_vm._v(" Bill Cycle : ")]),_vm._v(" "+_vm._s(_vm.apiDataObj.bill_cycle)+"  ("+_vm._s(_vm.convertDate(_vm.apiDataObj.start_date))+" - "+_vm._s(_vm.convertDate(_vm.apiDataObj.end_date))+")")]),_vm._v(" "),_c('p',{staticClass:"bill-header-content"},[_c('b',[_vm._v(" Dated : ")]),_vm._v(" "+_vm._s(_vm.convertDate(_vm.apiDataObj.billing_gen_date))+" ")]),_vm._v(" "),_c('p',{staticClass:"bill-header-content"},[_c('b',[_vm._v(" Gst No : ")]),_vm._v(" "+_vm._s(_vm.apiDataObj.gst_no)+" ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-5",staticStyle:{"float":"right","text-align":"justify"}},[_c('p',{staticClass:"bill-header-content"},[_c('b',[_vm._v(" Customer Name: ")]),_vm._v(_vm._s(_vm.apiDataObj.customer_name))]),_vm._v(" "),_c('p',{staticClass:"bill-header-content"},[_c('b',[_vm._v(" Customer Mobile: ")]),_vm._v(_vm._s(_vm.apiDataObj.customer_mobile))]),_vm._v(" "),_c('p',{staticClass:"bill-header-content"},[_c('b',[_vm._v(" Address: ")]),_vm._v(_vm._s(_vm.apiDataObj.customer_address))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-1"})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-1"}),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('table',{staticClass:"table table-bordered table-condensed table-hover small kv-table"},[_c('tbody',[_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),(Array.isArray(_vm.apiDataObj.billing_detail) && _vm.apiDataObj.billing_detail.length)?[_vm._l((_vm.apiDataObj.billing_detail),function(billing_detail,index){return [_c('tr',{key:billing_detail.bill_no},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(index+1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.convertDate(billing_detail.delivery_date)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(billing_detail.product))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(billing_detail.status))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s((billing_detail.mrp).toFixed(2)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(billing_detail.delivered))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s((billing_detail.row_amount).toFixed(2)))])])]})]:[_vm._m(3)],_vm._v(" "),_c('tr',{},[_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Total")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.apiDataObj.delivered_quantity))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.apiDataObj.sub_total))])]),_vm._v(" "),(_vm.apiDataObj.referral_discount != 0)?[_c('tr',{},[_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Referral Discount")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("-"+_vm._s(_vm.apiDataObj.referral_discount))])])]:_vm._e(),_vm._v(" "),(_vm.apiDataObj.voucher_discount != 0)?[_c('tr',{},[_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Voucher Discount")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("-"+_vm._s(_vm.apiDataObj.voucher_discount))])])]:_vm._e(),_vm._v(" "),(_vm.apiDataObj.tax != 0)?[_c('tr',{},[_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Taxes")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("+"+_vm._s(_vm.apiDataObj.tax))])])]:_vm._e(),_vm._v(" "),(_vm.apiDataObj.previous_due_amount != 0)?[_c('tr',{},[_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Previous Due Amount")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.apiDataObj.previous_due_amount))])])]:_vm._e(),_vm._v(" "),(_vm.apiDataObj.broken_bottle != 0)?[_c('tr',{},[_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Broken Bottle Amount")]),_vm._v(" "),_c('th',{staticClass:"text-center"}),_c('th',{staticClass:"text-right"},[_vm._v("+"+_vm._s((_vm.apiDataObj.broken_bottle * _vm.apiDataObj.broken_bottle_charge).toFixed(2)))])])]:_vm._e(),_vm._v(" "),_c('tr',{staticClass:"active"},[_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Total Bill Amount")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.apiDataObj.net_payable_amount))])]),_vm._v(" "),(_vm.apiDataObj.empty_bottle != 0)?[_c('tr',{},[_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Your Pending Empty Bottle")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.apiDataObj.empty_bottle))]),_vm._v(" "),_c('th')])]:_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-1"})]),_vm._v(" "),(_vm.apiDataObj.broken_bottle > 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-1"}),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('table',{staticClass:"table table-bordered table-condensed table-hover small kv-table"},[_c('tbody',[_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._l((_vm.apiDataObj.billing_detail),function(billing_detail,index){return [(billing_detail.broken_bottle > 0)?[_c('tr',{key:billing_detail.bill_no},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(index+1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.convertDate(billing_detail.delivery_date)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.apiDataObj.broken_bottle_charge))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(billing_detail.broken_bottle))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s((billing_detail.broken_bottle * _vm.apiDataObj.broken_bottle_charge).toFixed(2)))])])]:_vm._e()]}),_vm._v(" "),_c('tr',{},[_c('th'),_c('th'),_c('th',{staticClass:"text-right"},[_vm._v("Total")]),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.apiDataObj.broken_bottle))]),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s((_vm.apiDataObj.broken_bottle * _vm.apiDataObj.broken_bottle_charge).toFixed(2)))])]),_vm._v(" "),_c('tr',{staticClass:"active"},[_c('th'),_c('th'),_c('th',{staticClass:"text-right"},[_vm._v("Total Broken Bottle Amount(Rs)")]),_c('th'),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s((_vm.apiDataObj.broken_bottle * _vm.apiDataObj.broken_bottle_charge).toFixed(2)))])])],2)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-1"})]):_vm._e(),_vm._v(" "),((_vm.apiDataObj.igst_amount != 0 || _vm.apiDataObj.cgst_amount != 0 || _vm.apiDataObj.sgst_amount != 0))?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-1"}),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('table',{staticClass:"table table-bordered table-condensed table-hover small kv-table"},[_c('tbody',[_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('tr',[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.apiDataObj.igst_amount))]),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.apiDataObj.cgst_amount))]),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.apiDataObj.sgst_amount))])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-1"})]):_vm._e()])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center","width":"90%"},attrs:{"id":"url_expired"}},[_c('h4',[_vm._v("Welcome to Doodhvale, Please wait...")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"success"},[_c('th',{staticClass:"text-center text-danger",attrs:{"colspan":"10"}},[_vm._v("Bill Amount Breakup")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"active"},[_c('th',{staticClass:"text-center"},[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Date")]),_vm._v(" "),_c('th',[_vm._v("Product Name")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Unit Price(Rs)")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Del Qty.")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Amt.(Rs)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"text-center"},[_vm._v("1")]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v(" No Delivery breakup found")]),_vm._v(" "),_c('td',{staticClass:"text-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"success"},[_c('th',{staticClass:"text-center text-danger",attrs:{"colspan":"5"}},[_vm._v("Broken Bottle Details")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"active"},[_c('th',{staticClass:"text-center"},[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Date")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Unit Price(Rs)")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Qty.")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Amt.(Rs)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"success"},[_c('th',{staticClass:"text-center text-danger",attrs:{"colspan":"4"}},[_vm._v("Gst Charges")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"active"},[_c('th',{staticClass:"text-center"},[_vm._v("IGST")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("CGST")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("SGST")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Pn7K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

// import axios from 'axios'
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {},
  created: function created() {
    var fullUrl = document.URL;
    var splitUrl = fullUrl.split('r?');
    sessionStorage.setItem('urlstr', splitUrl[1]);
  },

  methods: {}
});

/***/ }),

/***/ "Q4lU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    LTable: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Table_vue__["a" /* default */],
    ChartCard: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */],
    StatsCard: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */]
  },
  data: function data() {
    return {
      urlInterface: [],
      apiDataObj: [],
      successfully_feedback: false,
      isLoading: true,
      isFullPage: true,
      reportHeader: '',
      reportBody: '',
      // reportFormat: '',
      // reportContent: '',
      resource_name_with_path: ''
    };
  },
  created: function created() {
    this.fetchData();
  },

  methods: {
    fetchData: function fetchData() {
      var _this = this;

      var params = new URLSearchParams();
      var fullUrl = document.URL;
      var splitUrl = fullUrl.split('tr1?');
      params.append('url_str', splitUrl[1]);
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/accounts/fetch-url-interface-data',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this.urlInterface = {};
        if (response.data.status === '000001' || response.data.status === '000002' || response.data.status === '000003') {
          _this.urlInterface.error_msg = response.data.msg;
          document.getElementById('url_valid').style.display = 'none';
          _this.isLoading = false;
        } else {
          document.getElementById('url_expired').style.display = 'none';
          _this.urlInterface.action_name = response.data.action_name;
          _this.urlInterface.url_interface_id = response.data.url_interface_id;
          _this.invokeUrlAction();
          _this.isLoading = false;
        }
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          _this.list = response.data.user_record;
          alert(_this.list);
        }
      }).catch(function (e) {});
    },
    linkClick: function linkClick() {
      this.isLoading = true;
    },
    invokeUrlAction: function invokeUrlAction() {
      var _this2 = this;

      var params = new URLSearchParams();
      params.append('url_interface_id', this.urlInterface.url_interface_id);
      params.append('action_name', this.urlInterface.action_name);
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/accounts/invoke-url-action',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this2.apiDataObj = {};
        var self = _this2;
        switch (_this2.urlInterface.action_name) {
          case 'cow_milk_test_report':
            // debugger
            // console.log(response.data.action_response.report_content)
            self.reportHeader = response.data.action_response.report_header;
            self.reportBody = response.data.action_response.report_body;
            // self.reportFormat = response.data.action_response.report_format
            self.resource_name_with_path = response.data.action_response.resource_name_with_path;
            self.isLoading = false;
            break;
          default:
            break;
        }
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          _this2.list = response.data.user_record;
          alert(_this2.list);
        }
      }).catch(function (e) {});
    }
  }
});

/***/ }),

/***/ "QDyf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'card'
});

/***/ }),

/***/ "QY6s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Location_vue__ = __webpack_require__("K5TN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03a63cb4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Location_vue__ = __webpack_require__("BZRp");
function injectStyle (ssrContext) {
  __webpack_require__("gCHH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Location_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03a63cb4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Location_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Qj8p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qkg6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'l-table',
  props: {
    columns: Array,
    data: Array
  },
  methods: {
    hasValue: function hasValue(item, column) {
      return item[column.toLowerCase()] !== 'undefined';
    },
    itemValue: function itemValue(item, column) {
      return item[column.toLowerCase()];
    }
  }
});

/***/ }),

/***/ "R5Ta":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__ = __webpack_require__("Mca5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2092a676_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__ = __webpack_require__("SHNQ");
function injectStyle (ssrContext) {
  __webpack_require__("dqdb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2092a676_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RSfl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_P_vue__ = __webpack_require__("Izxk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73aa389e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_P_vue__ = __webpack_require__("7j2F");
function injectStyle (ssrContext) {
  __webpack_require__("iCW5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_P_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73aa389e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_P_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RxQV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_date_pick__ = __webpack_require__("AA8V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_date_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_date_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_date_pick_dist_vueDatePick_css__ = __webpack_require__("DQ9D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_date_pick_dist_vueDatePick_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_date_pick_dist_vueDatePick_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { DatePick: __WEBPACK_IMPORTED_MODULE_0_vue_date_pick___default.a },
  data: function data() {
    return {
      subscriptionDetails: [],
      userDetails: [],
      isFullPage: true,
      isLoading: true,
      productName: '',
      prodQuantity: '',
      prodBaseQuantity: '',
      prodUnit: '',
      paymentModeText: '',
      scheduleText: '',
      displayStartDate: '',
      subDate: '',
      isPostpaidDisabled: false,
      customizeQtyDisplay: false,
      isOneTime: false,
      isEditSub: '',
      isEditSubscription: false,
      subscriptionId: 0,
      promoCodeVerified: 'no',
      promocodeText: '',
      dispatcherLocationFlow: false,
      isReferrerDisplay: false,
      dbList: [],
      referrerId: 0
    };
  },
  created: function created() {
    if (sessionStorage.getItem('dispatcherId') !== null) {
      this.dispatcherLocationFlow = true;
    }
    if (sessionStorage.getItem('custAddress1') !== null) {
      sessionStorage.removeItem('custAddress1');
    }
    if (sessionStorage.getItem('custAddress2') !== null) {
      sessionStorage.removeItem('custAddress2');
    }
    // console.log(atob(this.$route.query.cn))
    this.subscriptionDetails = JSON.parse(atob(this.$route.query.cn));
    // console.log(this.subscriptionDetails.start_date)
    // debugger
    this.displayStartDate = this.subscriptionDetails.start_date.split('-').reverse().join('-');
    this.fetchData();
  },

  methods: {
    fetchData: function fetchData() {
      this.userInfo();
      // alert(sessionStorage.getItem('isReferrerDisplay'))
      if (sessionStorage.getItem('isReferrerDisplay') === '1' && sessionStorage.getItem('dispatcherId') !== null) {
        if (sessionStorage.getItem('role') !== null && (sessionStorage.getItem('role') === '5' || sessionStorage.getItem('role') === 5)) {
          this.referrerId = sessionStorage.getItem('dispatcherId');
          this.isLoading = false;
        } else {
          this.deliveryBoyList();
        }
        // this.deliveryBoyList()
      } else {
        this.isLoading = false;
      }
      this.productName = sessionStorage.getItem('productName');
      this.prodQuantity = sessionStorage.getItem('prodQuantity');
      this.prodBaseQuantity = sessionStorage.getItem('prodBaseQuantity');
      this.prodUnit = sessionStorage.getItem('prodUnit');
      this.paymentModeText = sessionStorage.getItem('paymentModeText');
      this.scheduleText = sessionStorage.getItem('scheduleText');
      this.isEditSub = sessionStorage.getItem('isEditSubscription');
      this.subDate = sessionStorage.getItem('subDate');
      this.subDate = this.subDate.split('-').reverse().join('-');
      if (this.isEditSub === 'yes') {
        this.isEditSubscription = true;
      } else {
        this.isEditSubscription = false;
      }
      this.subscriptionId = sessionStorage.getItem('subscriptionId');
      this.promoCodeVerified = sessionStorage.getItem('promoCodeVerified');
      this.promocodeText = sessionStorage.getItem('promocodeText');
      if (this.subscriptionDetails.delivery_frequency === '1') {
        this.customizeQtyDisplay = true;
      } else {
        this.customizeQtyDisplay = false;
      }
      if (this.subscriptionDetails.type === 'One Time') {
        this.isOneTime = true;
      } else {
        this.isOneTime = false;
      }
      if (sessionStorage.getItem('isPostpaidDisabled') === 'yes') {
        this.isPostpaidDisabled = true;
      } else {
        this.isPostpaidDisabled = false;
      }
    },
    userInfo: function userInfo() {
      var _this = this;

      var params = new URLSearchParams();
      params.append('user_id', this.subscriptionDetails.user_id);
      __WEBPACK_IMPORTED_MODULE_2_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/users/user-info',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        // console.log(response)
        _this.userDetails = {};
        _this.userDetails.address = response.data.user_record.address.address1;
        /* this.userDetails.userId = userId
        this.userDetails.first_name = response.data.user_record.user_details.first_name
        this.userDetails.mobile = response.data.user_record.user.username
        this.userDetails.pincode = response.data.user_record.address.pincode
        this.userDetails.zombie = response.data.user_record.user_details.zombie
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          this.list = response.data.user_record
          alert(this.list)
        } */
      }).catch(function (e) {
        alert('not ok');
      });
    },
    deliveryBoyList: function deliveryBoyList() {
      var _this2 = this;

      var params = new URLSearchParams();
      params.append('dispatcher_id', sessionStorage.getItem('dispatcherId'));
      params.append('d_date', 'today');
      __WEBPACK_IMPORTED_MODULE_2_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/dispatchers/delivery-boy-list',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this2.dbList = response.data.db_list;
        // console.log(this.dbList)
        var selectDb = {
          'delivery_boy_id': 0,
          'name': 'Referred By(DB)'
        };
        _this2.dbList.unshift(selectDb);
        _this2.isReferrerDisplay = true;
        _this2.isLoading = false;
      }).catch(function (e) {
        alert('not ok');
      });
    },
    locationModule: function locationModule() {
      // alert('location')
      sessionStorage.setItem('userId', this.subscriptionDetails.user_id);
      sessionStorage.setItem('isProfile', 1);
      sessionStorage.setItem('actionName', 'subscription');
      sessionStorage.setItem('callbackUrlForSubscription', document.URL);
      sessionStorage.setItem('locationAction', 'getOldLocation');
      this.$router.push('/a/location');
    },
    addSubscription: function addSubscription() {
      var _this3 = this;

      // alert('addSubscription hit')
      /* alert('user_id' + this.userId)
      alert('product_id' + this.productId)
      alert('start_date' + this.subDate)
      alert('subscription_type' + this.subPaymentMode)
      alert('quantity' + this.quantityValue) */
      /* alert('everydayCheckbox' + this.everydayCheckbox)
      alert('customizeCheckbox' + this.customizeCheckbox)
      alert('alternateCheckbox' + this.alternateCheckbox) */
      var params = new URLSearchParams();
      if (this.isEditSubscription === true) {
        params.append('isUpdate', 1);
        params.append('subscription_id', this.subscriptionId);
      }
      if (sessionStorage.getItem('isReferrerDisplay') === '1' && this.referrerId !== 0) {
        params.append('sales_executive', this.referrerId);
      }
      params.append('user_id', this.subscriptionDetails.user_id);
      params.append('product_id', this.subscriptionDetails.product_id);
      params.append('start_date', this.subscriptionDetails.start_date);
      params.append('subscription_type', this.subscriptionDetails.subscription_type);
      params.append('product_price_id', this.subscriptionDetails.product_price_id);
      params.append('is_ring_bell', this.subscriptionDetails.is_ring_bell);
      params.append('nice_to_have_req', this.subscriptionDetails.nice_to_have_req);
      if (this.subscriptionDetails.delivery_frequency === '3' && this.subscriptionDetails.type === 'Daily') {
        sessionStorage.setItem('scheduleText', 'Everyday');
        params.append('type', 'Daily');
        params.append('delivery_frequency', 3);
        params.append('quantity', this.subscriptionDetails.quantity);
      } else if (this.subscriptionDetails.delivery_frequency === '1') {
        sessionStorage.setItem('scheduleText', 'Customize');
        params.append('type', 'Daily');
        params.append('delivery_frequency', 1);
        params.append('monday', this.subscriptionDetails.monday);
        params.append('tuesday', this.subscriptionDetails.tuesday);
        params.append('wednesday', this.subscriptionDetails.wednesday);
        params.append('thursday', this.subscriptionDetails.thursday);
        params.append('friday', this.subscriptionDetails.friday);
        params.append('saturday', this.subscriptionDetails.saturday);
        params.append('sunday', this.subscriptionDetails.sunday);
      } else if (this.subscriptionDetails.delivery_frequency === '2') {
        sessionStorage.setItem('scheduleText', 'Alternate');
        params.append('type', 'Daily');
        params.append('delivery_frequency', 2);
        params.append('quantity', this.subscriptionDetails.quantity);
        params.append('alternate', this.subscriptionDetails.alternate);
      } else {
        // for one time
        sessionStorage.setItem('scheduleText', 'One Time');
        params.append('type', 'One Time');
        params.append('delivery_frequency', 3);
        params.append('quantity', this.subscriptionDetails.quantity);
      }
      if (this.promoCodeVerified === 'yes') {
        params.append('promo_code', this.promocodeText);
      }
      if (sessionStorage.getItem('dispatcherId') !== null) {
        params.append('changes_by', sessionStorage.getItem('dispatcherId'));
      } else {
        params.append('changes_by', this.subscriptionDetails.user_id);
      }
      // console.log(params)
      __WEBPACK_IMPORTED_MODULE_2_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/subscriptions/add',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        // console.log(response)
        if (response.data.status === '000000') {
          _this3.$toast.open({
            message: response.data.msg,
            type: 'success'
          });
          // debugger
          // send to product list
          // window.location.href = response.data.product_list_url
          // debugger
          if (sessionStorage.getItem('productListUrl') !== null) {
            var path = sessionStorage.getItem('productListUrl');
            sessionStorage.removeItem('ringOnSelected');
            sessionStorage.removeItem('nice_to_have_req');
            sessionStorage.removeItem('subPaymentMode');
            sessionStorage.removeItem('subDate');
            sessionStorage.removeItem('scheduleText');
            sessionStorage.removeItem('isPostpaidDisabled');
            sessionStorage.removeItem('promoCodeVerified');
            sessionStorage.removeItem('promocodeText');
            sessionStorage.removeItem('prodQuantity');
            sessionStorage.removeItem('prodBaseQuantity');
            sessionStorage.removeItem('alternate');
            sessionStorage.removeItem('monQty');
            sessionStorage.removeItem('tueQty');
            sessionStorage.removeItem('wedQty');
            sessionStorage.removeItem('thuQty');
            sessionStorage.removeItem('friQty');
            sessionStorage.removeItem('satQty');
            sessionStorage.removeItem('sunQty');
            window.location.href = path;
          }
          // this.$router.push({path: '/a/productList'})
        } else {
          _this3.$toast.open({
            message: response.data.msg,
            type: 'error'
          });
        }
      }).catch(function (e) {
        alert('not ok');
      });
    }
  }
});

/***/ }),

/***/ "SHNQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar",style:(_vm.sidebarStyle),attrs:{"data-color":_vm.backgroundColor,"data-image":_vm.backgroundImage}},[_c('div',{staticClass:"sidebar-wrapper"},[_c('div',{staticClass:"logo"},[_c('a',{staticClass:"simple-text",attrs:{"href":"#"}},[_vm._m(0),_vm._v("\n        "+_vm._s(_vm.title)+"\n      ")])]),_vm._v(" "),_vm._t("content"),_vm._v(" "),_c('ul',{staticClass:"nav"},[_vm._t("default",_vm._l((_vm.sidebarLinks),function(link,index){return _c('sidebar-link',{key:link.name + index,attrs:{"to":link.path,"link":link},on:{"click":_vm.closeNavbar}},[_c('i',{class:link.icon}),_vm._v(" "),_c('p',[_vm._v(_vm._s(link.name))])])}))],2)],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-img"},[_c('img',{attrs:{"src":"static/img/vue-logo.png","alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SYh3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SYqB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-loading',{attrs:{"is-full-page":_vm.isFullPage,"active":_vm.isLoading},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),(_vm.successfully_feedback === false)?_c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"url_valid"}},[_c('div',{staticStyle:{"text-align":"center"}},[_c('div',[_c('h4',[_vm._v("Welcome "+_vm._s(_vm.userDetails.first_name)),_c('br'),_vm._v("("+_vm._s(_vm.userDetails.mobile)+")")])]),_vm._v(" "),_c('div',{staticStyle:{"padding":"5%"}},[_vm._v("\n        "+_vm._s(_vm.userDetails.address))]),_vm._v("\n        *****\n        "),_c('div',{staticStyle:{"padding":"5%"}},[_vm._v(_vm._s(_vm.text1))]),_c('br'),_vm._v(" "),_c('img',{staticStyle:{"width":"90%"},attrs:{"src":_vm.imageContent}}),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"padding":"5%"}},[_vm._v(_vm._s(_vm.text2))]),_vm._v(" "),_c('input',{staticClass:"buttonOnDelFbLoc",attrs:{"value":"UPDATE LOCATION","type":"button"},on:{"click":function($event){_vm.locationModule();}}})])])]):_vm._e(),_vm._v(" "),(_vm.successfully_feedback)?_c('div',[_c('div',{staticStyle:{"text-align":"center","width":"90%"}},[_c('br'),_c('br'),_vm._v(" "),_c('img',{staticStyle:{"width":"15%"},attrs:{"src":__webpack_require__("b4Vd")}}),_c('br'),_c('br'),_vm._v("\n      Thanks "+_vm._s(_vm.userDetails.first_name)+" "),_c('br'),_vm._v("\n      Your feedback is sent to our delivery partner. It will not repeat again!!"),_c('br'),_c('br')])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center","width":"90%"},attrs:{"id":"url_expired"}},[_c('h4',[_vm._v("Welcome to Doodhvale, Please wait...")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Sczw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Sh+Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subscription_vue__ = __webpack_require__("Jhqu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bf2e00e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subscription_vue__ = __webpack_require__("+33e");
function injectStyle (ssrContext) {
  __webpack_require__("5eTp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subscription_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bf2e00e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subscription_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SkI9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SpZ/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      urlInterface: [],
      after_checksum: false,
      genChecksum: {},
      promoCodeId: "0",
      cashback: "0"
    };
  },
  mounted: function mounted() {
    this.paytm();
  },

  methods: {
    paytm: function paytm() {
      var _this = this;

      var orderId = '';
      var params = new URLSearchParams();
      var userId = this.$route.query.USER_ID;
      this.promoCodeId = this.$route.query.PROMO_CODE_ID;
      this.cashback = this.$route.query.CASHBACK;

      params.append('user_id', userId);
      params.append('gateway_name', 'paytm');
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/accounts/generate-unique-order-id',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this.urlInterface = {};
        if (response.data.msg.trim().toUpperCase() === 'SUCCESS') {
          orderId = response.data.unique_order_id;
          var _params = new URLSearchParams();

          var txnAmount = _this.$route.query.TXN_AMOUNT;
          _this.urlInterface.callback_url = "https://doodhvale.in/dv/doodhvale/api/modules/v3" + '/controllers/pgResponse.php';
          _this.urlInterface.vue_url = "http:localhost:4000/#/a/";
          _this.isLoading = false;
          console.log(txnAmount);
          _params.append('CUST_ID', userId);
          _params.append('ORDER_ID', orderId);
          _params.append('CHANNEL_ID', 'WEB');
          _params.append('WEBSITE', 'SanjeeWEB');
          _params.append('TXN_AMOUNT', txnAmount);
          _params.append('MERC_UNQ_REF', userId + 'br' + _this.urlInterface.vue_url + 'br' + "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/accounts/verify-transaction');
          _params.append('CALLBACK_URL', _this.urlInterface.callback_url);
          _params.append('promo_code_id', _this.promoCodeId);
          _params.append('cashback_amount', _this.cashback);
          __WEBPACK_IMPORTED_MODULE_0_axios___default()({
            url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/accounts/generate-checksum',
            method: 'post',
            data: _params,
            withCredentials: false,
            headers: {}
          }).then(function (response) {
            _this.genChecksum = {};
            _this.genChecksum.MID = response.data.post_value.MID;
            _this.genChecksum.ORDER_ID = response.data.post_value.ORDER_ID;
            _this.genChecksum.CUST_ID = _this.$route.query.USER_ID;
            _this.genChecksum.INDUSTRY_TYPE_ID = response.data.post_value.INDUSTRY_TYPE_ID;
            _this.genChecksum.CHANNEL_ID = response.data.post_value.CHANNEL_ID;
            _this.genChecksum.WEBSITE = response.data.post_value.WEBSITE;
            _this.genChecksum.TXN_AMOUNT = _this.$route.query.TXN_AMOUNT;
            _this.genChecksum.CALLBACK_URL = response.data.post_value.CALLBACK_URL;
            _this.genChecksum.MERC_UNQ_REF = response.data.post_value.MERC_UNQ_REF;
            _this.genChecksum.checksum = response.data.checkSum;
            _this.after_checksum = true;
            _this.userData = false;
            _this.app_payment_gate = false;

            if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
              _this.list = response.data.user_record;
              alert(_this.list);
            }
          }).catch(function (e) {
            alert('not ok');
          });
        }
      }).catch(function (e) {
        _this.errors = 'Server error, Try again!';
        _this.isActive = true;
      });
    }
  }
});

/***/ }),

/***/ "Svje":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T1vP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__ = __webpack_require__("eCSI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_GeneralViews_NotFoundPage_vue__ = __webpack_require__("5FAv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_P_vue__ = __webpack_require__("RSfl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_UserProfile_vue__ = __webpack_require__("B2Q4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_U_vue__ = __webpack_require__("J11u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_L_vue__ = __webpack_require__("XuLK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_Icons_vue__ = __webpack_require__("U7xI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_S_vue__ = __webpack_require__("ftYJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_R_old_vue__ = __webpack_require__("PVy+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_Dashboard_Views_Reg_vue__ = __webpack_require__("KjHH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_Dashboard_Views_Profile_vue__ = __webpack_require__("Ba8P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_Dashboard_Views_Location_vue__ = __webpack_require__("QY6s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_Dashboard_Views_Subscription_vue__ = __webpack_require__("Sh+Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_Dashboard_Views_F_vue__ = __webpack_require__("nWjp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_Dashboard_Views_R1_vue__ = __webpack_require__("6+sq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_Dashboard_Views_Pp_vue__ = __webpack_require__("A05z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_Dashboard_Views_Sw_vue__ = __webpack_require__("GRlf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_components_Dashboard_Views_Privacy_vue__ = __webpack_require__("yfE3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_components_Dashboard_Views_Refund_vue__ = __webpack_require__("ahUB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_components_Dashboard_Views_Shipping_vue__ = __webpack_require__("vRYl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Terms_vue__ = __webpack_require__("VLb8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_src_components_Dashboard_Views_Contact_vue__ = __webpack_require__("KBIF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_components_Dashboard_Views_G3school_vue__ = __webpack_require__("rK2t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_src_components_Dashboard_Views_PostpaidNotice_vue__ = __webpack_require__("ERnB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_src_components_Dashboard_Views_Td_vue__ = __webpack_require__("/Ngp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_src_components_Dashboard_Views_ProductList_vue__ = __webpack_require__("UI2F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_src_components_Dashboard_Views_EditSubscription_vue__ = __webpack_require__("k7DQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_src_components_Dashboard_Views_SubscriptionVerification_vue__ = __webpack_require__("5iiD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_src_components_Dashboard_Views_Dispnewcust_vue__ = __webpack_require__("fX+i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_src_components_Dashboard_Views_Referral_vue__ = __webpack_require__("/8C+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_src_components_Dashboard_Views_Test_vue__ = __webpack_require__("UfF8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_src_components_Dashboard_Views_Delfbdbfault_vue__ = __webpack_require__("gw4i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_src_components_Dashboard_Views_Delfbloc_vue__ = __webpack_require__("ZnVD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_src_components_Dashboard_Views_Notifications_vue__ = __webpack_require__("nt0W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_src_components_Dashboard_Views_Tr1_vue__ = __webpack_require__("OjXr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_src_components_Dashboard_Views_UploadDailyMilkTestReport_vue__ = __webpack_require__("a4f0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_src_components_Dashboard_Views_Dmtr_vue__ = __webpack_require__("cBLl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_src_components_Dashboard_Views_AppLink_vue__ = __webpack_require__("BrJK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_src_components_Dashboard_Views_MedcoAppLink_vue__ = __webpack_require__("rbol");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_src_components_Dashboard_Views_Hmi_vue__ = __webpack_require__("nhQu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_src_components_Dashboard_Views_Bill_vue__ = __webpack_require__("3fGJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_src_components_Dashboard_Views_UnsubPromo_vue__ = __webpack_require__("gT9a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_src_components_Dashboard_Views_R_vue__ = __webpack_require__("qSKj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_src_components_Dashboard_Views_Referral2_vue__ = __webpack_require__("WCNf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_src_components_Dashboard_Views_Free_order_vue__ = __webpack_require__("TZWB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_src_components_Dashboard_Views_PaytmContd_vue__ = __webpack_require__("KYlc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_src_components_Dashboard_Views_Wc_vue__ = __webpack_require__("WqS3");

// GeneralViews


// Admin pages































/* import Payments from 'src/components/Dashboard/Views/Payments.vue' */










// routes added by rijul jain




//priya



var routes = [{
  path: '/',
  // component: DashboardLayout,
  name: 'R',
  component: __WEBPACK_IMPORTED_MODULE_42_src_components_Dashboard_Views_R_vue__["a" /* default */],
  meta: {
    header: 1,
    footer: 1
  }
}, {
  path: '/a',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  // redirect: '/a/r',
  meta: {
    header: 1,
    footer: 1
  },
  children: [{
    path: 'p',
    name: 'P',
    component: __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_P_vue__["a" /* default */],
    meta: {
      header: 1,
      footer: 1
    }
  }, {
    path: 'user',
    name: 'User',
    component: __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_UserProfile_vue__["a" /* default */],
    meta: {
      header: 1,
      footer: 1
    }
  }, {
    path: 'u',
    name: 'U',
    component: __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_U_vue__["a" /* default */],
    meta: {
      header: 1,
      footer: 1
    }
  }, {
    path: 'uploadDailyMilkTestReport',
    name: 'UploadDailyMilkTestReport',
    component: __WEBPACK_IMPORTED_MODULE_35_src_components_Dashboard_Views_UploadDailyMilkTestReport_vue__["a" /* default */],
    meta: {
      header: 1,
      footer: 1
    }
  }, {
    path: 'Dmtr',
    name: 'Dmtr',
    component: __WEBPACK_IMPORTED_MODULE_36_src_components_Dashboard_Views_Dmtr_vue__["a" /* default */],
    meta: {
      header: 2,
      footer: 2
    }
  }, {
    path: 'hmi',
    name: 'Hmi',
    component: __WEBPACK_IMPORTED_MODULE_39_src_components_Dashboard_Views_Hmi_vue__["a" /* default */],
    meta: {
      header: 2,
      footer: 2
    }
  }, {
    path: 'bill',
    name: 'Bill',
    component: __WEBPACK_IMPORTED_MODULE_40_src_components_Dashboard_Views_Bill_vue__["a" /* default */],
    meta: {
      header: 1,
      footer: 1
    }
  }, {
    path: 'appLink',
    name: 'AppLink',
    component: __WEBPACK_IMPORTED_MODULE_37_src_components_Dashboard_Views_AppLink_vue__["a" /* default */],
    meta: {
      header: 2,
      footer: 2
    }
  }, {
    path: 'medcoAppLink',
    name: 'MedcoAppLink',
    component: __WEBPACK_IMPORTED_MODULE_38_src_components_Dashboard_Views_MedcoAppLink_vue__["a" /* default */],
    meta: {
      header: 2,
      footer: 2
    }
  }, {
    path: 'l',
    name: 'L',
    component: __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_L_vue__["a" /* default */],
    meta: {
      header: 1,
      footer: 1
    }
  }, {
    path: 'f',
    name: 'F',
    component: __WEBPACK_IMPORTED_MODULE_13_src_components_Dashboard_Views_F_vue__["a" /* default */],
    meta: {
      header: 1,
      footer: 1
    }
  }, {
    path: 'icons',
    name: 'Icons',
    component: __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_Icons_vue__["a" /* default */],
    meta: {
      header: 1,
      footer: 1
    }
  }, {
    path: 'sw',
    name: 'Sw',
    component: __WEBPACK_IMPORTED_MODULE_16_src_components_Dashboard_Views_Sw_vue__["a" /* default */],
    meta: {
      header: 1,
      footer: 1
    }
  },
  /* {
    path: 'payment',
    name: 'Payment',
    component: Payments
  }, */
  {
    path: 's',
    name: 'S',
    component: __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_S_vue__["a" /* default */],
    meta: {
      header: 2,
      footer: 2
    }
  }, {
    path: 'r1',
    name: 'R1',
    component: __WEBPACK_IMPORTED_MODULE_14_src_components_Dashboard_Views_R1_vue__["a" /* default */],
    meta: {
      header: 1,
      footer: 1
    }
  }, {
    path: 'tr1',
    name: 'Tr1',
    component: __WEBPACK_IMPORTED_MODULE_34_src_components_Dashboard_Views_Tr1_vue__["a" /* default */],
    meta: {
      header: 2,
      footer: 2
    }
  }, {
    path: 'reg',
    name: 'Reg',
    component: __WEBPACK_IMPORTED_MODULE_9_src_components_Dashboard_Views_Reg_vue__["a" /* default */],
    meta: {
      header: 1,
      footer: 1
    }
  },
  // path added by rijul
  {
    path: 'rold',
    name: 'Rold',
    component: __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_R_old_vue__["a" /* default */],
    meta: {
      header: 1,
      footer: 1
    }
  }, {
    path: 'r',
    redirect: '/'
    /* name: 'R',
    component: R,
    meta: {
      header: 1,
      footer: 1
    } */
  }, {
    path: 'referral2',
    name: 'Referral2',
    component: __WEBPACK_IMPORTED_MODULE_43_src_components_Dashboard_Views_Referral2_vue__["a" /* default */]
  }, {
    path: 'notifications',
    name: 'Notifications',
    component: __WEBPACK_IMPORTED_MODULE_33_src_components_Dashboard_Views_Notifications_vue__["a" /* default */],
    meta: {
      header: 1,
      footer: 1
    }
  }, {
    path: 'profile',
    name: 'Profile',
    component: __WEBPACK_IMPORTED_MODULE_10_src_components_Dashboard_Views_Profile_vue__["a" /* default */],
    meta: {
      header: 1,
      footer: 1
    }
  }, {
    path: 'location',
    name: 'Location',
    component: __WEBPACK_IMPORTED_MODULE_11_src_components_Dashboard_Views_Location_vue__["a" /* default */],
    meta: {
      header: 1,
      footer: 1
    }
  }, {
    path: 'subscription',
    name: 'Subscription',
    component: __WEBPACK_IMPORTED_MODULE_12_src_components_Dashboard_Views_Subscription_vue__["a" /* default */],
    meta: {
      header: 1,
      footer: 1
    }
  }, {
    path: 'privacy',
    name: 'Privacy',
    component: __WEBPACK_IMPORTED_MODULE_17_src_components_Dashboard_Views_Privacy_vue__["a" /* default */],
    meta: {
      header: 1,
      footer: 1
    }
  }, {
    path: 'refund',
    name: 'Refund',
    component: __WEBPACK_IMPORTED_MODULE_18_src_components_Dashboard_Views_Refund_vue__["a" /* default */],
    meta: {
      header: 1,
      footer: 1
    }
  }, {
    path: 'shipping',
    name: 'Shipping',
    component: __WEBPACK_IMPORTED_MODULE_19_src_components_Dashboard_Views_Shipping_vue__["a" /* default */],
    meta: {
      header: 1,
      footer: 1
    }
  }, {
    path: 'contact',
    name: 'Contact',
    component: __WEBPACK_IMPORTED_MODULE_21_src_components_Dashboard_Views_Contact_vue__["a" /* default */],
    meta: {
      header: 1,
      footer: 1
    }
  }, {
    path: 'terms',
    name: 'Terms',
    component: __WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Terms_vue__["a" /* default */],
    meta: {
      header: 1,
      footer: 1
    }
  }, {
    path: 'postpaidNotice',
    name: 'PostpaidNotice',
    component: __WEBPACK_IMPORTED_MODULE_23_src_components_Dashboard_Views_PostpaidNotice_vue__["a" /* default */],
    meta: {
      header: 1,
      footer: 1
    }
  }, {
    path: 'td',
    name: 'Td',
    component: __WEBPACK_IMPORTED_MODULE_24_src_components_Dashboard_Views_Td_vue__["a" /* default */],
    meta: {
      header: 1,
      footer: 1
    }
  }, {
    path: 'test',
    name: 'Test',
    component: __WEBPACK_IMPORTED_MODULE_30_src_components_Dashboard_Views_Test_vue__["a" /* default */],
    meta: {
      header: 2,
      footer: 2
    }
  }, {
    path: 'f1',
    name: 'Delfbloc',
    component: __WEBPACK_IMPORTED_MODULE_32_src_components_Dashboard_Views_Delfbloc_vue__["a" /* default */],
    meta: {
      header: 1,
      footer: 1
    }
  }, {
    path: 'f2',
    name: 'Delfbdbfault',
    component: __WEBPACK_IMPORTED_MODULE_31_src_components_Dashboard_Views_Delfbdbfault_vue__["a" /* default */],
    meta: {
      header: 1,
      footer: 1
    }
  }, {
    path: 'pp',
    name: 'Pp',
    component: __WEBPACK_IMPORTED_MODULE_15_src_components_Dashboard_Views_Pp_vue__["a" /* default */],
    meta: {
      header: 2,
      footer: 2
    }
  }, {
    path: 'productList',
    name: 'ProductList',
    component: __WEBPACK_IMPORTED_MODULE_25_src_components_Dashboard_Views_ProductList_vue__["a" /* default */],
    meta: {
      header: 1,
      footer: 1
    }
  }, {
    path: 'editSubscription',
    name: 'EditSubscription',
    component: __WEBPACK_IMPORTED_MODULE_26_src_components_Dashboard_Views_EditSubscription_vue__["a" /* default */],
    meta: {
      header: 1,
      footer: 1
    }
  }, {
    path: 'subscriptionVerification',
    name: 'SubscriptionVerification',
    component: __WEBPACK_IMPORTED_MODULE_27_src_components_Dashboard_Views_SubscriptionVerification_vue__["a" /* default */],
    meta: {
      header: 1,
      footer: 2
    }
  }, {
    path: 'dispnewcust',
    name: 'Dispnewcust',
    component: __WEBPACK_IMPORTED_MODULE_28_src_components_Dashboard_Views_Dispnewcust_vue__["a" /* default */],
    meta: {
      header: 1,
      footer: 1
    }
  }, {
    path: 'referral',
    name: 'Referral',
    component: __WEBPACK_IMPORTED_MODULE_29_src_components_Dashboard_Views_Referral_vue__["a" /* default */],
    meta: {
      header: 1,
      footer: 1
    }
  }, {
    path: 'unsubPromo',
    name: 'UnsubPromo',
    component: __WEBPACK_IMPORTED_MODULE_41_src_components_Dashboard_Views_UnsubPromo_vue__["a" /* default */],
    meta: {
      header: 1,
      footer: 1
    }
  }, {
    path: 'g3school',
    name: 'G3school',
    component: __WEBPACK_IMPORTED_MODULE_22_src_components_Dashboard_Views_G3school_vue__["a" /* default */],
    meta: {
      header: 2,
      footer: 2
    }
  }, /* ,
     {
     path: 'profile/:id',
     name: 'Profile',
     component: Profile
     } */
  {
    path: 'free_order',
    name: 'Free_order',
    component: __WEBPACK_IMPORTED_MODULE_44_src_components_Dashboard_Views_Free_order_vue__["a" /* default */],
    meta: {
      header: 1,
      footer: 1
    }
  }, {
    path: 'wc',
    name: 'Wc',
    component: __WEBPACK_IMPORTED_MODULE_46_src_components_Dashboard_Views_Wc_vue__["a" /* default */],
    meta: {
      header: 1,
      footer: 1
    }
  }, {
    path: 'pc',
    name: 'PaytmContd',
    component: __WEBPACK_IMPORTED_MODULE_45_src_components_Dashboard_Views_PaytmContd_vue__["a" /* default */],
    meta: {
      header: 1,
      footer: 1
    }
  }]
}, { path: '*', component: __WEBPACK_IMPORTED_MODULE_1__components_GeneralViews_NotFoundPage_vue__["a" /* default */] }];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ "T6+J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container is-fluid has-text-centered"},[_c('b-loading',{attrs:{"is-full-page":_vm.isFullPage,"active":_vm.isLoading},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.urlValid === false)?_c('div',[_c('h4',[_vm._v("Welcome to Doodhvale, Please wait...")])]):_vm._e(),_vm._v(" "),(_vm.urlValid === true && _vm.salesman_otp_required === 0)?_c('div',[_c('i',{staticClass:"fa fa-mobile icon"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userMobile),expression:"userMobile"}],staticClass:"mobileOnDisp",attrs:{"id":"mobile","maxlength":"10","placeholder":"Enter mobile number","required":""},domProps:{"value":(_vm.userMobile)},on:{"input":function($event){if($event.target.composing){ return; }_vm.userMobile=$event.target.value}}}),_c('br'),_vm._v(" "),_c('input',{staticClass:"buttonOnRegFromDispatcher",staticStyle:{"margin-top":"3rem","margin-bottom":"3rem"},attrs:{"value":"CONTINUE","type":"button"},on:{"click":function($event){_vm.createUser();}}})]):_vm._e(),_vm._v(" "),(_vm.urlValid === true && _vm.salesman_otp_required === 1)?_c('div',[(_vm.otp === false)?_c('div',[_c('br'),_vm._v(" "),_c('form',{staticStyle:{"margin-top":"20%","margin-bottom":"20%"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"w3-center"},[_c('input',{staticClass:"regbutton",attrs:{"value":"NEXT","type":"button"},on:{"click":function($event){_vm.signup();}}})])])]):_vm._e(),_vm._v(" "),(_vm.otp)?_c('div',[_c('br'),_vm._v(" "),_c('form',{staticStyle:{"margin-top":"20%","margin-bottom":"20%"}},[_c('div',{staticStyle:{"position":"relative"}},[_c('i',{staticClass:"fa fa-mobile icon",staticStyle:{"margin-left":"15%"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signUp.disMobile),expression:"signUp.disMobile"}],staticClass:"mobile",attrs:{"id":"mobile","maxlength":"10","disabled":"true"},domProps:{"value":(_vm.signUp.disMobile)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.signUp, "disMobile", $event.target.value)}}}),_c('br'),_vm._v(" "),_c('hr',{staticStyle:{"display":"block","height":"1px","border":"0","border-top":"1px solid #9a9a9a","margin":"0em 15%","padding":"0"}}),_c('br')]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"w3-center"},[_c('input',{staticClass:"regbutton",attrs:{"value":"REGISTER","type":"button"},on:{"click":function($event){_vm.verifyotp();}}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"margin-left":"15%","margin-right":"15%","color":"#11a4e0"}},[_vm._v("\n        If you do not receive your HAPPY CODE within 1 minute, click the Resend HAPPY CODE button to resend code\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"w3-center"},[_c('input',{staticClass:"regbutton",attrs:{"value":"RESEND HAPPY CODE","type":"button"},on:{"click":function($event){_vm.resendotp();}}})])])]):_vm._e()]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[_c('i',{staticClass:"fa fa-mobile icon",staticStyle:{"margin-left":"15%"}}),_vm._v(" "),_c('input',{staticClass:"mobile",attrs:{"id":"mobile","maxlength":"10","placeholder":"Enter mobile number","required":""}}),_c('br'),_vm._v(" "),_c('hr',{staticStyle:{"display":"block","height":"1px","border":"0","border-top":"1px solid #3CB6C3","margin":"0em 15%","padding":"0"}}),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[_c('img',{staticStyle:{"width":"7%","margin-left":"15%"},attrs:{"src":__webpack_require__("cdbK")}}),_vm._v(" "),_c('input',{staticClass:"mobile",attrs:{"id":"otp","maxlength":"4","placeholder":"Enter HAPPY CODE","required":""}}),_c('br'),_vm._v(" "),_c('hr',{staticStyle:{"display":"block","height":"1px","border":"0","border-top":"1px solid #212529","margin":"0em 15%","padding":"0"}}),_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TJTB":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "TQ5B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TopNavbar_vue__ = __webpack_require__("2aTV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ContentFooter_vue__ = __webpack_require__("MZ8R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Content_vue__ = __webpack_require__("bwpC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MobileMenu_vue__ = __webpack_require__("0AsC");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TopNavbar: __WEBPACK_IMPORTED_MODULE_0__TopNavbar_vue__["a" /* default */],
    ContentFooter: __WEBPACK_IMPORTED_MODULE_1__ContentFooter_vue__["a" /* default */],
    DashboardContent: __WEBPACK_IMPORTED_MODULE_2__Content_vue__["a" /* default */],
    MobileMenu: __WEBPACK_IMPORTED_MODULE_3__MobileMenu_vue__["a" /* default */]
  },
  methods: {
    toggleSidebar: function toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  }
});

/***/ }),

/***/ "TZWB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Free_order_vue__ = __webpack_require__("8EQs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f18483ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Free_order_vue__ = __webpack_require__("K5hE");
function injectStyle (ssrContext) {
  __webpack_require__("27e6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Free_order_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f18483ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Free_order_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "To5b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U72P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "U7xI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Icons_vue__ = __webpack_require__("U72P");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af7cfaa0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Icons_vue__ = __webpack_require__("aHuc");
function injectStyle (ssrContext) {
  __webpack_require__("JuSb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Icons_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af7cfaa0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Icons_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UBvS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sad.8c0b4eb.png";

/***/ }),

/***/ "UI2F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductList_vue__ = __webpack_require__("b1fl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bb38962_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductList_vue__ = __webpack_require__("0A70");
function injectStyle (ssrContext) {
  __webpack_require__("quQw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7bb38962"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bb38962_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UdIB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UfF8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Test_vue__ = __webpack_require__("t+rC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2264e962_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Test_vue__ = __webpack_require__("93fV");
function injectStyle (ssrContext) {
  __webpack_require__("FqlF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Test_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2264e962_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Test_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UtZd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UvUG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,_vm._b({tag:"component",attrs:{"tag":"li"},nativeOn:{"click":function($event){return _vm.hideSidebar($event)}}},'component',_vm.$attrs,false),[_c('a',{staticClass:"nav-link"},[_vm._t("default",[(_vm.link.icon)?_c('i',{class:_vm.link.icon}):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.link.name))])])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UvxC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',{staticClass:"card-user"},[_c('img',{attrs:{"slot":"image","src":"https://ununsplash.imgix.net/photo-1431578500526-4d9613015464?fit=crop&fm=jpg&h=300&q=75&w=400","alt":"..."},slot:"image"}),_vm._v(" "),_c('div',{staticClass:"author"},[_c('a',{attrs:{"href":"#"}},[_c('img',{staticClass:"avatar border-gray",attrs:{"src":"static/img/faces/face-3.jpg","alt":"..."}}),_vm._v(" "),_c('h4',{staticClass:"title"},[_vm._v("Mike Andrew"),_c('br'),_vm._v(" "),_c('small',[_vm._v("michael24")])])])]),_vm._v(" "),_c('p',{staticClass:"description text-center"},[_vm._v(" \"Lamborghini Mercy "),_c('br'),_vm._v("\n    Your chick she so thirsty "),_c('br'),_vm._v("\n    I'm in that two seat Lambo\"\n  ")]),_vm._v(" "),_c('div',{staticClass:"text-center",attrs:{"slot":"footer"},slot:"footer"},[_c('button',{staticClass:"btn btn-simple",attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-facebook-square"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-simple",attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-twitter"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-simple",attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-google-plus-square"})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VLb8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Terms_vue__ = __webpack_require__("Iudz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10c9e8e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Terms_vue__ = __webpack_require__("LngK");
function injectStyle (ssrContext) {
  __webpack_require__("fZkL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Terms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10c9e8e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Terms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VnhA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "VuyX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ic_sale.f9cfc63.png";

/***/ }),

/***/ "WC7W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WCNf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Referral2_vue__ = __webpack_require__("8rri");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fc63c28_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Referral2_vue__ = __webpack_require__("g3u2");
function injectStyle (ssrContext) {
  __webpack_require__("ClWv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Referral2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fc63c28_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Referral2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WOE+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group",class:{'input-group': _vm.hasIcon}},[_vm._t("label",[(_vm.label)?_c('label',{staticClass:"control-label"},[_vm._v("\n      "+_vm._s(_vm.label)+"\n    ")]):_vm._e()]),_vm._v(" "),_vm._t("addonLeft",[(_vm.addonLeftIcon)?_c('span',{staticClass:"input-group-addon"},[_c('i',{class:_vm.addonLeftIcon})]):_vm._e()]),_vm._v(" "),_c('input',_vm._b({staticClass:"form-control",attrs:{"aria-describedby":"addon-right addon-left"},domProps:{"value":_vm.value},on:{"input":function($event){_vm.$emit('input',$event.target.value)}}},'input',_vm.$attrs,false)),_vm._v(" "),_vm._t("default"),_vm._v(" "),_vm._t("addonRight",[(_vm.addonRightIcon)?_c('span',{staticClass:"input-group-addon"},[_c('i',{class:_vm.addonRightIcon})]):_vm._e()])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Wgt+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hooper__ = __webpack_require__("chtd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_hooper_dist_hooper_css__ = __webpack_require__("qAob");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_hooper_dist_hooper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_hooper_dist_hooper_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'App',
  components: {
    Hooper: __WEBPACK_IMPORTED_MODULE_0_hooper__["a" /* Hooper */],
    Slide: __WEBPACK_IMPORTED_MODULE_0_hooper__["b" /* Slide */],
    HooperPagination: __WEBPACK_IMPORTED_MODULE_0_hooper__["c" /* Pagination */]
  },
  created: function created() {
    var fullUrl = document.URL;
    var splitUrl = fullUrl.split('r1?');
    sessionStorage.setItem('urlstr', splitUrl[1]);
  }
});

/***/ }),

/***/ "WqS3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Wc_vue__ = __webpack_require__("/P+Q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a9a139e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Wc_vue__ = __webpack_require__("KGkr");
function injectStyle (ssrContext) {
  __webpack_require__("0vN4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Wc_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a9a139e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Wc_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XH6a":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAEgklEQVR4nO2cW6gVVRiAv63iMREvSQk+KEdFQSihFxUSLyBeHlRUJKXyoC8JQQoigmLkBRUps+il8BIk+mCJSlKGCGnk0UOSGR4VQUojyFsHb8fb9mE5/mto9smje9a/Z+b/YOAwM2evb61/zZq11qwZMAzDMAzDMAzDMAzDMAzDMAyjAlOA/cBVoAU4AswHOmhKFYXNQLnCdhio01PLP+uQwr4PnAZOAq3e/u/U7ArANVwh3wYme/uH4pqjKDAvhlfLPxORWr4y4fgU7/jigF6FYR5SwNMTjg/xju8M6FUY5iMFPDXh+GDv+O6AXoXBAqCMBUAZPwDTcW3+KGAsrhc0DAtAavQAvkEK+KH3d9K+ZqBexTRnjAdOAPeoPPqttD0AzuCuHKOd9AOOklzTTwOfA+8CbwCzgHeATcCxCv/TDLweNAcZpYQbRN0nXoCNwJtA36f4jV64Qdm3/DcQnwGdq26dEzoD24gX2ClcM/Sss5yvAQeIXxWHcPcUw6MO2EV8ou19qje93ADc8n6/CZsvekIJ+BIpnJvA6BTSGQhc9NI5AryQQjqZ422kUFqAV1NMqzfwp5fehhTTygT1SBfzDjAhUJrRtHYZGBcgzZrla2QQtTFgum/hxgll4HcK2jMajtTCswrp7/fSb1BIX50dSO2fqZD+EKT5+w3XGSgMPZG++TlFjx+Qq2CEokdw5hIfnWox2/P4VNEjOFuRjL+i6FFCVlQcV/QIzq+4TP+tLYJbSxR1gwtBB+Tm16jsAvFR+ABllyD0QjK8T9kFYA3iM17ZJQj9kQx/pewCsBzx0egOB8dfv7NV2QVgKeIzR9klCBYAZSwAylgAlLEAKGMBUMYPwBZlFyhgAPwlhF8ouwC8h/jMVXYJwhhqYyY0ogHxWaCrEoZZSIZXKLuAeyYc+Xyo7BKED5AMJy0zD81Q5OHQLmWXIGyn9mYfo0VbJ7RFQtCMy+wVbRGPH3FOrUBHZZdUqUcu9++VXXzWUpAZ0dVIRhcqu/iMpraeUaTGKWTx7UvKLj6dcI9Hy8B1ctoMTUSan73KLkmsRK6CpBfBM08jksFJyi5JDESWK/5FzhZqTUNqfxO1mzl/ucw6ZZeqUQIukI0H34OQFRstQHddneqwCSn8LIw0lyG+h5Vdnps+uDdeokFOrYx826I77h4Q9dZG6uo8H01IbVqk7NIe/Am668ouz8wopFfxB9BVV6ddlHBvU0ZBWKKr035KwD9IBrJ4GfdFKlArGXuhbxXxG1mPKm09q3TO027rvXz8VNUSSpFOwF1EPE9bFjoRjCP5ew152D6qYjmlSqUPbWR1ewhcoqBvU4K80FHGLW9vi9uPz7uatlSRiKaxy0C3/zn3xuPzrqUtVSSOIgFo61MGLyNN36UAXoVhKhKAg22c53cbPwngVSjOI4W7h/jnZuqAj5Ha/y/QJbRg3hlG/Js/N3Cvlv6MW2ER7X8AzFByzD1jgctU7i7eoiDrOzXpjfua1i+4qe47uA/5bcQ9VjQMwzAMwzAMwzAMwzAMwzAMI84joERId2ncwooAAAAASUVORK5CYII="

/***/ }),

/***/ "Xi/V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$route.meta.header === 1)?_c('nav',{staticClass:"navbar fixed-top active",attrs:{"position":"fixed"}},[_c('div',{staticClass:"container-fluid"},[_c('router-link',{directives:[{name:"popover",rawName:"v-popover:popover1",arg:"popover1"}],staticClass:"navbar-brand",attrs:{"to":{ path: '/a/reg' }}},[_c('img',{attrs:{"alt":"doodhvale logo","src":"/static/img/d-logo.png"}})]),_vm._v(" "),_c('button',{staticClass:"mat-raised-button btn btn-info btn-md dv-primary-btn mobile-view",attrs:{"mat-raised-button":""},on:{"click":function($event){$event.preventDefault();_vm.goToEvents()}}},[_c('span',{staticClass:"mat-button-wrapper"},[_vm._v("INSTALL APP")]),_vm._v(" "),_c('div',{staticClass:"mat-button-ripple mat-ripple",attrs:{"matripple":""}}),_vm._v(" "),_c('div',{staticClass:"mat-button-focus-overlay"})])],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XuLK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_L_vue__ = __webpack_require__("t4W3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef0c8058_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_L_vue__ = __webpack_require__("rQhz");
function injectStyle (ssrContext) {
  __webpack_require__("4gSg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_L_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef0c8058_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_L_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XyFb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YI6p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__ = __webpack_require__("jIen");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_450708a0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__ = __webpack_require__("J9Ud");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_450708a0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "YTW2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background":"white"},attrs:{"id":"subVeri"}},[_c('b-loading',{attrs:{"is-full-page":_vm.isFullPage,"active":_vm.isLoading},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:" fontSizeClass leftMargin topMarginHalf columns is-mobile"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"column is-7"},[_vm._v("\n      "+_vm._s(_vm.productName)+"\n    ")])]),_vm._v(" "),_c('div',{staticClass:"fontSizeClass leftMargin columns is-mobile"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"column is-7"},[_vm._v("\n      "+_vm._s(_vm.prodBaseQuantity)+" "+_vm._s(_vm.prodUnit)+"\n    ")])]),_vm._v(" "),_c('div',{staticClass:"fontSizeClass leftMargin columns is-mobile"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"column is-7"},[_c('i',{staticClass:"fa fa-rupee"}),_vm._v(_vm._s(_vm.subscriptionDetails.discounted_mrp)+"\n    ")])]),_vm._v(" "),(_vm.isPostpaidDisabled === false)?_c('div',{staticClass:"fontSizeClass leftMargin columns is-mobile"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"column is-7"},[_vm._v("\n      "+_vm._s(_vm.paymentModeText)+"\n    ")])]):_vm._e(),_vm._v(" "),(_vm.isOneTime === false)?_c('div',{staticClass:"fontSizeClass leftMargin columns is-mobile"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"column is-7"},[_vm._v("\n      "+_vm._s(_vm.subDate)+"\n    ")])]):_vm._e(),_vm._v(" "),(_vm.isOneTime === false)?_c('div',{staticClass:"fontSizeClass leftMargin columns is-mobile"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"column is-7"},[_vm._v("\n      "+_vm._s(_vm.scheduleText)+"\n    ")])]):_vm._e(),_vm._v(" "),(_vm.customizeQtyDisplay === false)?_c('div',{staticClass:"fontSizeClass leftMargin columns is-mobile"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"column is-7"},[_vm._v("\n      "+_vm._s(_vm.subscriptionDetails.quantity)+"\n    ")])]):_c('div',{staticClass:"fontSizeClass leftMargin columns is-mobile"},[_vm._m(7),_vm._v(" "),_c('div',{staticClass:"column is-7"},[_c('div',{staticStyle:{"width":"14%","float":"left"}},[_c('div',[_vm._v("S")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.subscriptionDetails.sunday))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"14%","float":"left"}},[_c('div',[_vm._v("M")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.subscriptionDetails.monday))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"14%","float":"left"}},[_c('div',[_vm._v("T")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.subscriptionDetails.tuesday))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"14%","float":"left"}},[_c('div',[_vm._v("W")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.subscriptionDetails.wednesday))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"14%","float":"left"}},[_c('div',[_vm._v("T")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.subscriptionDetails.thursday))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"14%","float":"left"}},[_c('div',[_vm._v("F")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.subscriptionDetails.friday))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"14%","float":"left"}},[_c('div',[_vm._v("S")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.subscriptionDetails.saturday))])]),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}})])]),_vm._v(" "),(_vm.isOneTime === true)?_c('div',{staticClass:"fontSizeClass leftMargin columns is-mobile"},[_vm._m(8),_vm._v(" "),_c('div',{staticClass:"column is-7"},[_vm._v("\n      "+_vm._s(_vm.displayStartDate)+"\n    ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"bottomMargin fontSizeClass leftMargin columns is-mobile"},[_vm._m(9),_vm._v(" "),(_vm.dispatcherLocationFlow === false)?_c('div',{staticClass:"column is-7",staticStyle:{"color":"blue"}},[_c('u',{on:{"click":function($event){_vm.locationModule();}}},[_vm._v(_vm._s(_vm.userDetails.address))])]):_vm._e(),_vm._v(" "),(_vm.dispatcherLocationFlow === true)?_c('div',{staticClass:"column is-7",staticStyle:{"color":"gray"}},[_c('span',[_vm._v(_vm._s(_vm.userDetails.address))])]):_vm._e()]),_vm._v(" "),_c('hr',{staticClass:"topMargin",staticStyle:{"width":"100%"}}),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}}),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","margin-bottom":"1rem"}},[(_vm.isReferrerDisplay === true)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.referrerId),expression:"referrerId"}],staticStyle:{"background":"white"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.referrerId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{directives:[{name:"for-key",rawName:"v-for-key",value:(_vm.option in _vm.dbList),expression:"option in dbList"}],domProps:{"value":_vm.option.delivery_boy_id}},[_vm._v("\n        "+_vm._s(_vm.option.name)+"\n      ")])]):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}}),_vm._v(" "),_c('div',{staticStyle:{"bottom":"0","/* position":"fixed","*/ width":"100%"}},[_c('div',{staticStyle:{"height":"10px","background-color":"white"}}),_vm._v(" "),_c('div',[(_vm.isEditSubscription === false)?_c('input',{staticClass:"buttonOnAddSubscription",attrs:{"value":"SUBSCRIBE","type":"button"},on:{"click":function($event){_vm.addSubscription();}}}):_vm._e(),_vm._v(" "),(_vm.isEditSubscription === true)?_c('input',{staticClass:"buttonOnAddSubscription",attrs:{"value":"UPDATE","type":"button"},on:{"click":function($event){_vm.addSubscription();}}}):_vm._e()])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-5"},[_c('b',[_vm._v("Product :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-5"},[_c('b',[_vm._v("Unit :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-5"},[_c('b',[_vm._v("Price :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-5"},[_c('b',[_vm._v("Payment Mode :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-5"},[_c('b',[_vm._v("Subscription Date :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-5"},[_c('b',[_vm._v("Schedule :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-5"},[_c('b',[_vm._v("Quantity :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-5"},[_c('b',[_vm._v("Quantity :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-5"},[_c('b',[_vm._v("Delivered On :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-5"},[_c('b',[_vm._v("Address :")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YTiL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZET8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// import VueAxios from 'vue-axios'
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    LTable: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Table_vue__["a" /* default */],
    ChartCard: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */],
    StatsCard: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */]
  },
  data: function data() {
    return {
      urlInterface: [],
      apiDataObj: [],
      userDetails: [],
      isLoading: true,
      isLoaded: false,
      isFullPage: true
    };
  },
  created: function created() {
    this.fetchData();
  },

  methods: {
    fetchData: function fetchData() {
      var _this = this;

      var params = new URLSearchParams();
      var fullUrl = document.URL;
      var splitUrl = fullUrl.split('postpaidNotice?');
      params.append('url_str', splitUrl[1]);
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/accounts/fetch-url-interface-data',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this.urlInterface = {};
        if (response.data.status === '000001' || response.data.status === '000002' || response.data.status === '000003') {
          _this.urlInterface.error_msg = response.data.msg;
          document.getElementById('url_valid').style.display = 'none';
        } else {
          document.getElementById('url_expired').style.display = 'none';
          _this.urlInterface.action_name = response.data.action_name;
          _this.urlInterface.url_interface_id = response.data.url_interface_id;
          _this.invokeUrlAction();
        }
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          _this.list = response.data.user_record;
          alert(_this.list);
        }
      }).catch(function (e) {
        alert('not ok');
      });
    },
    invokeUrlAction: function invokeUrlAction() {
      var _this2 = this;

      var params = new URLSearchParams();
      params.append('url_interface_id', this.urlInterface.url_interface_id);
      params.append('action_name', this.urlInterface.action_name);
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/accounts/invoke-url-action',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this2.apiDataObj = {};
        switch (_this2.urlInterface.action_name) {
          case 'postpaid_notice':
            _this2.apiDataObj.userId = response.data.action_response.user_id;
            _this2.apiDataObj.paymentLink = response.data.action_response.payment_link;
            _this2.apiDataObj.callCenterPhoneNumber = response.data.action_response.call_center_phone_number;
            _this2.apiDataObj.doodhvaleCareMailId = response.data.action_response.doodhvale_care_mail_id;
            // console.log(response)
            _this2.userInfo();
            break;
          default:
            break;
        }
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          _this2.list = response.data.user_record;
          alert(_this2.list);
        }
      }).catch(function (e) {
        alert('not ok');
      });
    },
    userInfo: function userInfo() {
      var _this3 = this;

      var params = new URLSearchParams();
      var userId = this.apiDataObj.userId;
      params.append('user_id', userId);
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/users/user-info',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this3.userDetails = {};
        _this3.userDetails.userId = userId;
        _this3.userDetails.first_name = response.data.user_record.user_details.first_name;
        _this3.userDetails.fullName = response.data.user_record.user_details.first_name + ' ' + response.data.user_record.user_details.last_name;
        _this3.userDetails.userName = response.data.user_record.user.username;
        _this3.userDetails.mobile = response.data.user_record.user.username;
        _this3.userDetails.pincode = response.data.user_record.address.pincode;
        _this3.userDetails.address = response.data.user_record.address.address1 + ' ' + response.data.user_record.address.address2 + ' ' + response.data.user_record.address.city;
        _this3.userDetails.zombie = response.data.user_record.user_details.zombie;
        _this3.isLoading = false;
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          _this3.list = response.data.user_record;
          alert(_this3.list);
        }
      }).catch(function (e) {
        alert('not ok');
      });
    }
  }
});

/***/ }),

/***/ "ZQf1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__ = __webpack_require__("sQGm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_874b0e5a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__ = __webpack_require__("AxoN");
function injectStyle (ssrContext) {
  __webpack_require__("AKoQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-874b0e5a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_874b0e5a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZnVD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Delfbloc_vue__ = __webpack_require__("+XOo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01b863ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Delfbloc_vue__ = __webpack_require__("SYqB");
function injectStyle (ssrContext) {
  __webpack_require__("tpqd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Delfbloc_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01b863ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Delfbloc_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "a4f0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadDailyMilkTestReport_vue__ = __webpack_require__("MqDG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee365f00_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadDailyMilkTestReport_vue__ = __webpack_require__("owFT");
function injectStyle (ssrContext) {
  __webpack_require__("wyJp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadDailyMilkTestReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee365f00_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadDailyMilkTestReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "a9Yf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aAG9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__ = __webpack_require__("Qkg6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e81c4f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__ = __webpack_require__("bzSD");
function injectStyle (ssrContext) {
  __webpack_require__("xZNU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e81c4f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aHm/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-loading',{attrs:{"is-full-page":_vm.isFullPage,"active":_vm.isLoading},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"url_valid"}},[_c('div',{staticStyle:{"text-align":"center"}},[_c('b-tabs',{staticClass:"block",attrs:{"position":"is-centered"}},[_c('b-tab-item',{attrs:{"label":"Zones"}},[(_vm.table_load === true)?_c('div',[_c('div',{staticStyle:{"text-align":"center","margin-top":"20px"}},[_c('strong',[_vm._v(_vm._s(_vm.apiDataObj.route)+" ("+_vm._s(_vm.apiDataObj.date)+")")])]),_vm._v(" "),_c('div',{staticClass:"container is-fluid has-text-centered"},_vm._l((_vm.zones),function(zoneData,zone){return _c('div',[_c('b-collapse',{staticClass:"show panel",attrs:{"open":false}},[_c('div',{staticClass:"panel-heading collapseheader",attrs:{"slot":"trigger","role":"button"},slot:"trigger"},[_vm._v("\n                      "+_vm._s(zone)+" ("+_vm._s(zoneData.orders)+")\n                    ")]),_vm._v(" "),_c('table',[_c('tbody',[_c('tr',[_c('th',{staticClass:"is-fluid has-text-centered headercss"},[_vm._v("Products")]),_vm._v(" "),_c('th',{staticClass:"is-fluid has-text-centered headercss"},[_vm._v("Order")]),_vm._v(" "),_c('th',{staticClass:"is-fluid has-text-centered headercss"},[_vm._v("Delivered")])]),_vm._v(" "),_vm._l((zoneData.products),function(product){return _c('tr',[_c('td',[_vm._v(_vm._s(product.product_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(product.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(product.delivered))])])}),_vm._v(" "),_c('tr',[_c('th',{staticClass:"is-fluid has-text-centered footercss"},[_vm._v("Total")]),_vm._v(" "),_c('th',{staticClass:"is-fluid has-text-centered footercss"},[_vm._v(_vm._s(zoneData.total))]),_vm._v(" "),_c('th',{staticClass:"is-fluid has-text-centered footercss"},[_vm._v(_vm._s(zoneData.delivered))])])],2)])])],1)}))]):_vm._e()]),_vm._v(" "),_c('b-tab-item',{attrs:{"label":"Products"}},[(_vm.table_load === true)?_c('div',[_c('div',{staticStyle:{"text-align":"center","margin-top":"20px"}},[_c('strong',[_vm._v(_vm._s(_vm.apiDataObj.route)+" ("+_vm._s(_vm.apiDataObj.date)+")")])]),_vm._v(" "),_c('div',{staticClass:"container is-fluid has-text-centered"},_vm._l((_vm.products),function(product){return _c('div',[_c('b-collapse',{staticClass:"show panel",attrs:{"open":false}},[_c('div',{staticClass:"panel-heading collapseheader",attrs:{"slot":"trigger","role":"button"},slot:"trigger"},[_vm._v("\n                      "+_vm._s(product.prod_name)+"\n                    ")]),_vm._v(" "),_c('table',[_c('tbody',[_c('tr',[_c('th',{staticClass:"is-fluid has-text-centered headercss"},[_vm._v("Dispatcher")]),_vm._v(" "),_c('th',{staticClass:"is-fluid has-text-centered headercss"},[_vm._v("Order")]),_vm._v(" "),_c('th',{staticClass:"is-fluid has-text-centered headercss"},[_vm._v("Delivered")])]),_vm._v(" "),_vm._l((product.order_summary),function(row){return _c('tr',[_c('td',[_vm._v(_vm._s(row.disp_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.order))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.delivered))])])}),_vm._v(" "),_c('tr',[_c('th',{staticClass:"is-fluid has-text-centered footercss"},[_vm._v("Total")]),_vm._v(" "),_c('th',{staticClass:"is-fluid has-text-centered footercss"},[_vm._v(_vm._s(product.orderQuantity))]),_vm._v(" "),_c('th',{staticClass:"is-fluid has-text-centered footercss"},[_vm._v(_vm._s(product.deliveredQuantity))])])],2)])])],1)}))]):_vm._e()])],1)],1)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center","width":"90%"},attrs:{"id":"url_expired"}},[_c('h4',[_vm._v("Welcome to Doodhvale, Please wait...")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aHuc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("100 Awesome Nucleo Icons")]),_vm._v(" "),_c('p',{staticClass:"card-category"},[_vm._v("Handcrafted by our friends from "),_c('a',{attrs:{"target":"_blank","href":"https://nucleoapp.com/?ref=1712"}},[_vm._v("NucleoApp")])])]),_vm._v(" "),_c('div',{staticClass:"all-icons"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-air-baloon"}),_vm._v(" "),_c('p',[_vm._v("nc-air-baloon")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-album-2"}),_vm._v(" "),_c('p',[_vm._v("nc-album-2")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-alien-33"}),_vm._v(" "),_c('p',[_vm._v("nc-alien-33")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-align-center"}),_vm._v(" "),_c('p',[_vm._v("nc-align-center")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-align-left-2"}),_vm._v(" "),_c('p',[_vm._v("nc-align-left-2")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-ambulance"}),_vm._v(" "),_c('p',[_vm._v("nc-ambulance")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-android"}),_vm._v(" "),_c('p',[_vm._v("nc-android")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-app"}),_vm._v(" "),_c('p',[_vm._v("nc-app")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-apple"}),_vm._v(" "),_c('p',[_vm._v("nc-apple")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-atom"}),_vm._v(" "),_c('p',[_vm._v("nc-atom")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-attach-87"}),_vm._v(" "),_c('p',[_vm._v("nc-attach-87")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-audio-92"}),_vm._v(" "),_c('p',[_vm._v("nc-audio-92")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-backpack"}),_vm._v(" "),_c('p',[_vm._v("nc-backpack")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-badge"}),_vm._v(" "),_c('p',[_vm._v("nc-badge")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-bag"}),_vm._v(" "),_c('p',[_vm._v("nc-bag")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-bank"}),_vm._v(" "),_c('p',[_vm._v("nc-bank")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-battery-81"}),_vm._v(" "),_c('p',[_vm._v("nc-battery-81")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-bell-55"}),_vm._v(" "),_c('p',[_vm._v("nc-bell-55")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-bold"}),_vm._v(" "),_c('p',[_vm._v("nc-bold")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-bulb-63"}),_vm._v(" "),_c('p',[_vm._v("nc-bulb-63")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-bullet-list-67"}),_vm._v(" "),_c('p',[_vm._v("nc-bullet-list-67")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-bus-front-12"}),_vm._v(" "),_c('p',[_vm._v("nc-bus-front-12")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-button-pause"}),_vm._v(" "),_c('p',[_vm._v("nc-button-pause")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-button-play"}),_vm._v(" "),_c('p',[_vm._v("nc-button-play")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-button-power"}),_vm._v(" "),_c('p',[_vm._v("nc-button-power")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-camera-20"}),_vm._v(" "),_c('p',[_vm._v("nc-camera-20")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-caps-small"}),_vm._v(" "),_c('p',[_vm._v("nc-caps-small")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-cart-simple"}),_vm._v(" "),_c('p',[_vm._v("nc-cart-simple")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-cctv"}),_vm._v(" "),_c('p',[_vm._v("nc-cctv")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-chart-bar-32"}),_vm._v(" "),_c('p',[_vm._v("nc-chart-bar-32")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-chart-pie-35"}),_vm._v(" "),_c('p',[_vm._v("nc-chart-pie-35")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-chart-pie-36"}),_vm._v(" "),_c('p',[_vm._v("nc-chart-pie-36")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-chart"}),_vm._v(" "),_c('p',[_vm._v("nc-chart")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-chat-round"}),_vm._v(" "),_c('p',[_vm._v("nc-chat-round")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-check-2"}),_vm._v(" "),_c('p',[_vm._v("nc-check-2")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-circle-09"}),_vm._v(" "),_c('p',[_vm._v("nc-circle-09")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-circle"}),_vm._v(" "),_c('p',[_vm._v("nc-circle")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-cloud-download-93"}),_vm._v(" "),_c('p',[_vm._v("nc-cloud-download-93")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-cloud-upload-94"}),_vm._v(" "),_c('p',[_vm._v("nc-cloud-upload-94")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-compass-05"}),_vm._v(" "),_c('p',[_vm._v("nc-compass-05")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-controller-modern"}),_vm._v(" "),_c('p',[_vm._v("nc-controller-modern")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-credit-card"}),_vm._v(" "),_c('p',[_vm._v("nc-credit-card")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-delivery-fast"}),_vm._v(" "),_c('p',[_vm._v("nc-delivery-fast")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-email-83"}),_vm._v(" "),_c('p',[_vm._v("nc-email-83")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-email-85"}),_vm._v(" "),_c('p',[_vm._v("nc-email-85")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-explore-2"}),_vm._v(" "),_c('p',[_vm._v("nc-explore-2")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-fav-remove"}),_vm._v(" "),_c('p',[_vm._v("nc-fav-remove")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-favourite-28"}),_vm._v(" "),_c('p',[_vm._v("nc-favourite-28")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-globe-2"}),_vm._v(" "),_c('p',[_vm._v("nc-globe-2")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-grid-45"}),_vm._v(" "),_c('p',[_vm._v("nc-grid-45")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-headphones-2"}),_vm._v(" "),_c('p',[_vm._v("nc-headphones-2")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-html5"}),_vm._v(" "),_c('p',[_vm._v("nc-html5")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-istanbul"}),_vm._v(" "),_c('p',[_vm._v("nc-istanbul")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-key-25"}),_vm._v(" "),_c('p',[_vm._v("nc-key-25")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-layers-3"}),_vm._v(" "),_c('p',[_vm._v("nc-layers-3")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-light-3"}),_vm._v(" "),_c('p',[_vm._v("nc-light-3")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-lock-circle-open"}),_vm._v(" "),_c('p',[_vm._v("nc-lock-circle-open")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-map-big"}),_vm._v(" "),_c('p',[_vm._v("nc-map-big")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-mobile"}),_vm._v(" "),_c('p',[_vm._v("nc-mobile")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-money-coins"}),_vm._v(" "),_c('p',[_vm._v("nc-money-coins")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-note-03"}),_vm._v(" "),_c('p',[_vm._v("nc-note-03")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-notes"}),_vm._v(" "),_c('p',[_vm._v("nc-notes")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-notification-70"}),_vm._v(" "),_c('p',[_vm._v("nc-notification-70")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-palette"}),_vm._v(" "),_c('p',[_vm._v("nc-palette")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-paper-2"}),_vm._v(" "),_c('p',[_vm._v("nc-paper-2")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-pin-3"}),_vm._v(" "),_c('p',[_vm._v("nc-pin-3")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-planet"}),_vm._v(" "),_c('p',[_vm._v("nc-planet")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-preferences-circle-rotate"}),_vm._v(" "),_c('p',[_vm._v("nc-preferences-circle-rotate")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-puzzle-10"}),_vm._v(" "),_c('p',[_vm._v("nc-puzzle-10")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-quote"}),_vm._v(" "),_c('p',[_vm._v("nc-quote")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-refresh-02"}),_vm._v(" "),_c('p',[_vm._v("nc-refresh-02")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-ruler-pencil"}),_vm._v(" "),_c('p',[_vm._v("nc-ruler-pencil")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-satisfied"}),_vm._v(" "),_c('p',[_vm._v("nc-satisfied")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-scissors"}),_vm._v(" "),_c('p',[_vm._v("nc-scissors")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-send"}),_vm._v(" "),_c('p',[_vm._v("nc-send")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-settings-90"}),_vm._v(" "),_c('p',[_vm._v("nc-settings-90")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-settings-gear-64"}),_vm._v(" "),_c('p',[_vm._v("nc-settings-gear-64")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-settings-tool-66"}),_vm._v(" "),_c('p',[_vm._v("nc-settings-tool-66")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-simple-add"}),_vm._v(" "),_c('p',[_vm._v("nc-simple-add")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-simple-delete"}),_vm._v(" "),_c('p',[_vm._v("nc-simple-delete")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-simple-remove"}),_vm._v(" "),_c('p',[_vm._v("nc-simple-remove")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-single-02"}),_vm._v(" "),_c('p',[_vm._v("nc-single-02")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-single-copy-04"}),_vm._v(" "),_c('p',[_vm._v("nc-single-copy-04")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-spaceship"}),_vm._v(" "),_c('p',[_vm._v("nc-spaceship")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-square-pin"}),_vm._v(" "),_c('p',[_vm._v("nc-square-pin")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-stre-down"}),_vm._v(" "),_c('p',[_vm._v("nc-stre-down")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-stre-left"}),_vm._v(" "),_c('p',[_vm._v("nc-stre-left")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-stre-right"}),_vm._v(" "),_c('p',[_vm._v("nc-stre-right")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-stre-up"}),_vm._v(" "),_c('p',[_vm._v("nc-stre-up")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-sun-fog-29"}),_vm._v(" "),_c('p',[_vm._v("nc-sun-fog-29")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-support-17"}),_vm._v(" "),_c('p',[_vm._v("nc-support-17")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-tablet-2"}),_vm._v(" "),_c('p',[_vm._v("nc-tablet-2")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-tag-content"}),_vm._v(" "),_c('p',[_vm._v("nc-tag-content")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-tap-01"}),_vm._v(" "),_c('p',[_vm._v("nc-tap-01")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-time-alarm"}),_vm._v(" "),_c('p',[_vm._v("nc-time-alarm")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-tv-2"}),_vm._v(" "),_c('p',[_vm._v("nc-tv-2")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-umbrella-13"}),_vm._v(" "),_c('p',[_vm._v("nc-umbrella-13")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-vector"}),_vm._v(" "),_c('p',[_vm._v("nc-vector")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-watch-time"}),_vm._v(" "),_c('p',[_vm._v("nc-watch-time")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-zoom-split"}),_vm._v(" "),_c('p',[_vm._v("nc-zoom-split")])])])])])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ahUB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Refund_vue__ = __webpack_require__("rYNy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a07a447_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Refund_vue__ = __webpack_require__("saWt");
function injectStyle (ssrContext) {
  __webpack_require__("lW6Z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Refund_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a07a447_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Refund_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "b1fl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__List_ListOfProducts__ = __webpack_require__("7QIX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
//
//
//
//
//
//
//
//
//
//
//
//

// import { mapGetters } from 'vuex'


// import Vue from 'vue'

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      getAllProducts: [],
      getFilteredProducts: [],
      urlInterface: [],
      apiDataObj: [],
      isFullPage: true,
      isLoading: true,
      urlValid: false,
      userId: 0
    };
  },
  created: function created() {
    if (sessionStorage.getItem('promocodeName') !== null) {
      sessionStorage.removeItem('promocodeName');
      sessionStorage.removeItem('directLinkOfferedDiscount');
    }
    sessionStorage.removeItem('ringOnSelected');
    sessionStorage.removeItem('nice_to_have_req');
    sessionStorage.removeItem('subPaymentMode');
    sessionStorage.removeItem('subDate');
    sessionStorage.removeItem('scheduleText');
    sessionStorage.removeItem('isPostpaidDisabled');
    sessionStorage.removeItem('promoCodeVerified');
    sessionStorage.removeItem('promocodeText');
    sessionStorage.removeItem('prodQuantity');
    sessionStorage.removeItem('prodBaseQuantity');
    sessionStorage.removeItem('alternate');
    sessionStorage.removeItem('monQty');
    sessionStorage.removeItem('tueQty');
    sessionStorage.removeItem('wedQty');
    sessionStorage.removeItem('thuQty');
    sessionStorage.removeItem('friQty');
    sessionStorage.removeItem('satQty');
    sessionStorage.removeItem('sunQty');
    this.fetchData();
  },

  components: {
    listOfProducts: __WEBPACK_IMPORTED_MODULE_0__List_ListOfProducts__["a" /* default */]
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;

      var params = new URLSearchParams();
      var fullUrl = document.URL;
      var splitUrl = fullUrl.split('productList?');
      params.append('url_str', splitUrl[1]);
      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/accounts/fetch-url-interface-data',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this.urlInterface = {};
        if (response.data.status === '000001' || response.data.status === '000002' || response.data.status === '000003') {
          _this.urlInterface.error_msg = response.data.msg;
          _this.urlValid = false;
        } else {
          // this.urlValid = true
          _this.urlInterface.action_name = response.data.action_name;
          _this.urlInterface.url_interface_id = response.data.url_interface_id;
          _this.invokeUrlAction();
        }
        _this.isLoading = false;
        // console.log(response)
      }).catch(function (e) {
        alert('not ok');
      });
    },
    invokeUrlAction: function invokeUrlAction() {
      var _this2 = this;

      var params = new URLSearchParams();
      params.append('url_interface_id', this.urlInterface.url_interface_id);
      params.append('action_name', this.urlInterface.action_name);
      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/accounts/invoke-url-action',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        // console.log(response)
        _this2.apiDataObj = {};
        switch (_this2.urlInterface.action_name) {
          case 'product_list':
            _this2.userId = response.data.action_response.user_id;
            _this2.getProductList();
            break;
          default:
            break;
        }
        _this2.isLoading = false;
      }).catch(function (e) {
        alert('not ok');
      });
    },
    getProductList: function getProductList() {
      var _this3 = this;

      var params = new URLSearchParams();
      sessionStorage.setItem('userId', this.userId);
      // var userId = sessionStorage.getItem('userId')
      var userId = this.userId;
      params.append('user_id', userId);
      params.append('cat_id', 2);
      params.append('device_type', 'web_view');
      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/products/product-list',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        if (response.data.msg.trim().toUpperCase() === 'SUCCESS') {
          _this3.getAllProducts = response.data.product_list;
          _this3.getFilteredProducts = _this3.getAllProducts.filter(function (p) {
            return p.subscription_type !== 'One Time';
          });
          _this3.urlValid = true;
        }
      }).catch(function (e) {
        alert('Some Error Occured');
      });
    }
  }
});

/***/ }),

/***/ "b4Vd":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "bwpC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Content_vue__ = __webpack_require__("VnhA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20ea8e9e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Content_vue__ = __webpack_require__("FGMu");
function injectStyle (ssrContext) {
  __webpack_require__("GjBJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Content_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20ea8e9e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Content_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bzSD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table"},[_c('thead',[_vm._t("columns",_vm._l((_vm.columns),function(column){return _c('th',[_vm._v(_vm._s(column))])}))],2),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',[_vm._t("default",_vm._l((_vm.columns),function(column){return (_vm.hasValue(item, column))?_c('td',[_vm._v(_vm._s(_vm.itemValue(item, column)))]):_vm._e()}),{row:item})],2)}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "c919":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_date_pick__ = __webpack_require__("AA8V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_date_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_date_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_date_pick_dist_vueDatePick_css__ = __webpack_require__("DQ9D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_date_pick_dist_vueDatePick_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_date_pick_dist_vueDatePick_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { DatePick: __WEBPACK_IMPORTED_MODULE_1_vue_date_pick___default.a },
  data: function data() {
    return {
      prepaidProductPriceObj: [],
      promoVerifyObj: [],
      subscriptionVerificationObj: [],
      userId: 0,
      productId: 0,
      subscriptionId: 0,
      productName: "",
      productImageUrl: "",
      subscriptionType: "",
      subscriptionTypeDaily: false,
      subscriptionTypeBoth: false,
      subscriptionTypeOneTime: false,
      alternateDisplay: false,
      customizeDisplay: false,
      productShortDescription: "",
      productLongDescription: "",
      isEditSubscription: true,
      brandName: "",
      subDate: "2019-08-27",
      quantityValue: 1,
      maxQuantity: 5,
      selectedAlternate: 2,
      selectedDayId: "sun",
      alternateOptions: [{
        value: "2",
        text: "Every 2nd Day"
      }, {
        value: "3",
        text: "Every 3rd Day"
      }, {
        value: "4",
        text: "Every 4th Day"
      }],
      sunQty: 1,
      monQty: 1,
      tueQty: 1,
      wedQty: 1,
      thuQty: 1,
      friQty: 1,
      satQty: 1,
      fillSunColor: false,
      closePromo: true,
      closeNiceTohave: true,
      isFullPage: true,
      isLoading: true,
      subPaymentMode: "Prepaid",
      promocodeText: "",
      nicetohavereqText: "",
      prepaidCheckbox: true,
      postpaidCheckbox: false,
      everydayCheckbox: true,
      customizeCheckbox: false,
      alternateCheckbox: false,
      onetimeCheckbox: false,
      descAngleDown: true,
      ringOnNotSelected: false,
      ringOnSelected: true,
      ringOffNotSelected: true,
      ringOffSelected: false,
      isPostpaidDisabled: false,
      promoCodeSuccess: false,
      promoCodeFailed: false,
      promoCodeVerifyMsg: "",
      promoCodeVerified: false,
      promoCodeVerifiedDirectLink: false,
      productPriceId: 0,
      displayPromocodeText: "",
      displayedDate: "",
      directLinkOfferedDiscount: 0,
      cutPrice: false
    };
  },
  created: function created() {
    // sessionStorage.setItem('paymentFlow', 'productList')
    this.fetchData();
  },

  methods: {
    fetchData: function fetchData() {
      var _this = this;

      this.userId = sessionStorage.getItem("userId");
      this.productId = sessionStorage.getItem("productId");
      this.productName = sessionStorage.getItem("productName");
      this.productImageUrl = sessionStorage.getItem("productImageUrl");
      this.productShortDescription = sessionStorage.getItem("productShortDescription");
      this.productLongDescription = sessionStorage.getItem("productLongDescription");
      this.brandName = sessionStorage.getItem("brandName");
      this.isEditSub = sessionStorage.getItem("isEditSubscription");
      if (this.isEditSub === "yes") {
        this.isEditSubscription = true;
      } else {
        this.isEditSubscription = false;
      }
      this.subscriptionId = sessionStorage.getItem("subscriptionId");
      this.subscriptionType = sessionStorage.getItem("subscriptionType");
      this.subscriptionTypeDaily = false;
      this.subscriptionTypeBoth = false;
      this.subscriptionTypeOneTime = false;
      if (this.subscriptionType === "Daily") {
        this.subscriptionTypeDaily = true;
      } else if (this.subscriptionType === "Both") {
        this.subscriptionTypeBoth = true;
      } else {
        this.subscriptionTypeOneTime = true;
      }
      var params = new URLSearchParams();
      params.append("user_id", this.userId);
      params.append("product_id", this.productId);
      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + "/subscriptions/prepaid-product-price",
        method: "post",
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        // console.log(response)
        // debugger
        _this.prepaidProductPriceObj = {};
        _this.prepaidProductPriceObj.pincode = response.data.pincode;
        _this.prepaidProductPriceObj.postpaidPrice = response.data.postpaid_price;
        _this.prepaidProductPriceObj.prepaidPrice = response.data.prepaid_price;
        _this.prepaidProductPriceObj.postpaidPrice = parseFloat(Math.round(_this.prepaidProductPriceObj.postpaidPrice * 100) / 100).toFixed(2);
        _this.prepaidProductPriceObj.prepaidPrice = parseFloat(Math.round(_this.prepaidProductPriceObj.prepaidPrice * 100) / 100).toFixed(2);
        _this.prepaidProductPriceObj.flat_discount_mrp_applicable = response.data.flat_discount_mrp_applicable;
        _this.prepaidProductPriceObj.prodQuantity = response.data.quantity;
        _this.prepaidProductPriceObj.prodUnit = response.data.unit;
        sessionStorage.setItem("prodBaseQuantity", _this.prepaidProductPriceObj.prodQuantity);
        sessionStorage.setItem("prodUnit", _this.prepaidProductPriceObj.prodUnit);
        _this.prepaidProductPriceObj.subStartDate = response.data.sub_start_date;
        _this.maxQuantity = response.data.prod_max_order_quantity;
        if (sessionStorage.getItem("subDate")) {
          _this.subDate = sessionStorage.getItem("subDate");
        } else {
          _this.subDate = _this.prepaidProductPriceObj.subStartDate;
        }
        if (sessionStorage.getItem("subPaymentMode")) {
          _this.subPaymentMode = sessionStorage.getItem("subPaymentMode");
        } else {
          _this.subPaymentMode = response.data.default_subscription;
        }
        if (sessionStorage.getItem("prodQuantity")) {
          _this.quantityValue = sessionStorage.getItem("prodQuantity");
        } else {
          _this.quantityValue = _this.prepaidProductPriceObj.prodQuantity;
        }
        _this.productPriceId = response.data.product_price_id;
        if (sessionStorage.getItem("ringOnSelected") === "true") {
          _this.ringOnNotSelected = false;
          _this.ringOnSelected = true;
          _this.ringOffNotSelected = true;
          _this.ringOffSelected = false;
        } else if (response.data.bell_status === 0 || sessionStorage.getItem("ringOnSelected") === "false") {
          _this.ringOnNotSelected = true;
          _this.ringOnSelected = false;
          _this.ringOffNotSelected = false;
          _this.ringOffSelected = true;
        } else {}
        if (sessionStorage.getItem("nice_to_have_req")) {
          _this.nicetohavereqText = sessionStorage.getItem("nice_to_have_req");
          _this.closeNiceTohave = false;
        } else {
          _this.nicetohavereqText = response.data.nice_to_have_req;
        }
        /* if (this.nicetohavereqText !== '') {
          this.closeNiceTohave = false
        } */
        /* let postpaidDisabled = response.data.is_postpaid_disabled
        if (postpaidDisabled === 1) {
          this.isPostpaidDisabled = true
        } else {
          this.isPostpaidDisabled = false
        } */
        switch (sessionStorage.getItem("scheduleText")) {
          case "Everyday":
            _this.everydayCheckbox = true;
            _this.customizeCheckbox = false;
            _this.alternateCheckbox = false;
            break;
          case "Customize":
            _this.everydayCheckbox = false;
            _this.customizeCheckbox = true;
            _this.customizeDisplay = true;
            _this.alternateCheckbox = false;
            if (sessionStorage.getItem("monQty")) {
              _this.monQty = sessionStorage.getItem("monQty");
            }
            if (sessionStorage.getItem("tueQty")) {
              _this.tueQty = sessionStorage.getItem("tueQty");
            }
            if (sessionStorage.getItem("wedQty")) {
              _this.wedQty = sessionStorage.getItem("wedQty");
            }
            if (sessionStorage.getItem("thuQty")) {
              _this.thuQty = sessionStorage.getItem("thuQty");
            }
            if (sessionStorage.getItem("friQty")) {
              _this.friQty = sessionStorage.getItem("friQty");
            }
            if (sessionStorage.getItem("satQty")) {
              _this.satQty = sessionStorage.getItem("satQty");
            }
            if (sessionStorage.getItem("sunQty")) {
              _this.sunQty = sessionStorage.getItem("sunQty");
            }
            break;
          case "Alternate":
            _this.everydayCheckbox = false;
            _this.customizeCheckbox = false;
            _this.alternateCheckbox = true;
            _this.alternateDisplay = true;
            _this.selectedAlternate = sessionStorage.getItem("alternate");
            break;
          default:
            if (_this.subscriptionTypeOneTime === false) {
              document.getElementById("everydayid").checked = true;
            } else {
              _this.everydayCheckbox = false;
              _this.customizeCheckbox = false;
              _this.alternateCheckbox = false;
            }
            break;
        }
        if (_this.subPaymentMode === "Prepaid") {
          _this.prepaidCheckbox = true;
          _this.postpaidCheckbox = false;
        } else {
          _this.prepaidCheckbox = false;
          _this.postpaidCheckbox = true;
        }
        // alert(this.isEditSubscription)
        if (_this.isEditSubscription === true) {
          _this.editSubscription();
        } else {
          if (_this.productId === "128" || _this.productId === "129" || _this.productId === 128 || _this.productId === 129 || _this.productId === "151" || _this.productId === 151) {
            _this.quantityValue = 2;
          }
          _this.isLoading = false;
        }
        var postpaidDisabled = response.data.is_postpaid_disabled;
        if (postpaidDisabled === 1) {
          _this.isPostpaidDisabled = true;
          _this.prepaidCheckbox = true;
          _this.postpaidCheckbox = false;
          _this.subPaymentMode = "Prepaid";
        } else {
          _this.isPostpaidDisabled = false;
        }
        // debugger
        if (sessionStorage.getItem("promocodeName") !== null) {
          _this.promocodeText = sessionStorage.getItem("promocodeName");
          _this.displayPromocodeText = sessionStorage.getItem("promocodeDesc");
          _this.promoCodeVerified = true;
          _this.promoCodeVerifiedDirectLink = true;
          if (sessionStorage.getItem("directLinkOfferedDiscount") > 0) {
            _this.directLinkOfferedDiscount = parseFloat(sessionStorage.getItem("directLinkOfferedDiscount"));
            _this.directLinkOfferedDiscount = _this.directLinkOfferedDiscount.toFixed(2);
            _this.cutPrice = true;
          }
        } else if (response.data.flat_discount_mrp_applicable === true) {
          _this.cutPrice = true;
          _this.prepaidProductPriceObj.postpaid_price_without_offer = response.data.postpaid_price_without_offer;
          _this.prepaidProductPriceObj.prepaid_price_without_offer = response.data.prepaid_price_without_offer;
          _this.prepaidProductPriceObj.postpaid_price_without_offer = parseFloat(Math.round(_this.prepaidProductPriceObj.postpaid_price_without_offer * 100) / 100).toFixed(2);
          _this.prepaidProductPriceObj.prepaid_price_without_offer = parseFloat(Math.round(_this.prepaidProductPriceObj.prepaid_price_without_offer * 100) / 100).toFixed(2);
        }

        // console.log(this.directLinkOfferedDiscount)
        // this.isLoading = false
        /* if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          this.list = response.data.user_record
          alert(this.list)
        } */
      }).catch(function (e) {
        alert("not ok");
      });
    },
    isServicePincode: function isServicePincode() {
      var _this2 = this;

      if (sessionStorage.getItem("dispatcherId") !== null) {
        this.subscriptionVerification();
      } else {
        var params = new URLSearchParams();
        params.append("user_id", this.userId);
        params.append("pincode", this.prepaidProductPriceObj.pincode);
        __WEBPACK_IMPORTED_MODULE_3_axios___default()({
          url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + "/subscriptions/is-service-pincode",
          method: "post",
          data: params,
          withCredentials: false,
          headers: {}
        }).then(function (response) {
          var str = response.data.msg;
          if (response.data.status === "000000") {
            _this2.subscriptionVerification();
          } else {
            _this2.$swal({
              text: str,
              showCancelButton: true,
              confirmButtonText: "Update Address",
              cancelButtonText: "Cancel"
              // showCloseButton: true,
              // showLoaderOnConfirm: true
            }).then(function (result) {
              if (result.value) {
                _this2.locationModule();
              } else {
                // nothing
              }
            });
          }
        }).catch(function (e) {
          alert("not ok");
        });
      }
    },
    locationModule: function locationModule() {
      // alert('location')
      sessionStorage.setItem("userId", this.userId);
      sessionStorage.setItem("isProfile", 1);
      sessionStorage.setItem("actionName", "subscription");
      sessionStorage.setItem("callbackUrlForSubscription", document.URL);
      sessionStorage.setItem("locationAction", "getOldLocation");
      this.$router.push("/a/location");
    },
    editSubscription: function editSubscription() {
      var _this3 = this;

      var params = new URLSearchParams();
      params.append("subscription_id", this.subscriptionId);
      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + "/subscriptions/edit-subscription",
        method: "post",
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        // debugger
        // console.log(response)
        // this.subPaymentMode = response.data.edit_subscription.subscription_type
        _this3.subDate = response.data.edit_subscription.start_date;
        _this3.displayedDate = _this3.subDate.split("-").reverse().join("-");
        // alert(this.subPaymentMode)
        if (sessionStorage.getItem("subPaymentMode")) {
          _this3.subPaymentMode = sessionStorage.getItem("subPaymentMode");
        } else {
          _this3.subPaymentMode = response.data.edit_subscription.subscription_type;
        }
        if (sessionStorage.getItem("ringOnSelected") === "true") {
          _this3.ringOnNotSelected = false;
          _this3.ringOnSelected = true;
          _this3.ringOffNotSelected = true;
          _this3.ringOffSelected = false;
        } else if (response.data.edit_subscription.bell_status === 0 || sessionStorage.getItem("ringOnSelected") === "false") {
          _this3.ringOnNotSelected = true;
          _this3.ringOnSelected = false;
          _this3.ringOffNotSelected = false;
          _this3.ringOffSelected = true;
        } else {}
        if (sessionStorage.getItem("nice_to_have_req")) {
          _this3.nicetohavereqText = sessionStorage.getItem("nice_to_have_req");
          _this3.closeNiceTohave = false;
        } else {
          _this3.nicetohavereqText = response.data.edit_subscription.nice_to_have_req;
        }
        if (_this3.nicetohavereqText !== "") {
          _this3.closeNiceTohave = false;
        }
        if (_this3.subPaymentMode === "Prepaid") {
          _this3.prepaidCheckbox = true;
          _this3.postpaidCheckbox = false;
        } else {
          _this3.prepaidCheckbox = false;
          _this3.postpaidCheckbox = true;
        }

        if (response.data.edit_subscription["promo-status"] === "Valid") {
          _this3.displayPromocodeText = "*Promo code discount Rs " + response.data.edit_subscription["offer-amount"].toFixed(2) + "/- expire on " + response.data.edit_subscription.expire_date + ".";
        }
        if (response.data.edit_subscription["promo-status"] === "Expired") {
          _this3.displayPromocodeText = "*Your promo code expired on " + response.data.edit_subscription.expire_date + ".";
        }
        /* this.subscriptionTypeBoth = false
        this.subscriptionTypeOneTime = false
        // alert(response.data.edit_subscription.type)
        if (response.data.edit_subscription.type === 'Daily') {
          this.subscriptionTypeBoth = true
        } else {
          this.subscriptionTypeOneTime = true
        } */
        /* this.subscriptionTypeDaily = false
        this.subscriptionTypeBoth = false
        this.subscriptionTypeOneTime = false
        if (response.data.edit_subscription.type === 'Daily') {
          this.subscriptionTypeDaily = true
        } else if (response.data.edit_subscription.type === 'Both') {
          this.subscriptionTypeBoth = true
        } else {
          this.subscriptionTypeOneTime = true
        } */
        if (_this3.subscriptionTypeOneTime === false) {
          document.getElementById("everydayid").checked = true;
        } else {
          _this3.everydayCheckbox = false;
          _this3.customizeCheckbox = false;
          _this3.alternateCheckbox = false;
        }
        _this3.everydayCheckbox = false;
        _this3.customizeCheckbox = false;
        _this3.alternateCheckbox = false;
        _this3.onetimeCheckbox = false;
        if (response.data.edit_subscription.delivery_frequency === "3" && response.data.edit_subscription.type === "Daily") {
          _this3.everydayCheckbox = true;
          _this3.quantityValue = response.data.edit_subscription.quantity;
        } else if (response.data.edit_subscription.delivery_frequency === "1") {
          _this3.customizeCheckbox = true;
          _this3.customizeDisplay = true;
          _this3.sunQty = response.data.edit_subscription.sunday;
          _this3.monQty = response.data.edit_subscription.monday;
          _this3.tueQty = response.data.edit_subscription.tuesday;
          _this3.wedQty = response.data.edit_subscription.wednesday;
          _this3.thuQty = response.data.edit_subscription.thursday;
          _this3.friQty = response.data.edit_subscription.friday;
          _this3.satQty = response.data.edit_subscription.saturday;
          _this3.selectedDayId = "sun";
          _this3.quantityValue = _this3.sunQty;
          _this3.fillSunColor = true;
          if (document.getElementById("sun")) {
            document.getElementById("sun").style.backgroundColor = "white";
            document.getElementById("mon").style.backgroundColor = "white";
            document.getElementById("tue").style.backgroundColor = "white";
            document.getElementById("wed").style.backgroundColor = "white";
            document.getElementById("thu").style.backgroundColor = "white";
            document.getElementById("fri").style.backgroundColor = "white";
            document.getElementById("sat").style.backgroundColor = "white";
            document.getElementById("sun").style.color = "#5e5a57";
            document.getElementById("mon").style.color = "#5e5a57";
            document.getElementById("tue").style.color = "#5e5a57";
            document.getElementById("wed").style.color = "#5e5a57";
            document.getElementById("thu").style.color = "#5e5a57";
            document.getElementById("fri").style.color = "#5e5a57";
            document.getElementById("sat").style.color = "#5e5a57";
            document.getElementById("sun").style.backgroundColor = "#3CB6C3";
            document.getElementById("sun").style.color = "white";
          }
        } else if (response.data.edit_subscription.delivery_frequency === "2") {
          _this3.alternateDisplay = true;
          _this3.alternateCheckbox = true;
          _this3.quantityValue = response.data.edit_subscription.quantity;
          _this3.selectedAlternate = response.data.edit_subscription.alternate;
        } else {
          _this3.onetimeCheckbox = true;
          _this3.quantityValue = response.data.edit_subscription.quantity;
        }
        switch (sessionStorage.getItem("scheduleText")) {
          case "Everyday":
            _this3.everydayCheckbox = true;
            _this3.customizeCheckbox = false;
            _this3.alternateCheckbox = false;
            break;
          case "Customize":
            _this3.everydayCheckbox = false;
            _this3.customizeCheckbox = true;
            _this3.customizeDisplay = true;
            _this3.alternateCheckbox = false;
            if (sessionStorage.getItem("monQty")) {
              _this3.monQty = sessionStorage.getItem("monQty");
            }
            if (sessionStorage.getItem("tueQty")) {
              _this3.tueQty = sessionStorage.getItem("tueQty");
            }
            if (sessionStorage.getItem("wedQty")) {
              _this3.wedQty = sessionStorage.getItem("wedQty");
            }
            if (sessionStorage.getItem("thuQty")) {
              _this3.thuQty = sessionStorage.getItem("thuQty");
            }
            if (sessionStorage.getItem("friQty")) {
              _this3.friQty = sessionStorage.getItem("friQty");
            }
            if (sessionStorage.getItem("satQty")) {
              _this3.satQty = sessionStorage.getItem("satQty");
            }
            if (sessionStorage.getItem("sunQty")) {
              _this3.sunQty = sessionStorage.getItem("sunQty");
            }
            break;
          case "Alternate":
            _this3.everydayCheckbox = false;
            _this3.customizeCheckbox = false;
            _this3.alternateCheckbox = true;
            _this3.alternateDisplay = true;
            _this3.selectedAlternate = sessionStorage.getItem("alternate");
            break;
          default:
            if (_this3.subscriptionTypeOneTime === false) {
              document.getElementById("everydayid").checked = true;
            } else {
              _this3.everydayCheckbox = false;
              _this3.customizeCheckbox = false;
              _this3.alternateCheckbox = false;
            }
            break;
        }
        if (sessionStorage.getItem("prodQuantity")) {
          _this3.quantityValue = sessionStorage.getItem("prodQuantity");
        } else {
          _this3.quantityValue = response.data.edit_subscription.quantity;
        }
        _this3.isLoading = false;
      }).catch(function (e) {
        alert("not ok");
      });
    },
    paymentMode: function paymentMode(event) {
      var checkId = event.srcElement.offsetParent.id;
      // console.log(checkId)
      this.prepaidCheckbox = false;
      this.postpaidCheckbox = false;
      if (checkId === "prepaidB") {
        this.prepaidCheckbox = true;
        this.subPaymentMode = "Prepaid";
      } else {
        this.postpaidCheckbox = true;
        this.subPaymentMode = "Postpaid";
      }
    },
    descriptionClick: function descriptionClick(event) {
      if (this.descAngleDown === true) {
        this.descAngleDown = false;
      } else {
        this.descAngleDown = true;
      }
    },
    checkPromoValid: function checkPromoValid() {
      var _this4 = this;

      // debugger
      if (this.promocodeText !== "") {
        var params = new URLSearchParams();
        params.append("user_id", this.userId);
        params.append("product_id", this.productId);
        params.append("promo_code", this.promocodeText);
        __WEBPACK_IMPORTED_MODULE_3_axios___default()({
          url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + "/subscriptions/promo-verify",
          method: "post",
          data: params,
          withCredentials: false,
          headers: {}
        }).then(function (response) {
          // console.log(response)
          _this4.promoVerifyObj = {};
          if (response.data.status === "000000") {
            _this4.promoCodeSuccess = true;
            _this4.promoCodeFailed = false;
            _this4.promoCodeVerified = true;
          } else {
            _this4.promoCodeFailed = true;
            _this4.promoCodeSuccess = false;
          }
          _this4.promoCodeVerifyMsg = response.data.msg;
          // console.log(response)
          _this4.isLoading = false;
          /* if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
            this.list = response.data.user_record
            alert(this.list)
          } */
        }).catch(function (e) {
          alert("not ok");
        });
      }
    },
    schedulePlan: function schedulePlan(event) {
      this.quantityValue = 1;
      this.fillSunColor = false;
      this.alternateDisplay = false;
      this.customizeDisplay = false;
      var checkId = event.srcElement.offsetParent.id;
      // console.log(checkId)
      this.everydayCheckbox = false;
      this.customizeCheckbox = false;
      this.alternateCheckbox = false;
      this.onetimeCheckbox = false;
      if (checkId === "everydayid") {
        this.everydayCheckbox = true;
      } else if (checkId === "customizeid") {
        this.customizeCheckbox = true;
        this.customizeDisplay = true;
        this.sunQty = 1;
        this.monQty = 1;
        this.tueQty = 1;
        this.wedQty = 1;
        this.thuQty = 1;
        this.friQty = 1;
        this.satQty = 1;
        this.selectedDayId = "sun";
        // this.quantityValue = this.sunQty
        this.fillSunColor = true;
        if (document.getElementById("sun")) {
          document.getElementById("sun").style.backgroundColor = "white";
          document.getElementById("mon").style.backgroundColor = "white";
          document.getElementById("tue").style.backgroundColor = "white";
          document.getElementById("wed").style.backgroundColor = "white";
          document.getElementById("thu").style.backgroundColor = "white";
          document.getElementById("fri").style.backgroundColor = "white";
          document.getElementById("sat").style.backgroundColor = "white";
          document.getElementById("sun").style.color = "#5e5a57";
          document.getElementById("mon").style.color = "#5e5a57";
          document.getElementById("tue").style.color = "#5e5a57";
          document.getElementById("wed").style.color = "#5e5a57";
          document.getElementById("thu").style.color = "#5e5a57";
          document.getElementById("fri").style.color = "#5e5a57";
          document.getElementById("sat").style.color = "#5e5a57";
          document.getElementById("sun").style.backgroundColor = "#3CB6C3";
          document.getElementById("sun").style.color = "white";
        }
      } else if (checkId === "alternateid") {
        this.alternateDisplay = true;
        this.alternateCheckbox = true;
      } else {
        this.onetimeCheckbox = true;
      }
    },
    customizeDivColor: function customizeDivColor(event) {
      // console.log(event.toElement.id)
      document.getElementById("sun").style.backgroundColor = "white";
      document.getElementById("mon").style.backgroundColor = "white";
      document.getElementById("tue").style.backgroundColor = "white";
      document.getElementById("wed").style.backgroundColor = "white";
      document.getElementById("thu").style.backgroundColor = "white";
      document.getElementById("fri").style.backgroundColor = "white";
      document.getElementById("sat").style.backgroundColor = "white";
      document.getElementById("sun").style.color = "#5e5a57";
      document.getElementById("mon").style.color = "#5e5a57";
      document.getElementById("tue").style.color = "#5e5a57";
      document.getElementById("wed").style.color = "#5e5a57";
      document.getElementById("thu").style.color = "#5e5a57";
      document.getElementById("fri").style.color = "#5e5a57";
      document.getElementById("sat").style.color = "#5e5a57";
      var dayId = event.target.id;
      document.getElementById(dayId).style.backgroundColor = "#3CB6C3";
      document.getElementById(dayId).style.color = "white";
      if (dayId === "sun") {
        this.quantityValue = this.sunQty;
      } else if (dayId === "mon") {
        this.quantityValue = this.monQty;
      } else if (dayId === "tue") {
        this.quantityValue = this.tueQty;
      } else if (dayId === "wed") {
        this.quantityValue = this.wedQty;
      } else if (dayId === "thu") {
        this.quantityValue = this.thuQty;
      } else if (dayId === "fri") {
        this.quantityValue = this.friQty;
      } else {
        this.quantityValue = this.satQty;
      }
      this.selectedDayId = dayId;
    },
    promocode: function promocode(event) {
      var promoId = event.target.id;
      console.log(promoId);
      if (promoId === "closePromocode" || promoId === "closePromocode1") {
        this.closePromo = false;
      } else {
        this.closePromo = true;
        this.promoCodeSuccess = false;
        this.promoCodeFailed = false;
        this.promocodeText = "";
        this.promoCodeVerified = false;
      }
    },
    nicetohavereq: function nicetohavereq(event) {
      var nicetohaveId = event.target.id;
      if (nicetohaveId === "closeNiceToHaveRequest" || nicetohaveId === "closeNiceToHaveRequest1") {
        this.closeNiceTohave = false;
      } else {
        this.closeNiceTohave = true;
      }
    },
    bellStatusChange: function bellStatusChange(event) {
      this.ringOnNotSelected = false;
      this.ringOnSelected = false;
      this.ringOffNotSelected = false;
      this.ringOffSelected = false;
      var bellId = event.target.id;
      // console.log(event)
      if (bellId === "ring_on_not_selected") {
        this.ringOnNotSelected = false;
        this.ringOnSelected = true;
        this.ringOffNotSelected = true;
        this.ringOffSelected = false;
      } else if (bellId === "ring_on_selected") {
        this.ringOnNotSelected = false;
        this.ringOnSelected = true;
        this.ringOffNotSelected = true;
        this.ringOffSelected = false;
      } else if (bellId === "ring_on_not_selected") {
        this.ringOnNotSelected = true;
        this.ringOnSelected = false;
        this.ringOffNotSelected = false;
        this.ringOffSelected = true;
      } else {
        this.ringOnNotSelected = true;
        this.ringOnSelected = false;
        this.ringOffNotSelected = false;
        this.ringOffSelected = true;
      }
    },
    changeQuantity: function changeQuantity(newValue) {
      // console.productLongDescriptiong(newValue)
      if (this.customizeDisplay === true) {
        // this.sunQty = newValue
        if (this.selectedDayId === "sun") {
          this.sunQty = newValue;
        } else if (this.selectedDayId === "mon") {
          this.monQty = newValue;
        } else if (this.selectedDayId === "tue") {
          this.tueQty = newValue;
        } else if (this.selectedDayId === "wed") {
          this.wedQty = newValue;
        } else if (this.selectedDayId === "thu") {
          this.thuQty = newValue;
        } else if (this.selectedDayId === "fri") {
          this.friQty = newValue;
        } else {
          this.satQty = newValue;
        }
        // this.selectedDayId = dayId
      }
    },
    subscriptionVerification: function subscriptionVerification() {
      var _this5 = this;

      /* alert('user_id' + this.userId)
      alert('product_id' + this.productId)
      alert('start_date' + this.subDate)
      alert('subscription_type' + this.subPaymentMode)
      alert('quantity' + this.quantityValue) */
      /* alert('everydayCheckbox' + this.everydayCheckbox)
      alert('customizeCheckbox' + this.customizeCheckbox)
      alert('alternateCheckbox' + this.alternateCheckbox) */
      if (this.customizeCheckbox === true && this.monQty === 0 && this.tueQty === 0 && this.wedQty === 0 && this.thuQty === 0 && this.friQty === 0 && this.satQty === 0 && this.sunQty === 0) {
        this.$toast.open({
          message: "Please enter quantity for atleast one day",
          type: "error"
        });
        // this.$swal.fire({text: 'Please enter quantity for atleast one day'})
      } else if (this.everydayCheckbox === true && this.alternateCheckbox === true && this.quantityValue < 1) {
        this.$toast.open({
          message: "Please enter quantity for atleast one day",
          type: "error"
        });
      } else {
        var params = new URLSearchParams();
        if (this.isEditSubscription === true) {
          params.append("isUpdate", 1);
          params.append("subscription_id", this.subscriptionId);
        }
        params.append("user_id", this.userId);
        params.append("product_id", this.productId);
        params.append("start_date", this.subDate);
        params.append("subscription_type", this.subPaymentMode);
        sessionStorage.setItem("subPaymentMode", this.subPaymentMode);
        sessionStorage.setItem("subDate", this.subDate);
        params.append("product_price_id", this.productPriceId);
        if (this.ringOnSelected === true) {
          params.append("is_ring_bell", 1);
        } else {
          params.append("is_ring_bell", 0);
        }
        sessionStorage.setItem("ringOnSelected", this.ringOnSelected);
        params.append("nice_to_have_req", this.nicetohavereqText);
        sessionStorage.setItem("nice_to_have_req", this.nicetohavereqText);
        if (this.everydayCheckbox === true) {
          sessionStorage.setItem("scheduleText", "Everyday");
          params.append("type", "Daily");
          params.append("delivery_frequency", 3);
          params.append("quantity", this.quantityValue);
        } else if (this.customizeCheckbox === true) {
          sessionStorage.setItem("scheduleText", "Customize");
          params.append("type", "Daily");
          params.append("delivery_frequency", 1);
          params.append("monday", this.monQty);
          params.append("tuesday", this.tueQty);
          params.append("wednesday", this.wedQty);
          params.append("thursday", this.thuQty);
          params.append("friday", this.friQty);
          params.append("saturday", this.satQty);
          params.append("sunday", this.sunQty);
          sessionStorage.setItem("monQty", this.monQty);
          sessionStorage.setItem("tueQty", this.tueQty);
          sessionStorage.setItem("wedQty", this.wedQty);
          sessionStorage.setItem("thuQty", this.thuQty);
          sessionStorage.setItem("friQty", this.friQty);
          sessionStorage.setItem("satQty", this.satQty);
          sessionStorage.setItem("sunQty", this.sunQty);
        } else if (this.alternateCheckbox === true) {
          sessionStorage.setItem("scheduleText", "Alternate");
          params.append("type", "Daily");
          params.append("delivery_frequency", 2);
          params.append("quantity", this.quantityValue);
          params.append("alternate", this.selectedAlternate);
          sessionStorage.setItem("alternate", this.selectedAlternate);
        } else {
          // for one time
          sessionStorage.setItem("scheduleText", "One Time");
          params.append("type", "One Time");
          params.append("delivery_frequency", 3);
          params.append("quantity", this.quantityValue);
        }
        if (this.isPostpaidDisabled === true) {
          sessionStorage.setItem("isPostpaidDisabled", "yes");
        } else {
          sessionStorage.setItem("isPostpaidDisabled", "no");
        }
        if (this.promoCodeVerified === true) {
          sessionStorage.setItem("promoCodeVerified", "yes");
          sessionStorage.setItem("promocodeText", this.promocodeText);
          params.append("promo_code", this.promocodeText);
        } else {
          sessionStorage.setItem("promoCodeVerified", "no");
          sessionStorage.setItem("promocodeText", "");
        }
        sessionStorage.setItem("prodQuantity", this.quantityValue);
        __WEBPACK_IMPORTED_MODULE_3_axios___default()({
          url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + "/subscriptions/subscription-verification",
          method: "post",
          data: params,
          withCredentials: false,
          headers: {}
        }).then(function (response) {
          // console.log(response)
          var str = response.data.msg;
          str = str.replace("EMOJI_ONE", "😃");
          str = str.replace("EMOJI_TWO", "😲");
          str = str.replace("EMOJI_THREE", "☹");
          _this5.subscriptionVerificationObj = {};
          // debugger
          if (response.data.msg_type === "msg_no_msg") {
            sessionStorage.setItem("paymentModeText", response.data.payment_mode_text);
            sessionStorage.setItem("isReferrerDisplay", response.data.is_referrer_dispaly);
            var subDetail = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data.subscription_details);
            _this5.$router.push({
              path: "/a/subscriptionVerification",
              query: { cn: btoa(subDetail) }
            });
          } else if (response.data.msg_type === "msg_warning") {
            // alert(str)
            _this5.$swal({
              title: "Warning!",
              text: str,
              type: "warning",
              showCancelButton: true,
              confirmButtonText: "Replan",
              cancelButtonText: "Continue"
              // showCloseButton: true,
              // showLoaderOnConfirm: true
            }).then(function (result) {
              if (result.value) {
                // this.$swal('Success', 'Thanks you Replan!', 'success')
              } else {
                sessionStorage.setItem("paymentModeText", response.data.payment_mode_text);
                sessionStorage.setItem("isReferrerDisplay", response.data.is_referrer_dispaly);
                var _subDetail = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data.subscription_details);
                _this5.$router.push({
                  path: "/a/subscriptionVerification",
                  query: { cn: btoa(_subDetail) }
                });
              }
            });
          } else if (response.data.msg_type === "msg_error" && response.data.error_code === "000005") {
            // alert(str)
            _this5.$swal({
              title: "Warning!",
              text: str,
              type: "error",
              showCancelButton: true,
              confirmButtonText: "Recharge",
              cancelButtonText: "Cancel"
              // showCloseButton: true,
              // showLoaderOnConfirm: true
            }).then(function (result) {
              if (result.value) {
                params.append("action_name", "order_flow_payment_url");
                params.append("user_id", _this5.userId);
                params.append("required_amount", response.data.default_amount);
                __WEBPACK_IMPORTED_MODULE_3_axios___default()({
                  url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + "/users/invoke-user-action",
                  method: "post",
                  data: params,
                  withCredentials: false,
                  headers: {}
                }).then(function (response) {
                  sessionStorage.setItem("paymentFlow", "payment");
                  // console.log(response)
                  window.location.href = response.data.payment_url;
                  /*  var fullUrl = response.data.payment_url;
                  var splitUrl = fullUrl.split("pp?");
                  window.location.href =
                    "http://localhost:4000/a/pp?" + splitUrl[1]; */
                  // window.location.href = 'https://t.doodhvale.in/#/a/pp?' + splitUrl[1]
                }).catch(function (e) {
                  alert("not ok");
                });
              } else {
                // this.$swal('Success', 'Thanks you Replan!', 'success')
              }
            });
          } else {
            // alert(response.data.msg)
            // alert(str)
            _this5.$swal({
              title: "Sorry!",
              text: str + "!",
              type: "warning",
              showCancelButton: false,
              confirmButtonText: "Okay"
              // showCloseButton: true,
              // showLoaderOnConfirm: true
            }).then(function (result) {});
          }
        }).catch(function (e) {
          alert("not ok");
        });
      }
    },
    isPastDate: function isPastDate(date) {
      // let today = new Date()
      var dd = String(date.getDate()).padStart(2, "0");
      var mm = String(date.getMonth() + 1).padStart(2, "0");
      var yyyy = date.getFullYear();
      var selectedDate = yyyy + "-" + mm + "-" + dd;
      if (selectedDate < this.prepaidProductPriceObj.subStartDate) {
        return date;
      }
    }
  }
});

/***/ }),

/***/ "cBLl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dmtr_vue__ = __webpack_require__("lpFE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_435db8b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dmtr_vue__ = __webpack_require__("mgdb");
function injectStyle (ssrContext) {
  __webpack_require__("gTFP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dmtr_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_435db8b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dmtr_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cNny":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  data: function data() {
    return {
      type: ['', 'info', 'success', 'warning', 'danger'],
      notifications: {
        topCenter: false
      }
    };
  },

  methods: {
    notifyVue: function notifyVue(verticalAlign, horizontalAlign) {
      var notification = {
        template: '<span>Welcome to <b>Light Bootstrap Dashboard</b> - a beautiful freebie for every web developer.</span>'
      };

      var color = Math.floor(Math.random() * 4 + 1);
      this.$notifications.notify({
        component: notification,
        icon: 'nc-icon nc-app',
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: this.type[color]
      });
    }
  }
});

/***/ }),

/***/ "cdbK":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "ctRh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-map-container"},[_c('div',{ref:"vue-map",staticClass:"vue-map"}),_vm._v(" "),_c('div',{staticClass:"vue-map-hidden"},[_vm._t("default")],2),_vm._v(" "),_vm._t("visible")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cxu9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',{staticClass:"card-stats"},[_c('div',{staticClass:"row"},[(_vm.$slots.header)?_c('div',{staticClass:"col-5"},[_c('div',{staticClass:"icon-big text-center"},[_vm._t("header")],2)]):_vm._e(),_vm._v(" "),(_vm.$slots.content)?_c('div',{staticClass:"col-7"},[_c('div',{staticClass:"numbers"},[_vm._t("content")],2)]):_vm._e()]),_vm._v(" "),(_vm.$slots.footer)?_c('div',{staticClass:"stats",attrs:{"slot":"footer"},slot:"footer"},[_vm._t("footer")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dXEd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ddgI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartCard_vue__ = __webpack_require__("OaMs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b3465d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartCard_vue__ = __webpack_require__("LvYP");
function injectStyle (ssrContext) {
  __webpack_require__("D2Ge")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b3465d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dqdb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dzxp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    LTable: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Table_vue__["a" /* default */],
    ChartCard: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */],
    StatsCard: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */]
  },
  data: function data() {
    return {
      urlInterface: [],
      apiDataObj: [],
      userDetails: [],
      disagreeResponse: [],
      successfully_feedback: false
    };
  },
  created: function created() {
    this.fetchData();
  },

  methods: {
    fetchData: function fetchData() {
      var _this = this;

      var params = new URLSearchParams();
      var fullUrl = document.URL;
      var splitUrl = fullUrl.split('f?');
      params.append('url_str', splitUrl[1]);
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/accounts/fetch-url-interface-data',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this.urlInterface = {};
        if (response.data.status === '000001' || response.data.status === '000002' || response.data.status === '000003') {
          _this.urlInterface.error_msg = response.data.msg;
          document.getElementById('url_valid').style.display = 'none';
        } else {
          document.getElementById('url_expired').style.display = 'none';
          _this.urlInterface.action_name = response.data.action_name;
          _this.urlInterface.url_interface_id = response.data.url_interface_id;
          _this.invokeUrlAction();
        }
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          _this.list = response.data.user_record;
          alert(_this.list);
        }
      }).catch(function (e) {
        alert('not ok');
      });
    },
    invokeUrlAction: function invokeUrlAction() {
      var _this2 = this;

      var params = new URLSearchParams();
      params.append('url_interface_id', this.urlInterface.url_interface_id);
      params.append('action_name', this.urlInterface.action_name);
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/accounts/invoke-url-action',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this2.apiDataObj = {};
        switch (_this2.urlInterface.action_name) {
          case 'door_not_open_case':
          case 'delivery_not_taken_case':
            _this2.apiDataObj.userId = response.data.action_response.user_id;
            _this2.apiDataObj.deliveryDate = response.data.action_response.delivery_date;
            _this2.apiDataObj.deliveryId = response.data.action_response.delivery_id;
            _this2.userInfo();
            break;
          default:
            break;
        }
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          _this2.list = response.data.user_record;
          alert(_this2.list);
        }
      }).catch(function (e) {
        alert('not ok');
      });
    },
    userInfo: function userInfo() {
      var _this3 = this;

      var params = new URLSearchParams();
      var userId = this.apiDataObj.userId;
      params.append('user_id', userId);
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/users/user-info',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this3.userDetails = {};
        _this3.userDetails.userId = userId;
        _this3.userDetails.first_name = response.data.user_record.user_details.first_name;
        _this3.userDetails.mobile = response.data.user_record.user.username;
        _this3.userDetails.address = response.data.user_record.address.address1 + ' ' + response.data.user_record.address.address2 + ' ' + response.data.user_record.address.city;
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          _this3.list = response.data.user_record;
          alert(_this3.list);
        }
      }).catch(function (e) {
        alert('not ok');
      });
    },
    disagree: function disagree() {
      var _this4 = this;

      var params = new URLSearchParams();
      params.append('url_interface_id', this.urlInterface.url_interface_id);
      params.append('delivery_id', this.apiDataObj.deliveryId);
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/accounts/update-url-user-response',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this4.disagreeResponse = {};
        _this4.successfully_feedback = true;
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          _this4.list = response.data.user_record;
          alert(_this4.list);
        }
      }).catch(function (e) {
        alert('not ok');
      });
    }
  }
});

/***/ }),

/***/ "eAxr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "eCSI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardLayout_vue__ = __webpack_require__("TQ5B");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e0d8694c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardLayout_vue__ = __webpack_require__("NxSr");
function injectStyle (ssrContext) {
  __webpack_require__("pR+G")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e0d8694c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eU1q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  inheritAttrs: false,
  name: 'fg-input',
  props: {
    label: String,
    value: [String, Number],
    addonRightIcon: String,
    addonLeftIcon: String
  },
  computed: {
    hasIcon: function hasIcon() {
      var _$slots = this.$slots,
          addonRight = _$slots.addonRight,
          addonLeft = _$slots.addonLeft;

      return addonRight !== undefined || addonLeft !== undefined || this.addonRightIcon !== undefined || this.addonLeftIcon !== undefined;
    }
  }
});

/***/ }),

/***/ "ekt6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fSd6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    LTable: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Table_vue__["a" /* default */],
    ChartCard: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */],
    StatsCard: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */]
  },
  data: function data() {
    return {
      urlInterface: [],
      apiDataObj: [],
      userDetails: [],
      table_load: false,
      isLoading: true,
      isFullPage: true,
      isOpen: false,
      products: [],
      zones: {}
    };
  },
  created: function created() {
    this.fetchData();
  },

  methods: {
    fetchData: function fetchData() {
      var _this = this;

      var params = new URLSearchParams();
      var fullUrl = document.URL;
      var splitUrl = fullUrl.split('td?');
      params.append('url_str', splitUrl[1]);
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/accounts/fetch-url-interface-data',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        // console.log(response)
        _this.urlInterface = {};
        if (response.data.status === '000001' || response.data.status === '000002' || response.data.status === '000003') {
          _this.isLoading = false;
          _this.urlInterface.error_msg = response.data.msg;
          document.getElementById('url_valid').style.display = 'none';
        } else {
          document.getElementById('url_expired').style.display = 'none';
          _this.urlInterface.action_name = response.data.action_name;
          _this.urlInterface.url_interface_id = response.data.url_interface_id;
          _this.invokeUrlAction();
        }
        if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          _this.list = response.data.user_record;
          alert(_this.list);
        }
      }).catch(function (e) {
        alert('not ok');
      });
    },
    invokeUrlAction: function invokeUrlAction() {
      var _this2 = this;

      var params = new URLSearchParams();
      params.append('url_interface_id', this.urlInterface.url_interface_id);
      params.append('action_name', this.urlInterface.action_name);
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/accounts/invoke-url-action',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        // console.log(response)
        _this2.apiDataObj = {};
        switch (_this2.urlInterface.action_name) {
          case 'total_delhi':
          case 'noida_route':
          case 'gurugram_route':
          case 'total_delhi_vegetable_orders':
          case 'total_delhi_fruit_orders':
          case 'total_delhi_bakery_orders':
          case 'total_delhi_vegetable_orders_suppliers':
          case 'total_delhi_fruit_orders_suppliers':
          case 'total_delhi_bakery_orders_suppliers':
          default:
            _this2.apiDataObj.userId = response.data.action_response.user_id;
            _this2.apiDataObj.date = response.data.action_response.date;
            _this2.apiDataObj.route = response.data.action_response.route;
            _this2.apiDataObj.orderQuantity = response.data.action_response.orderQuantity;
            _this2.apiDataObj.deliveredQuantity = response.data.action_response.deliveredQuantity;
            _this2.products = response.data.action_response.productData;
            _this2.zones = response.data.action_response.zonesData;
            _this2.table_load = true;
            _this2.isLoading = false;
            // this.userInfo()
            break;
        }
        if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          _this2.list = response.data.user_record;
          alert(_this2.list);
        }
      }).catch(function (e) {
        alert('not ok');
      });
    },
    userInfo: function userInfo() {
      var _this3 = this;

      var params = new URLSearchParams();
      var userId = this.apiDataObj.userId;
      params.append('user_id', userId);
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/users/user-info',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this3.userDetails = {};
        _this3.userDetails.userId = userId;
        _this3.userDetails.first_name = response.data.user_record.user_details.first_name;
        _this3.userDetails.mobile = response.data.user_record.user.username;
        _this3.userDetails.address = response.data.user_record.address.address1 + ' ' + response.data.user_record.address.address2 + ' ' + response.data.user_record.address.city;
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          _this3.list = response.data.user_record;
          alert(_this3.list);
        }
      }).catch(function (e) {
        alert('not ok');
      });
    }
  }
});

/***/ }),

/***/ "fX+i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dispnewcust_vue__ = __webpack_require__("MNEg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62bb88a3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dispnewcust_vue__ = __webpack_require__("T6+J");
function injectStyle (ssrContext) {
  __webpack_require__("2Y1d")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dispnewcust_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62bb88a3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dispnewcust_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fZkL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ftYJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_S_vue__ = __webpack_require__("Atwy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12dade6d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_S_vue__ = __webpack_require__("7a+9");
function injectStyle (ssrContext) {
  __webpack_require__("Qj8p")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_S_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12dade6d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_S_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fuBC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "g3u2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"referral-page"},[_c('div',{staticClass:"banner"},[_c('img',{attrs:{"src":"/../../../static/img/icons/banner-img-referral.jpg","alt":"Referral Page"}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"thanks-para",staticStyle:{"display":"flex","justify-content":"justify"}},[_c('p',{staticStyle:{"height":"auto","text-align":"none"}},[_vm._v("\n      Thank you for your interest in participating in Doodhvale's Multi-Level\n      Referral Scheme. This policy outlines the terms, conditions, and\n      guidelines governing the referral program. By participating in the\n      program, you agree to comply with the following:\n    ")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"info-box"},[_c('div',[_c('div',{staticStyle:{"display":"flex"}},[_c('img',{staticClass:"heading-img",attrs:{"src":"/../../../../static/img/icons/skills.png","alt":"icon"}}),_vm._v(" "),_c('h4',[_vm._v("Eligibility")])]),_vm._v(" "),_c('p',[_vm._v("\n        The referral scheme is open to all existing Doodhvale customers.\n        Participants must be of legal age in their jurisdiction to be\n        eligible. Referrals must be new customers who have not previously made\n        a purchase from Doodhvale. Same address Referrals are not permitted.\n      ")])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"info-box"},[_c('div',[_c('div',{staticStyle:{"display":"flex"}},[_c('img',{staticClass:"heading-img",attrs:{"src":"/../../../../static/img/icons/change.png","alt":"icon "}}),_vm._v(" "),_c('h4',[_vm._v("Referral Process")])]),_vm._v(" "),_c('ul',[_c('li',[_c('p',[_vm._v("\n            To refer someone, you must share your unique referral code\n            provided by Doodhvale. When a referral signs up using your code,\n            they become your Level 1 referee. Level 1 referees can refer\n            others, who become your Level 2 referees, and so on for Level 3.\n            Referral Rewards:\n          ")])]),_vm._v(" "),_c('ol',{staticStyle:{"text-decoration":"dotted","margin-left":"15px"}},[_c('li',[_vm._v("\n            For each Level 1 referee, the referrer will earn 3% of the\n            referee's bill value as a reward.\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n            For Level 2 referees, the referrer will earn 2% of the referee's\n            bill value.\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n            For Level 3 referees, the referrer will earn 1% of the referee's\n            bill value.\n          ")])])]),_vm._v(" "),_c('p',[_vm._v("\n        Rewards will be credited to the referrer's account after the referee's\n        purchase is confirmed. Referee earns 5% of their Bill Value in Month 1\n        and 3% of their Bill Value from Month 2 to Month 6.\n      ")])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"info-box",staticStyle:{"justify-content":"left"}},[_c('div',[_c('div',{staticStyle:{"display":"flex"}},[_c('img',{staticClass:"heading-img",attrs:{"src":"/../../../../static/img/icons/bill.png","alt":"icon"}}),_vm._v(" "),_c('h4',[_vm._v("Bill Value Calculation")])]),_vm._v(" "),_c('p',[_vm._v("\n        The bill value considered for reward calculation excludes taxes,\n        discounts, and delivery charges. Referral rewards are calculated based\n        on the net bill value paid by the referee.\n      ")])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"info-box",staticStyle:{"justify-content":"left"}},[_c('div',[_c('div',{staticStyle:{"display":"flex"}},[_c('img',{staticClass:"heading-img",attrs:{"src":"/../../../../static/img/icons/buy.png","alt":"Payout"}}),_vm._v(" "),_c('h4',[_vm._v("Payout and Redemption")])]),_vm._v(" "),_c('p',[_vm._v("\n        Referral rewards earned can be redeemed on future purchases. Rewards\n        cannot be transferred to another user or combined with other offers\n        unless explicitly mentioned. Payouts will be processed periodically as\n        per Doodhvale's standard policies.\n      ")])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"info-box",staticStyle:{"justify-content":"left"}},[_c('div',[_c('div',{staticStyle:{"display":"flex"}},[_c('img',{staticClass:"heading-img",attrs:{"src":"/../../../../static/img/icons/compliant.png","alt":"icon"}}),_vm._v(" "),_c('h4',[_vm._v("Compliance and Misuse")])]),_vm._v(" "),_c('p',{staticStyle:{"width":"100%"}},[_vm._v("\n        Participants are strictly prohibited from engaging in fraudulent or\n        deceptive activities to gain referrals. Any misuse, manipulation, or\n        violation of the referral scheme may result in disqualification and\n        cancellation of rewards.\n        "),_c('br'),_vm._v("Doodhvale reserves the right to investigate and take appropriate\n        action against fraudulent or suspicious activities.\n      ")])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"info-box",staticStyle:{"justify-content":"left"}},[_c('div',[_c('div',{staticStyle:{"display":"flex"}},[_c('img',{staticClass:"heading-img",attrs:{"src":"/../../../../static/img/icons/modification.png","alt":"icon"}}),_vm._v(" "),_c('h4',[_vm._v("Modifications and Termination")])]),_vm._v(" "),_c('p',{staticStyle:{"width":"100%"}},[_vm._v("\n        Doodhvale reserves the right to modify, suspend, or terminate the\n        referral scheme at any time without prior notice.\n        "),_c('br'),_vm._v("Changes or updates to the referral scheme will be communicated\n        through appropriate channels.\n      ")])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"info-box"},[_c('div',[_c('div',{staticStyle:{"display":"flex"}},[_c('img',{staticClass:"heading-img",attrs:{"src":"/../../../../static/img/icons/limitation.png","alt":"Eligibility"}}),_vm._v(" "),_c('h4',[_vm._v("Disclaimer")])]),_vm._v(" "),_c('p',[_vm._v("\n        Doodhvale reserves the right to review and verify all referrals and\n        associated transactions. Referral rewards are subject to change\n        without notice.\n        "),_c('br'),_vm._v("Doodhvale is not responsible for any technical issues or\n        disruptions that may affect the referral scheme. By participating in\n        the Multi-Level Referral Scheme, you acknowledge and agree to the\n        terms and conditions outlined above. For any queries or concerns,\n        please contact our customer support team.\n      ")])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"width":"10px"}}),_vm._v(" "),_c('div',[_c('img',{staticClass:"referral-img",attrs:{"src":"/../../../static/img/icons/referralPro.jpeg","alt":"program"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gCHH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gT9a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UnsubPromo_vue__ = __webpack_require__("sap4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c88c02b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UnsubPromo_vue__ = __webpack_require__("NNqC");
function injectStyle (ssrContext) {
  __webpack_require__("XyFb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UnsubPromo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c88c02b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UnsubPromo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gTFP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ghI9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hooper',{staticStyle:{"height":"400px"},attrs:{"autoPlay":true}},[_c('slide',[_c('img',{staticStyle:{"width":"100%","height":"400px"},attrs:{"src":__webpack_require__("2/wk")}})]),_vm._v(" "),_c('slide',[_c('img',{staticStyle:{"width":"100%","height":"400px"},attrs:{"src":__webpack_require__("tTke")}})]),_vm._v(" "),_c('slide',[_c('img',{staticStyle:{"width":"100%","height":"400px"},attrs:{"src":__webpack_require__("ihhz")}})]),_vm._v(" "),_c('slide',[_c('img',{staticStyle:{"width":"100%","height":"400px"},attrs:{"src":__webpack_require__("mLAn")}})]),_vm._v(" "),_c('hooper-pagination',{attrs:{"slot":"hooper-addons"},slot:"hooper-addons"})],1),_vm._v(" "),_c('form',{attrs:{"action":"#","target":"_blank"}},[_c('p',{staticClass:"w3-center"},[_c('router-link',{staticClass:"w3-button w3-orange w3-section",attrs:{"to":{path:'/a/reg'}}},[_vm._v("SUBSCRIBE MILK")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gw4i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Delfbdbfault_vue__ = __webpack_require__("LEMU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42cfaf58_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Delfbdbfault_vue__ = __webpack_require__("5D9b");
function injectStyle (ssrContext) {
  __webpack_require__("UtZd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Delfbdbfault_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42cfaf58_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Delfbdbfault_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gwCQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    LTable: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Table_vue__["a" /* default */],
    ChartCard: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */],
    StatsCard: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */]
  },
  data: function data() {
    return {
      apiDataObj: {},
      urlInterface: {},
      isLoading: true,
      isFullPage: true,
      count: 0
    };
  },
  created: function created() {
    this.fetchData();
  },

  methods: {
    fetchData: function fetchData() {
      var _this = this;

      var params = new URLSearchParams();
      var fullUrl = document.URL;
      var splitUrl = fullUrl.split('bill?');
      params.append('url_str', splitUrl[1]);
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/accounts/fetch-url-interface-data',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this.urlInterface = {};
        if (response.data.status === '000001' || response.data.status === '000002' || response.data.status === '000003') {
          _this.urlInterface.error_msg = response.data.msg;
          document.getElementById('url_valid').style.display = 'none';
          _this.isLoading = false;
        } else {
          document.getElementById('url_expired').style.display = 'none';
          _this.urlInterface.action_name = response.data.action_name;
          _this.urlInterface.url_interface_id = response.data.url_interface_id;
          _this.invokeUrlAction();
          _this.isLoading = false;
        }
        if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          alert(_this.list);
        }
        setTimeout(function () {
          _this.isLoading = false;
        }, 10000);
      }).catch(function (e) {
        _this.isLoading = false;
        alert('not ok');
      });
    },
    invokeUrlAction: function invokeUrlAction() {
      var _this2 = this;

      var params = new URLSearchParams();
      params.append('url_interface_id', this.urlInterface.url_interface_id);
      params.append('action_name', this.urlInterface.action_name);
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/accounts/invoke-url-action',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        if (response.data.action_response.user_id === null || response.data.action_response.user_id === 0 || response.data.action_response.user_id === '0' || response.data.action_response.user_id === 'undefined') {
          window.location.reload();
        }
        switch (_this2.urlInterface.action_name) {
          case 'customer_bill':
            _this2.apiDataObj = response.data.action_response.bill_list;
            _this2.apiDataObj.sub_total = _this2.apiDataObj.sub_total.toFixed(2);
            _this2.apiDataObj.igst_amount = _this2.apiDataObj.igst_amount.toFixed(2);
            _this2.apiDataObj.cgst_amount = _this2.apiDataObj.cgst_amount.toFixed(2);
            _this2.apiDataObj.sgst_amount = _this2.apiDataObj.sgst_amount.toFixed(2);
            _this2.apiDataObj.referral_discount = _this2.apiDataObj.referral_discount.toFixed(2);
            _this2.apiDataObj.voucher_discount = _this2.apiDataObj.voucher_discount.toFixed(2);
            _this2.apiDataObj.tax = _this2.apiDataObj.tax.toFixed(2);
            _this2.apiDataObj.bill_amount = _this2.apiDataObj.bill_amount.toFixed(2);
            _this2.apiDataObj.previous_due_amount = _this2.apiDataObj.previous_due_amount.toFixed(2);
            _this2.apiDataObj.net_payable_amount = _this2.apiDataObj.net_payable_amount.toFixed(2);
            _this2.apiDataObj.broken_bottle_charge = _this2.apiDataObj.broken_bottle_charge.toFixed(2);
            break;
          default:
            break;
        }
        setTimeout(function () {
          _this2.isLoading = false;
        }, 10000);
      }).catch(function (e) {
        alert('not ok');
      });
    },
    convertDate: function convertDate(dateString) {
      var mydate = new Date(dateString).toDateString().split(' ');
      return mydate[2] + '-' + mydate[1] + '-' + mydate[3];
    }
  }
});

/***/ }),

/***/ "h0DP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hEw7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay__ = __webpack_require__("ZZvs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__("SYh3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay_dist_vue_loading_css__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    LTable: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Table_vue__["a" /* default */],
    ChartCard: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */],
    StatsCard: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */],
    Loading: __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      error_msg: '',
      error_mob: '',
      error_pin: '',
      fullPage: true,
      isLoading: false,
      isActive: false,
      errors: '',
      name: '',
      mobile_no: '',
      address: '',
      pin_code: '',
      form_no: '1',
      surveyResult: [],
      backgroundUrl: '',
      formSubmit: false,
      bgImage: 'https://www.doodhvale.com/hmi_images/bg.jpg',
      questionArray: [{
        id: 1,
        questions: '1. Does your milk brand provide at least 150sq ft of average space per cattle (sufficient enough for them to roam and recreate)?',
        answer: ''
      }, {
        id: 2,
        questions: '2. Is the cattle kept untied all the time?',
        answer: ''
      }, {
        id: 3,
        questions: '3. Is your milk’s farm well equipped with stress relievers like brushes, fans and cooling system for the mental and physical well-being of the Cattle?',
        answer: ''
      }, {
        id: 4,
        questions: '4. Is the cattle kept together for companionship and socialising?',
        answer: ''
      }, {
        id: 5,
        questions: '5. Does your milk brand encourage regular farm visits from outsiders?',
        answer: ''
      }, {
        id: 6,
        questions: '6. Do they treat cattle like their family by naming them, celebrating their birthdays, etc ?',
        answer: ''
      }, {
        id: 7,
        questions: '7. Is the cattle given optimum exposure to sunlight for a better synthesis of Vitamin D3?',
        answer: ''
      }, {
        id: 8,
        questions: '8. Easy access to clean drinkable water for the cattle?(Within 50ft.)',
        answer: ''
      }, {
        id: 9,
        questions: '9. Is each cattle given personalised feed & supplements to match their nutritional requirement?',
        answer: ''
      }, {
        id: 10,
        questions: '10. Are there regular cattle health checkups & vaccinations?',
        answer: ''
      }]
    };
  },
  created: function created() {
    this.fetchData();
  },

  methods: {
    fetchData: function fetchData() {},
    getImage: function getImage() {
      var imagePath = '';
      switch (this.surveyResult.length) {
        case 0:
          imagePath = 'https://www.doodhvale.com/hmi_images/0.jpg';
          break;
        case 1:
          imagePath = 'https://www.doodhvale.com/hmi_images/1.jpg';
          break;
        case 2:
          imagePath = 'https://www.doodhvale.com/hmi_images/2.jpg';
          break;
        case 3:
          imagePath = 'https://www.doodhvale.com/hmi_images/3.jpg';
          break;
        case 4:
          imagePath = 'https://www.doodhvale.com/hmi_images/4.jpg';
          break;
        case 5:
          imagePath = 'https://www.doodhvale.com/hmi_images/5.jpg';
          break;
        case 6:
          imagePath = 'https://www.doodhvale.com/hmi_images/6.jpg';
          break;
        case 7:
          imagePath = 'https://www.doodhvale.com/hmi_images/7.jpg';
          break;
        case 8:
          imagePath = 'https://www.doodhvale.com/hmi_images/8.jpg';
          break;
        case 9:
          imagePath = 'https://www.doodhvale.com/hmi_images/9.jpg';
          break;
        case 10:
          imagePath = 'https://www.doodhvale.com/hmi_images/10.jpg';
          break;
      }
      return imagePath;
    },
    downloadApp: function downloadApp() {
      this.$router.push({ path: '/a/appLink' });
    },
    saveFormDetails: function saveFormDetails() {
      var _this = this;

      var self = this;
      this.isLoading = true;
      if (this.mobile_no !== '') {
        if (this.mobile_no.length !== 10) {
          this.error_mob = 'Please Enter 10-digit Mobile Number';
          this.isLoading = false;
          this.isActive = true;
          setTimeout(function () {
            _this.error_mob = '';
          }, 3000);
          document.getElementById('mobile').focus();
          return;
        }
      }
      if (this.pin_code !== '') {
        if (this.pin_code.length !== 6) {
          this.error_pin = 'Please Enter 6-digit Pin Code';
          this.isLoading = false;
          this.isActive = true;
          setTimeout(function () {
            _this.error_pin = '';
          }, 5000);
          return;
        }
      }
      var surveyResult = self.questionArray.filter(function (x) {
        return x.answer === '';
      });
      if (surveyResult.length !== 0) {
        var errNo = surveyResult[0].id;
        var errDiv = document.getElementById(errNo);
        errDiv.scrollIntoView();
        document.getElementById('err_' + errNo).innerHTML = 'Please fill answers for the questions';
        // this.error_msg = 'Please fill answers for all the questions'
        this.isLoading = false;
        setTimeout(function () {
          document.getElementById('err_' + errNo).innerHTML = '';
        }, 3000);
        return;
      }
      var postData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.questionArray);
      var params = new URLSearchParams();
      params.append('form_no', self.form_no);
      params.append('phone_no', self.mobile_no);
      params.append('name', self.name);
      params.append('pincode', self.pin_code);
      params.append('questions_json', postData);
      params.append('address', self.address);
      __WEBPACK_IMPORTED_MODULE_6_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/users/survey-data',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        if (response.data.status === '000000') {
          self.surveyResult = self.questionArray.filter(function (x) {
            return x.answer === '1';
          });
          _this.isLoading = true;
          setTimeout(function () {
            _this.isLoading = false;
          }, 5000);
          self.formSubmit = true;
        } else {
          _this.error_msg = response.data.msg;
          setTimeout(function () {
            _this.error_msg = '';
          }, 5000);
          // setTimeout(function() { self.openToast(response.data.msg, 'danger') }, 200)
        }
      }).catch(function (e) {
        _this.error_msg = e;
        // setTimeout(function() { self.openToast(e, 'danger') }, 200)
        // console.log(e)
      });
      self.isLoading = false;
    }
  }

});

/***/ }),

/***/ "hHDF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  data: function data() {
    return {
      details: [{
        title: '12',
        subTitle: 'Files'
      }, {
        title: '2GB',
        subTitle: 'Used'
      }, {
        title: '24,6$',
        subTitle: 'Spent'
      }]
    };
  },

  methods: {
    getClasses: function getClasses(index) {
      var remainder = index % 3;
      if (remainder === 0) {
        return 'col-md-3 col-md-offset-1';
      } else if (remainder === 2) {
        return 'col-md-4';
      } else {
        return 'col-md-3';
      }
    }
  }
});

/***/ }),

/***/ "hr0A":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/G3-School.b702ea4.gif";

/***/ }),

/***/ "iCW5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ihhz":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/page3.f5fefec.jpg";

/***/ }),

/***/ "ioF4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['btnColor', 'cartIcon']
});

/***/ }),

/***/ "ipMx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"url_valid"}},[_c('div',{attrs:{"id":"border"}},[_c('div',{staticClass:"survey-forms"},[_c('div',{staticClass:"row "},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12"}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.formSubmit),expression:"!formSubmit"}],staticClass:"col-xs-12 col-sm-12 col-md-12 survey-form",style:({ 'background-image': 'url(' + _vm.bgImage + ')' })},[_c('div',{staticClass:"survey-content"},[_c('div',{staticClass:"form-layout"},[_c('p',{attrs:{"id":"top-para"}},[_vm._v("Happy Milk Index(HMI) is an index created by Doodhvale to measure the happiness index of the milk you are consuming.  It is proven that a happier milk is a healthier milk.")]),_vm._v(" "),_c('p',{attrs:{"id":"question_para"}},[_vm._v("Please answer the following questions to find out your milk’s HMI score : ")]),_vm._v(" "),_c('form',[_c('b-field',{attrs:{"label":"Name"}},[_c('b-input',{staticStyle:{"width":"100%","height":"50px"},attrs:{"name":"name","type":"text","placeholder":"Name"},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1),_vm._v(" "),_c('b-field',{attrs:{"label":"Mobile Number"}},[_c('b-input',{staticStyle:{"width":"100%","height":"50px"},attrs:{"type":"text","name":"mobile","id":"mobile","placeholder":"Mobile Number","oninput":"this.value=this.value.replace(/[^0-9]/g,'');"},model:{value:(_vm.mobile_no),callback:function ($$v) {_vm.mobile_no=$$v},expression:"mobile_no"}})],1),_vm._v(" "),(_vm.error_mob.length>0)?_c('span',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.error_mob)+"\n                      ")]):_vm._e(),_vm._v(" "),_c('b-field',{attrs:{"label":"Address"}},[_c('b-input',{staticStyle:{"width":"100%","height":"50px"},attrs:{"type":"text","name":"address","placeholder":"Address"},model:{value:(_vm.address),callback:function ($$v) {_vm.address=$$v},expression:"address"}})],1),_vm._v(" "),_c('b-field',{attrs:{"label":"Pin Code"}},[_c('b-input',{staticStyle:{"width":"100%","height":"50px"},attrs:{"id":"pincode","type":"text","name":"pincode","placeholder":"Pin Code","oninput":"this.value=this.value.replace(/[^0-9]/g,'');"},model:{value:(_vm.pin_code),callback:function ($$v) {_vm.pin_code=$$v},expression:"pin_code"}})],1),_vm._v(" "),(_vm.error_pin.length>0)?_c('span',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.error_pin)+"\n                      ")]):_vm._e()],1)]),_vm._v(" "),_vm._l((_vm.questionArray),function(questionObj){return _c('div',{key:questionObj.id,staticClass:"card-layout"},[_c('div',{staticClass:"card-view"},[_c('div',{staticClass:"question",attrs:{"id":questionObj.id}},[_vm._v("\n                        "+_vm._s(questionObj.questions)+"\n                      ")]),_vm._v(" "),_c('div',{staticClass:"answer row"},[_c('div',{staticClass:"col-xs-4 col-sm-4 col-md-4"},[_c('b-radio',{attrs:{"native-value":"1"},model:{value:(questionObj.answer),callback:function ($$v) {_vm.$set(questionObj, "answer", $$v)},expression:"questionObj.answer"}},[_vm._v("\n                            Yes\n                          ")])],1),_vm._v(" "),_c('div',{staticClass:"col-xs-4 col-sm-4 col-md-4"},[_c('b-radio',{attrs:{"native-value":"0"},model:{value:(questionObj.answer),callback:function ($$v) {_vm.$set(questionObj, "answer", $$v)},expression:"questionObj.answer"}},[_vm._v("\n                            No\n                          ")])],1),_vm._v(" "),_c('div',{staticClass:"col-xs-4 col-sm-4 col-md-4"},[_c('b-radio',{attrs:{"native-value":"-1"},model:{value:(questionObj.answer),callback:function ($$v) {_vm.$set(questionObj, "answer", $$v)},expression:"questionObj.answer"}},[_vm._v("\n                            Don't Know\n                          ")])],1)]),_vm._v(" "),_c('span',{staticClass:"errormsg",attrs:{"id":'err_'+ questionObj.id}})])])}),_vm._v(" "),_c('div',{staticClass:"text-center submit-btn"},[_c('b-button',{staticClass:"btn btn-primary rounded",attrs:{"rounded":"true","type":"is-primary","size":"is-medium"},on:{"click":_vm.saveFormDetails}},[_vm._v("CHECK SCORE")])],1),_vm._v(" "),_c('p',{attrs:{"id":"disclaimer"}},[_vm._v("*Happy Milk Index is an index made and managed by Doodhvale itself to maintain their milk’s quality standards. HMI is not an industry standard metric and is not accredited by any of the certified bodies.")])],2)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.formSubmit),expression:"formSubmit"}],staticClass:"col-xs-12 col-sm-12 col-md-12 survey-result"},[_c('img',{staticClass:"result-image",attrs:{"src":_vm.getImage()}}),_vm._v(" "),_c('div',{staticClass:"succes-button"},[_c('b-button',{staticClass:"btn btn-primary rounded",attrs:{"rounded":"true","type":"is-primary","size":"is-medium"},on:{"click":_vm.downloadApp}},[_vm._v("Download App")])],1)]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12"})]),_vm._v(" "),_c('div')]),_vm._v(" "),_c('loading',{attrs:{"active":_vm.isLoading,"is-full-page":_vm.fullPage,"color":'#FFDE00'},on:{"update:active":function($event){_vm.isLoading=$event}}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "j6QX":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAKT2lDQ1BQaG90b3Nob3AgSUNDIHByb2ZpbGUAAHjanVNnVFPpFj333vRCS4iAlEtvUhUIIFJCi4AUkSYqIQkQSoghodkVUcERRUUEG8igiAOOjoCMFVEsDIoK2AfkIaKOg6OIisr74Xuja9a89+bN/rXXPues852zzwfACAyWSDNRNYAMqUIeEeCDx8TG4eQuQIEKJHAAEAizZCFz/SMBAPh+PDwrIsAHvgABeNMLCADATZvAMByH/w/qQplcAYCEAcB0kThLCIAUAEB6jkKmAEBGAYCdmCZTAKAEAGDLY2LjAFAtAGAnf+bTAICd+Jl7AQBblCEVAaCRACATZYhEAGg7AKzPVopFAFgwABRmS8Q5ANgtADBJV2ZIALC3AMDOEAuyAAgMADBRiIUpAAR7AGDIIyN4AISZABRG8lc88SuuEOcqAAB4mbI8uSQ5RYFbCC1xB1dXLh4ozkkXKxQ2YQJhmkAuwnmZGTKBNA/g88wAAKCRFRHgg/P9eM4Ors7ONo62Dl8t6r8G/yJiYuP+5c+rcEAAAOF0ftH+LC+zGoA7BoBt/qIl7gRoXgugdfeLZrIPQLUAoOnaV/Nw+H48PEWhkLnZ2eXk5NhKxEJbYcpXff5nwl/AV/1s+X48/Pf14L7iJIEyXYFHBPjgwsz0TKUcz5IJhGLc5o9H/LcL//wd0yLESWK5WCoU41EScY5EmozzMqUiiUKSKcUl0v9k4t8s+wM+3zUAsGo+AXuRLahdYwP2SycQWHTA4vcAAPK7b8HUKAgDgGiD4c93/+8//UegJQCAZkmScQAAXkQkLlTKsz/HCAAARKCBKrBBG/TBGCzABhzBBdzBC/xgNoRCJMTCQhBCCmSAHHJgKayCQiiGzbAdKmAv1EAdNMBRaIaTcA4uwlW4Dj1wD/phCJ7BKLyBCQRByAgTYSHaiAFiilgjjggXmYX4IcFIBBKLJCDJiBRRIkuRNUgxUopUIFVIHfI9cgI5h1xGupE7yAAygvyGvEcxlIGyUT3UDLVDuag3GoRGogvQZHQxmo8WoJvQcrQaPYw2oefQq2gP2o8+Q8cwwOgYBzPEbDAuxsNCsTgsCZNjy7EirAyrxhqwVqwDu4n1Y8+xdwQSgUXACTYEd0IgYR5BSFhMWE7YSKggHCQ0EdoJNwkDhFHCJyKTqEu0JroR+cQYYjIxh1hILCPWEo8TLxB7iEPENyQSiUMyJ7mQAkmxpFTSEtJG0m5SI+ksqZs0SBojk8naZGuyBzmULCAryIXkneTD5DPkG+Qh8lsKnWJAcaT4U+IoUspqShnlEOU05QZlmDJBVaOaUt2ooVQRNY9aQq2htlKvUYeoEzR1mjnNgxZJS6WtopXTGmgXaPdpr+h0uhHdlR5Ol9BX0svpR+iX6AP0dwwNhhWDx4hnKBmbGAcYZxl3GK+YTKYZ04sZx1QwNzHrmOeZD5lvVVgqtip8FZHKCpVKlSaVGyovVKmqpqreqgtV81XLVI+pXlN9rkZVM1PjqQnUlqtVqp1Q61MbU2epO6iHqmeob1Q/pH5Z/YkGWcNMw09DpFGgsV/jvMYgC2MZs3gsIWsNq4Z1gTXEJrHN2Xx2KruY/R27iz2qqaE5QzNKM1ezUvOUZj8H45hx+Jx0TgnnKKeX836K3hTvKeIpG6Y0TLkxZVxrqpaXllirSKtRq0frvTau7aedpr1Fu1n7gQ5Bx0onXCdHZ4/OBZ3nU9lT3acKpxZNPTr1ri6qa6UbobtEd79up+6Ynr5egJ5Mb6feeb3n+hx9L/1U/W36p/VHDFgGswwkBtsMzhg8xTVxbzwdL8fb8VFDXcNAQ6VhlWGX4YSRudE8o9VGjUYPjGnGXOMk423GbcajJgYmISZLTepN7ppSTbmmKaY7TDtMx83MzaLN1pk1mz0x1zLnm+eb15vft2BaeFostqi2uGVJsuRaplnutrxuhVo5WaVYVVpds0atna0l1rutu6cRp7lOk06rntZnw7Dxtsm2qbcZsOXYBtuutm22fWFnYhdnt8Wuw+6TvZN9un2N/T0HDYfZDqsdWh1+c7RyFDpWOt6azpzuP33F9JbpL2dYzxDP2DPjthPLKcRpnVOb00dnF2e5c4PziIuJS4LLLpc+Lpsbxt3IveRKdPVxXeF60vWdm7Obwu2o26/uNu5p7ofcn8w0nymeWTNz0MPIQ+BR5dE/C5+VMGvfrH5PQ0+BZ7XnIy9jL5FXrdewt6V3qvdh7xc+9j5yn+M+4zw33jLeWV/MN8C3yLfLT8Nvnl+F30N/I/9k/3r/0QCngCUBZwOJgUGBWwL7+Hp8Ib+OPzrbZfay2e1BjKC5QRVBj4KtguXBrSFoyOyQrSH355jOkc5pDoVQfujW0Adh5mGLw34MJ4WHhVeGP45wiFga0TGXNXfR3ENz30T6RJZE3ptnMU85ry1KNSo+qi5qPNo3ujS6P8YuZlnM1VidWElsSxw5LiquNm5svt/87fOH4p3iC+N7F5gvyF1weaHOwvSFpxapLhIsOpZATIhOOJTwQRAqqBaMJfITdyWOCnnCHcJnIi/RNtGI2ENcKh5O8kgqTXqS7JG8NXkkxTOlLOW5hCepkLxMDUzdmzqeFpp2IG0yPTq9MYOSkZBxQqohTZO2Z+pn5mZ2y6xlhbL+xW6Lty8elQfJa7OQrAVZLQq2QqboVFoo1yoHsmdlV2a/zYnKOZarnivN7cyzytuQN5zvn//tEsIS4ZK2pYZLVy0dWOa9rGo5sjxxedsK4xUFK4ZWBqw8uIq2Km3VT6vtV5eufr0mek1rgV7ByoLBtQFr6wtVCuWFfevc1+1dT1gvWd+1YfqGnRs+FYmKrhTbF5cVf9go3HjlG4dvyr+Z3JS0qavEuWTPZtJm6ebeLZ5bDpaql+aXDm4N2dq0Dd9WtO319kXbL5fNKNu7g7ZDuaO/PLi8ZafJzs07P1SkVPRU+lQ27tLdtWHX+G7R7ht7vPY07NXbW7z3/T7JvttVAVVN1WbVZftJ+7P3P66Jqun4lvttXa1ObXHtxwPSA/0HIw6217nU1R3SPVRSj9Yr60cOxx++/p3vdy0NNg1VjZzG4iNwRHnk6fcJ3/ceDTradox7rOEH0x92HWcdL2pCmvKaRptTmvtbYlu6T8w+0dbq3nr8R9sfD5w0PFl5SvNUyWna6YLTk2fyz4ydlZ19fi753GDborZ752PO32oPb++6EHTh0kX/i+c7vDvOXPK4dPKy2+UTV7hXmq86X23qdOo8/pPTT8e7nLuarrlca7nuer21e2b36RueN87d9L158Rb/1tWeOT3dvfN6b/fF9/XfFt1+cif9zsu72Xcn7q28T7xf9EDtQdlD3YfVP1v+3Njv3H9qwHeg89HcR/cGhYPP/pH1jw9DBY+Zj8uGDYbrnjg+OTniP3L96fynQ89kzyaeF/6i/suuFxYvfvjV69fO0ZjRoZfyl5O/bXyl/erA6xmv28bCxh6+yXgzMV70VvvtwXfcdx3vo98PT+R8IH8o/2j5sfVT0Kf7kxmTk/8EA5jz/GMzLdsAAAAgY0hSTQAAeiUAAICDAAD5/wAAgOkAAHUwAADqYAAAOpgAABdvkl/FRgAABHhJREFUeNrs3F1MW2Ucx/GFELMYshjvzWKMXnrjbUvJFJ0Xi16IGE8QPSmI3YBCB+NNZJS1tqVv55y1FjhdX3RtQYcUeja3bK6tiSZ6YeKViYsxTmM0MUFBIdv6eGGrC1tTWlp6nnN+F99rkv+nfXpeHp4DhJADqH5hCAAAAAIAABAAAIAAAAAEAAAgAAAAAQAAFaWRsjXPKphmuqP+X4+uXMy1Ji/nOmPB9WnfaEhk2MZa/23VAxjPOb/VSFlyv14/H1wXOfYQAGrUqYUznxcbfiH9+4HfAFCjnlu5lCsF0JxKE8GmfxQAVc7GD75daviFJgOTSQBUuWn/aGi3AMfD3h8AUOXMZQD0RIWfAQAAAAAAAMoA4M50HX4rIvy0W4CXl+JbvKtHA4A95uAGxphEdFOXuk52O/xC2lSatC0ltk/7x6IAKDPB+eZTHfHwhlbKlD34It+IbZenVw+AEokM2zAZmFyt5BNf8hshZchg0P6N6GIfBMD9hm9hm/rPOb+r9uB39sb5hd85Z9dhANw9/Cn2kCHC/1jr4Rdi4pENwaV/DAD5ZWc/Pvk764wF10UH+5DqAcy+kYX9Hn6hYdH6paoBOLdB17L2KakXgEbKklneaFItQDk3V7WqfTG2JVrYJtUBuLhefb2HX8jsHxVVB5B/Zi8LgPbF2N8iwzaoBoCzdz9Rrbvcqv0WcP09qgEw++t35VMsU9D2tWoA+kLuG3IDYBLRTdUAtC/GtuQG0LJ2jYjzpTd2UQ8gMmxjcypN5AagkbLEPWvQKR5g/t9nMLIEsPEDE4oHyL+pkiWA5eyQS/EAHrfhqGwBfMMcAAAAAAAAAAAAAEBtADgA1BfA5TnRJleAGd9IQPEAdt5olCvAtH8spngAizDklivA8IL1K8UDjM1Np+UKYIjwNxUPcCLs/V6uAK8sfvCX4gHalhLbcgVoWbtGTAz7gGIB+NmeZrm9C77nUlQYmlUswMj8zGdyHr5GypLuqP8XxQLI8VXkzp5NXsqJluLLELUANn5gQu7LT6GROXNGcQAd8fAGDcPXSFlybHnlTrGNWlQCWIWT79Ly6S+UPxiEfoDXGLbxhQvLt2gavkbKktbk5Rxn7XqEeoD8jjNCY52x4DrVAIKz+8mnV68QWgGaU2ni9vZ1UQvAxCObtA7/7stSKgEcXH+vVqY74MptIjAlUQUgMmzD8x+n7ihh+P/tG7WwD1MDMDpvzipl+IU6YqE/qAAQx9mD9f7Hu1rFuQ062QPYvUYjbTdd5bwxo2IJ6oiH/1QSglbKkGPLK7dFC9uEk3PrHAAAsH8Ads5oGhYtX+ylKf94HACVHmEzzh5sTX6Sq3Tt1qWuk7MO/eMA2MuxZd7+45Vc1mqlDJnyjyewBFXluPqTjiOrV8t6iDYx9//jAwBUIY+n99X8vp1Sb7Nu24TBd/AjXLNDvE2n+0LuGy99uLj9TPIKObJ6lbz40YVbhgh/0+w79d5ez4SjHgABAAAIAABAAAAAAgAAEAAAgAAAAAQAAKB7+2cAekX5xqckrn0AAAAASUVORK5CYII="

/***/ }),

/***/ "jEp+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Card_vue__ = __webpack_require__("QDyf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e5ece06_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Card_vue__ = __webpack_require__("pLT5");
function injectStyle (ssrContext) {
  __webpack_require__("tIy3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e5ece06_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jHIg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import axios from 'axios'
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {},
  created: function created() {
    var fullUrl = document.URL;
    var splitUrl = fullUrl.split('r?');
    sessionStorage.setItem('urlstr', splitUrl[1]);
  },

  methods: {}
});

/***/ }),

/***/ "k7DQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditSubscription_vue__ = __webpack_require__("c919");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bfedd5f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditSubscription_vue__ = __webpack_require__("49Z0");
function injectStyle (ssrContext) {
  __webpack_require__("0Zgk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditSubscription_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bfedd5f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditSubscription_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kVx9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkbox_vue__ = __webpack_require__("uEKC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21231a5c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkbox_vue__ = __webpack_require__("nZ8L");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21231a5c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kefX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isEditable: false,
      popImage: "https://www.doodhvale.com/hmi_images/popup-img.png"
    };
  },
  created: function created() {
    this.fetchData();
  },

  methods: {
    fetchData: function fetchData() {
      var params = new URLSearchParams();
      var fullUrl = document.URL;
      var splitUrl = fullUrl.split("appLink?");
      if (splitUrl[1] != null) {
        params.append("source_name", splitUrl[1]);
        __WEBPACK_IMPORTED_MODULE_0_axios___default()({
          url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + "/accounts/app-download-source-name",
          method: "post",
          data: params,
          withCredentials: false,
          headers: {}
        });
      }
      if (navigator.userAgent.indexOf("Android") !== -1) {
        location.replace("https://play.google.com/store/apps/details?id=com.technologies.subtlelabs.doodhvale&hl=en");
      } else if (navigator.userAgent.indexOf("like Mac") !== -1) {
        location.replace("https://apps.apple.com/in/app/doodhvale/id1435706071");
      } else {
        location.replace("https://www.doodhvalefarms.com");
      }
    },
    closeModal: function closeModal() {
      this.isEditable = false;
      this.fetchData();
    }
  }
});

/***/ }),

/***/ "kmBe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('form',{staticStyle:{"height":"70px"},attrs:{"action":"#","target":"_blank"}},[_c('p',{staticStyle:{"text-align":"center"}},[_c('br'),_vm._v(" "),_c('router-link',{staticClass:"sub-btn",attrs:{"to":{ path: '/a/reg' }}},[_vm._v("SUBSCRIBE MILK")])],1)]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"apilist-innercontainer"},[_c('center',[_c('h3',{staticStyle:{"font-size":"22px","font-weight":"600"}},[_vm._v("Our Product")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"16px","text-align":"center"}},[_vm._v("\n          We produce Fresh Milk and other Dairy Products\n        ")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"api-call",staticStyle:{"margin":"auto","width":"90%"}},[_c('ul',_vm._l((_vm.products),function(product){return (product.cat_id == 2)?_c('li',{key:product.product_id},[_c('div',{staticClass:"api-box"},[_c('div',{staticClass:"product-image product_mobile_view_image productImageMobile",staticStyle:{"text-align":"center"}},[_c('img',{staticClass:"prod-imagee",attrs:{"src":product.product_image_s3_url
                      ? product.product_image_s3_url
                      : '',"alt":"product.product_name"}})]),_vm._v(" "),_c('div',{staticClass:"api-info product_mobile_view_app_info",staticStyle:{"width":"70vw","height":"auto"}},[_c('p',{staticClass:"product_name mobileViewContent",staticStyle:{"font-size":"18px","margin":"10px 0px","font-weight":"700"}},[_vm._v("\n                  "+_vm._s(product.product_name)),_c('br')]),_vm._v(" "),_c('p',{staticClass:"product_description mobileViewContent",staticStyle:{"font-size":"14px","font-weight":"600"}},[_vm._v("\n                  "+_vm._s(product.product_description)),_c('br')]),_vm._v(" "),_c('p',{staticClass:"prod_description",staticStyle:{"font-size":"16px","height":"auto","text-align":"justify"}},[_vm._v("\n                  "+_vm._s(product.prod_description)+"\n                ")])])])]):_vm._e()}))])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"innercontainer",attrs:{"width":"auto"}},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"cont-heading"},[_c('center',[_c('h3',{staticStyle:{"font-weight":"bold","font-size":"22px","padding":"20px 0px 10px","margin":"0"}},[_vm._v("\n            Unadulterated Staples and Groceries - Need of the hour\n          ")])])],1),_vm._v(" "),_vm._m(3)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"innercontainer",attrs:{"width":"auto"}},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"cont-heading"},[_c('center',[_c('h3',{staticStyle:{"font-weight":"bold","font-size":"22px","padding":"20px 0px 10px","margin":"0"}},[_vm._v("\n            Fresh and Hygienic Fruits and Vegetables\n          ")])])],1),_vm._v(" "),_vm._m(5)]),_vm._v(" "),_c('form',{staticStyle:{"height":"70px"},attrs:{"action":"#","target":"_blank"}},[_c('p',{staticStyle:{"text-align":"center"}},[_c('br'),_vm._v(" "),_c('router-link',{staticClass:"sub-btn",attrs:{"to":{ path: '/a/reg' }}},[_vm._v("SUBSCRIBE MILK")])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-image"},[_c('img',{staticClass:"big-banner",attrs:{"src":"https://www.doodhvale.com/img/desktop-banner3.png","alt":"Banner"}}),_vm._v(" "),_c('img',{staticClass:"small-banner",attrs:{"src":"https://www.doodhvale.com/img/home-banner-3.png","alt":"Banner"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",staticStyle:{"padding":"20px 10px"},attrs:{"align":"center"}},[_c('p',{staticStyle:{"font-size":"20px","font-weight":"600","text-align":"center"}},[_vm._v("\n          Download the Doodhvale app on your phone\n        ")]),_vm._v(" "),_c('div',{staticClass:"download-link"},[_c('a',{attrs:{"href":"https://apps.apple.com/in/app/doodhvale/id1435706071","target":"_main"}},[_c('img',{attrs:{"alt":"appstore","src":"https://www.doodhvale.com/img/appstore.png"}})]),_vm._v(" "),_c('a',{attrs:{"href":"https://play.google.com/store/apps/details?id=com.technologies.subtlelabs.doodhvale","target":"_main"}},[_c('img',{attrs:{"alt":"googleplay","src":"https://www.doodhvale.com/img/google-play.png"}})])]),_vm._v(" "),_c('div',{staticClass:"hero-box"},[_c('div',{staticClass:"msg"},[_c('p',{staticStyle:{"font-size":"20px","display":"flex","font-weight":"600","justify-content":"center","margin-bottom":"0"}},[_vm._v("\n          Delivering Farm Happiness to your home with Love!\n        ")])]),_vm._v(" "),_c('div',{staticClass:"hero-msg",staticStyle:{"text-align":"center"}},[_c('p',{staticStyle:{"margin":"10px 0px"}},[_vm._v("\n            Doodhvale is a D2C dairy company that delivers high-quality milk\n            products straight from the farm to the customer's doorstep. With\n            Customer-first approach, Cutting-edge technology, and high focus\n            on Quality, we are disrupting the broken and exploited Dairy\n            industry!\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"grid-container"},[_c('div',{staticClass:"grid-item",staticStyle:{"border-bottom":"1px solid lightgrey","border-right":"1px solid lightgrey"}},[_c('div',{staticClass:"msg-icon"},[_c('img',{attrs:{"src":"static/img/icons/handshake.png","alt":""}})]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"20px","margin":"0px 0px 10px","font-weight":"bold","width":"330px","text-align":"center"}},[_vm._v("\n            Farm Fresh Pure and Happy Milk\n          ")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"14px","width":"350px"}},[_vm._v("\n            Doodhvale's milk comes from large Hi Tech dairy farms. The milk is\n            natural, stress-free and delivered within 24-36 hours of milking.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"grid-item",staticStyle:{"border-bottom":"1px solid lightgrey","border-right":"1px solid lightgrey"}},[_c('div',{staticClass:"msg-icon"},[_c('img',{attrs:{"src":"static/img/icons/dropper.png","alt":""}})]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"20px","margin":"0px 0px 10px","font-weight":"bold","width":"330px","text-align":"center"}},[_vm._v("\n            Rigorous Daily Quality Testing\n          ")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"16px","width":"350px"}},[_vm._v("\n            We ensure high quality with scientific testing from cattle feed to\n            final production. Customers gain confidence with our self-test\n            kit, external certified lab report on 65+ parameters, and daily\n            lab test report available on our app.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"grid-item",staticStyle:{"border-bottom":"1px solid lightgrey"}},[_c('div',{staticClass:"msg-icon"},[_c('img',{attrs:{"src":"static/img/icons/freezing.png","alt":""}})]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"20px","margin":"0px 0px 10px","font-weight":"bold","width":"330px","text-align":"center"}},[_vm._v("\n            Grass to Glass - Enabled by Cold Chain\n          ")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"16px","width":"350px"}},[_vm._v("\n            Our pasteurization process and end-to-end cold-chain at 3°C\n            maintains healthy shelf life for the milk and prevents any\n            increase in bacteria counts.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"grid-item box4grid",staticStyle:{"border-right":"1px solid lightgrey"}},[_c('div',{staticClass:"msg-icon"},[_c('img',{attrs:{"src":"static/img/icons/house.png","alt":""}})]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"20px","margin":"0px 0px 10px","font-weight":"bold","width":"330px","max-height":"30px","text-align":"center"}},[_vm._v("\n            Hassle-free, Free Home Delivery\n          ")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"16px","width":"350px"}},[_vm._v("\n            We believe in delivering fresh products to your doorstep without\n            any hassle. Our delivery is free of cost, and we strive to ensure\n            a hassle-free experience where our partners drop off the product\n            in a bag hanging outside the customer's gate without any\n            disturbance.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"grid-item",staticStyle:{"border-right":"1px solid lightgrey"}},[_c('div',{staticClass:"msg-icon"},[_c('img',{attrs:{"src":"static/img/icons/smartphone.png","alt":""}})]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"20px","margin":"0px 0px 10px","font-weight":"bold","width":"330px","text-align":"center"}},[_vm._v("\n            User Friendly Mobile App\n          ")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"16px","width":"350px"}},[_vm._v("\n            Technology is at your fingertips. Our convenient mobile app allows\n            customers to control their daily orders until 12 AM, with easy\n            access to all our services including ordering, customer service,\n            billing, payments, rewards, and offers.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"grid-item"},[_c('div',{staticClass:"msg-icon"},[_c('img',{attrs:{"src":"static/img/icons/smile.png","alt":""}})]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"20px","margin":"0px 0px 10px","font-weight":"bold","width":"330px","text-align":"center"}},[_vm._v("\n            Loved by more than 50,000 Customers\n          ")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"16px","width":"350px"}},[_vm._v("\n            The customer is at the forefront of our venture. We are proud to\n            be consistently appreciated and rated 4.5+ by thousands of happy\n            families, from babies to the elderly.\n          ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cont-img"},[_c('img',{attrs:{"src":"https://www.doodhvale.com/img/Grocery3.jpg","alt":"Unadlterarted Pure and Grocery"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cont-info"},[_c('p',{staticStyle:{"margin":"15px 0px 16px"}},[_vm._v("\n          At Doodhvale, we understand that good health is a top priority for\n          everyone. That's why we source only the purest and most natural\n          staples and spices directly from farmers, eliminating any\n          possibility of unnatural mixing or adulteration. We cut out the\n          middleman to offer the best possible prices for our customers. Our\n          rigorous selection process ensures that all items are thoroughly\n          cleaned and packed using the best materials before being delivered\n          straight to your doorstep. With our convenient online shopping and\n          delivery, you can save time, money, and effort while prioritizing\n          your health. Download the Doodhvale app today and experience\n          hassle-free shopping for all your kitchen essentials.\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cont-img"},[_c('img',{attrs:{"src":"https://www.doodhvale.com/img/fresh-fruits-vegetables-doodhvale.jpg","alt":"Fresh and Hygienic Fruits and Vegetables"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cont-info"},[_c('p',{staticStyle:{"margin":"15px 0px 16px"}},[_vm._v("\n          Fresh and chemical-free fruits and vegetables are critically\n          important in your daily diet. That's why we offer a wide range of\n          fresh and hygienic vegetables like potatoes, tomatoes, carrots,\n          onions, and more, directly sourced from farmers and delivered to\n          your doorstep. Our quality packaging ensures that the produce\n          reaches you in the best condition possible. And with our competitive\n          pricing, you can trust us to provide the best value for your money.\n          Shop for your daily needs hassle-free on our online platform and\n          enjoy the convenience of doorstep delivery.\n        ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kwv9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-street-view-pano-container"},[_c('div',{ref:"vue-street-view-pano",staticClass:"vue-street-view-pano"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kxy4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lH3w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lW6Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lpEV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Edit Profile")]),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('fg-input',{attrs:{"type":"text","label":"Company","disabled":true,"placeholder":"Paper dashboard"},model:{value:(_vm.user.company),callback:function ($$v) {_vm.$set(_vm.user, "company", $$v)},expression:"user.company"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('fg-input',{attrs:{"type":"text","label":"Username","placeholder":"Username"},model:{value:(_vm.user.username),callback:function ($$v) {_vm.$set(_vm.user, "username", $$v)},expression:"user.username"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('fg-input',{attrs:{"type":"email","label":"Username","placeholder":"Email"},model:{value:(_vm.user.email),callback:function ($$v) {_vm.$set(_vm.user, "email", $$v)},expression:"user.email"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"First Name","placeholder":"First Name"},model:{value:(_vm.user.firstName),callback:function ($$v) {_vm.$set(_vm.user, "firstName", $$v)},expression:"user.firstName"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Last Name","placeholder":"Last Name"},model:{value:(_vm.user.lastName),callback:function ($$v) {_vm.$set(_vm.user, "lastName", $$v)},expression:"user.lastName"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('fg-input',{attrs:{"type":"text","label":"Address","placeholder":"Home Address"},model:{value:(_vm.user.address),callback:function ($$v) {_vm.$set(_vm.user, "address", $$v)},expression:"user.address"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('fg-input',{attrs:{"type":"text","label":"City","placeholder":"City"},model:{value:(_vm.user.city),callback:function ($$v) {_vm.$set(_vm.user, "city", $$v)},expression:"user.city"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('fg-input',{attrs:{"type":"text","label":"Country","placeholder":"Country"},model:{value:(_vm.user.country),callback:function ($$v) {_vm.$set(_vm.user, "country", $$v)},expression:"user.country"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('fg-input',{attrs:{"type":"number","label":"Postal Code","placeholder":"ZIP Code"},model:{value:(_vm.user.postalCode),callback:function ($$v) {_vm.$set(_vm.user, "postalCode", $$v)},expression:"user.postalCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("About Me")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.aboutMe),expression:"user.aboutMe"}],staticClass:"form-control border-input",attrs:{"rows":"5","placeholder":"Here can be your description"},domProps:{"value":(_vm.user.aboutMe)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "aboutMe", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-info btn-fill float-right",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.updateProfile($event)}}},[_vm._v("\n        Update Profile\n      ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lpFE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// import VueAxios from 'vue-axios'
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    LTable: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Table_vue__["a" /* default */],
    ChartCard: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */],
    StatsCard: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */]
  },
  data: function data() {
    return {
      urlInterface: [],
      obj: {},
      successfully_feedback: false,
      test_date: String,
      cow_test: {},
      buff_test: {},
      apiDataObj: [],
      isLoading: true,
      isFullPage: true
    };
  },
  created: function created() {
    this.fetchData();
  },

  methods: {
    fetchData: function fetchData() {
      var _this = this;

      // console.log(process.env.BASE_API+ '/accounts/fetch-url-interface-data')
      var params = new URLSearchParams();
      var fullUrl = document.URL;
      var splitUrl = fullUrl.split('dmtr?');
      params.append('url_str', splitUrl[1]);
      // console.log(splitUrl[1])
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/accounts/fetch-url-interface-data',
        method: 'post',
        data: params
      }).then(function (response) {
        _this.urlInterface = {};
        if (response.data.status === '000001' || response.data.status === '000002' || response.data.status === '000003') {
          _this.urlInterface.error_msg = response.data.msg;
          document.getElementById('url_valid').style.display = 'none';
          _this.isLoading = false;
        } else {
          document.getElementById('url_expired').style.display = 'none';
          _this.urlInterface.action_name = response.data.action_name;
          _this.urlInterface.url_interface_id = response.data.url_interface_id;
          _this.urlInterface.sub_action_name = 'load';
          _this.urlInterface.vue_url = fullUrl;
          _this.invokeUrlAction();
        }
        setTimeout(function () {
          _this.isLoading = false;
        }, 10000);
      }).catch(function (e) {
        _this.isLoading = false;
      });
    },
    invokeUrlAction: function invokeUrlAction() {
      var _this2 = this;

      var params = new URLSearchParams();
      params.append('url_interface_id', this.urlInterface.url_interface_id);
      params.append('action_name', this.urlInterface.action_name);
      params.append('sub_action_name', this.urlInterface.sub_action_name);
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/accounts/invoke-url-action',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this2.apiDataObj = {};
        _this2.obj = response.data.action_response;
        _this2.test_date = _this2.obj.test_date;
        _this2.cow_test.fat = _this2.obj.cow_test_fat;
        _this2.cow_test.snf = _this2.obj.cow_test_snf;
        _this2.cow_test.clr = _this2.obj.cow_test_clr;
        _this2.cow_test.urea = _this2.obj.cow_test_urea;
        _this2.cow_test.starch = _this2.obj.cow_test_starch;
        _this2.cow_test.detergent = _this2.obj.cow_test_detergent;
        _this2.cow_test.caustic = _this2.obj.cow_test_caustic;
        _this2.cow_test.antibiotic = _this2.obj.cow_test_antibiotic;
        _this2.cow_test.alcohol = _this2.obj.cow_test_alcohol;
        _this2.buff_test.snf = _this2.obj.buff_test_snf;
        _this2.buff_test.clr = _this2.obj.buff_test_clr;
        _this2.buff_test.fat = _this2.obj.buff_test_fat;
        _this2.buff_test.urea = _this2.obj.buff_test_urea;
        _this2.buff_test.starch = _this2.obj.buff_test_starch;
        _this2.buff_test.detergent = _this2.obj.buff_test_detergent;
        _this2.buff_test.caustic = _this2.obj.buff_test_caustic;
        _this2.buff_test.antibiotic = _this2.obj.buff_test_antibiotic;
        _this2.buff_test.alcohol = _this2.obj.buff_test_alcohol;
        setTimeout(function () {
          _this2.isLoading = false;
        }, 10000);
      }).catch(function (e) {});
    },

    convertDate: function convertDate(dateString) {
      var myday = new Date(dateString).getDay();
      var mydate = new Date(dateString).toDateString().split(' ');
      var weekday = new Array(7);
      weekday[0] = 'Sunday';
      weekday[1] = 'Monday';
      weekday[2] = 'Tuesday';
      weekday[3] = 'Wednesday';
      weekday[4] = 'Thursday';
      weekday[5] = 'Friday';
      weekday[6] = 'Saturday';
      return weekday[myday] + ' ' + mydate[2] + '-' + mydate[1] + '-' + mydate[3];
    }
  }
});

/***/ }),

/***/ "mLAn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/page4.a2370d0.jpg";

/***/ }),

/***/ "mfGc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mgdb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-loading',{attrs:{"is-full-page":_vm.isFullPage,"active":_vm.isLoading},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),(_vm.successfully_feedback === false)?_c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"url_valid"}},[_c('div',{attrs:{"id":"border"}},[_c('div',{staticStyle:{"text-align":"center","margin-bottom":"10px"},attrs:{"id":"milk_test_date"}},[_c('h4',{staticStyle:{"font-family":"Calibari"}},[_vm._v("Test Date")]),_vm._v(" "),_c('div',{staticClass:"display_test_date"},[_c('b',{staticStyle:{"font-family":"Calibari"}},[_vm._v(_vm._s(_vm.convertDate(_vm.test_date)))])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('table',{staticClass:"table table-bordered"},[_c('col',{attrs:{"width":"20"}}),_vm._v(" "),_c('col',{attrs:{"width":"20"}}),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('tbody',[_c('tr',[_vm._m(3),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.cow_test.fat)+" %")])]),_vm._v(" "),_c('tr',[_vm._m(4),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.cow_test.snf)+" %")])]),_vm._v(" "),_c('tr',[_vm._m(5),_vm._v(" "),_c('td',[_c('span',{class:{ 'negative': _vm.cow_test.urea, 'positive': 1 }},[_vm._v("0000")]),_c('span',{staticClass:"graytext"}),_vm._v("\n                ("+_vm._s(_vm.cow_test.urea ? "Adultrated" : "Non-Adultrated")+")")])]),_vm._v(" "),_c('tr',[_vm._m(6),_vm._v(" "),_c('td',[_c('span',{class:{ 'negative': _vm.cow_test.starch, 'positive': 1 }},[_vm._v("0000")]),_c('span',{staticClass:"graytext"},[_vm._v(" ("+_vm._s(_vm.cow_test.starch ? "Adultrated" : "Non-Adultrated")+")")])])]),_vm._v(" "),_c('tr',[_vm._m(7),_vm._v(" "),_c('td',[_c('span',{class:{ 'negative': _vm.cow_test.detergent, 'positive': 1 }},[_vm._v("0000")]),_c('span',{staticClass:"graytext"},[_vm._v(" ("+_vm._s(_vm.cow_test.detergent ? "Adultrated" : "Non-Adultrated")+")")])])]),_vm._v(" "),_c('tr',[_vm._m(8),_vm._v(" "),_c('td',[_c('span',{class:{ 'negative': _vm.cow_test.antibiotic, 'positive': 1 }},[_vm._v("0000")]),_c('span',{staticClass:"graytext"},[_vm._v(" ("+_vm._s(_vm.cow_test.antibiotic ? "Adultrated" : "Non-Adultrated")+")")])])]),_vm._v(" "),_c('tr',[_vm._m(9),_vm._v(" "),_c('td',[_c('span',{class:{ 'negative': _vm.cow_test.alcohol, 'positive': 1 }},[_vm._v("0000")]),_c('span',{staticClass:"graytext"},[_vm._v(" ("+_vm._s(_vm.cow_test.alcohol ? "Not-Fresh" : "Fresh")+")")])])]),_vm._v(" "),_c('tr',[_vm._m(10),_vm._v(" "),_c('td',[_c('span',{class:{ 'negative': _vm.cow_test.caustic, 'positive': 1 }},[_vm._v("0000")]),_c('span',{staticClass:"graytext"},[_vm._v(" ("+_vm._s(_vm.cow_test.caustic ? "Adultrated" : "Non-Adultrated")+")")])])])])]),_vm._v(" "),_vm._m(11),_vm._v(" "),_c('table',{staticClass:"table table-bordered"},[_c('col',{attrs:{"width":"20"}}),_vm._v(" "),_c('col',{attrs:{"width":"20"}}),_vm._v(" "),_vm._m(12),_vm._v(" "),_c('tbody',[_c('tr',[_vm._m(13),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.buff_test.fat)+" %")])]),_vm._v(" "),_c('tr',[_vm._m(14),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.buff_test.snf)+" %")])]),_vm._v(" "),_c('tr',[_vm._m(15),_vm._v(" "),_c('td',[_c('span',{class:{ 'negative': _vm.buff_test.urea, 'positive': 1 }},[_vm._v("0000")]),_c('span',{staticClass:"graytext"},[_vm._v(" ("+_vm._s(_vm.buff_test.urea ? "Adultrated" : "Non-Adultrated")+")")])])]),_vm._v(" "),_c('tr',[_vm._m(16),_vm._v(" "),_c('td',[_c('span',{class:{ 'negative': _vm.buff_test.starch, 'positive': 1 }},[_vm._v("0000")]),_c('span',{staticClass:"graytext"},[_vm._v(" ("+_vm._s(_vm.buff_test.starch ? "Adultrated" : "Non-Adultrated")+")")])])]),_vm._v(" "),_c('tr',[_vm._m(17),_vm._v(" "),_c('td',[_c('span',{class:{ 'negative': _vm.buff_test.detergent, 'positive': 1 }},[_vm._v("0000")]),_c('span',{staticClass:"graytext"},[_vm._v(" ("+_vm._s(_vm.buff_test.detergent ? "Adultrated" : "Non-Adultrated")+")")])])]),_vm._v(" "),_c('tr',[_vm._m(18),_vm._v(" "),_c('td',[_c('span',{class:{ 'negative': _vm.buff_test.antibiotic, 'positive': 1 }},[_vm._v("0000")]),_c('span',{staticClass:"graytext"},[_vm._v(" ("+_vm._s(_vm.buff_test.antibiotic ? "Adultrated" : "Non-Adultrated")+")")])])]),_vm._v(" "),_c('tr',[_vm._m(19),_vm._v(" "),_c('td',[_c('span',{class:{ 'negative': _vm.buff_test.alcohol, 'positive': 1 }},[_vm._v("0000")]),_c('span',{staticClass:"graytext"},[_vm._v(" ("+_vm._s(_vm.buff_test.alcohol ? "Not-Fresh" : "Fresh")+")")])])]),_vm._v(" "),_c('tr',[_vm._m(20),_vm._v(" "),_c('td',[_c('span',{class:{ 'negative': _vm.buff_test.caustic, 'positive': 1 }},[_vm._v("0000")]),_c('span',{staticClass:"graytext"},[_vm._v(" ("+_vm._s(_vm.buff_test.caustic ? "Adultrated" : "Non-Adultrated")+")")])])])])]),_vm._v(" "),_vm._m(21)])])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center","width":"90%"},attrs:{"id":"url_expired"}},[_c('h4',[_vm._v("Welcome to Doodhvale, Please wait...")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center","margin-bottom":"10px"},attrs:{"id":"display_cow_milk_test_result"}},[_c('h4',[_c('b',{staticStyle:{"font-family":"Calibari"}},[_vm._v("Cow Milk Test Result")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticClass:"usertable"},[_c('th',{attrs:{"scope":"col"}},[_vm._v("Tests")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Results")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_vm._v("FAT"),_c('span',{staticClass:"graytext"},[_vm._v(" (3.5% to 3.9%)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_vm._v("SNF"),_c('span',{staticClass:"graytext"},[_vm._v(" (7.8 to 8.3)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_vm._v("Urea"),_c('span',{staticClass:"graytext"},[_vm._v(" (0.0% to 0.5%)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_vm._v("Starch"),_c('span',{staticClass:"graytext"},[_vm._v(" (0.0% to 0.5%)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_vm._v("Detergent"),_c('span',{staticClass:"graytext"},[_vm._v(" (0.0% to 0.5%)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_vm._v("Antibiotics"),_c('span',{staticClass:"graytext"},[_vm._v(" (0.0% to 0.5%)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_vm._v("Acidity"),_c('span',{staticClass:"graytext"},[_vm._v(" (0.0%v/v - 68.0% v/v)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_vm._v("Caustic Soda"),_c('span',{staticClass:"graytext"},[_vm._v(" (0.0% to 0.5%)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center","margin-bottom":"10px"},attrs:{"id":"display_cow_milk_test_result"}},[_c('h4',[_c('b',{staticStyle:{"font-family":"Calibari"}},[_vm._v("Buffalo Milk Test Result")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticClass:"usertable"},[_c('th',{attrs:{"scope":"col"}},[_vm._v("Tests")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Results")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_vm._v("FAT"),_c('span',{staticClass:"graytext"},[_vm._v(" (6.2% to 6.7%)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_vm._v("SNF"),_c('span',{staticClass:"graytext"},[_vm._v(" (8.6 to 9.2)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_vm._v("Urea"),_c('span',{staticClass:"graytext"},[_vm._v(" (0.0% to 0.5%)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_vm._v("Starch"),_c('span',{staticClass:"graytext"},[_vm._v(" (0.0% to 0.5%)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_vm._v("Detergent"),_c('span',{staticClass:"graytext"},[_vm._v(" (0.0% to 0.5%)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_vm._v("Antibiotics"),_c('span',{staticClass:"graytext"},[_vm._v(" (0.0% to 0.5%)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_vm._v("Acidity"),_c('span',{staticClass:"graytext"},[_vm._v(" (0.0%v/v - 68.0% v/v)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_vm._v("Caustic Soda"),_c('span',{staticClass:"graytext"},[_vm._v(" (0.0% to 0.5%)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"para-color",attrs:{"id":"test-discription"}},[_c('p',[_vm._v("\n            Legends: Green - No adultration in milk. Red - Adultrated milk.\n          ")]),_vm._v(" "),_c('h6',{staticStyle:{"font-family":"Calibari"}},[_vm._v("Test Description:")]),_vm._v(" "),_c('p',[_vm._v("\n            1. FAT: The fat content of milk is the proportion of milk, by weight, made up by butterfat.\n            Market processed milk FAT: Full Cream:6.2, Tonned:3.1, Double Tonned:1.5, Skimmed:.1\n            Natural Healthy Cow Milk FAT varies between 3.4 to 4.0, Natural Healthy Buffalo Milk FAT varies between\n            6.0 to 7.0\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            2. SNF: Solid Not Fat, The substances in milk other than butterfat and water. They include casein,\n            lactose, vitamins, and minerals which contribute significantly to the nutritive value of milk. Natural\n            Healthy Cow Milk SNF varies between 7.5 to 8.5, Natural Healthy Buffalo Milk SNF varies between 8.5 to 9.5\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            3. Urea: PASS {Green}: Milk is not adulterated with Urea. FAIL {Red}: Milk is adultrated with Urea.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            4. Starch: PASS {Green}: Milk is not adulterated with Starch. FAIL {Red}: Milk is adultrated with Starch.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            5. Detergent: PASS {Green}: Milk is not adulterated with Detergent. FAIL {Red}: Milk is adultrated with\n            Detergent.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            6. Antibiotics: PASS {Green}: Milk is not adulterated with any antibiotics. FAIL {Red}: Milk is adultrated\n            with antibiotics.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            7. Alcohol: Freshness & Acidity test of milk. PASS {Green}: Milk passes 68% v/v ethanol test. FAIL {Red}:\n            Milk fails 68% v/v ethanol test.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            8. Caustic Soda: PASS {Green}: Milk is not adulterated with Castic Soda. FAIL {Red}: Milk is adultrated\n            with Castic Soda.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            *Note: Minimum detection range: 0.5%\n          ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nWjp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_F_vue__ = __webpack_require__("dzxp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1db5b136_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_F_vue__ = __webpack_require__("61BT");
function injectStyle (ssrContext) {
  __webpack_require__("vG9Y")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_F_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1db5b136_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_F_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nZ8L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-check",class:{disabled: _vm.disabled}},[_c('label',{staticClass:"form-check-label",attrs:{"for":_vm.cbId}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],staticClass:"form-check-input",attrs:{"id":_vm.cbId,"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":Array.isArray(_vm.model)?_vm._i(_vm.model,null)>-1:(_vm.model)},on:{"change":function($event){var $$a=_vm.model,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.model=$$a.concat([$$v]))}else{$$i>-1&&(_vm.model=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.model=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"form-check-sign"})]),_vm._v(" "),_c('span',[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nfaN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w3-content",staticStyle:{"max-width":"90%"}},[_c('h2',{staticStyle:{"text-align":"center"}},[_vm._v("Contact Us")]),_vm._v(" "),_c('br'),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("Contact Information")]),_c('br'),_c('br'),_vm._v("\n\nSanjeevani Dairy Farms Pvt. Ltd."),_c('br'),_vm._v("\nB2, Vikas Chamber, D Block Central Market, Rohini, Delhi – 110085"),_c('br'),_vm._v("\nTel.: +91 11 47035487"),_c('br'),_vm._v("\nEmail id: doodhvale@gmail.com"),_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nhQu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hmi_vue__ = __webpack_require__("hEw7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_547bfdde_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hmi_vue__ = __webpack_require__("ipMx");
function injectStyle (ssrContext) {
  __webpack_require__("lH3w")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hmi_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_547bfdde_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hmi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nqbW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditProfileForm_vue__ = __webpack_require__("CO8C");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07ac72ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditProfileForm_vue__ = __webpack_require__("lpEV");
function injectStyle (ssrContext) {
  __webpack_require__("NINg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditProfileForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07ac72ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditProfileForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nt0W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notifications_vue__ = __webpack_require__("cNny");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_460d7076_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notifications_vue__ = __webpack_require__("9/pl");
function injectStyle (ssrContext) {
  __webpack_require__("vS1+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notifications_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_460d7076_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notifications_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ofci":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Btn__ = __webpack_require__("+zKw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['products'],

  components: {
    btn: __WEBPACK_IMPORTED_MODULE_2__Btn__["a" /* default */]
  },
  data: function data() {
    return {
      imgPreUrl: 'https://doodhvale.in'
    };
  },
  created: function created() {
    // console.log(this.$props.products)
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['addProduct', 'currentProduct']), {
    addProductToCart: function addProductToCart(product) {
      this.addProduct(product);
    },
    onClickSubButton: function onClickSubButton(productList) {
      // console.log(productList)
      // alert(productList.product_id)
      if (productList.btn_text === 'NOTIFY ME') {
        // alert('notified')
        this.$swal.fire({
          text: 'Do you want to get notified when this product is in store?',
          showCancelButton: true,
          confirmButtonColor: '#3CB6C3',
          cancelButtonColor: '#3CB6C3',
          confirmButtonText: 'No',
          cancelButtonText: 'Yes'
        }).then(function (result) {
          if (result.value) {
            // alert('no')
          } else {
            var params = new URLSearchParams();
            params.append('action_name', 'notify_for_product');
            params.append('user_id', sessionStorage.getItem('userId'));
            params.append('product_id', productList.product_id);
            __WEBPACK_IMPORTED_MODULE_3_axios___default()({
              url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/users/invoke-user-action',
              method: 'post',
              data: params,
              withCredentials: false,
              headers: {}
            }).then(function (response) {
              // console.log(response)
              window.location.reload();
            }).catch(function (e) {
              alert('not ok');
            });
          }
        });
      } else if (productList.is_button_enable === 1) {
        sessionStorage.setItem('productId', productList.product_id);
        sessionStorage.setItem('productName', productList.product_name);
        sessionStorage.setItem('productImageUrl', productList.product_image_s3_url);
        sessionStorage.setItem('productShortDescription', productList.product_description);
        sessionStorage.setItem('productLongDescription', productList.prod_description);
        sessionStorage.setItem('brandName', productList.brand_name);
        sessionStorage.setItem('isEditSubscription', productList.subscription);
        sessionStorage.setItem('subscriptionType', productList.subscription_type);
        var subscriptionId = 0;
        if (productList.subscription_id !== 'undefined') {
          subscriptionId = productList.subscription_id;
        }
        sessionStorage.setItem('subscriptionId', subscriptionId);
        this.$router.push('/a/editSubscription');
      }
    },
    addCurrentProduct: function addCurrentProduct(product) {
      this.currentProduct(product);
    }
  })
});

/***/ }),

/***/ "owFT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-loading',{attrs:{"is-full-page":_vm.isFullPage,"active":_vm.isLoading},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"url_valid"}},[_c('div',[_c('div',{attrs:{"id":"border"}},[_c('div',{staticStyle:{"text-align":"center","margin-bottom":"10px"},attrs:{"id":"milk_test_date"}},[_c('h4',[_vm._v("Test Date")]),_vm._v(" "),_c('div',{staticClass:"display_test_date"},[_c('b',[_vm._v(_vm._s(_vm.test_date))])])]),_vm._v(" "),_c('form',{on:{"submit":function($event){_vm.submitDailyMilkTestReportData()}}},[_c('div',{staticStyle:{"text-align":"center","margin-bottom":"10px"},attrs:{"id":"display_cow_milk_test_result"}},[_c('h4',[_vm._v("Cow Milk Test Result")]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(1),_vm._v(" "),_c('div',{staticStyle:{"width":"50%"}},[_c('div',{staticStyle:{"text-align":"left","margin-bottom":"10px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cow_test.fat),expression:"cow_test.fat"}],class:{'inp readonlytextbox': _vm.lock,  'inp': 1 },attrs:{"type":"number","name":"cow_test_fat","id":"cow_test_fat","step":"0.01","maxlength":"4","min":"3","value":"","max":"5","required":"","readonly":_vm.lock == 1},domProps:{"value":(_vm.cow_test.fat)},on:{"blur":function($event){_vm.calCowSNF()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cow_test, "fat", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"left","margin-bottom":"10px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cow_test.clr),expression:"cow_test.clr"}],class:{'inp readonlytextbox': _vm.lock,  'inp': 1 },attrs:{"type":"number","name":"cow_test_clr","id":"cow_test_clr","step":"0.01","maxlength":"4","min":"20.0","max":"35.0","required":"","readonly":_vm.lock == 1},domProps:{"value":(_vm.cow_test.clr)},on:{"blur":function($event){_vm.calCowSNF()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cow_test, "clr", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"left","margin-bottom":"10px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cow_test.snf),expression:"cow_test.snf"}],staticClass:"inp readonlytextbox",attrs:{"type":"number","name":"cow_test_snf","id":"cow_test_snf","maxlength":"4","required":"","readonly":""},domProps:{"value":(_vm.cow_test.snf)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cow_test, "snf", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"my-toggle-btn-wrapper",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"my-toggle-btn"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cow_test.urea),expression:"cow_test.urea"}],attrs:{"name":"cow_test_urea","type":"checkbox","id":"cow_test_urea","disabled":_vm.lock == 1},domProps:{"checked":Array.isArray(_vm.cow_test.urea)?_vm._i(_vm.cow_test.urea,null)>-1:(_vm.cow_test.urea)},on:{"change":function($event){var $$a=_vm.cow_test.urea,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.cow_test, "urea", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.cow_test, "urea", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.cow_test, "urea", $$c)}}}}),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('div',{staticClass:"my-toggle-btn-wrapper",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"my-toggle-btn"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cow_test.starch),expression:"cow_test.starch"}],attrs:{"name":"cow_test_starch","type":"checkbox","id":"cow_test_starch","disabled":_vm.lock == 1},domProps:{"checked":Array.isArray(_vm.cow_test.starch)?_vm._i(_vm.cow_test.starch,null)>-1:(_vm.cow_test.starch)},on:{"change":function($event){var $$a=_vm.cow_test.starch,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.cow_test, "starch", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.cow_test, "starch", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.cow_test, "starch", $$c)}}}}),_vm._v(" "),_vm._m(3)])]),_vm._v(" "),_c('div',{staticClass:"my-toggle-btn-wrapper",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"my-toggle-btn"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cow_test.detergent),expression:"cow_test.detergent"}],attrs:{"name":"cow_test_detergent","type":"checkbox","id":"cow_test_detergent","disabled":_vm.lock == 1},domProps:{"checked":Array.isArray(_vm.cow_test.detergent)?_vm._i(_vm.cow_test.detergent,null)>-1:(_vm.cow_test.detergent)},on:{"change":function($event){var $$a=_vm.cow_test.detergent,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.cow_test, "detergent", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.cow_test, "detergent", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.cow_test, "detergent", $$c)}}}}),_vm._v(" "),_vm._m(4)])]),_vm._v(" "),_c('div',{staticClass:"my-toggle-btn-wrapper",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"my-toggle-btn"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cow_test.antibiotic),expression:"cow_test.antibiotic"}],attrs:{"name":"cow_test_antibiotic","type":"checkbox","id":"cow_test_antibiotic","disabled":_vm.lock == 1},domProps:{"checked":Array.isArray(_vm.cow_test.antibiotic)?_vm._i(_vm.cow_test.antibiotic,null)>-1:(_vm.cow_test.antibiotic)},on:{"change":function($event){var $$a=_vm.cow_test.antibiotic,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.cow_test, "antibiotic", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.cow_test, "antibiotic", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.cow_test, "antibiotic", $$c)}}}}),_vm._v(" "),_vm._m(5)])]),_vm._v(" "),_c('div',{staticClass:"my-toggle-btn-wrapper",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"my-toggle-btn"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cow_test.alcohol),expression:"cow_test.alcohol"}],attrs:{"name":"cow_test_alcohol","type":"checkbox","id":"cow_test_alcohol","disabled":_vm.lock == 1},domProps:{"checked":Array.isArray(_vm.cow_test.alcohol)?_vm._i(_vm.cow_test.alcohol,null)>-1:(_vm.cow_test.alcohol)},on:{"change":function($event){var $$a=_vm.cow_test.alcohol,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.cow_test, "alcohol", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.cow_test, "alcohol", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.cow_test, "alcohol", $$c)}}}}),_vm._v(" "),_vm._m(6)])]),_vm._v(" "),_c('div',{staticClass:"my-toggle-btn-wrapper",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"my-toggle-btn"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cow_test.caustic),expression:"cow_test.caustic"}],attrs:{"name":"cow_test_caustic","type":"checkbox","id":"cow_test_caustic","disabled":_vm.lock == 1},domProps:{"checked":Array.isArray(_vm.cow_test.caustic)?_vm._i(_vm.cow_test.caustic,null)>-1:(_vm.cow_test.caustic)},on:{"change":function($event){var $$a=_vm.cow_test.caustic,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.cow_test, "caustic", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.cow_test, "caustic", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.cow_test, "caustic", $$c)}}}}),_vm._v(" "),_vm._m(7)])])])])]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","margin-bottom":"10px"},attrs:{"id":"display_cow_milk_test_result"}},[_c('h4',[_vm._v("Buffalo Milk Test Result")]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(8),_vm._v(" "),_c('div',{staticStyle:{"width":"50%"}},[_c('div',{staticStyle:{"text-align":"left","margin-bottom":"10px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.buff_test.fat),expression:"buff_test.fat"}],class:{'inp readonlytextbox': _vm.lock,  'inp': 1 },attrs:{"type":"number","name":"buff_test_fat","id":"buff_test_fat","step":"0.01","maxlength":"4","min":"5.5","max":"7.5","required":"","readonly":_vm.lock == 1},domProps:{"value":(_vm.buff_test.fat)},on:{"blur":function($event){_vm.calBuffSNF()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.buff_test, "fat", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"left","margin-bottom":"10px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.buff_test.clr),expression:"buff_test.clr"}],class:{'inp readonlytextbox': _vm.lock,  'inp': 1 },attrs:{"type":"number","name":"buff_test_clr","id":"buff_test_clr","step":"0.01","maxlength":"4","min":"20","max":"35","required":"","readonly":_vm.lock == 1},domProps:{"value":(_vm.buff_test.clr)},on:{"blur":function($event){_vm.calBuffSNF()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.buff_test, "clr", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"left","margin-bottom":"10px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.buff_test.snf),expression:"buff_test.snf"}],staticClass:"inp readonlytextbox",attrs:{"type":"number","name":"buff_test_snf","id":"buff_test_snf","step":"0.01","maxlength":"4","required":"","readonly":""},domProps:{"value":(_vm.buff_test.snf)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.buff_test, "snf", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"my-toggle-btn-wrapper",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"my-toggle-btn"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.buff_test.urea),expression:"buff_test.urea"}],attrs:{"name":"buff_test_urea","type":"checkbox","id":"buff_test_urea","disabled":_vm.lock == 1},domProps:{"checked":Array.isArray(_vm.buff_test.urea)?_vm._i(_vm.buff_test.urea,null)>-1:(_vm.buff_test.urea)},on:{"change":function($event){var $$a=_vm.buff_test.urea,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.buff_test, "urea", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.buff_test, "urea", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.buff_test, "urea", $$c)}}}}),_vm._v(" "),_vm._m(9)])]),_vm._v(" "),_c('div',{staticClass:"my-toggle-btn-wrapper",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"my-toggle-btn"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.buff_test.starch),expression:"buff_test.starch"}],attrs:{"name":"buff_test_starch","type":"checkbox","id":"buff_test_starch","disabled":_vm.lock == 1},domProps:{"checked":Array.isArray(_vm.buff_test.starch)?_vm._i(_vm.buff_test.starch,null)>-1:(_vm.buff_test.starch)},on:{"change":function($event){var $$a=_vm.buff_test.starch,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.buff_test, "starch", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.buff_test, "starch", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.buff_test, "starch", $$c)}}}}),_vm._v(" "),_vm._m(10)])]),_vm._v(" "),_c('div',{staticClass:"my-toggle-btn-wrapper",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"my-toggle-btn"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.buff_test.detergent),expression:"buff_test.detergent"}],attrs:{"name":"buff_test_detergent","type":"checkbox","id":"buff_test_detergent","disabled":_vm.lock == 1},domProps:{"checked":Array.isArray(_vm.buff_test.detergent)?_vm._i(_vm.buff_test.detergent,null)>-1:(_vm.buff_test.detergent)},on:{"change":function($event){var $$a=_vm.buff_test.detergent,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.buff_test, "detergent", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.buff_test, "detergent", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.buff_test, "detergent", $$c)}}}}),_vm._v(" "),_vm._m(11)])]),_vm._v(" "),_c('div',{staticClass:"my-toggle-btn-wrapper",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"my-toggle-btn"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.buff_test.antibiotic),expression:"buff_test.antibiotic"}],attrs:{"name":"buff_test_antibiotic","type":"checkbox","id":"buff_test_antibiotic","disabled":_vm.lock == 1},domProps:{"checked":Array.isArray(_vm.buff_test.antibiotic)?_vm._i(_vm.buff_test.antibiotic,null)>-1:(_vm.buff_test.antibiotic)},on:{"change":function($event){var $$a=_vm.buff_test.antibiotic,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.buff_test, "antibiotic", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.buff_test, "antibiotic", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.buff_test, "antibiotic", $$c)}}}}),_vm._v(" "),_vm._m(12)])]),_vm._v(" "),_c('div',{staticClass:"my-toggle-btn-wrapper",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"my-toggle-btn"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.buff_test.alcohol),expression:"buff_test.alcohol"}],attrs:{"name":"buff_test_alcohol","type":"checkbox","id":"buff_test_alcohol","disabled":_vm.lock == 1},domProps:{"checked":Array.isArray(_vm.buff_test.alcohol)?_vm._i(_vm.buff_test.alcohol,null)>-1:(_vm.buff_test.alcohol)},on:{"change":function($event){var $$a=_vm.buff_test.alcohol,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.buff_test, "alcohol", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.buff_test, "alcohol", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.buff_test, "alcohol", $$c)}}}}),_vm._v(" "),_vm._m(13)])]),_vm._v(" "),_c('div',{staticClass:"my-toggle-btn-wrapper",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"my-toggle-btn"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.buff_test.caustic),expression:"buff_test.caustic"}],attrs:{"name":"buff_test_caustic","type":"checkbox","id":"buff_test_caustic","disabled":_vm.lock == 1},domProps:{"checked":Array.isArray(_vm.buff_test.caustic)?_vm._i(_vm.buff_test.caustic,null)>-1:(_vm.buff_test.caustic)},on:{"change":function($event){var $$a=_vm.buff_test.caustic,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.buff_test, "caustic", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.buff_test, "caustic", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.buff_test, "caustic", $$c)}}}}),_vm._v(" "),_vm._m(14)])]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"15px","text-align":"left"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lock_report),expression:"lock_report"}],attrs:{"id":"resize_checkbox","type":"checkbox","name":"lock_report","disabled":_vm.lock ==1},domProps:{"checked":Array.isArray(_vm.lock_report)?_vm._i(_vm.lock_report,null)>-1:(_vm.lock_report)},on:{"change":function($event){var $$a=_vm.lock_report,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.lock_report=$$a.concat([$$v]))}else{$$i>-1&&(_vm.lock_report=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.lock_report=$$c}}}})])])])]),_vm._v(" "),_c('div',[_c('input',{staticClass:"button",attrs:{"type":"submit","value":"Submit Test","disabled":_vm.lock == 1}})])])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center","width":"90%"},attrs:{"id":"url_expired"}},[_c('h4',[_vm._v("Welcome to Doodhvale, Please wait...")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"50%","margin-top":"10px"}},[_c('div',{staticStyle:{"text-align":"right"}},[_c('strong',[_c('label',[_vm._v("FAT")]),_vm._v("  :  ")])]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin-top":"15px"}},[_c('strong',[_c('label',[_vm._v("CLR")]),_vm._v("  :  ")])]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin-top":"15px"}},[_c('strong',[_c('label',[_vm._v("SNF")]),_vm._v("  :  ")])]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin-top":"20px"}},[_c('strong',[_c('label',[_vm._v("UREA")]),_vm._v("  :  ")])]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin-top":"15px"}},[_c('strong',[_c('label',[_vm._v("STARCH")]),_vm._v("  :  ")])]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin-top":"15px"}},[_c('strong',[_c('label',[_vm._v("DETERGENT")]),_vm._v("  :  ")])]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin-top":"15px"}},[_c('strong',[_c('label',[_vm._v("ANTIBIOTICS")]),_vm._v("  :  ")])]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin-top":"15px"}},[_c('strong',[_c('label',[_vm._v("ALCOHOL")]),_vm._v("  :  ")])]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin-top":"15px"}},[_c('strong',[_c('label',[_vm._v("CAUSTIC")]),_vm._v("  :  ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"cow_test_urea"}},[_c('span',{staticClass:"on"},[_vm._v("Pos(+)")]),_vm._v(" "),_c('span',{staticClass:"off"},[_vm._v("Neg(-)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"cow_test_starch"}},[_c('span',{staticClass:"on"},[_vm._v("Pos(+)")]),_vm._v(" "),_c('span',{staticClass:"off"},[_vm._v("Neg(-)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"cow_test_detergent"}},[_c('span',{staticClass:"on"},[_vm._v("Pos(+)")]),_vm._v(" "),_c('span',{staticClass:"off"},[_vm._v("Neg(-)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"cow_test_antibiotic"}},[_c('span',{staticClass:"on"},[_vm._v("Pos(+)")]),_vm._v(" "),_c('span',{staticClass:"off"},[_vm._v("Neg(-)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"cow_test_alcohol"}},[_c('span',{staticClass:"on"},[_vm._v("Pos(+)")]),_vm._v(" "),_c('span',{staticClass:"off"},[_vm._v("Neg(-)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"cow_test_caustic"}},[_c('span',{staticClass:"on"},[_vm._v("Pos(+)")]),_vm._v(" "),_c('span',{staticClass:"off"},[_vm._v("Neg(-)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"50%","margin-top":"10px"}},[_c('div',{staticStyle:{"text-align":"right"}},[_c('strong',[_c('label',[_vm._v("FAT")]),_vm._v("  :  ")])]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin-top":"15px"}},[_c('strong',[_c('label',[_vm._v("CLR")]),_vm._v("  :  ")])]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin-top":"15px"}},[_c('strong',[_c('label',[_vm._v("SNF")]),_vm._v("  :  ")])]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin-top":"20px"}},[_c('strong',[_c('label',[_vm._v("UREA")]),_vm._v("  :  ")])]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin-top":"15px"}},[_c('strong',[_c('label',[_vm._v("STARCH")]),_vm._v("  :  ")])]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin-top":"15px"}},[_c('strong',[_c('label',[_vm._v("DETERGENT")]),_vm._v("  :  ")])]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin-top":"15px"}},[_c('strong',[_c('label',[_vm._v("ANTIBIOTICS")]),_vm._v("  :  ")])]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin-top":"15px"}},[_c('strong',[_c('label',[_vm._v("ALCOHOL")]),_vm._v("  :  ")])]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin-top":"15px"}},[_c('strong',[_c('label',[_vm._v("CAUSTIC")]),_vm._v("  :  ")])]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin-top":"15px"}},[_c('strong',[_c('label',[_vm._v("Lock Report")]),_vm._v("  :  ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"buff_test_urea"}},[_c('span',{staticClass:"on"},[_vm._v("Pos(+)")]),_vm._v(" "),_c('span',{staticClass:"off"},[_vm._v("Neg(-)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"buff_test_starch"}},[_c('span',{staticClass:"on"},[_vm._v("Pos(+)")]),_vm._v(" "),_c('span',{staticClass:"off"},[_vm._v("Neg(-)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"buff_test_detergent"}},[_c('span',{staticClass:"on"},[_vm._v("Pos(+)")]),_vm._v(" "),_c('span',{staticClass:"off"},[_vm._v("Neg(-)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"buff_test_antibiotic"}},[_c('span',{staticClass:"on"},[_vm._v("Pos(+)")]),_vm._v(" "),_c('span',{staticClass:"off"},[_vm._v("Neg(-)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"buff_test_alcohol"}},[_c('span',{staticClass:"on"},[_vm._v("Pos(+)")]),_vm._v(" "),_c('span',{staticClass:"off"},[_vm._v("Neg(-)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"buff_test_caustic"}},[_c('span',{staticClass:"on"},[_vm._v("Pos(+)")]),_vm._v(" "),_c('span',{staticClass:"off"},[_vm._v("Neg(-)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "p8uF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pLT5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[(_vm.$slots.image)?_c('div',{staticClass:"card-image"},[_vm._t("image")],2):_vm._e(),_vm._v(" "),(_vm.$slots.header)?_c('div',{staticClass:"card-header"},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-body"},[_vm._t("default")],2),_vm._v(" "),(_vm.$slots.footer)?_c('div',{staticClass:"card-footer"},[_c('hr'),_vm._v(" "),_vm._t("footer")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pR+G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "peGW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w3-content",staticStyle:{"max-width":"90%"}},[_c('h2',{staticStyle:{"text-align":"center"}},[_vm._v("Shipping Policy")]),_vm._v(" "),_c('br'),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("SHIPPING POLICY")]),_c('br'),_c('br'),_vm._v("\n\nThank you for visiting and shopping at www.sanjeevanidairyfarms.com or www.doodhvale.com. Following are the terms and conditions that constitute our Shipping Policy.\n\n"),_c('br'),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("Shipment processing time")]),_c('br'),_c('br'),_vm._v("\n\nShipping time can vary as per the user selection at the time of checkout of products and it may get delayed because of various reasons like traffic conditions, reach ability conditions of buyers address, natural delay like rain etc but the company puts its best effort to delivery the products as per the time specified at the time of checkout. Orders are not shipped or delivered on holidays."),_c('br'),_c('br'),_vm._v("\n\nIf we are experiencing a high volume of orders, shipments may be delayed as mentioned at the time of products checkout. Please allow additional time in transit for delivery. If there will be a significant delay in shipment of your order, we will contact you via email or telephone."),_c('br'),_c('br'),_vm._v(" "),_c('br'),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("Shipping rates & delivery estimates")]),_c('br'),_c('br'),_vm._v("\n\nShipping charges for your order will be calculated and displayed at the time of checkout.\n  ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "preG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__ = __webpack_require__("osty");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_f6f0fb3e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__ = __webpack_require__("4DuJ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_f6f0fb3e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ptyN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pvED":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cross_icon.23e34c9.png";

/***/ }),

/***/ "qAob":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qG9C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"url_valid"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qSKj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_R_vue__ = __webpack_require__("AH7q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b2ca2ba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_R_vue__ = __webpack_require__("kmBe");
function injectStyle (ssrContext) {
  __webpack_require__("8dQ5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8b2ca2ba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_R_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b2ca2ba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_R_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qq+n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "quQw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rChP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CouponAnimation_vue__ = __webpack_require__("xqMj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90d72a64_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CouponAnimation_vue__ = __webpack_require__("6ckh");
function injectStyle (ssrContext) {
  __webpack_require__("Ae1M")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-90d72a64"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CouponAnimation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90d72a64_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CouponAnimation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rK2t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_G3school_vue__ = __webpack_require__("GacN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ce76d5c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_G3school_vue__ = __webpack_require__("5xiS");
function injectStyle (ssrContext) {
  __webpack_require__("0wCC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_G3school_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ce76d5c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_G3school_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rQhz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"url_valid"}},[_c('div',{staticStyle:{"text-align":"center"}},[_c('div',[_c('h4',[_vm._v("Welcome "+_vm._s(_vm.userDetails.first_name)),_c('br'),_vm._v("("+_vm._s(_vm.userDetails.mobile)+")")])]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.userDetails.address))]),_vm._v("\n      *****\n      "),_c('div',{attrs:{"id":"location_not_null"}},[_vm._v("\n        Sorry! Your location is already updated, if you want to change your delivery location then please change it from doodhvale app.\n      ")]),_vm._v(" "),_c('div',{attrs:{"id":"location_null"}},[_c('br'),_vm._v(" "),_c('div',{attrs:{"id":"floating-panel"},on:{"click":function($event){_vm.onClickCurrentLocationButtion();}}},[_c('img',{staticStyle:{"width":"17%"},attrs:{"src":__webpack_require__("4hQa")}})]),_vm._v(" "),_c('gmap-map',{staticStyle:{"height":"250px"},attrs:{"center":_vm.center,"zoom":14}},_vm._l((_vm.markers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":m.position,"clickable":true,"draggable":true},on:{"drag":_vm.updateCoordinates}})})),_c('br'),_vm._v(" "),_c('input',{staticClass:"button1",attrs:{"value":"Update Delivery Location","type":"button"},on:{"click":function($event){_vm.latLngCheck();}}})],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"url_expired"}},[_c('h4',[_vm._v("Welcome to Doodhvale, Please wait...")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rYNy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import axios from 'axios'
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {},
  created: function created() {
    var fullUrl = document.URL;
    var splitUrl = fullUrl.split('r?');
    sessionStorage.setItem('urlstr', splitUrl[1]);
  },

  methods: {}
});

/***/ }),

/***/ "rZMg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// import VueAxios from 'vue-axios'
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    LTable: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Table_vue__["a" /* default */],
    ChartCard: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */],
    StatsCard: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */]
  },
  data: function data() {
    return {
      urlInterface: [],
      apiDataObj: [],
      userDetails: [],
      genChecksum: [],
      appPaymentGateway: [],
      after_checksum: false,
      userData: true,
      app_payment_gate: false,
      payu_payment_gate: false,
      payment_type: "cc",
      errors: "",
      isActive: false,
      isLoading: true,
      isLoaded: false,
      isFullPage: true,
      btnOneValue: 500,
      btnTwoValue: 1000,
      btnThreeValue: 1500,
      isQuickPaymentButtonDisplay: 1,
      fiveDeliveryAmount: 100,
      sevenDeliveryAmount: 200,
      fifteenDeliveryAmount: 400,
      thirtyDeliveryAmount: 800,
      fourtyFiveDeliveryAmount: 1200,
      sixtyDeliveryAmount: 1600,
      ninetyDeliveryAmount: 2400,
      custName: "",
      custAddress: "",
      fiveDeliveryAmountLabel: "5 Deliveries",
      sevenDeliveryAmountLabel: "7 Deliveries",
      fifteenDeliveryAmountLabel: "15 Deliveries",
      thirtyDeliveryAmountLabel: "30 Deliveries",
      fourtyFiveDeliveryAmountLabel: "45 Deliveries",
      sixtyDeliveryAmountLabel: "60 Deliveries",
      ninetyDeliveryAmountLabel: "90 Deliveries",
      afterPaymentMsgShow: false
    };
  },
  created: function created() {
    if (sessionStorage.getItem("paymentFlow") === "editSubscription") {
      sessionStorage.removeItem("paymentFlow");
      this.afterPaymentMsgShow = true;
      this.isLoading = false;
      // this.$router.push('/a/editSubscription')
    } else {
      this.fetchData();
    }
  },

  methods: {
    fetchData: function fetchData() {
      var _this = this;

      var params = new URLSearchParams();
      var fullUrl = document.URL;
      var splitUrl = fullUrl.split("pp?");
      params.append("url_str", splitUrl[1]);
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + "/accounts/fetch-url-interface-data",
        method: "post",
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this.urlInterface = {};
        if (response.data.status === "000001" || response.data.status === "000002" || response.data.status === "000003") {
          _this.urlInterface.error_msg = response.data.msg;
          if (document.getElementById("url_valid") !== null) {
            document.getElementById("url_valid").style.display = "none";
          }
        } else {
          if (document.getElementById("url_expired") !== null) {
            document.getElementById("url_expired").style.display = "none";
          }
          _this.urlInterface.action_name = response.data.action_name;
          _this.urlInterface.url_interface_id = response.data.url_interface_id;
          _this.urlInterface.vue_url = fullUrl;
          _this.urlInterface.callback_url = "https://doodhvale.in/dv/doodhvale/api/modules/v3" + "/controllers/pgResponse.php";
          _this.invokeUrlAction();
        }
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === "SUCCESS") {
          _this.list = response.data.user_record;
          alert(_this.list);
        }
        setTimeout(function () {
          if (document.getElementById("bafore_checksum") !== null) {
            document.getElementById("bafore_checksum").style.display = "block";
          }
          _this.isLoading = false;
        }, 10000);
      }).catch(function (e) {
        if (document.getElementById("bafore_checksum") !== null) {
          document.getElementById("bafore_checksum").style.display = "block";
        }
        _this.isLoading = false;
        alert("not ok");
      });
    },
    invokeUrlAction: function invokeUrlAction() {
      var _this2 = this;

      var params = new URLSearchParams();
      params.append("url_interface_id", this.urlInterface.url_interface_id);
      params.append("action_name", this.urlInterface.action_name);
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + "/accounts/invoke-url-action",
        method: "post",
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        if (response.data.action_response.user_id === null || response.data.action_response.user_id === 0 || response.data.action_response.user_id === "0" || response.data.action_response.user_id === "undefined") {
          window.location.reload();
        }
        _this2.apiDataObj = {};
        switch (_this2.urlInterface.action_name) {
          case "cow_milk_bill":
            // for cow milk billing
            break;
          case "pending_bill_payment":
            // console.log(response)
            _this2.apiDataObj.userId = response.data.action_response.user_id;
            _this2.apiDataObj.payment_gateway = response.data.action_response.app_payment_gateway_v2;
            _this2.apiDataObj.app_payment_gateway = response.data.action_response.app_payment_gateway_v2;
            // ///////// start for payment option //////
            _this2.apiDataObj.cc = response.data.action_response.app_payment_cc_v2;
            _this2.apiDataObj.upi = response.data.action_response.app_payment_upi_v2;
            _this2.apiDataObj.paytm = response.data.action_response.app_payment_wallet_paytm_v2;
            _this2.apiDataObj.mobikwik = response.data.action_response.app_payment_wallet_mobikwik_v2;
            _this2.apiDataObj.ola = response.data.action_response.app_payment_wallet_olamoney_v2;
            _this2.apiDataObj.jio = response.data.action_response.app_payment_wallet_jiomoney_v2;
            _this2.apiDataObj.freecharge = response.data.action_response.app_payment_wallet_freecharge_v2;
            // ///////// end for payment option //////
            _this2.apiDataObj.pending_amount = Math.ceil(response.data.action_response.pending_amount);
            // console.log(response.data.action_response.is_quick_payment_button_display)
            _this2.isQuickPaymentButtonDisplay = response.data.action_response.is_quick_payment_button_display;
            if (_this2.isQuickPaymentButtonDisplay === 0) {
              _this2.fiveDeliveryAmount = response.data.action_response.five_deliveries_amount;
              _this2.sevenDeliveryAmount = response.data.action_response.seven_deliveries_amount;
              _this2.fifteenDeliveryAmount = response.data.action_response.fifteen_deliveries_amount;
              _this2.thirtyDeliveryAmount = response.data.action_response.thirty_deliveries_amount;
              _this2.fourtyFiveDeliveryAmount = response.data.action_response.fourty_five_deliveries_amount;
              _this2.sixtyDeliveryAmount = response.data.action_response.sixty_deliveries_amount;
              _this2.ninetyDeliveryAmount = response.data.action_response.ninety_deliveries_amount;
            }
            // this.apiDataObj.pending_amount = -5
            _this2.apiDataObj.wallet_amount = 0;
            if (_this2.apiDataObj.pending_amount > 0) {
              if (document.getElementById("not_pending") !== null) {
                document.getElementById("not_pending").style.display = "none";
              }
              if (document.getElementById("clear") !== null) {
                document.getElementById("clear").style.display = "none";
              }
            } else {
              if (document.getElementById("pending") !== null) {
                document.getElementById("pending").style.display = "none";
              }
              if (document.getElementById("clear") !== null) {
                document.getElementById("clear").style.display = "none";
              }
              _this2.apiDataObj.wallet_amount = Math.abs(_this2.apiDataObj.pending_amount);
              _this2.apiDataObj.pending_amount = 0;
            }
            _this2.apiDataObj.default_amount = _this2.apiDataObj.pending_amount;
            _this2.pendingBillPayment();
            break;
          case "order_flow_payment":
            // console.log(response)
            _this2.apiDataObj.userId = response.data.action_response.user_id;
            _this2.apiDataObj.payment_gateway = response.data.action_response.app_payment_gateway_v2;
            _this2.apiDataObj.app_payment_gateway = response.data.action_response.app_payment_gateway_v2;
            // ///////// start for payment option //////
            _this2.apiDataObj.cc = response.data.action_response.app_payment_cc_v2;
            _this2.apiDataObj.upi = response.data.action_response.app_payment_upi_v2;
            _this2.apiDataObj.paytm = response.data.action_response.app_payment_wallet_paytm_v2;
            _this2.apiDataObj.mobikwik = response.data.action_response.app_payment_wallet_mobikwik_v2;
            _this2.apiDataObj.ola = response.data.action_response.app_payment_wallet_olamoney_v2;
            _this2.apiDataObj.jio = response.data.action_response.app_payment_wallet_jiomoney_v2;
            _this2.apiDataObj.freecharge = response.data.action_response.app_payment_wallet_freecharge_v2;
            // ///////// end for payment option //////
            _this2.apiDataObj.pending_amount = Math.ceil(response.data.action_response.pending_amount);
            _this2.apiDataObj.default_amount = Math.ceil(response.data.action_response.default_amount);
            // this.apiDataObj.pending_amount = -5
            _this2.apiDataObj.wallet_amount = 0;
            if (_this2.apiDataObj.pending_amount > 0) {
              if (document.getElementById("not_pending") !== null) {
                document.getElementById("not_pending").style.display = "none";
              }
              if (document.getElementById("clear") !== null) {
                document.getElementById("clear").style.display = "none";
              }
            } else {
              if (document.getElementById("pending") !== null) {
                document.getElementById("pending").style.display = "none";
              }
              if (document.getElementById("clear") !== null) {
                document.getElementById("clear").style.display = "none";
              }
              _this2.apiDataObj.wallet_amount = Math.abs(_this2.apiDataObj.pending_amount);
              _this2.apiDataObj.pending_amount = 0;
            }
            _this2.pendingBillPayment();
            break;
          default:
            break;
        }
        if (_this2.apiDataObj.default_amount > 0) {
          _this2.btnOneValue = (parseInt(_this2.apiDataObj.default_amount / 500) + 1) * 500;
          _this2.btnTwoValue = _this2.btnOneValue + 500;
          _this2.btnThreeValue = _this2.btnOneValue + 1000;
        }
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === "SUCCESS") {
          _this2.list = response.data.user_record;
          alert(_this2.list);
        }
      }).catch(function (e) {
        alert("not ok");
      });
    },
    btnOneClick: function btnOneClick() {
      document.getElementById("txn_amt").value = this.btnOneValue;
    },
    btnTwoClick: function btnTwoClick() {
      document.getElementById("txn_amt").value = this.btnTwoValue;
    },
    btnThreeClick: function btnThreeClick() {
      document.getElementById("txn_amt").value = this.btnThreeValue;
    },
    fiveDeliveryBtnClick: function fiveDeliveryBtnClick() {
      document.getElementById("txn_amt").value = this.fiveDeliveryAmount;
    },
    sevenDeliveryBtnClick: function sevenDeliveryBtnClick() {
      document.getElementById("txn_amt").value = this.sevenDeliveryAmount;
    },
    fifteenDeliveryBtnClick: function fifteenDeliveryBtnClick() {
      document.getElementById("txn_amt").value = this.fifteenDeliveryAmount;
    },
    thirtyDeliveryBtnClick: function thirtyDeliveryBtnClick() {
      document.getElementById("txn_amt").value = this.thirtyDeliveryAmount;
    },
    fourtyFiveDeliveryBtnClick: function fourtyFiveDeliveryBtnClick() {
      document.getElementById("txn_amt").value = this.fourtyFiveDeliveryAmount;
    },
    sixtyDeliveryBtnClick: function sixtyDeliveryBtnClick() {
      document.getElementById("txn_amt").value = this.sixtyDeliveryAmount;
    },
    ninetyDeliveryBtnClick: function ninetyDeliveryBtnClick() {
      document.getElementById("txn_amt").value = this.ninetyDeliveryAmount;
    },
    pendingBillPayment: function pendingBillPayment() {
      var _this3 = this;

      var params = new URLSearchParams();
      var userId = this.apiDataObj.userId;
      params.append("user_id", userId);
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + "/users/user-info",
        method: "post",
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        if (document.getElementById("txn_amt") !== null) {
          document.getElementById("txn_amt").focus();
        }
        _this3.userDetails = {};
        _this3.userDetails.userId = userId;
        _this3.userDetails.first_name = response.data.user_record.user_details.first_name;
        _this3.userDetails.mobile = response.data.user_record.user.username;
        _this3.userDetails.address = response.data.user_record.address.address1 + " " + response.data.user_record.address.address2 + " " + response.data.user_record.address.city;
        _this3.userDetails.pincode = response.data.user_record.address.pincode;
        _this3.userDetails.city = response.data.user_record.address.city;
        _this3.userDetails.state = response.data.user_record.address.state;
        _this3.userDetails.fullName = response.data.user_record.user_details.first_name + " " + response.data.user_record.user_details.last_name;
        _this3.custName = _this3.userDetails.fullName;
        _this3.custAddress = _this3.userDetails.address;
        _this3.userDetails.fullName = _this3.userDetails.fullName.replace(/[^a-zA-Z0-9 ]/g, "");
        _this3.userDetails.address = _this3.userDetails.address.replace(/[^a-zA-Z0-9 ]/g, "");
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === "SUCCESS") {
          _this3.list = response.data.user_record;
          alert(_this3.list);
        }
      }).catch(function (e) {
        alert("not ok");
      });
    },
    onAmmountChange: function onAmmountChange() {
      this.errors = "";
      this.isActive = false;
      document.getElementById("txn_amt").value = Number(document.getElementById("txn_amt").value);
    },
    generateChecksum: function generateChecksum() {
      if (sessionStorage.getItem("paymentFlow") !== null) {
        sessionStorage.setItem("paymentFlow", "editSubscription");
      }
      /* var paymentType = "2";
      switch (this.payment_type) {
        case "cc":
          paymentType = this.apiDataObj.cc;
          break;
        case "upi":
          paymentType = this.apiDataObj.upi;
          break;
        case "paytm":
          paymentType = this.apiDataObj.paytm;
          break;
        case "mobikwik":
          paymentType = this.apiDataObj.mobikwik;
          break;
        case "ola":
          paymentType = this.apiDataObj.ola;
          break;
        case "jio":
          paymentType = this.apiDataObj.jio;
          break;
        case "freecharge":
          paymentType = this.apiDataObj.freecharge;
          break;
        default:
      }
      this.apiDataObj.app_payment_gateway = paymentType;
      if (paymentType === "1") {
        this.paytm();
      } else {
        if (this.apiDataObj.app_payment_gateway === "1") {
          this.paytm();
        } else if (this.apiDataObj.app_payment_gateway === "4") {
          this.payumoney();
        } else {
          this.hdfc();
        }
      } */
      if (this.apiDataObj.app_payment_gateway == "payu") {
        this.payumoney();
      } else {
        this.hdfc();
      }
    },
    paytm: function paytm() {
      var _this4 = this;

      var orderId = "";
      var params = new URLSearchParams();
      var userId = this.apiDataObj.userId;
      params.append("user_id", userId);
      params.append("gateway_name", "paytm");
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + "/accounts/generate-unique-order-id",
        method: "post",
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        if (response.data.msg.trim().toUpperCase() === "SUCCESS") {
          orderId = response.data.unique_order_id;
          var _params = new URLSearchParams();
          var txnAmount = document.getElementById("txn_amt").value;
          if (isNaN(txnAmount) || txnAmount <= 0 || txnAmount === "") {
            document.getElementById("txn_amt").focus();
            _this4.errors = "Oops! Invalid Amount.";
            _this4.isActive = true;
          } else {
            _this4.isLoading = false;
            // var orderId = 'DVWP' + Math.floor(Math.random() * 10000000)
            _params.append("CUST_ID", userId);
            _params.append("ORDER_ID", orderId);
            _params.append("CHANNEL_ID", "WEB");
            _params.append("WEBSITE", "SanjeeWEB");
            // params.append('WEBSITE', 'APP_STAGING')// staging
            _params.append("TXN_AMOUNT", txnAmount);
            _params.append("MERC_UNQ_REF", userId + "br" + _this4.urlInterface.vue_url + "br" + "https://doodhvale.in/dv/doodhvale/api/web/v3" + "/accounts/verify-transaction");
            _params.append("CALLBACK_URL", _this4.urlInterface.callback_url);
            __WEBPACK_IMPORTED_MODULE_5_axios___default()({
              url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + "/accounts/generate-checksum",
              method: "post",
              data: _params,
              withCredentials: false,
              headers: {}
            }).then(function (response) {
              _this4.genChecksum = {};
              _this4.genChecksum.MID = response.data.post_value.MID;
              _this4.genChecksum.ORDER_ID = response.data.post_value.ORDER_ID;
              _this4.genChecksum.CUST_ID = response.data.post_value.CUST_ID;
              _this4.genChecksum.INDUSTRY_TYPE_ID = response.data.post_value.INDUSTRY_TYPE_ID;
              _this4.genChecksum.CHANNEL_ID = response.data.post_value.CHANNEL_ID;
              _this4.genChecksum.WEBSITE = response.data.post_value.WEBSITE;
              _this4.genChecksum.TXN_AMOUNT = response.data.post_value.TXN_AMOUNT;
              _this4.genChecksum.CALLBACK_URL = response.data.post_value.CALLBACK_URL;
              _this4.genChecksum.MERC_UNQ_REF = response.data.post_value.MERC_UNQ_REF;
              _this4.genChecksum.checksum = response.data.checkSum;
              _this4.after_checksum = true;
              _this4.userData = false;
              _this4.app_payment_gate = false;
              _this4.payu_payment_gate = false;
              // console.log(response)
              if (response.data.status.trim().toUpperCase() === "SUCCESS") {
                _this4.list = response.data.user_record;
                alert(_this4.list);
              }
            }).catch(function (e) {
              alert("not ok");
            });
          }
        }
      }).catch(function (e) {
        _this4.errors = "Server error, Try again!";
        _this4.isActive = true;
      });
    },
    hdfc: function hdfc() {
      var _this5 = this;

      var orderId = "";
      var userId = this.apiDataObj.userId;
      var params = new URLSearchParams();
      params.append("user_id", userId);
      params.append("gateway_name", "hdfc");
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + "/accounts/generate-unique-order-id",
        method: "post",
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        if (response.data.msg.trim().toUpperCase() === "SUCCESS") {
          orderId = response.data.unique_order_id;
          // var userId = this.apiDataObj.userId
          var txnAmount = Number(document.getElementById("txn_amt").value);
          if (isNaN(txnAmount) || txnAmount <= 0 || txnAmount === "") {
            document.getElementById("txn_amt").focus();
            _this5.errors = "Oops! Invalid Amount.";
            _this5.isActive = true;
          } else {
            _this5.after_checksum = false;
            _this5.userData = false;
            _this5.app_payment_gate = true;
            _this5.payu_payment_gate = false;
            _this5.appPaymentGateway = {};
            _this5.appPaymentGateway.TXN_AMOUNT = txnAmount;
            _this5.appPaymentGateway.ORDER_ID = orderId; // 'DVWH' + Math.floor(Math.random() * 10000000)
            _this5.appPaymentGateway.TID = new Date().getTime();
            _this5.appPaymentGateway.CALLBACK_URL = _this5.urlInterface.vue_url;
            _this5.appPaymentGateway.APP_PAYMENT_GATEWAY = _this5.apiDataObj.app_payment_gateway_v2;
            _this5.appPaymentGateway.actionUrl = "https://doodhvale.in/dv/doodhvale/api/modules/v3" + "/controllers/ccavRequestHandler.php";
            _this5.appPaymentGateway.responseUrl = "https://doodhvale.in/dv/doodhvale/api/modules/v3" + "/controllers/ccavResponseHandler.php";
            _this5.appPaymentGateway.apiUrl = "https://doodhvale.in/dv/doodhvale/api/web/v3" + "/accounts/payment-gateway-transaction";
            setTimeout(function () {
              document.getElementById("hdfcform").submit();
            }, 300);
          }
        }
      }).catch(function (e) {
        _this5.errors = "Server error, Try again!";
        _this5.isActive = true;
      });
      this.isLoading = false;
    },
    payumoney: function payumoney() {
      var _this6 = this;

      var orderId = "";
      var params = new URLSearchParams();
      var userId = this.apiDataObj.userId;
      params.append("user_id", userId);
      params.append("gateway_name", "payu");
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + "/accounts/generate-unique-order-id",
        method: "post",
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        if (response.data.msg.trim().toUpperCase() === "SUCCESS") {
          orderId = response.data.unique_order_id;
          _this6.appPaymentGateway = {};
          _this6.appPaymentGateway.user_id = userId;
          var _params2 = new URLSearchParams();
          var txnAmount = document.getElementById("txn_amt").value;
          if (isNaN(txnAmount) || txnAmount <= 0 || txnAmount === "") {
            document.getElementById("txn_amt").focus();
            _this6.errors = "Oops! Invalid Amount.";
            _this6.isActive = true;
          } else {
            _this6.appPaymentGateway.TXN_AMOUNT = txnAmount;
            _this6.isLoading = false;
            _params2.append("merchant_param1", userId);
            _params2.append("order_id", orderId);
            var firstname = _this6.userDetails.first_name;
            _params2.append("amount", txnAmount);
            _params2.append("delivery_name", firstname);
            _params2.append("merchant_param2", _this6.urlInterface.vue_url);
            _params2.append("merchant_param4", "https://doodhvale.in/dv/doodhvale/api/web/v3" + "/accounts/payment-gateway-transaction");
            _params2.append("CALLBACK_URL", _this6.urlInterface.vue_url);
            __WEBPACK_IMPORTED_MODULE_5_axios___default()({
              url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + "/payumoneypayments/payment-initiate",
              method: "post",
              data: _params2,
              withCredentials: false,
              headers: {}
            }).then(function (response) {
              _this6.after_checksum = false;
              _this6.userData = false;
              _this6.app_payment_gate = false;
              _this6.payu_payment_gate = true;
              // this.appPaymentGateway = {};
              _this6.appPaymentGateway.HASH = response.data.hash;
              _this6.appPaymentGateway.ORDER_ID = response.data.order_id;
              _this6.appPaymentGateway.CALLBACK_URL = _this6.urlInterface.vue_url;
              _this6.appPaymentGateway.APP_PAYMENT_GATEWAY = _this6.apiDataObj.app_payment_gateway_v2;
              _this6.appPaymentGateway.actionUrl = "https://doodhvale.in/dv/doodhvale/api/modules/v3" + "/controllers/payuRequestHandler.php";
              _this6.appPaymentGateway.responseUrl = "https://doodhvale.in/dv/doodhvale/api/modules/v3" + "/controllers/payuResponseHandler.php";
              setTimeout(function () {
                document.getElementById("payuform").submit();
              }, 300);
            }).catch(function (e) {
              alert("not ok");
            });
          }
        }
      }).catch(function (e) {
        _this6.errors = "Server error, Try again!";
        _this6.isActive = true;
      });
    },

    isNumber: function isNumber(evt) {
      if (!evt) {
        evt = window.event;
      }
      // evt = (evt) ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    }
  }
});

/***/ }),

/***/ "rbol":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MedcoAppLink_vue__ = __webpack_require__("Kxwc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ac73663_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MedcoAppLink_vue__ = __webpack_require__("qG9C");
function injectStyle (ssrContext) {
  __webpack_require__("PG13")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MedcoAppLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ac73663_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MedcoAppLink_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sQGm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'drop-down',
  props: {
    title: String,
    icon: String,
    tag: {
      type: String,
      default: 'li'
    }
  },
  data: function data() {
    return {
      isOpen: false
    };
  },

  methods: {
    toggleDropDown: function toggleDropDown() {
      this.isOpen = !this.isOpen;
      this.$emit('change', this.isOpen);
    },
    closeDropDown: function closeDropDown() {
      this.isOpen = false;
      this.$emit('change', this.isOpen);
    }
  }
});

/***/ }),

/***/ "saWt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w3-content",staticStyle:{"max-width":"90%"}},[_c('h2',{staticStyle:{"text-align":"center"}},[_vm._v("Refund Policy")]),_vm._v(" "),_c('br'),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("Refund and Cancellation Policy")]),_c('br'),_c('br'),_vm._v("\nOur focus is complete customer satisfaction. In the event, if you are displeased with the services provided, we will refund back the money, provided the reasons are genuine and proved after investigation. Please read the fine prints of each deal before buying it, it provides all the details about the services or the product you purchase."),_c('br'),_c('br'),_vm._v("\n\nIn case of dissatisfaction from our services, clients have the liberty to cancel their projects and request a refund from us. Our Policy for the cancellation and refund will be as follows:\n\n "),_c('br'),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("Cancellation Policy")]),_c('br'),_c('br'),_vm._v("\n\nFor Cancellations please contact us via contact us link."),_c('br'),_c('br'),_vm._v("\n\nRequests received later than 1 business days prior to the end of the current service period will be treated as cancellation of services for the next service period."),_c('br'),_c('br'),_vm._v(" "),_c('br'),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("Refund Policy")]),_c('br'),_c('br'),_vm._v("\n\nWe will try our best to create the suitable design concepts for our clients."),_c('br'),_c('br'),_vm._v("\n\nIn case any client is not completely satisfied with our products we can provide a refund."),_c('br'),_c('br'),_vm._v("\n\nIf paid by credit card, refunds will be issued to the original credit card provided at the time of purchase and in case of payment gateway name payments refund will be made to the same account."),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('br'),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("PROCESS FLOW")]),_c('br'),_c('br'),_vm._v("\n\nhttp://sanjeevanidairyfarms.com/process-flow\n  ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sap4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      urlInterface: [],
      apiDataObj: [],
      isLoading: true,
      isLoaded: false,
      isFullPage: true
    };
  },
  created: function created() {
    this.fetchData();
  },

  methods: {
    reloadPage: function reloadPage() {
      window.location.reload();
    },
    fetchData: function fetchData() {
      var _this = this;

      var params = new URLSearchParams();
      var fullUrl = document.URL;
      var splitUrl = fullUrl.split('unsubPromo?');
      params.append('url_str', splitUrl[1]);
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/accounts/fetch-url-interface-data',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this.urlInterface = {};
        if (response.data.status === '000001') {
          _this.urlInterface.error_msg = response.data.msg;
          document.getElementById('url_valid').style.display = 'none';
        } else {
          document.getElementById('url_expired').style.display = 'none';
          _this.urlInterface.action_name = response.data.action_name;
          _this.urlInterface.url_interface_id = response.data.url_interface_id;
          _this.invokeUrlAction();
        }
      }).catch(function (e) {
        alert('not ok');
      });
    },
    invokeUrlAction: function invokeUrlAction() {
      var _this2 = this;

      var params = new URLSearchParams();
      params.append('url_interface_id', this.urlInterface.url_interface_id);
      params.append('action_name', this.urlInterface.action_name);
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/accounts/invoke-url-action',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this2.apiDataObj.response = response.data.action_response;
        // console.log(response)
        if (response.data.msg.trim().toUpperCase() === 'SUCCESS') {
          if (response.data.action_response.trim().toUpperCase() === 'SUBSCRIBED') {
            document.getElementById('unsubscribed').style.display = 'none';
            document.getElementById('error').style.display = 'none';
          } else if (response.data.action_response.trim().toUpperCase() === 'UNSUBSCRIBED') {
            document.getElementById('subscribed').style.display = 'none';
            document.getElementById('error').style.display = 'none';
          } else {
            document.getElementById('unsubscribed').style.display = 'none';
            document.getElementById('subscribed').style.display = 'none';
          }
        }
        _this2.isLoading = false;
      }).catch(function (e) {
        alert('not ok');
      });
    }
  }
});

/***/ }),

/***/ "sp4L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sqji":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-loading',{attrs:{"is-full-page":_vm.isFullPage,"active":_vm.isLoading},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"url_valid"}},[_c('div',[_c('div',{staticStyle:{"margin-left":"5%","width":"90%"}},[_vm._m(1),_vm._v(" "),_c('p',[_vm._v("Dear "+_vm._s(_vm.userDetails.fullName)+","),_c('br'),_vm._v("\n        Mobile: "+_vm._s(_vm.userDetails.mobile)),_c('br'),_vm._v("\n        Address: "+_vm._s(_vm.userDetails.address))]),_c('br'),_vm._v(" "),_c('p',[_vm._v("We, Sanjeevani Dairy Farms Pvt. Ltd., a company incorporated under the provisions of the Companies Act, 1956 having its registered and corporate office at B2, Vikas Chamber, D Block, Prashant Vihar, Rohini, Delhi – 110085 (hereinafter referred to as “Doodhvale” / “Company”), has been authorized to Collect the outstanding unpaid amount and to serve upon you the following notice:")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('p',[_vm._v("A copy of this notice is being retained in our records for future action.")]),_vm._v(" "),_c('p',[_vm._v("To pay your bill now, click "),_c('a',{attrs:{"href":_vm.apiDataObj.paymentLink}},[_vm._v(_vm._s(_vm.apiDataObj.paymentLink))]),_vm._v("  or visit Doodhvale Mobile Application logged in with your registered mobile number "+_vm._s(_vm.userDetails.userName)+" on your Doodhvale Application.")]),_vm._v(" "),_c('p',[_vm._v("For any clarifications, you may reach at customer care number "),_c('a',{attrs:{"href":'tel:' + _vm.apiDataObj.callCenterPhoneNumber}},[_vm._v(_vm._s(_vm.apiDataObj.callCenterPhoneNumber))]),_vm._v(" or email at "),_c('a',{attrs:{"href":'mailto:' + _vm.apiDataObj.doodhvaleCareMailId}},[_vm._v(_vm._s(_vm.apiDataObj.doodhvaleCareMailId))])]),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4)])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container is-fluid has-text-centered",attrs:{"id":"url_expired"}},[_c('h4',[_vm._v("Welcome to Doodhvale, Please wait...")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Subject: Legal Notice for Recovery of Money")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticStyle:{"margin-left":"5%"}},[_c('li',[_vm._v("That you are well aware of the fact that based upon your acceptance of the Terms and Conditions for “Doodhvale” Services, offered you a "),_c('strong',[_vm._v("Postpaid facility through Doodhvale")]),_vm._v(" wherein you were provided a facility to purchases of Doodhvale products from Doodhvale website or Mobile Applications named Doodhvale or through call center executive in postpaid facility. That your eligibility for said Postpaid facility was for a definite time and limit.")]),_vm._v(" "),_c('li',[_vm._v("That you accepted the said Postpaid facility subject to the terms and conditions enumerated therein. As per the terms and conditions, "),_c('strong',[_vm._v("you were duty bound to pay the purchased Outstanding Amount on or before the due date")]),_vm._v(". You have further agreed that Late Fees shall be imposed upon you in case you fail to pay the Outstanding Amount by the Due date.")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Please note that an amount is due on you and payable by you")]),_vm._v(". Despite repeated reminders and demands by the Company, you have failed to make the payment of the aforesaid outstanding amount to us which is a breach of the terms and conditions of Postpaid facility and utter disregard of the law of the land. ")]),_vm._v(" "),_c('li',[_vm._v("From the aforesaid, it is apparent that you have intentionally and deliberately not paid the said amount for the facility availed by you to make wrongful gains for yourself and to cause wrongful losses to the Company.")]),_vm._v(" "),_c('li',[_vm._v("In the circumstances, we hereby call upon you to pay the due amount at the earliest, failing which our Company reserves the right to initiate / to proceed Civil and/or Criminal proceedings for the fraudulent acts of breach of trust and cheating, against you, entirely at your risk as to cost and consequences, which please note.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('em',[_vm._v("Note: Please ignore this notice if you have already paid the complete due amount.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Sincerely,"),_c('em',[_c('br')]),_vm._v("Sanjeevani Dairy Farms Pvt. Ltd.")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "svx4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t+rC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay__ = __webpack_require__("ZZvs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__("SYh3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay_dist_vue_loading_css__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    LTable: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Table_vue__["a" /* default */],
    ChartCard: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */],
    StatsCard: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */],
    Loading: __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      error_msg: '',
      error_mob: '',
      error_pin: '',
      fullPage: true,
      isLoading: false,
      isActive: false,
      errors: '',
      name: '',
      mobile_no: '',
      address: '',
      pin_code: '',
      form_no: '1',
      surveyResult: [],
      backgroundUrl: '',
      formSubmit: false,
      bgImage: 'https://www.doodhvale.com/hmi_images/bg.jpg',
      questionArray: [{
        id: 1,
        questions: '1. Does your milk brand provide at least 150sq ft of average space per cattle (sufficient enough for them to roam and recreate)?',
        answer: ''
      }, {
        id: 2,
        questions: '2. Is the cattle kept untied all the time?',
        answer: ''
      }, {
        id: 3,
        questions: '3. Is your milk’s farm well equipped with stress relievers like brushes, fans and cooling system for the mental and physical well-being of the Cattle?',
        answer: ''
      }, {
        id: 4,
        questions: '4. Is the cattle kept together for companionship and socialising?',
        answer: ''
      }, {
        id: 5,
        questions: '5. Does your milk brand encourage regular farm visits from outsiders?',
        answer: ''
      }, {
        id: 6,
        questions: '6. Do they treat cattle like their family by naming them, celebrating their birthdays, etc ?',
        answer: ''
      }, {
        id: 7,
        questions: '7. Is the cattle given optimum exposure to sunlight for a better synthesis of Vitamin D3?',
        answer: ''
      }, {
        id: 8,
        questions: '8. Easy access to clean drinkable water for the cattle?(Within 50ft.)',
        answer: ''
      }, {
        id: 9,
        questions: '9. Is each cattle given personalised feed & supplements to match their nutritional requirement?',
        answer: ''
      }, {
        id: 10,
        questions: '10. Are there regular cattle health checkups & vaccinations?',
        answer: ''
      }]
    };
  },
  created: function created() {
    this.fetchData();
  },

  methods: {
    fetchData: function fetchData() {},
    getImage: function getImage() {
      var imagePath = '';
      switch (this.surveyResult.length) {
        case 0:
          imagePath = 'https://www.doodhvale.com/hmi_images/0.jpg';
          break;
        case 1:
          imagePath = 'https://www.doodhvale.com/hmi_images/1.jpg';
          break;
        case 2:
          imagePath = 'https://www.doodhvale.com/hmi_images/2.jpg';
          break;
        case 3:
          imagePath = 'https://www.doodhvale.com/hmi_images/3.jpg';
          break;
        case 4:
          imagePath = 'https://www.doodhvale.com/hmi_images/4.jpg';
          break;
        case 5:
          imagePath = 'https://www.doodhvale.com/hmi_images/5.jpg';
          break;
        case 6:
          imagePath = 'https://www.doodhvale.com/hmi_images/6.jpg';
          break;
        case 7:
          imagePath = 'https://www.doodhvale.com/hmi_images/7.jpg';
          break;
        case 8:
          imagePath = 'https://www.doodhvale.com/hmi_images/8.jpg';
          break;
        case 9:
          imagePath = 'https://www.doodhvale.com/hmi_images/9.jpg';
          break;
        case 10:
          imagePath = 'https://www.doodhvale.com/hmi_images/10.jpg';
          break;
      }
      return imagePath;
    },
    downloadApp: function downloadApp() {
      this.$router.push({ path: '/a/appLink' });
    },
    saveFormDetails: function saveFormDetails() {
      var _this = this;

      var self = this;
      this.isLoading = true;
      if (this.mobile_no !== '') {
        if (this.mobile_no.length !== 10) {
          this.error_mob = 'Please Enter 10-digit Mobile Number';
          this.isLoading = false;
          this.isActive = true;
          setTimeout(function () {
            _this.error_mob = '';
          }, 3000);
          document.getElementById('mobile').focus();
          return;
        }
      }
      if (this.pin_code !== '') {
        if (this.pin_code.length !== 6) {
          this.error_pin = 'Please Enter 6-digit Pin Code';
          this.isLoading = false;
          this.isActive = true;
          setTimeout(function () {
            _this.error_pin = '';
          }, 5000);
          return;
        }
      }
      var surveyResult = self.questionArray.filter(function (x) {
        return x.answer === '';
      });
      if (surveyResult.length !== 0) {
        var errNo = surveyResult[0].id;
        var errDiv = document.getElementById(errNo);
        errDiv.scrollIntoView();
        document.getElementById('err_' + errNo).innerHTML = 'Please fill answers for the questions';
        // this.error_msg = 'Please fill answers for all the questions'
        this.isLoading = false;
        setTimeout(function () {
          document.getElementById('err_' + errNo).innerHTML = '';
        }, 3000);
        return;
      }
      var postData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.questionArray);
      var params = new URLSearchParams();
      params.append('form_no', self.form_no);
      params.append('phone_no', self.mobile_no);
      params.append('name', self.name);
      params.append('pincode', self.pin_code);
      params.append('questions_json', postData);
      params.append('address', self.address);
      __WEBPACK_IMPORTED_MODULE_6_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/users/survey-data',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        if (response.data.status === '000000') {
          self.surveyResult = self.questionArray.filter(function (x) {
            return x.answer === '1';
          });
          _this.isLoading = true;
          setTimeout(function () {
            _this.isLoading = false;
          }, 5000);
          self.formSubmit = true;
        } else {
          _this.error_msg = response.data.msg;
          setTimeout(function () {
            _this.error_msg = '';
          }, 5000);
          // setTimeout(function() { self.openToast(response.data.msg, 'danger') }, 200)
        }
      }).catch(function (e) {
        _this.error_msg = e;
        // setTimeout(function() { self.openToast(e, 'danger') }, 200)
        // console.log(e)
      });
      self.isLoading = false;
    }
  }

});

/***/ }),

/***/ "t4W3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      urlInterface: [],
      apiDataObj: [],
      userDetails: [],
      deliveryLocObj: [],
      center: { lat: 0, lng: 0 },
      markers: [{
        position: { lat: 0, lng: 0 }
      }]
    };
  },
  created: function created() {
    this.fetchData();
  },

  methods: {
    fetchData: function fetchData() {
      var _this = this;

      var params = new URLSearchParams();
      var fullUrl = document.URL;
      var splitUrl = fullUrl.split('l?');
      params.append('url_str', splitUrl[1]);
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/accounts/fetch-url-interface-data',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this.urlInterface = {};
        if (response.data.status === '000001' || response.data.status === '000002' || response.data.status === '000003') {
          _this.urlInterface.error_msg = response.data.msg;
          document.getElementById('url_valid').style.display = 'none';
        } else {
          document.getElementById('url_expired').style.display = 'none';
          _this.urlInterface.action_name = response.data.action_name;
          _this.urlInterface.url_interface_id = response.data.url_interface_id;
          _this.invokeUrlAction();
        }
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          _this.list = response.data.user_record;
          alert(_this.list);
        }
      }).catch(function (e) {
        alert('not ok');
      });
    },
    invokeUrlAction: function invokeUrlAction() {
      var _this2 = this;

      var params = new URLSearchParams();
      params.append('url_interface_id', this.urlInterface.url_interface_id);
      params.append('action_name', this.urlInterface.action_name);
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/accounts/invoke-url-action',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this2.apiDataObj = {};
        switch (_this2.urlInterface.action_name) {
          case 'location_url':
            _this2.apiDataObj.userId = response.data.action_response.user_id;
            _this2.apiDataObj.pincode = response.data.action_response.pincode;
            if (response.data.action_response.lat != null && response.data.action_response.lng != null) {
              document.getElementById('location_null').style.display = 'none';
              document.getElementById('location_not_null').style.display = 'block';
            } else {
              document.getElementById('location_not_null').style.display = 'none';
              document.getElementById('location_null').style.display = 'block';
              _this2.fetchCurrentLocation();
            }
            _this2.userInfo();
            break;
          default:
            break;
        }
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          _this2.list = response.data.user_record;
          alert(_this2.list);
        }
      }).catch(function (e) {
        alert('not ok');
      });
    },
    userInfo: function userInfo() {
      var _this3 = this;

      var params = new URLSearchParams();
      var userId = this.apiDataObj.userId;
      params.append('user_id', userId);
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/users/user-info',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this3.userDetails = {};
        _this3.userDetails.userId = userId;
        _this3.userDetails.first_name = response.data.user_record.user_details.first_name;
        _this3.userDetails.mobile = response.data.user_record.user.username;
        _this3.userDetails.address = response.data.user_record.address.address1 + ' ' + response.data.user_record.address.address2 + ' ' + response.data.user_record.address.city;
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          _this3.list = response.data.user_record;
          alert(_this3.list);
        }
      }).catch(function (e) {
        alert('not ok');
      });
    },
    fetchCurrentLocation: function fetchCurrentLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
          var pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          this.center.lat = pos.lat;
          this.center.lng = pos.lng;
          this.markers[0].position.lat = pos.lat;
          this.markers[0].position.lng = pos.lng;
          // this.geocodeLatLng(new google.maps.Geocoder, pos, google.maps.InfoWindow);
        }.bind(this));
      }
    },
    onClickCurrentLocationButtion: function onClickCurrentLocationButtion() {
      // this.fetchCurrentLocation()
      window.location.reload();
    },
    updateCoordinates: function updateCoordinates(location) {
      this.markers[0].position.lat = location.latLng.lat();
      this.markers[0].position.lng = location.latLng.lng();
    },
    latLngCheck: function latLngCheck() {
      if (this.markers[0].position.lat !== 0 && this.markers[0].position.lng !== 0) {
        var answer = confirm('Do you want to update delivery location?');
        if (answer) {
          this.onClickUpdateLocation();
        }
      } else {
        alert('Cant update location. Please enable your location from Browser settings');
      }
    },
    onClickUpdateLocation: function onClickUpdateLocation() {
      var _this4 = this;

      var params = new URLSearchParams();
      var userId = this.apiDataObj.userId;
      var userPincode = this.apiDataObj.pincode;
      var userLat = this.markers[0].position.lat;
      var userLng = this.markers[0].position.lng;
      params.append('customer_id', userId);
      params.append('latitude', userLat);
      params.append('longitude', userLng);
      params.append('pincode', userPincode);
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + '/deliveries/add-coordinate-map',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this4.deliveryLocObj = {};
        if (response.data.status === '000000') {
          alert('Your delivery location updated succussfully.');
        } else {
          alert('Opps! we have faced problem in updating your location. Retry again.');
        }
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          _this4.list = response.data.user_record;
          alert(_this4.list);
        }
      }).catch(function (e) {
        alert('not ok');
      });
    }
  }
});

/***/ }),

/***/ "tIy3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tTke":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/page2.4a3fb1a.jpg";

/***/ }),

/***/ "tWR5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tpqd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u1jR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"listOfProducts"},_vm._l((_vm.products),function(product,index){return _c('li',{key:index,staticClass:"product"},[_c('div',{staticStyle:{"width":"100%"}},[_c('img',{staticClass:"product-image",attrs:{"src":product.product_image_s3_url ? product.product_image_s3_url :'',"alt":product.product_image_s3_url ? product.product_image_s3_url :'No Image'}}),_vm._v(" "),_c('div',{staticStyle:{"width":"65%","float":"right"}},[_c('div',[_c('b',[_vm._v(_vm._s(product.product_name))]),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"color":"gray","font-size":"13px","font-style":"italic"}},[_vm._v(_vm._s(product.product_description))]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"14px"}},[_vm._v(_vm._s(product.product_price_list[0].quantity)+" "+_vm._s(product.product_price_list[0].unit))]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%"}},[_c('div',{staticStyle:{"width":"30%","float":"left","font-size":"13px"}},[(product.flat_discount_mrp_applicable === false)?_c('div',[_c('div',{staticStyle:{"float":"left"}},[_c('i',{staticClass:"fa fa-rupee"}),_vm._v(" "),_c('b',[_vm._v(_vm._s(product.product_price.toFixed(2)))])])]):_c('div',[_c('div',{staticStyle:{"float":"left","text-decoration":"line-through","color":"gray"}},[_c('i',{staticClass:"fa fa-rupee"}),_vm._v(" "),_c('b',[_vm._v(_vm._s(product.mrp_without_discount.toFixed(2)))])]),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"float":"left"}},[_c('i',{staticClass:"fa fa-rupee"}),_vm._v(" "),_c('b',[_vm._v(_vm._s(product.product_price.toFixed(2)))])])])]),_vm._v(" "),_c('div',{staticStyle:{"float":"right"}},[_c('btn',{staticClass:"subButton",style:({'background-color': product.button_color}),nativeOn:{"click":function($event){_vm.onClickSubButton(product)}}},[_vm._v("\n                "+_vm._s(product.btn_text)+"\n              ")])],1)])])])])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uEKC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'p-checkbox',
  model: {
    prop: 'checked'
  },
  props: {
    checked: [Array, Boolean],
    disabled: [Boolean, String],
    inline: Boolean
  },
  data: function data() {
    return {
      cbId: ''
    };
  },

  computed: {
    model: {
      get: function get() {
        return this.checked;
      },
      set: function set(check) {
        this.$emit('input', check);
      }
    },
    inlineClass: function inlineClass() {
      if (this.inline) {
        return 'checkbox-inline';
      }
    }
  },
  created: function created() {
    this.cbId = Math.random().toString(16).slice(2);
  }
});

/***/ }),

/***/ "vG9Y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vNb6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatsCard_vue__ = __webpack_require__("0XqQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54112600_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatsCard_vue__ = __webpack_require__("cxu9");
function injectStyle (ssrContext) {
  __webpack_require__("To5b")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatsCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54112600_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatsCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vRYl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Shipping_vue__ = __webpack_require__("8O/4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e34cfbc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Shipping_vue__ = __webpack_require__("peGW");
function injectStyle (ssrContext) {
  __webpack_require__("sp4L")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Shipping_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e34cfbc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Shipping_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vS1+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vn/I":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vzx8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-loading',{attrs:{"is-full-page":_vm.isFullPage,"active":_vm.isLoading},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),(_vm.successfully_feedback === false)?_c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"url_valid"}},[_c('div',{staticStyle:{"text-align":"center"}},[_c('h6',{staticStyle:{"padding":"1%"}},[_vm._v(_vm._s(_vm.reportHeader))]),_vm._v(" "),_c('p',{staticStyle:{"padding":"1%","font-size":"12px"}},[_vm._v(_vm._s(_vm.reportBody))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":_vm.resource_name_with_path,"type":"application/pdf"},on:{"click":_vm.linkClick}},[_vm._v("View Test Report")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center","width":"90%"},attrs:{"id":"url_expired"}},[_c('h4',[_vm._v("Welcome to Doodhvale, Please wait...")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wJGD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      signUp: [],
      resendOtp: [],
      verifyOtp: [],
      otp: false
    };
  },
  created: function created() {
    var userId = sessionStorage.getItem("userId");
    var productListUrl = sessionStorage.getItem("productListUrl");
    if (userId && productListUrl) {
      window.location.href = productListUrl;
    } else {
      sessionStorage.clear();
    }
  },


  methods: {
    signup: function signup() {
      var _this = this;

      var params = new URLSearchParams();
      var mobile = document.getElementById("mobile").value;
      var deviceID = document.getElementById("mobile").value;
      if (isNaN(mobile) || mobile.length !== 10 || mobile === "") {
        alert("Oops! Invalid Mobile Number.");
      } else {
        params.append("mobile", mobile);
        params.append("deviceId", deviceID);
        __WEBPACK_IMPORTED_MODULE_0_axios___default()({
          url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + "/users/signup",
          method: "post",
          data: params,
          withCredentials: false,
          headers: {}
        }).then(function (response) {
          _this.signUp = {};
          if (response.data.status === "000000" || response.data.status === "000001" || response.data.status === "000002" || response.data.status === "000007" || response.data.status === "000012") {
            _this.signUp.disMobile = mobile;
            _this.otp = true;
            if (response.data.status === "000000" && response.data.is_profile === 1) {} else {
              _this.resendotp();
            }
          } else {
            alert(response.data.msg);
          }
          // console.log(response)
          if (response.data.status.trim().toUpperCase() === "SUCCESS") {
            _this.list = response.data.user_record;
            // alert(this.list)
          }
        }).catch(function (e) {
          alert("Please try again!");
        });
      }
    },
    resendotp: function resendotp() {
      var _this2 = this;

      var params = new URLSearchParams();
      params.append("mobile", this.signUp.disMobile);
      params.append("deviceId", this.signUp.disMobile);
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + "/users/resend-otp",
        method: "post",
        data: params,
        withCredentials: false,
        headers: {}
      }).then(function (response) {
        _this2.resendOtp = {};
        if (response.data.status !== "000000") {
          alert(response.data.msg);
        }
        // console.log(response)
        if (response.data.status.trim().toUpperCase() === "SUCCESS") {
          _this2.list = response.data.user_record;
          // alert(this.list)
        }
      }).catch(function (e) {
        alert("Please try again!");
      });
    },
    verifyotp: function verifyotp() {
      var _this3 = this;

      var params = new URLSearchParams();
      var otp = document.getElementById("otp").value;
      var mobile = this.signUp.disMobile;
      var deviceID = this.signUp.disMobile;
      if (isNaN(otp) || otp.length !== 4 || otp === "") {
        alert("Oops! Invalid OTP.");
      } else {
        params.append("otp", otp);
        params.append("mobile", mobile);
        params.append("deviceId", deviceID);
        __WEBPACK_IMPORTED_MODULE_0_axios___default()({
          url: "https://doodhvale.in/dv/doodhvale/api/web/v3" + "/users/verify-otp",
          method: "post",
          data: params,
          withCredentials: false,
          headers: {}
        }).then(function (response) {
          _this3.verifyOtp = {};
          if (response.data.status === "000000") {
            /* this.verifyOtp.userId = response.data.user_id
            this.verifyOtp.roleId = response.data.role_id
            this.verifyOtp.isProfile = response.data.is_profile
            this.verifyOtp.userMobile = response.data.user_mobile */
            sessionStorage.setItem("userId", response.data.user_id);
            sessionStorage.setItem("roleId", response.data.role_id);
            sessionStorage.setItem("isProfile", response.data.is_profile);
            sessionStorage.setItem("userMobile", response.data.user_mobile);
            if (response.data.is_profile === 0) {
              if (sessionStorage.getItem("urlstr") === "undefined" || sessionStorage.getItem("urlstr") === null) {
                // this.$router.push('/a/subscription')
                sessionStorage.setItem("productListUrl", response.data.product_list_url);
                window.location.href = response.data.product_list_url;
                /* var fullUrl = response.data.product_list_url;
                var splitUrl = fullUrl.split("productList?");
                // sessionStorage.setItem('productListUrl', 'https://t.doodhvale.in/#/a/productList?' + splitUrl[1])
                // window.location.href = 'https://t.doodhvale.in/#/a/productList?' + splitUrl[1]
                sessionStorage.setItem(
                  "productListUrl",
                  "http://localhost:4000/a/productList?" + splitUrl[1]
                );
                window.location.href =
                  "http://localhost:4000/a/productList?" + splitUrl[1]; */
              } else {
                _this3.$router.push("/a/s?" + sessionStorage.getItem("urlstr"));
              }
            } else {
              _this3.$router.push("/a/location");
            }
          } else {
            alert(response.data.msg);
          }
          // console.log(response)
          if (response.data.status.trim().toUpperCase() === "SUCCESS") {
            _this3.list = response.data.user_record;
            // alert(this.list)
          }
        }).catch(function (e) {
          alert("Please try again!");
        });
      }
    }
  }
});

/***/ }),

/***/ "wv4A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"has-text-centered con"},[(_vm.after_checksum)?_c('div',[_c('div',[_vm._v("\n    Please press button to continue..\n    "),_c('br'),_vm._v("\n    Amount "),_c('i',{staticClass:"fa fa-rupee"}),_c('b',[_vm._v(_vm._s(_vm.genChecksum.TXN_AMOUNT))]),_c('br'),_c('br'),_vm._v(" "),_c('div',[_c('form',{attrs:{"method":"post","action":"https://securegw.paytm.in/theia/processTransaction"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.genChecksum.MID),expression:"genChecksum.MID"}],attrs:{"type":"hidden","name":"MID"},domProps:{"value":(_vm.genChecksum.MID)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.genChecksum, "MID", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.genChecksum.ORDER_ID),expression:"genChecksum.ORDER_ID"}],attrs:{"type":"hidden","name":"ORDER_ID"},domProps:{"value":(_vm.genChecksum.ORDER_ID)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.genChecksum, "ORDER_ID", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.genChecksum.CUST_ID),expression:"genChecksum.CUST_ID"}],attrs:{"type":"hidden","name":"CUST_ID"},domProps:{"value":(_vm.genChecksum.CUST_ID)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.genChecksum, "CUST_ID", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.genChecksum.INDUSTRY_TYPE_ID),expression:"genChecksum.INDUSTRY_TYPE_ID"}],attrs:{"type":"hidden","name":"INDUSTRY_TYPE_ID"},domProps:{"value":(_vm.genChecksum.INDUSTRY_TYPE_ID)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.genChecksum, "INDUSTRY_TYPE_ID", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.genChecksum.CHANNEL_ID),expression:"genChecksum.CHANNEL_ID"}],attrs:{"type":"hidden","name":"CHANNEL_ID"},domProps:{"value":(_vm.genChecksum.CHANNEL_ID)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.genChecksum, "CHANNEL_ID", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.genChecksum.WEBSITE),expression:"genChecksum.WEBSITE"}],attrs:{"type":"hidden","name":"WEBSITE"},domProps:{"value":(_vm.genChecksum.WEBSITE)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.genChecksum, "WEBSITE", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.genChecksum.CALLBACK_URL),expression:"genChecksum.CALLBACK_URL"}],attrs:{"type":"hidden","name":"CALLBACK_URL"},domProps:{"value":(_vm.genChecksum.CALLBACK_URL)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.genChecksum, "CALLBACK_URL", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.genChecksum.checksum),expression:"genChecksum.checksum"}],attrs:{"type":"hidden","name":"CHECKSUMHASH"},domProps:{"value":(_vm.genChecksum.checksum)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.genChecksum, "checksum", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.genChecksum.TXN_AMOUNT),expression:"genChecksum.TXN_AMOUNT"}],attrs:{"type":"hidden","name":"TXN_AMOUNT"},domProps:{"value":(_vm.genChecksum.TXN_AMOUNT)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.genChecksum, "TXN_AMOUNT", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.genChecksum.MERC_UNQ_REF),expression:"genChecksum.MERC_UNQ_REF"}],attrs:{"type":"hidden","name":"MERC_UNQ_REF"},domProps:{"value":(_vm.genChecksum.MERC_UNQ_REF)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.genChecksum, "MERC_UNQ_REF", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.promoCodeId),expression:"promoCodeId"}],attrs:{"type":"hidden","name":"promo_code_id"},domProps:{"value":(_vm.promoCodeId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.promoCodeId=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cashback),expression:"cashback"}],attrs:{"type":"hidden","name":"cashback_amount"},domProps:{"value":(_vm.cashback)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cashback=$event.target.value}}}),_vm._v(" "),_c('input',{staticClass:"button5",attrs:{"id":"pay","value":"Continue","type":"submit"},on:{"click":function($event){_vm.isLoading=true}}})])])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wyJp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "xSBc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.successfully_feedback === false)?_c('div',[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"url_valid"}},[_c('div',{staticStyle:{"text-align":"center"}},[_c('div',[_c('h4',[_vm._v("Welcome "+_vm._s(_vm.userDetails.first_name)),_c('br'),_vm._v("("+_vm._s(_vm.userDetails.mobile)+")")])]),_vm._v(" "),_c('div',[_vm._v("\n        "+_vm._s(_vm.userDetails.address))]),_vm._v("\n        *****"),_c('br'),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.apiDataObj.titleMsg))]),_c('br'),_c('br'),_vm._v(" "),_c('ul',{attrs:{"id":"example-1"}},_vm._l((_vm.items),function(item){return _c('li',[_vm._v("\n            "+_vm._s(item)+"\n          ")])})),_vm._v(" "),(_vm.pre_prod === true)?_c('div',[_c('input',{staticClass:"switch",attrs:{"value":"Switch To Postpaid","type":"button"},on:{"click":_vm.switchToPostpaid}})]):_vm._e()])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center","width":"90%"},attrs:{"id":"url_expired"}},[_c('h4',[_vm._v("Welcome to Doodhvale, Please wait...")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xZNU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xkpb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xqMj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lottie_web__ = __webpack_require__("tgCg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lottie_web___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lottie_web__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_assets_json_Animation_json__ = __webpack_require__("JLYD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_assets_json_Animation_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__src_assets_json_Animation_json__);
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      containerWidth: '350px',
      containerHeight: '350px'
    };
  },
  mounted: function mounted() {
    this.initAnimation();
  },

  methods: {
    initAnimation: function initAnimation() {
      var container = this.$refs.lottieContainer;
      if (container) {
        __WEBPACK_IMPORTED_MODULE_0_lottie_web___default.a.loadAnimation({
          container: container,
          renderer: 'svg', // Use 'canvas' or 'svg' based on your preference
          autoplay: true,
          animationData: __WEBPACK_IMPORTED_MODULE_1__src_assets_json_Animation_json___default.a
        });
      }
    }
  }
});

/***/ }),

/***/ "yfE3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Privacy_vue__ = __webpack_require__("jHIg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4129399c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Privacy_vue__ = __webpack_require__("5Aj9");
function injectStyle (ssrContext) {
  __webpack_require__("Svje")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Privacy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4129399c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Privacy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zTLC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    routeName: function routeName() {
      var name = this.$route.name;

      return this.capitalizeFirstLetter(name);
    }
  },
  data: function data() {
    return {
      activeNotifications: false
    };
  },

  methods: {
    capitalizeFirstLetter: function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown: function toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown: function closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar: function toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar: function hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    goToEvents: function goToEvents() {
      location.href = "https://v.doodhvale.in/#/a/appLink";
    }
  }
});

/***/ }),

/***/ "zV0d":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/boy.cc25330.png";

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.a279f42ea02479f1bc33.js